// This file is auto-generated by @hey-api/openapi-ts

import { buildClientParams, type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape, urlSearchParamsBodySerializer } from './client';
import { client } from './client.gen';
import type { AcceptedAdAssessmentCreate, AcceptedAdAssessmentsAcceptAssessmentErrors, AcceptedAdAssessmentsAcceptAssessmentResponses, AcceptedAdAssessmentsGetAdComplianceForAircraftErrors, AcceptedAdAssessmentsGetAdComplianceForAircraftResponses, AcceptedSbAssessmentCreate, AcceptedSbAssessmentsAcceptAssessmentErrors, AcceptedSbAssessmentsAcceptAssessmentResponses, AcceptedSbAssessmentsExportSbComplianceReportErrors, AcceptedSbAssessmentsExportSbComplianceReportResponses, AcceptedSbAssessmentsGetSbComplianceForAircraftErrors, AcceptedSbAssessmentsGetSbComplianceForAircraftResponses, AdComplianceHistoryCreate, AdComplianceHistoryCreateItemErrors, AdComplianceHistoryCreateItemResponses, AdComplianceHistoryDeleteItemErrors, AdComplianceHistoryDeleteItemResponses, AdComplianceHistoryReadItemErrors, AdComplianceHistoryReadItemResponses, AdComplianceHistoryReadItemsErrors, AdComplianceHistoryReadItemsResponses, AdComplianceHistoryUpdate, AdComplianceHistoryUpdateItemErrors, AdComplianceHistoryUpdateItemResponses, AdminPasswordReset, AdRecordTriggerBackfillErrors, AdRecordTriggerBackfillResponses, AircraftAgentCreate, AircraftAgentCreateAircraftErrors, AircraftAgentCreateAircraftResponses, AircraftCreate, AircraftCreateItemErrors, AircraftCreateItemResponses, AircraftDeleteItemErrors, AircraftDeleteItemResponses, AircraftGetAircraftByCustomerErrors, AircraftGetAircraftByCustomerResponses, AircraftGetFittedComponentsByAircraftIdErrors, AircraftGetFittedComponentsByAircraftIdResponses, AircraftGetModStatusByAircraftIdErrors, AircraftGetModStatusByAircraftIdResponses, AircraftImportPayload, AircraftReadItemErrors, AircraftReadItemResponses, AircraftReadItemsErrors, AircraftReadItemsResponses, AircraftReadModStatusByAircraftErrors, AircraftReadModStatusByAircraftResponses, AircraftUpdate, AircraftUpdateItemErrors, AircraftUpdateItemResponses, AppDataImportSchemasExternalImport, AppDataImportSchemasInternalImport, ApplySquawkSuggestion, ApprovalPoliciesCreateApprovalPolicyErrors, ApprovalPoliciesCreateApprovalPolicyResponses, ApprovalPoliciesDeleteApprovalPolicyErrors, ApprovalPoliciesDeleteApprovalPolicyResponses, ApprovalPoliciesEditApprovalPolicyErrors, ApprovalPoliciesEditApprovalPolicyResponses, ApprovalPoliciesGetApprovalPoliciesErrors, ApprovalPoliciesGetApprovalPoliciesResponses, ApprovalPoliciesGetApprovalPolicyOptionsResponses, ApprovalPoliciesGetApprovalPolicyReferenceErrors, ApprovalPoliciesGetApprovalPolicyReferenceResponses, ApprovalPoliciesListApprovalPoliciesResponses, ApprovalPoliciesOrderApprovalPoliciesErrors, ApprovalPoliciesOrderApprovalPoliciesResponses, ApprovalPoliciesUpdateApprovalPoliciesErrors, ApprovalPoliciesUpdateApprovalPoliciesResponses, ApprovalPolicyCreate, ApprovalPolicyOrder, ApprovalPolicySetUpdate, ApprovalPolicyUpdate, ApprovedVendorBulkIds, ApprovedVendorCreate, ApprovedVendorsArchiveErrors, ApprovedVendorsArchiveResponses, ApprovedVendorsCreateErrors, ApprovedVendorsCreateResponses, ApprovedVendorsDeleteErrors, ApprovedVendorsDeleteManyErrors, ApprovedVendorsDeleteManyResponses, ApprovedVendorsDeleteResponses, ApprovedVendorsGetErrors, ApprovedVendorsGetResponses, ApprovedVendorsListApprovedVendorsErrors, ApprovedVendorsListApprovedVendorsResponses, ApprovedVendorsRestoreErrors, ApprovedVendorsRestoreResponses, ApprovedVendorsUpdateErrors, ApprovedVendorsUpdateResponses, ApprovedVendorUpdate, AssignWorkTasks, AtaChapterClassifyAllTasksErrors, AtaChapterClassifyAllTasksResponses, AtaChapterClassifyWorkTaskErrors, AtaChapterClassifyWorkTaskResponses, AtaChapterListChaptersResponses, AtlApplyAtlPageUpdateErrors, AtlApplyAtlPageUpdateResponses, AtlAtlPageBroughtForwardErrors, AtlAtlPageBroughtForwardResponses, AtlEnterAtlPageErrors, AtlEnterAtlPageResponses, AtlExtractErrors, AtlExtractResponses, AtlGetAtlPageErrors, AtlGetAtlPageResponses, AtlListAtlPagesErrors, AtlListAtlPagesResponses, AtlPageEntry, AtlPageEntryCreate, AtlPageGrouping, AtlPageSort, AtlPageStatus, AtlRecordAtlPageErrors, AtlRecordAtlPageResponses, AtlUpdateAtlPageErrors, AtlUpdateAtlPageResponses, AtlVoidAtlPageErrors, AtlVoidAtlPageResponses, AttachExistingDocuments, AudioIntent, AuditLogListLogsErrors, AuditLogListLogsResponses, BodyDocumentsUpload, BodyDocumentsUploadGlobal, BodyLoginLoginAccessToken, BodyQuoteTaskAttachmentUploadForQuoteTask, BodyTenantUploadCompanyLogo, BodyTenantUploadCurrentCompanyLogo, BodyTraceAttachmentUploadAttachment, BodyTraceAttachmentUploadSandboxAttachment, BodyTraceAudio, BodyTraceTranscribe, CannedWorkPackageBulkIds, CannedWorkPackageCreate, CannedWorkPackageGrouping, CannedWorkPackagesArchiveManyErrors, CannedWorkPackagesArchiveManyResponses, CannedWorkPackagesArchivePackageErrors, CannedWorkPackagesArchivePackageResponses, CannedWorkPackagesCreateErrors, CannedWorkPackagesCreateResponses, CannedWorkPackagesDeleteManyErrors, CannedWorkPackagesDeleteManyResponses, CannedWorkPackagesDeletePackageErrors, CannedWorkPackagesDeletePackageResponses, CannedWorkPackagesGetPackageErrors, CannedWorkPackagesGetPackageResponses, CannedWorkPackagesImport, CannedWorkPackagesListPackagesErrors, CannedWorkPackagesListPackagesResponses, CannedWorkPackageSortField, CannedWorkPackagesRestoreManyErrors, CannedWorkPackagesRestoreManyResponses, CannedWorkPackagesRestorePackageErrors, CannedWorkPackagesRestorePackageResponses, CannedWorkPackageStatus, CannedWorkPackagesUpdatePackageErrors, CannedWorkPackagesUpdatePackageResponses, CannedWorkPackageUpdate, CannedWorkTaskBulkDepartment, CannedWorkTaskBulkIds, CannedWorkTaskBulkTaskGroup, CannedWorkTaskCreate, CannedWorkTaskGrouping, CannedWorkTaskReviews, CannedWorkTasksArchiveManyErrors, CannedWorkTasksArchiveManyResponses, CannedWorkTasksCountByStatusErrors, CannedWorkTasksCountByStatusResponses, CannedWorkTasksCreateErrors, CannedWorkTasksCreateResponses, CannedWorkTasksCreateVersionErrors, CannedWorkTasksCreateVersionResponses, CannedWorkTasksDeleteTaskErrors, CannedWorkTasksDeleteTaskResponses, CannedWorkTasksDeleteVersionErrors, CannedWorkTasksDeleteVersionResponses, CannedWorkTasksGetTaskErrors, CannedWorkTasksGetTaskResponses, CannedWorkTasksImport, CannedWorkTasksListTasksErrors, CannedWorkTasksListTasksResponses, CannedWorkTaskSortField, CannedWorkTasksRestoreManyErrors, CannedWorkTasksRestoreManyResponses, CannedWorkTasksRestoreTaskErrors, CannedWorkTasksRestoreTaskResponses, CannedWorkTasksReviewVersionErrors, CannedWorkTasksReviewVersionResponses, CannedWorkTasksReviewVersionsErrors, CannedWorkTasksReviewVersionsResponses, CannedWorkTasksSetDepartmentErrors, CannedWorkTasksSetDepartmentResponses, CannedWorkTasksSetTaskGroupErrors, CannedWorkTasksSetTaskGroupResponses, CannedWorkTasksSuggestPartsErrors, CannedWorkTasksSuggestPartsResponses, CannedWorkTasksUndoApprovalErrors, CannedWorkTasksUndoApprovalResponses, CannedWorkTaskVersionCreate, CannedWorkTaskVersionReview, ClassifyTasks, CloseWorkPackages, CloseWorkTasks, CommentVisibility, ComplianceNoteCreate, ComplianceNoteCreateItemErrors, ComplianceNoteCreateItemResponses, ComplianceNoteGetLatestComplianceNoteByWorkTaskIdErrors, ComplianceNoteGetLatestComplianceNoteByWorkTaskIdResponses, ComplianceNoteUpdate, ComplianceNoteUpdateItemErrors, ComplianceNoteUpdateItemResponses, CorridorQuotePushCreate, CorridorRelayUpdate, CustomerAddressCreate, CustomerAddressCreateErrors, CustomerAddressCreateResponses, CustomerAddressDeleteErrors, CustomerAddressDeleteResponses, CustomerAddressGetErrors, CustomerAddressGetResponses, CustomerAddressListAddressesErrors, CustomerAddressListAddressesResponses, CustomerAddressUpdate, CustomerAddressUpdateErrors, CustomerAddressUpdateResponses, CustomerArchiveCustomerErrors, CustomerArchiveCustomerResponses, CustomerContactArchiveErrors, CustomerContactArchiveResponses, CustomerContactCreate, CustomerContactCreateErrors, CustomerContactCreateResponses, CustomerContactDeleteErrors, CustomerContactDeleteResponses, CustomerContactGetErrors, CustomerContactGetResponses, CustomerContactListContactsErrors, CustomerContactListContactsResponses, CustomerContactRestoreErrors, CustomerContactRestoreResponses, CustomerContactUpdate, CustomerContactUpdateErrors, CustomerContactUpdateResponses, CustomerCreate, CustomerCreateCustomerErrors, CustomerCreateCustomerResponses, CustomerDeleteCustomerErrors, CustomerDeleteCustomerResponses, CustomerGetCustomerErrors, CustomerGetCustomerResponses, CustomerListCustomersErrors, CustomerListCustomersResponses, CustomerRestoreErrors, CustomerRestoreResponses, CustomerUpdate, CustomerUpdateCustomerErrors, CustomerUpdateCustomerResponses, CustomRoleCreate, CustomRoleUpdate, DeleteWorkTasks, DepartmentCreate, DepartmentsCreateErrors, DepartmentsCreateResponses, DepartmentsDeleteErrors, DepartmentsDeleteResponses, DepartmentsGetErrors, DepartmentsGetResponses, DepartmentsListDepartmentsErrors, DepartmentsListDepartmentsResponses, DepartmentsRestoreErrors, DepartmentsRestoreResponses, DepartmentsUpdateErrors, DepartmentsUpdateResponses, DepartmentUpdate, DesktopCheckForUpdateErrors, DesktopCheckForUpdateResponses, DocumentBatchDownload, DocumentBulkDelete, DocumentBulkUpdate, DocumentFilters, DocumentKind, DocumentOrderBy, DocumentsArchiveDocumentErrors, DocumentsArchiveDocumentResponses, DocumentsArchiveManyErrors, DocumentsArchiveManyResponses, DocumentsDeleteDocumentErrors, DocumentsDeleteDocumentResponses, DocumentsDeleteManyErrors, DocumentsDeleteManyResponses, DocumentsDownloadErrors, DocumentsDownloadManyErrors, DocumentsDownloadManyResponses, DocumentsDownloadResponses, DocumentSearch, DocumentsFilterOptionsErrors, DocumentsFilterOptionsResponses, DocumentsGetErrors, DocumentsGetResponses, DocumentsListDocumentsErrors, DocumentsListDocumentsResponses, DocumentsReExtractErrors, DocumentsReExtractResponses, DocumentsRestoreDocumentErrors, DocumentsRestoreDocumentResponses, DocumentsRestoreManyErrors, DocumentsRestoreManyResponses, DocumentsSearchAirworthinessDirectivesErrors, DocumentsSearchAirworthinessDirectivesResponses, DocumentsSearchDocumentsErrors, DocumentsSearchDocumentsResponses, DocumentsUpdateErrors, DocumentsUpdateManyErrors, DocumentsUpdateManyResponses, DocumentsUpdateResponses, DocumentsUploadErrors, DocumentsUploadGlobalErrors, DocumentsUploadGlobalResponses, DocumentsUploadResponses, DocumentTemplatePreview, DocumentTemplatesGetDocumentTemplateErrors, DocumentTemplatesGetDocumentTemplateResponses, DocumentTemplatesListDocumentTemplatesResponses, DocumentTemplatesPreviewDocumentTemplateErrors, DocumentTemplatesPreviewDocumentTemplateResponses, DocumentTemplatesResetDocumentTemplateErrors, DocumentTemplatesResetDocumentTemplateResponses, DocumentTemplatesUpdateDocumentTemplateErrors, DocumentTemplatesUpdateDocumentTemplateResponses, DocumentTemplateUpsert, DocumentUpdate, DraftTraceCreate, EmailArchiveEmailErrors, EmailArchiveEmailResponses, EmailArchiveManyErrors, EmailArchiveManyResponses, EmailBulkIds, EmailDeleteEmailErrors, EmailDeleteEmailResponses, EmailDeleteManyErrors, EmailDeleteManyResponses, EmailFilterOptionsErrors, EmailFilterOptionsResponses, EmailGetEmailErrors, EmailGetEmailResponses, EmailGetForwardingAddressResponses, EmailListEmailsErrors, EmailListEmailsResponses, EmailReceiveErrors, EmailReceiveResponses, EmailResolveTraceErrors, EmailResolveTraceResponses, EmailRestoreEmailErrors, EmailRestoreEmailResponses, EmailRestoreManyErrors, EmailRestoreManyResponses, EmailShareManyErrors, EmailShareManyResponses, EmailUpdate, EmailUpdateEmailErrors, EmailUpdateEmailResponses, EmailVisibility, ErpApiKeyClearErpApiKeyResponses, ErpApiKeyGetErpApiKeyResponses, ErpApiKeySetErpApiKeyResponses, ErpConfigsCreateErpConfigErrors, ErpConfigsCreateErpConfigResponses, ErpConfigsDeleteErpConfigErrors, ErpConfigsDeleteErpConfigResponses, ErpConfigsGetErpConfigByIdErrors, ErpConfigsGetErpConfigByIdResponses, ErpConfigsGetErpConfigIdsErrors, ErpConfigsGetErpConfigIdsResponses, ErpConfigsGetErpConfigsErrors, ErpConfigsGetErpConfigsResponses, ErpConfigsUpdateErpConfigErrors, ErpConfigsUpdateErpConfigResponses, ErpCorridorRelayClearCorridorRelayResponses, ErpCorridorRelayCreateCorridorQuotePushErrors, ErpCorridorRelayCreateCorridorQuotePushResponses, ErpCorridorRelayGetCorridorRelayResponses, ErpCorridorRelayListCorridorQuotePushesErrors, ErpCorridorRelayListCorridorQuotePushesResponses, ErpCorridorRelayRetryCorridorQuotePushErrors, ErpCorridorRelayRetryCorridorQuotePushResponses, ErpCorridorRelaySetCorridorRelayErrors, ErpCorridorRelaySetCorridorRelayResponses, ErpIntegrationGetErpConfigResponses, ErpIntegrationSyncFromErpResponses, ErpVendor, ExtensionFeedbackCreate, ExtensionFeedbackSubmitExtensionFeedbackErrors, ExtensionFeedbackSubmitExtensionFeedbackResponses, ExtractAtl, ExtractionRequest, ExtractProgramme, FacilitiesCreateErrors, FacilitiesCreateResponses, FacilitiesDeleteErrors, FacilitiesDeleteResponses, FacilitiesGetErrors, FacilitiesGetResponses, FacilitiesListFacilitiesErrors, FacilitiesListFacilitiesResponses, FacilitiesRestoreErrors, FacilitiesRestoreResponses, FacilitiesUpdateErrors, FacilitiesUpdateResponses, FacilityCreate, FacilityUpdate, FeatureFlagsGetFeatureFlagsResponses, FieldUpdateRequest, FilterableSquawkStatus, FittedComponentCreate, FittedComponentCreateItemErrors, FittedComponentCreateItemResponses, FittedComponentDeleteItemErrors, FittedComponentDeleteItemResponses, FittedComponentReadItemErrors, FittedComponentReadItemResponses, FittedComponentReadItemsErrors, FittedComponentReadItemsResponses, FittedComponentSearchFittedComponentsByAircraftIdErrors, FittedComponentSearchFittedComponentsByAircraftIdResponses, FittedComponentUpdate, FittedComponentUpdateItemErrors, FittedComponentUpdateItemResponses, ForecastArchiveForecastErrors, ForecastArchiveForecastResponses, ForecastBasis, ForecastConfirmationCreate, ForecastConfirmForecastItemErrors, ForecastConfirmForecastItemResponses, ForecastCreate, ForecastCreateForecastErrors, ForecastCreateForecastResponses, ForecastCreateForecastWorkOrderErrors, ForecastCreateForecastWorkOrderResponses, ForecastDeleteForecastErrors, ForecastDeleteForecastResponses, ForecastExcludeForecastItemErrors, ForecastExcludeForecastItemResponses, ForecastExclusionCreate, ForecastGetForecastErrors, ForecastGetForecastResponses, ForecastIncludeForecastItemErrors, ForecastIncludeForecastItemResponses, ForecastListForecastsErrors, ForecastListForecastsResponses, ForecastListForecastSummariesErrors, ForecastListForecastSummariesResponses, ForecastParameters, ForecastPin, ForecastPinForecastErrors, ForecastPinForecastResponses, ForecastPreviewForecastErrors, ForecastPreviewForecastResponses, ForecastPrintingPrintDueListErrors, ForecastPrintingPrintDueListResponses, ForecastRestoreForecastErrors, ForecastRestoreForecastResponses, ForecastSummariesRequest, ForecastUpdate, ForecastUpdateForecastErrors, ForecastUpdateForecastResponses, ForecastWorkOrderCreate, HubSpotEligibilityUpsert, HubSpotIntegrationConfigUpsert, HubSpotPropertyMappingUpsert, HubSpotQuoteCreate, HubSpotQuotingConfigUpsert, ImportExternalErrors, ImportExternalResponses, ImportGetImportCheckpointErrors, ImportGetImportCheckpointResponses, ImportImportAircraftErrors, ImportImportAircraftResponses, ImportImportCannedWorkPackagesErrors, ImportImportCannedWorkPackagesResponses, ImportImportCannedWorkTasksErrors, ImportImportCannedWorkTasksResponses, ImportImportMeResponses, ImportImportQuotesErrors, ImportImportQuotesResponses, ImportIngestRatesErrors, ImportIngestRatesResponses, ImportInternalErrors, ImportInternalResponses, ImportOpenWorkPackagesErrors, ImportOpenWorkPackagesResponses, ImportPutImportCheckpointErrors, ImportPutImportCheckpointResponses, ImportUpsertPartsErrors, ImportUpsertPartsResponses, IngestRatesItem, IntegrationCheckpointCreate, IntegrationCredentialsCreateWithPlaintextPassword, IntegrationCredentialsUpdateWithPlaintextPassword, IntegrationsCreateIntegrationCredentialsWithPlaintextPasswordErrors, IntegrationsCreateIntegrationCredentialsWithPlaintextPasswordResponses, IntegrationsDeleteIntegrationCredentialByTenantErrors, IntegrationsDeleteIntegrationCredentialByTenantResponses, IntegrationsGetIntegrationCredentialsByTenantErrors, IntegrationsGetIntegrationCredentialsByTenantResponses, IntegrationsUpdateIntegrationCredentialsWithPlaintextPasswordErrors, IntegrationsUpdateIntegrationCredentialsWithPlaintextPasswordResponses, IssueWorkTaskPart, LocationCreate, LocationsCreateErrors, LocationsCreateResponses, LocationsDeleteErrors, LocationsDeleteResponses, LocationsListLocationsErrors, LocationsListLocationsResponses, LocationsRestoreErrors, LocationsRestoreResponses, LocationsUpdateErrors, LocationsUpdateResponses, LocationUpdate, LoginAdminResetPasswordErrors, LoginAdminResetPasswordResponses, LoginGetPasswordPolicyResponses, LoginGetSessionFreshnessResponses, LoginLoginAccessTokenErrors, LoginLoginAccessTokenResponses, LoginLogoutResponses, LoginRecoverPasswordErrors, LoginRecoverPasswordHtmlContentErrors, LoginRecoverPasswordHtmlContentResponses, LoginRecoverPasswordResponses, LoginResetPasswordErrors, LoginResetPasswordResponses, MailgunRequest, MaintenanceProgrammeAddProgrammeCheckErrors, MaintenanceProgrammeAddProgrammeCheckResponses, MaintenanceProgrammeAddProgrammeTaskErrors, MaintenanceProgrammeAddProgrammeTaskResponses, MaintenanceProgrammeApplyProgrammeRevisionUpdateErrors, MaintenanceProgrammeApplyProgrammeRevisionUpdateResponses, MaintenanceProgrammeArchiveProgrammesErrors, MaintenanceProgrammeArchiveProgrammesResponses, MaintenanceProgrammeCreateProgrammeErrors, MaintenanceProgrammeCreateProgrammeResponses, MaintenanceProgrammeCreateProgrammeRevisionErrors, MaintenanceProgrammeCreateProgrammeRevisionResponses, MaintenanceProgrammeDeleteProgrammesErrors, MaintenanceProgrammeDeleteProgrammesResponses, MaintenanceProgrammeEnrolProgrammeAircraftErrors, MaintenanceProgrammeEnrolProgrammeAircraftResponses, MaintenanceProgrammeExtractErrors, MaintenanceProgrammeExtractResponses, MaintenanceProgrammeGetProgrammeErrors, MaintenanceProgrammeGetProgrammeOverviewResponses, MaintenanceProgrammeGetProgrammeResponses, MaintenanceProgrammeListAircraftEnrolmentsErrors, MaintenanceProgrammeListAircraftEnrolmentsResponses, MaintenanceProgrammeListProgrammeActivityErrors, MaintenanceProgrammeListProgrammeActivityResponses, MaintenanceProgrammeListProgrammeAircraftErrors, MaintenanceProgrammeListProgrammeAircraftResponses, MaintenanceProgrammeListProgrammeChecksErrors, MaintenanceProgrammeListProgrammeChecksResponses, MaintenanceProgrammeListProgrammeRevisionsErrors, MaintenanceProgrammeListProgrammeRevisionsResponses, MaintenanceProgrammeListProgrammesErrors, MaintenanceProgrammeListProgrammesResponses, MaintenanceProgrammeListProgrammeTasksErrors, MaintenanceProgrammeListProgrammeTasksResponses, MaintenanceProgrammeListTaskTrackedComponentsErrors, MaintenanceProgrammeListTaskTrackedComponentsResponses, MaintenanceProgrammeListTrackedComponentsErrors, MaintenanceProgrammeListTrackedComponentsResponses, MaintenanceProgrammeNextProgrammeNumberResponses, MaintenanceProgrammeReleaseProgrammeRevisionErrors, MaintenanceProgrammeReleaseProgrammeRevisionResponses, MaintenanceProgrammeRemoveProgrammeCheckErrors, MaintenanceProgrammeRemoveProgrammeCheckResponses, MaintenanceProgrammeRemoveProgrammeTaskErrors, MaintenanceProgrammeRemoveProgrammeTaskResponses, MaintenanceProgrammeReplaceProgrammeCheckErrors, MaintenanceProgrammeReplaceProgrammeCheckResponses, MaintenanceProgrammeReplaceProgrammeTaskErrors, MaintenanceProgrammeReplaceProgrammeTaskResponses, MaintenanceProgrammeRestoreProgrammesErrors, MaintenanceProgrammeRestoreProgrammesResponses, MaintenanceProgrammeSendProgrammeToSalesforceErrors, MaintenanceProgrammeSendProgrammeToSalesforceResponses, MaintenanceProgrammeUnenrolProgrammeAircraftErrors, MaintenanceProgrammeUnenrolProgrammeAircraftResponses, MaintenanceProgrammeUpdateProgrammeErrors, MaintenanceProgrammeUpdateProgrammeResponses, MergeQuoteTasks, Mode, ModStatusCreate, ModStatusCreateItemErrors, ModStatusCreateItemResponses, ModStatusDeleteItemErrors, ModStatusDeleteItemResponses, ModStatusEnum, ModStatusReadItemErrors, ModStatusReadItemResponses, ModStatusReadItemsErrors, ModStatusReadItemsResponses, ModStatusSearchModStatusByAircraftIdErrors, ModStatusSearchModStatusByAircraftIdResponses, ModStatusUpdate, ModStatusUpdateItemErrors, ModStatusUpdateItemResponses, MoveOutsideService, NewPassword, NotificationPreferenceUpsert, NotificationRuleCreate, NotificationRulesCreateNotificationRuleErrors, NotificationRulesCreateNotificationRuleResponses, NotificationRulesDeleteNotificationRuleErrors, NotificationRulesDeleteNotificationRuleResponses, NotificationRulesEditNotificationRuleErrors, NotificationRulesEditNotificationRuleResponses, NotificationRuleSetUpdate, NotificationRulesGetNotificationRuleOptionsResponses, NotificationRulesGetNotificationRuleReferenceErrors, NotificationRulesGetNotificationRuleReferenceResponses, NotificationRulesGetNotificationRulesErrors, NotificationRulesGetNotificationRulesResponses, NotificationRulesListNotificationRulesResponses, NotificationRulesUpdateNotificationRulesErrors, NotificationRulesUpdateNotificationRulesResponses, NotificationRuleUpdate, NotificationsDismissErrors, NotificationsDismissResponses, NotificationsListNotificationPreferencesResponses, NotificationsListNotificationsResponses, NotificationsMarkAllSeenResponses, NotificationsMarkSeenErrors, NotificationsMarkSeenResponses, NotificationsResolveTraceErrors, NotificationsResolveTraceResponses, NotificationsUpdateNotificationPreferencesErrors, NotificationsUpdateNotificationPreferencesResponses, OnExisting, PartAlternateCreate, PartAlternateCreateErrors, PartAlternateCreateResponses, PartAlternateDeleteErrors, PartAlternateDeleteResponses, PartAlternateGetErrors, PartAlternateGetResponses, PartAlternateListAlternatesErrors, PartAlternateListAlternatesResponses, PartAlternateUpdate, PartAlternateUpdateErrors, PartAlternateUpdateResponses, PartArchiveScope, PartBalanceCreate, PartBalanceCreateErrors, PartBalanceCreateResponses, PartBalanceDeleteErrors, PartBalanceDeleteResponses, PartBalanceGetErrors, PartBalanceGetResponses, PartBalanceListBalancesErrors, PartBalanceListBalancesResponses, PartBalanceUpdate, PartBalanceUpdateErrors, PartBalanceUpdateResponses, PartBulkIds, PartCondition, PartDetails, PartInstanceWorkHistoryEntryCreate, PartPriceCreate, PartPriceCreateErrors, PartPriceCreateResponses, PartPriceDeleteErrors, PartPriceDeleteResponses, PartPriceGetErrors, PartPriceGetResponses, PartPriceListPricesErrors, PartPriceListPricesResponses, PartPriceUpdate, PartPriceUpdateErrors, PartPriceUpdateResponses, PartReservationCreate, PartReservationCreateErrors, PartReservationCreateResponses, PartReservationDeleteErrors, PartReservationDeleteResponses, PartReservationGetErrors, PartReservationGetResponses, PartReservationListHoldingWorkOrdersResponses, PartReservationListReservationsErrors, PartReservationListReservationsResponses, PartReservationUpdate, PartReservationUpdateErrors, PartReservationUpdateResponses, PartsArchivePartErrors, PartsArchivePartResponses, PartsCreatePartErrors, PartsCreatePartResponses, PartsDeletePartErrors, PartsDeletePartResponses, PartsDeletePartsErrors, PartsDeletePartsResponses, PartsGetPartErrors, PartsGetPartResponses, PartsListManufacturersErrors, PartsListManufacturersResponses, PartsRestorePartErrors, PartsRestorePartResponses, PartsRfpExtractionCreate, PartsSearchPartsErrors, PartsSearchPartsResponses, PartStockGetErrors, PartStockGetResponses, PartStockGrouping, PartStockListStockErrors, PartStockListStockResponses, PartStockSort, PartStockStatus, PartStockView, PartsUpdatePartErrors, PartsUpdatePartResponses, PartsUpsert, PartUpdate, PartWorkHistoryLinkErrors, PartWorkHistoryLinkResponses, PartWorkHistoryListEntriesErrors, PartWorkHistoryListEntriesResponses, PartWorkHistoryUnlinkErrors, PartWorkHistoryUnlinkResponses, PositionCreate, PositionsCreateErrors, PositionsCreateResponses, PositionsDeleteErrors, PositionsDeleteResponses, PositionsListPositionsErrors, PositionsListPositionsResponses, PositionsUpdateErrors, PositionsUpdateResponses, PositionUpdate, PrintDueList, PrintSquawkCards, PrintSquawkList, PrintTaskCards, ProgrammeAccomplishmentCreate, ProgrammeAccomplishmentCreateAccomplishmentErrors, ProgrammeAccomplishmentCreateAccomplishmentResponses, ProgrammeAccomplishmentDeleteAccomplishmentErrors, ProgrammeAccomplishmentDeleteAccomplishmentResponses, ProgrammeAccomplishmentListAccomplishmentsErrors, ProgrammeAccomplishmentListAccomplishmentsResponses, ProgrammeCheckBase, ProgrammeCreate, ProgrammeDraftRevisionCreate, ProgrammeEnrolmentCreate, ProgrammeRevisionRelease, ProgrammesBulkChange, ProgrammeTaskBase, PurchaseOrderCreate, PurchaseOrderCreatePurchaseOrderErrors, PurchaseOrderCreatePurchaseOrderResponses, PurchaseOrderExportPurchaseOrderPdfErrors, PurchaseOrderExportPurchaseOrderPdfResponses, PurchaseOrderGetPurchaseOrderErrors, PurchaseOrderGetPurchaseOrderResponses, PurchaseOrderListPurchaseOrdersErrors, PurchaseOrderListPurchaseOrdersResponses, QuoteActivityListActivityErrors, QuoteActivityListActivityResponses, QuoteChargesSearchAvrefPricesErrors, QuoteChargesSearchAvrefPricesResponses, QuoteChargesSetAvrefPriceErrors, QuoteChargesSetAvrefPriceResponses, QuoteChargesSetInventoryPriceErrors, QuoteChargesSetInventoryPriceResponses, QuoteChargesSuggestOutsideServicePricesErrors, QuoteChargesSuggestOutsideServicePricesResponses, QuoteCommentCreate, QuoteCommentsCountByTaskErrors, QuoteCommentsCountByTaskResponses, QuoteCommentsCreateErrors, QuoteCommentsCreateResponses, QuoteCommentsDeleteErrors, QuoteCommentsDeleteResponses, QuoteCommentsListCommentsErrors, QuoteCommentsListCommentsResponses, QuoteCommentsUpdateErrors, QuoteCommentsUpdateResponses, QuoteCommentUpdate, QuoteCreate, QuoteDispositionChange, QuoteDispositionKind, QuoteDispositionsListQuoteDispositionsResponses, QuoteDispositionsUpdateErrors, QuoteDispositionsUpdateResponses, QuoteDispositionUpdate, QuoteExportFormat, QuoteFeeTemplateCreate, QuoteFeeTemplatesCreateErrors, QuoteFeeTemplatesCreateResponses, QuoteFeeTemplatesDeleteErrors, QuoteFeeTemplatesDeleteResponses, QuoteFeeTemplatesGetErrors, QuoteFeeTemplatesGetResponses, QuoteFeeTemplatesListQuoteFeeTemplatesErrors, QuoteFeeTemplatesListQuoteFeeTemplatesResponses, QuoteFeeTemplatesUpdateErrors, QuoteFeeTemplatesUpdateResponses, QuoteFeeTemplateUpdate, QuoteGrouping, QuoteKind, QuoteNumberSequenceGetQuoteNumberSequenceResponses, QuoteNumberSequenceUpsert, QuoteNumberSequenceUpsertQuoteNumberSequenceErrors, QuoteNumberSequenceUpsertQuoteNumberSequenceResponses, QuoteOrder, QuotePayerAllocationCreate, QuotePayerAllocationsCreateErrors, QuotePayerAllocationsCreateResponses, QuotePayerAllocationsDeleteErrors, QuotePayerAllocationsDeleteResponses, QuotePayerAllocationsGetErrors, QuotePayerAllocationsGetResponses, QuotePayerAllocationsListPayerAllocationsErrors, QuotePayerAllocationsListPayerAllocationsResponses, QuotePayerAllocationsUpdateErrors, QuotePayerAllocationsUpdateResponses, QuotePayerAllocationUpdate, QuotePhaseCreate, QuotePhaseOrder, QuotePhasesCreatePhaseErrors, QuotePhasesCreatePhaseResponses, QuotePhasesDeletePhaseErrors, QuotePhasesDeletePhaseResponses, QuotePhasesReorderPhasesErrors, QuotePhasesReorderPhasesResponses, QuotePhasesUpdatePhaseErrors, QuotePhasesUpdatePhaseResponses, QuotePhaseUpdate, QuoteReviewCodeRequest, QuoteReviewCommentCreate, QuoteReviewDecision, QuoteReviewersChange, QuoteReviewsCommentErrors, QuoteReviewsCommentResponses, QuoteReviewsDecideErrors, QuoteReviewsDecideResponses, QuoteReviewSessionCreate, QuoteReviewSignatureCreate, QuoteReviewsLinkErrors, QuoteReviewsLinkResponses, QuoteReviewsOpenSessionErrors, QuoteReviewsOpenSessionResponses, QuoteReviewsProposalErrors, QuoteReviewsProposalResponses, QuoteReviewsSendCodeErrors, QuoteReviewsSendCodeResponses, QuoteReviewsSignedAuthorisationErrors, QuoteReviewsSignedAuthorisationResponses, QuoteReviewsSignErrors, QuoteReviewsSignResponses, QuoteRevisionsGetErrors, QuoteRevisionsGetResponses, QuoteRulesetCreate, QuoteRulesetEvaluationCreate, QuoteRulesetEvaluationResultCreate, QuoteRulesetEvaluationsCreate, QuoteRulesetEvaluationsCreateApplicableErrors, QuoteRulesetEvaluationsCreateApplicableResponses, QuoteRulesetEvaluationsCreateErrors, QuoteRulesetEvaluationsCreateResponses, QuoteRulesetEvaluationsCreateResultErrors, QuoteRulesetEvaluationsCreateResultResponses, QuoteRulesetEvaluationsDeleteErrors, QuoteRulesetEvaluationsDeleteResponses, QuoteRulesetEvaluationsGetErrors, QuoteRulesetEvaluationsGetResponses, QuoteRulesetEvaluationsListEvaluationsErrors, QuoteRulesetEvaluationsListEvaluationsResponses, QuoteRulesetEvaluationsPendingRulesErrors, QuoteRulesetEvaluationsPendingRulesResponses, QuoteRulesetsArchiveErrors, QuoteRulesetsArchiveResponses, QuoteRulesetsCreateErrors, QuoteRulesetsCreateResponses, QuoteRulesetsCreateVersionErrors, QuoteRulesetsCreateVersionResponses, QuoteRulesetsGetErrors, QuoteRulesetsGetResponses, QuoteRulesetsListRulesetsErrors, QuoteRulesetsListRulesetsResponses, QuoteRulesetsListVersionsErrors, QuoteRulesetsListVersionsResponses, QuoteRulesetsUpdateErrors, QuoteRulesetsUpdateResponses, QuoteRulesetUpdate, QuoteRulesetVersionCreate, QuotesApplyUpdateErrors, QuotesApplyUpdateResponses, QuotesArchiveErrors, QuotesArchiveResponses, QuotesChangeDispositionErrors, QuotesChangeDispositionResponses, QuotesCreateErrors, QuotesCreateQuoteFromHubspotDealErrors, QuotesCreateQuoteFromHubspotDealResponses, QuotesCreateResponses, QuotesCreateWorkPackageErrors, QuotesCreateWorkPackageResponses, QuotesDeleteErrors, QuotesDeleteResponses, QuotesDuplicateErrors, QuotesDuplicateResponses, QuotesExportPdfErrors, QuotesExportPdfResponses, QuotesExtractPartsRfpErrors, QuotesExtractPartsRfpResponses, QuotesExtractTasksErrors, QuotesExtractTasksResponses, QuotesFilterOptionsErrors, QuotesFilterOptionsResponses, QuotesFindSimilarPackagesErrors, QuotesFindSimilarPackagesResponses, QuotesGetErrors, QuotesGetHubspotDealErrors, QuotesGetHubspotDealResponses, QuotesGetOverviewErrors, QuotesGetOverviewResponses, QuotesGetResponses, QuotesGetTaxErrors, QuotesGetTaxResponses, QuotesImport, QuotesImportHubspotAttachmentErrors, QuotesImportHubspotAttachmentResponses, QuotesListHubspotDealsErrors, QuotesListHubspotDealsResponses, QuotesListPartHistoryErrors, QuotesListPartHistoryResponses, QuotesListQuotesErrors, QuotesListQuotesResponses, QuotesListRateCardsErrors, QuotesListRateCardsResponses, QuoteSort, QuotesPreviewForCustomerErrors, QuotesPreviewForCustomerResponses, QuotesResendEmailErrors, QuotesResendEmailResponses, QuotesRestoreErrors, QuotesRestoreResponses, QuotesReviewHistoryErrors, QuotesReviewHistoryResponses, QuotesReviewTasksErrors, QuotesReviewTasksResponses, QuotesSendQuoteToSalesforceErrors, QuotesSendQuoteToSalesforceResponses, QuotesSetReviewersErrors, QuotesSetReviewersResponses, QuotesUndoTaskReviewsErrors, QuotesUndoTaskReviewsResponses, QuotesUpdateErrors, QuotesUpdateResponses, QuotesUpdateTaskErrors, QuotesUpdateTaskResponses, QuoteTaskAttachmentDeleteAttachmentErrors, QuoteTaskAttachmentDeleteAttachmentResponses, QuoteTaskAttachmentGetDownloadUrlErrors, QuoteTaskAttachmentGetDownloadUrlResponses, QuoteTaskAttachmentListForQuoteTaskErrors, QuoteTaskAttachmentListForQuoteTaskResponses, QuoteTaskAttachmentUploadForQuoteTaskErrors, QuoteTaskAttachmentUploadForQuoteTaskResponses, QuoteTaskBase, QuoteTaskExtractionCreate, QuoteTaskGroupCreate, QuoteTaskGroupOrder, QuoteTaskGroupsCreate, QuoteTaskGroupsCreateErrors, QuoteTaskGroupsCreateManyErrors, QuoteTaskGroupsCreateManyResponses, QuoteTaskGroupsCreateResponses, QuoteTaskGroupsDeleteErrors, QuoteTaskGroupsDeleteResponses, QuoteTaskGroupsGetErrors, QuoteTaskGroupsGetResponses, QuoteTaskGroupsListQuoteTaskGroupsErrors, QuoteTaskGroupsListQuoteTaskGroupsResponses, QuoteTaskGroupsReorderErrors, QuoteTaskGroupsReorderResponses, QuoteTaskGroupsRestoreErrors, QuoteTaskGroupsRestoreResponses, QuoteTaskGroupsUpdateErrors, QuoteTaskGroupsUpdateResponses, QuoteTaskGroupUpdate, QuoteTaskReview, QuoteTaskReviewUndo, QuoteTasksClassifyTaskGroupsErrors, QuoteTasksClassifyTaskGroupsResponses, QuoteTasksEstimateLabourErrors, QuoteTasksEstimateLabourResponses, QuoteTasksFindSimilarPackagesErrors, QuoteTasksFindSimilarPackagesResponses, QuoteTasksGetPriceHistoryErrors, QuoteTasksGetPriceHistoryResponses, QuoteTasksListPastPartsErrors, QuoteTasksListPastPartsResponses, QuoteTasksMergeTasksErrors, QuoteTasksMergeTasksResponses, QuoteTasksSearchCannedTasksErrors, QuoteTasksSearchCannedTasksResponses, QuoteTasksSuggestPartsErrors, QuoteTasksSuggestPartsResponses, QuoteTaskStepCreate, QuoteTaskStepsCreateTaskStepErrors, QuoteTaskStepsCreateTaskStepResponses, QuoteTaskStepsDeleteTaskStepErrors, QuoteTaskStepsDeleteTaskStepResponses, QuoteTaskStepsUpdateTaskStepErrors, QuoteTaskStepsUpdateTaskStepResponses, QuoteTaskStepUpdate, QuoteUpdate, RateCardCreate, RateCardsCreateErrors, RateCardsCreateResponses, RateCardsDeleteErrors, RateCardsDeleteResponses, RateCardsGetErrors, RateCardsGetResponses, RateCardsListRateCardsErrors, RateCardsListRateCardsResponses, RateCardsRestoreErrors, RateCardsRestoreResponses, RateCardsUpdateErrors, RateCardsUpdateResponses, RateCardUpdate, RemoveSigningPin, RequestOutsideService, RequestWorkTaskPart, ReviewStatus, RolesAssignRoleToUserErrors, RolesAssignRoleToUserResponses, RolesCreateRoleErrors, RolesCreateRoleResponses, RolesDeleteRoleErrors, RolesDeleteRoleResponses, RolesListRolesErrors, RolesListRolesResponses, RolesRemoveRoleFromUserErrors, RolesRemoveRoleFromUserResponses, RolesResetRoleErrors, RolesResetRoleResponses, RolesUpdateRoleErrors, RolesUpdateRoleResponses, SbComplianceExportRequest, SbComplianceType, SbFieldUpdateRequest, SearchRequest, SetAvrefPrice, SetInventoryPrice, SetSigningPin, SeverityFilter, SignerKind, SignOffWorkTasks, SortDirection, SquawkBulkIds, SquawkCommentCreate, SquawkGrouping, SquawkPrintingPrintSquawkCardsErrors, SquawkPrintingPrintSquawkCardsResponses, SquawkPrintingPrintSquawkListErrors, SquawkPrintingPrintSquawkListResponses, SquawkQuoteCreate, SquawksAddCommentErrors, SquawksAddCommentResponses, SquawksApplySuggestionErrors, SquawksApplySuggestionResponses, SquawksApprovalHistoryErrors, SquawksApprovalHistoryResponses, SquawksArchiveErrors, SquawksArchiveManyErrors, SquawksArchiveManyResponses, SquawksArchiveResponses, SquawksCreateErrors, SquawksCreateResponses, SquawksDeleteErrors, SquawksDeleteResponses, SquawksEstimateLabourErrors, SquawksEstimateLabourResponses, SquawksFilterOptionsErrors, SquawksFilterOptionsResponses, SquawksFindDuplicatesErrors, SquawksFindDuplicatesResponses, SquawksGetErrors, SquawksGetPriceHistoryErrors, SquawksGetPriceHistoryResponses, SquawksGetResponses, SquawksListCommentsErrors, SquawksListCommentsResponses, SquawksListPastPartsErrors, SquawksListPastPartsResponses, SquawksListSquawksErrors, SquawksListSquawksGroupedErrors, SquawksListSquawksGroupedResponses, SquawksListSquawksResponses, SquawkSort, SquawksQuoteSquawksErrors, SquawksQuoteSquawksResponses, SquawksRestoreErrors, SquawksRestoreManyErrors, SquawksRestoreManyResponses, SquawksRestoreResponses, SquawksSearchAvrefPricesErrors, SquawksSearchAvrefPricesResponses, SquawksSetAvrefPriceErrors, SquawksSetAvrefPriceResponses, SquawksSuggestDetailsErrors, SquawksSuggestDetailsResponses, SquawkStatusUpdates, SquawksUpdateErrors, SquawksUpdateResponses, SquawksUpdateStatusesErrors, SquawksUpdateStatusesResponses, SquawkUpdate, SquawkUpsert, StartTimer, SuggestedComplianceNoteAcceptSuggestedComplianceNoteRouteErrors, SuggestedComplianceNoteAcceptSuggestedComplianceNoteRouteResponses, SuggestedComplianceNoteCreateComplianceNoteWhenSuggestedComplianceNoteIsAcceptedRouteErrors, SuggestedComplianceNoteCreateComplianceNoteWhenSuggestedComplianceNoteIsAcceptedRouteResponses, SuggestedComplianceNoteEvalGenerateNoteContentByDescriptionErrors, SuggestedComplianceNoteEvalGenerateNoteContentByDescriptionResponses, SuggestedComplianceNoteGenerateNoteContentByDescriptionErrors, SuggestedComplianceNoteGenerateNoteContentByDescriptionResponses, SuggestedComplianceNoteGetLatestSuggestedComplianceNoteByWorkTaskIdAndTypeRouteErrors, SuggestedComplianceNoteGetLatestSuggestedComplianceNoteByWorkTaskIdAndTypeRouteResponses, SuggestedComplianceNoteReadItemErrors, SuggestedComplianceNoteReadItemResponses, SuggestedComplianceNoteType, SuggestedComplianceNoteUpdate, SuggestedComplianceNoteUpdateItemErrors, SuggestedComplianceNoteUpdateItemResponses, TaskTranscriptCategory, TaskTranscriptCreateTieInErrors, TaskTranscriptCreateTieInResponses, TaskTranscriptGetLatestTieInsReferencesErrors, TaskTranscriptGetLatestTieInsReferencesResponses, TaskTranscriptGetTaskTranscriptsByWorkPackageIdErrors, TaskTranscriptGetTaskTranscriptsByWorkPackageIdResponses, TaskTranscriptGetTaskTranscriptsByWorkTaskIdErrors, TaskTranscriptGetTaskTranscriptsByWorkTaskIdResponses, TaskTranscriptGetTieInErrors, TaskTranscriptGetTieInResponses, TaskTranscriptGetTieInsErrors, TaskTranscriptGetTieInsResponses, TaskTranscriptUpdate, TaskTranscriptUpdateItemErrors, TaskTranscriptUpdateItemResponses, TaxRateCreate, TaxRatesCreateErrors, TaxRatesCreateResponses, TaxRatesDeleteErrors, TaxRatesDeleteResponses, TaxRatesGetErrors, TaxRatesGetResponses, TaxRatesListTaxRatesErrors, TaxRatesListTaxRatesResponses, TaxRatesRestoreErrors, TaxRatesRestoreResponses, TaxRatesUpdateErrors, TaxRatesUpdateResponses, TaxRateUpdate, TeamCreate, TeamsCreateErrors, TeamsCreateResponses, TeamsDeleteErrors, TeamsDeleteResponses, TeamsGetErrors, TeamsGetResponses, TeamsListTeamsErrors, TeamsListTeamsResponses, TeamsRestoreErrors, TeamsRestoreResponses, TeamsUpdateErrors, TeamsUpdateResponses, TeamUpdate, TenantAssignRoleToUserErrors, TenantAssignRoleToUserResponses, TenantAssignTenantOwnerErrors, TenantAssignTenantOwnerResponses, TenantCreate, TenantCreateMultipleUsersErrors, TenantCreateMultipleUsersResponses, TenantCreateTenantErrors, TenantCreateTenantResponses, TenantCreateUserByTenantIdErrors, TenantCreateUserByTenantIdResponses, TenantDeleteCompanyLogoErrors, TenantDeleteCompanyLogoResponses, TenantDeleteCurrentCompanyLogoResponses, TenantDeleteUserByTenantIdErrors, TenantDeleteUserByTenantIdResponses, TenantErpConfigCreate, TenantErpConfigUpdate, TenantExportUsersByTenantIdErrors, TenantExportUsersByTenantIdResponses, TenantGetCurrentTenantResponses, TenantGetTenantErrors, TenantGetTenantModulesEnabledResponses, TenantGetTenantOwnerErrors, TenantGetTenantOwnerResponses, TenantGetTenantResponses, TenantGetTenantsErrors, TenantGetTenantsResponses, TenantIndexingIndexTenantErrors, TenantIndexingIndexTenantResponses, TenantIndexingReindexTenantErrors, TenantIndexingReindexTenantResponses, TenantIntegrationConfigCreate, TenantIntegrationConfigsCreateErrors, TenantIntegrationConfigsCreateResponses, TenantIntegrationConfigsDeleteErrors, TenantIntegrationConfigsDeleteResponses, TenantIntegrationConfigsGetErrors, TenantIntegrationConfigsGetHubspotConfigErrors, TenantIntegrationConfigsGetHubspotConfigResponses, TenantIntegrationConfigsGetHubspotEligibilityErrors, TenantIntegrationConfigsGetHubspotEligibilityResponses, TenantIntegrationConfigsGetHubspotPropertyMappingErrors, TenantIntegrationConfigsGetHubspotPropertyMappingResponses, TenantIntegrationConfigsGetHubspotQuotingConfigErrors, TenantIntegrationConfigsGetHubspotQuotingConfigResponses, TenantIntegrationConfigsGetResponses, TenantIntegrationConfigsListConfigsResponses, TenantIntegrationConfigsSetHubspotEligibilityErrors, TenantIntegrationConfigsSetHubspotEligibilityResponses, TenantIntegrationConfigsSetHubspotPropertyMappingErrors, TenantIntegrationConfigsSetHubspotPropertyMappingResponses, TenantIntegrationConfigsSetHubspotQuotingConfigErrors, TenantIntegrationConfigsSetHubspotQuotingConfigResponses, TenantIntegrationConfigsSetHubspotWebhookSecretErrors, TenantIntegrationConfigsSetHubspotWebhookSecretResponses, TenantIntegrationConfigsUpdateErrors, TenantIntegrationConfigsUpdateResponses, TenantIntegrationConfigUpdate, TenantListRolesErrors, TenantListRolesResponses, TenantOwnerAssign, TenantProfile, TenantQuotingSettingsGetTenantQuotingSettingsResponses, TenantQuotingSettingsUpsert, TenantQuotingSettingsUpsertTenantQuotingSettingsErrors, TenantQuotingSettingsUpsertTenantQuotingSettingsResponses, TenantReadUsersByTenantIdErrors, TenantReadUsersByTenantIdResponses, TenantRemoveRoleFromUserErrors, TenantRemoveRoleFromUserResponses, TenantResendLoginEmailByTenantIdErrors, TenantResendLoginEmailByTenantIdResponses, TenantUpdate, TenantUpdateCurrentTenantErrors, TenantUpdateCurrentTenantResponses, TenantUpdateTenantErrors, TenantUpdateTenantResponses, TenantUpdateUserByTenantIdErrors, TenantUpdateUserByTenantIdResponses, TenantUploadCompanyLogoErrors, TenantUploadCompanyLogoResponses, TenantUploadCurrentCompanyLogoErrors, TenantUploadCurrentCompanyLogoResponses, TieInAgentCreate, TieInReferenceType, TimeEntryCreate, TimeEntryCreateTimeEntryErrors, TimeEntryCreateTimeEntryResponses, TimeEntryDeleteTimeEntryErrors, TimeEntryDeleteTimeEntryResponses, TimeEntryGetTaskTimeErrors, TimeEntryGetTaskTimeResponses, TimeEntryGrouping, TimeEntryListRecentTimeEntryTasksResponses, TimeEntryListTimeEntriesErrors, TimeEntryListTimeEntriesResponses, TimeEntryListTimeEntryFilterOptionsErrors, TimeEntryListTimeEntryFilterOptionsResponses, TimeEntrySearchTimeEntryTasksErrors, TimeEntrySearchTimeEntryTasksResponses, TimeEntryStatus, TimerGetTimerResponses, TimerPauseTimerResponses, TimerResumeTimerResponses, TimerStartTimerErrors, TimerStartTimerResponses, TimerStopTimerResponses, TimerStopTimerTaskErrors, TimerStopTimerTaskResponses, ToolCalibrationComplete, ToolCalibrationCreate, ToolCategoriesCreateToolCategoryErrors, ToolCategoriesCreateToolCategoryResponses, ToolCategoriesDeleteToolCategoryErrors, ToolCategoriesDeleteToolCategoryResponses, ToolCategoriesListToolCategoriesErrors, ToolCategoriesListToolCategoriesResponses, ToolCategoriesRestoreToolCategoryErrors, ToolCategoriesRestoreToolCategoryResponses, ToolCategoriesUpdateToolCategoryErrors, ToolCategoriesUpdateToolCategoryResponses, ToolCategoryCreate, ToolCategoryUpdate, ToolCreate, ToolDocumentCreate, ToolIssue, ToolLoanUpdate, ToolReceive, ToolsAddToolCalibrationErrors, ToolsAddToolCalibrationResponses, ToolsAddToolDocumentErrors, ToolsAddToolDocumentResponses, ToolsCompleteToolCalibrationErrors, ToolsCompleteToolCalibrationResponses, ToolsCreateToolErrors, ToolsCreateToolResponses, ToolsGetToolErrors, ToolsGetToolResponses, ToolsIssueToolErrors, ToolsIssueToolResponses, ToolsListToolsErrors, ToolsListToolsResponses, ToolsReceiveToolErrors, ToolsReceiveToolResponses, ToolsRemoveToolDocumentErrors, ToolsRemoveToolDocumentResponses, ToolsRestoreToolErrors, ToolsRestoreToolResponses, ToolsRetireToolErrors, ToolsRetireToolResponses, ToolsUndoToolIssueErrors, ToolsUndoToolIssueResponses, ToolsUpdateToolErrors, ToolsUpdateToolLoanErrors, ToolsUpdateToolLoanResponses, ToolsUpdateToolResponses, ToolUpdate, TraceAdEvalReportCreate, TraceAdEvalReportsCreateItemErrors, TraceAdEvalReportsCreateItemResponses, TraceAdEvalReportsFinalizeFieldErrors, TraceAdEvalReportsFinalizeFieldResponses, TraceAdEvalReportsGetReportsByTraceIdErrors, TraceAdEvalReportsGetReportsByTraceIdResponses, TraceAdEvalReportsGetReportsByTraceResponses, TraceAdEvalReportsReadItemErrors, TraceAdEvalReportsReadItemResponses, TraceAdEvalReportsUnfinalizeFieldErrors, TraceAdEvalReportsUnfinalizeFieldResponses, TraceAdEvalReportsUpdateFieldErrors, TraceAdEvalReportsUpdateFieldResponses, TraceAttachmentAttachExistingDocumentsErrors, TraceAttachmentAttachExistingDocumentsResponses, TraceAttachmentReadSandboxAttachmentErrors, TraceAttachmentReadSandboxAttachmentResponses, TraceAttachmentUploadAttachmentErrors, TraceAttachmentUploadAttachmentResponses, TraceAttachmentUploadSandboxAttachmentErrors, TraceAttachmentUploadSandboxAttachmentResponses, TraceAudioErrors, TraceAudioResponses, TraceAvailableIntentsResponses, TraceAvailableIntentsV2Responses, TraceAvailableModesResponses, TracesArchiveItemErrors, TracesArchiveItemResponses, TraceSbEvalReportCreate, TraceSbEvalReportsCreateItemErrors, TraceSbEvalReportsCreateItemResponses, TraceSbEvalReportsFinalizeFieldErrors, TraceSbEvalReportsFinalizeFieldResponses, TraceSbEvalReportsGetReportsByTraceResponses, TraceSbEvalReportsReadItemErrors, TraceSbEvalReportsReadItemResponses, TraceSbEvalReportsUnfinalizeFieldErrors, TraceSbEvalReportsUnfinalizeFieldResponses, TraceSbEvalReportsUpdateFieldErrors, TraceSbEvalReportsUpdateFieldResponses, TraceScope, TracesCreateDraftTraceErrors, TracesCreateDraftTraceResponses, TracesDeleteItemErrors, TracesDeleteItemResponses, TracesReadItemErrors, TracesReadItemResponses, TracesReadTraceMessagesErrors, TracesReadTraceMessagesResponses, TracesReadUserTracesErrors, TracesReadUserTracesResponses, TracesRestoreItemErrors, TracesRestoreItemResponses, TracesSearchTracesErrors, TracesSearchTracesResponses, TracesSetTraceWorkTasksEndpointErrors, TracesSetTraceWorkTasksEndpointResponses, TracesUpdateItemErrors, TracesUpdateItemResponses, TraceTraceActivityErrors, TraceTraceActivityResponses, TraceTranscribeErrors, TraceTranscribeResponses, TraceUpdate, TraceWorkTasksUpdate, TypeCertificateGetVariantErrors, TypeCertificateGetVariantResponses, TypeCertificateListGroupedErrors, TypeCertificateListGroupedResponses, TypeCertificateResolveErrors, TypeCertificateResolveResponses, TypeCertificateTriggerAssignAllAircraftErrors, TypeCertificateTriggerAssignAllAircraftResponses, TypeCertificateTriggerAssignAllWorkPackagesErrors, TypeCertificateTriggerAssignAllWorkPackagesResponses, UpdateAtlPage, UpdatePassword, UpdateProgramme, UpdateProgrammeRevision, UpdateQuote, UserCreate, UserRoleCreate, UsersBulkCreate, UsersCreateMultipleUsersErrors, UsersCreateMultipleUsersResponses, UsersCreateUserErrors, UsersCreateUserResponses, UsersDeleteUserErrors, UsersDeleteUserMeResponses, UsersDeleteUserResponses, UsersExportUsersErrors, UsersExportUsersResponses, UsersListInspectorsErrors, UsersListInspectorsResponses, UsersListQuoteReviewersErrors, UsersListQuoteReviewersResponses, UsersListReportersErrors, UsersListReportersResponses, UsersListSalesRepsErrors, UsersListSalesRepsResponses, UserSortField, UsersReadUserByIdErrors, UsersReadUserByIdResponses, UsersReadUserMeResponses, UsersReadUsersErrors, UsersReadUsersResponses, UsersRemoveSigningPinMeErrors, UsersRemoveSigningPinMeResponses, UsersResendLoginEmailErrors, UsersResendLoginEmailResponses, UsersSetSigningPinMeErrors, UsersSetSigningPinMeResponses, UsersUpdatePasswordMeErrors, UsersUpdatePasswordMeResponses, UsersUpdateUserErrors, UsersUpdateUserMeErrors, UsersUpdateUserMeResponses, UsersUpdateUserResponses, UserUpdate, UserUpdateMe, UtilizationCreate, UtilizationCreateAircraftReadingErrors, UtilizationCreateAircraftReadingResponses, UtilizationCreatePartInstanceReadingErrors, UtilizationCreatePartInstanceReadingResponses, UtilizationDeleteAircraftReadingErrors, UtilizationDeleteAircraftReadingResponses, UtilizationDeletePartInstanceReadingErrors, UtilizationDeletePartInstanceReadingResponses, UtilizationListAircraftReadingsErrors, UtilizationListAircraftReadingsResponses, UtilizationListPartInstanceReadingsErrors, UtilizationListPartInstanceReadingsResponses, UtilizationRecordAircraftReadingErrors, UtilizationRecordAircraftReadingResponses, UtilizationUpdate, UtilizationUpdateAircraftReadingErrors, UtilizationUpdateAircraftReadingResponses, UtilizationUpdatePartInstanceReadingErrors, UtilizationUpdatePartInstanceReadingResponses, UtilsHealthCheckResponses, VendorStatus, Visibility, WebhooksHandleReductoWebhookResponses, WebhooksHealthReductoWebhookResponses, WorkflowCreate, WorkflowsCreateErrors, WorkflowsCreateResponses, WorkflowsDeleteErrors, WorkflowsDeleteResponses, WorkflowsGetErrors, WorkflowsGetResponses, WorkflowsListWorkflowsErrors, WorkflowsListWorkflowsResponses, WorkflowStepCreate, WorkflowStepsCreateStepErrors, WorkflowStepsCreateStepResponses, WorkflowStepsDeleteStepErrors, WorkflowStepsDeleteStepResponses, WorkflowStepsListStepsErrors, WorkflowStepsListStepsResponses, WorkflowStepsUpdateStepErrors, WorkflowStepsUpdateStepResponses, WorkflowStepUpdate, WorkflowsUpdateErrors, WorkflowsUpdateResponses, WorkflowUpdate, WorkOrderIntake, WorkOrderIntakeCreateWorkOrderErrors, WorkOrderIntakeCreateWorkOrderResponses, WorkOrderIntakeExtractWorkOrderErrors, WorkOrderIntakeExtractWorkOrderResponses, WorkPackageActivityListActivityErrors, WorkPackageActivityListActivityResponses, WorkPackageArchiveItemErrors, WorkPackageArchiveItemResponses, WorkPackageClassificationClassifyErrors, WorkPackageClassificationClassifyResponses, WorkPackageClassificationSet, WorkPackageClassificationSetClassificationErrors, WorkPackageClassificationSetClassificationResponses, WorkPackageCreate, WorkPackageCreateItemErrors, WorkPackageCreateItemResponses, WorkPackageDeleteItemErrors, WorkPackageDeleteItemResponses, WorkPackageFilter, WorkPackageGrouping, WorkPackageKind, WorkPackageLifecycleChangeWorkPackageStatusErrors, WorkPackageLifecycleChangeWorkPackageStatusResponses, WorkPackageLifecycleClearWorkPackageAogErrors, WorkPackageLifecycleClearWorkPackageAogResponses, WorkPackageLifecycleCloseWorkPackageErrors, WorkPackageLifecycleCloseWorkPackageResponses, WorkPackageLifecycleCloseWorkPackagesErrors, WorkPackageLifecycleCloseWorkPackagesResponses, WorkPackageLifecycleCloseWorkPackageTasksErrors, WorkPackageLifecycleCloseWorkPackageTasksResponses, WorkPackageLifecycleMarkWorkPackageAogErrors, WorkPackageLifecycleMarkWorkPackageAogResponses, WorkPackageListRateCardsErrors, WorkPackageListRateCardsResponses, WorkPackageNumberSequenceGetWorkPackageNumberSequenceResponses, WorkPackageNumberSequenceUpsert, WorkPackageNumberSequenceUpsertWorkPackageNumberSequenceErrors, WorkPackageNumberSequenceUpsertWorkPackageNumberSequenceResponses, WorkPackagePhaseCreate, WorkPackagePhaseOrder, WorkPackagePhasesCreatePhaseErrors, WorkPackagePhasesCreatePhaseResponses, WorkPackagePhasesDeletePhaseErrors, WorkPackagePhasesDeletePhaseResponses, WorkPackagePhasesReorderPhasesErrors, WorkPackagePhasesReorderPhasesResponses, WorkPackagePhasesUpdatePhaseErrors, WorkPackagePhasesUpdatePhaseResponses, WorkPackagePhaseUpdate, WorkPackagePrintingPrintTaskCardsErrors, WorkPackagePrintingPrintTaskCardsResponses, WorkPackagePrintingPrintWorkPackErrors, WorkPackagePrintingPrintWorkPackResponses, WorkPackagePriority, WorkPackageReadGroupedErrors, WorkPackageReadGroupedResponses, WorkPackageReadItemErrors, WorkPackageReadItemResponses, WorkPackageReadItemsErrors, WorkPackageReadItemsResponses, WorkPackageReadWithTasksErrors, WorkPackageReadWithTasksResponses, WorkPackageRestoreItemErrors, WorkPackageRestoreItemResponses, WorkPackageScope, WorkPackageSettingsGetWorkPackageSettingsResponses, WorkPackageSettingsUpsert, WorkPackageSettingsUpsertWorkPackageSettingsErrors, WorkPackageSettingsUpsertWorkPackageSettingsResponses, WorkPackageStatus, WorkPackageSubjectsResponses, WorkPackageSubscribeToWorkPackageErrors, WorkPackageSubscribeToWorkPackageResponses, WorkPackageTransition, WorkPackageUnsubscribeFromWorkPackageErrors, WorkPackageUnsubscribeFromWorkPackageResponses, WorkPackageUpdate, WorkPackageUpdateItemErrors, WorkPackageUpdateItemResponses, WorkPackageView, Workscope, WorkTaskAssignErrors, WorkTaskAssignResponses, WorkTaskChangeStatusErrors, WorkTaskChangeStatusResponses, WorkTaskCreate, WorkTaskCreateItemErrors, WorkTaskCreateItemResponses, WorkTaskDeleteItemsErrors, WorkTaskDeleteItemsResponses, WorkTaskGetWorkTaskByErpExternalIdErrors, WorkTaskGetWorkTaskByErpExternalIdResponses, WorkTaskGetWorkTaskByWorkPackageIdErrors, WorkTaskGetWorkTaskByWorkPackageIdResponses, WorkTaskNoteCreate, WorkTaskNotesCreateNoteErrors, WorkTaskNotesCreateNoteResponses, WorkTaskOutsideServicesMoveOutsideServiceErrors, WorkTaskOutsideServicesMoveOutsideServiceResponses, WorkTaskOutsideServicesRequestOutsideServiceErrors, WorkTaskOutsideServicesRequestOutsideServiceResponses, WorkTaskOutsideServicesUpdateOutsideServiceErrors, WorkTaskOutsideServicesUpdateOutsideServiceResponses, WorkTaskOutsideServicesWithdrawOutsideServiceErrors, WorkTaskOutsideServicesWithdrawOutsideServiceResponses, WorkTaskOutsideServiceUpdate, WorkTaskPartsIssuePartErrors, WorkTaskPartsIssuePartResponses, WorkTaskPartsListPartsErrors, WorkTaskPartsListPartsResponses, WorkTaskPartsRequestPartErrors, WorkTaskPartsRequestPartResponses, WorkTaskPartsUpdatePartErrors, WorkTaskPartsUpdatePartResponses, WorkTaskPartsWithdrawPartErrors, WorkTaskPartsWithdrawPartResponses, WorkTaskPartUpdate, WorkTaskReadItemErrors, WorkTaskReadItemResponses, WorkTaskReadItemsErrors, WorkTaskReadItemsResponses, WorkTaskSearchWorkTasksErrors, WorkTaskSearchWorkTasksResponses, WorkTaskSignature, WorkTaskSignOffInspectTaskErrors, WorkTaskSignOffInspectTaskResponses, WorkTaskSignOffListSignersErrors, WorkTaskSignOffListSignersResponses, WorkTaskSignOffSignOffTaskErrors, WorkTaskSignOffSignOffTaskResponses, WorkTaskSignOffSignOffTasksErrors, WorkTaskSignOffSignOffTasksResponses, WorkTaskSignOffTaskSignOffHistoryErrors, WorkTaskSignOffTaskSignOffHistoryResponses, WorkTaskSignOffUndoTaskInspectionErrors, WorkTaskSignOffUndoTaskInspectionResponses, WorkTaskSignOffUndoTaskSignOffErrors, WorkTaskSignOffUndoTaskSignOffResponses, WorkTaskStatusChange, WorkTaskStepCreate, WorkTaskStepInspection, WorkTaskStepsCreateStepErrors, WorkTaskStepsCreateStepResponses, WorkTaskStepsDeleteStepErrors, WorkTaskStepsDeleteStepResponses, WorkTaskStepSignOff, WorkTaskStepsInspectStepErrors, WorkTaskStepsInspectStepResponses, WorkTaskStepsSignOffStepErrors, WorkTaskStepsSignOffStepResponses, WorkTaskStepsUndoStepInspectionErrors, WorkTaskStepsUndoStepInspectionResponses, WorkTaskStepsUndoStepSignOffErrors, WorkTaskStepsUndoStepSignOffResponses, WorkTaskStepsUpdateStepErrors, WorkTaskStepsUpdateStepResponses, WorkTaskStepUpdate, WorkTaskUpdate, WorkTaskUpdateItemErrors, WorkTaskUpdateItemResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export class AcceptedAdAssessmentsService {
    /**
     * Accept Assessment
     *
     * Accept a TraceAdEvalReport as the final assessment for an aircraft+AD.
     *
     * The TraceAdEvalReport must:
     * - Have status='completed'
     * - Have all 6 fields finalized
     * - Have an aircraft_id assigned
     *
     * If an existing accepted assessment exists for the same aircraft+AD,
     * it will be superseded (not deleted) for audit purposes.
     */
    public static acceptAssessment<ThrowOnError extends boolean = false>(parameters: {
        acceptedAdAssessmentCreate: AcceptedAdAssessmentCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<AcceptedAdAssessmentsAcceptAssessmentResponses, AcceptedAdAssessmentsAcceptAssessmentErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'acceptedAdAssessmentCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<AcceptedAdAssessmentsAcceptAssessmentResponses, AcceptedAdAssessmentsAcceptAssessmentErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/accepted-ad-assessments/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Get Ad Compliance For Aircraft
     *
     * Get all accepted AD assessments for an aircraft in table format.
     *
     * Returns rows formatted for the AD Compliance tab with filtering and sorting.
     */
    public static getAdComplianceForAircraft<ThrowOnError extends boolean = false>(parameters: {
        aircraft_id: string;
        skip?: number;
        limit?: number;
        recurrent?: boolean | null;
        applicability?: boolean | null;
        regulatory_authority?: Array<'AAC CD' | 'AAC PA' | 'AAC RM' | 'AAC SV' | 'AACM' | 'AACR' | 'AAN' | 'ACAA' | 'AESA' | 'ANAC AR' | 'ANAC BR' | 'ANAC CI' | 'ANAC DJ' | 'ANAC GA' | 'ANAC GN' | 'ANAC ML' | 'ANAC MR' | 'ANAC Niger' | 'ANAC PT' | 'ANAC Senegal' | 'ANAC Togo' | 'ASECNA' | 'BHDCA' | 'CAA AL' | 'CAA BG' | 'CAA BH' | 'CAA CR' | 'CAA LT' | 'CAA LV' | 'CAA LY' | 'CAA MK' | 'CAA MNE' | 'CAA MV' | 'CAA NO' | 'CAA NZ' | 'CAA Pakistan' | 'CAA QA' | 'CAA RT' | 'CAA SI' | 'CAA SL' | 'CAA SR' | 'CAA TW' | 'CAA UK' | 'CAA Uganda' | 'CAAB BD' | 'CAAB BW' | 'CAAC' | 'CAAE' | 'CAAF' | 'CAAH' | 'CAAI' | 'CAAM MN' | 'CAAM MW' | 'CAAM MY' | 'CAAN' | 'CAAP' | 'CAAS' | 'CAASI' | 'CAAT' | 'CAAV VN' | 'CAAV VU' | 'CAAZ ZM' | 'CAAZ ZW' | 'CAD HK' | 'CAD MT' | 'CAD RS' | 'CAMA' | 'CAO.IRI' | 'CARC' | 'CASA' | 'CASA PNG' | 'CASAS' | 'CCAA' | 'DAC' | 'DCA BN' | 'DCA CY' | 'DCA LA' | 'DCA MM' | 'DGAC BO' | 'DGAC CL' | 'DGAC CR' | 'DGAC DZ' | 'DGAC EC' | 'DGAC FR' | 'DGAC GT' | 'DGAC HN' | 'DGAC MX' | 'DGAC PE' | 'DGAC TN' | 'DGCA ID' | 'DGCA IN' | 'DGCA KW' | 'DGCA LB' | 'DGCA TR' | 'DGTA/DGLV' | 'DINAC' | 'DINACIA' | 'EASA' | 'ECAA EE' | 'ECAA EG' | 'ECAA ET' | 'ENAC' | 'FAA' | 'FOCA' | 'GACA' | 'GCAA AE' | 'GCAA GE' | 'GCAA GH' | 'GCAA GM' | 'GDCA' | 'HCAA' | 'IAA' | 'IACC' | 'ICAA' | 'ICETRA' | 'IDAC' | 'ILT' | 'INAC NI' | 'INAC VE' | 'INAVIC' | 'JCAA' | 'JCAB' | 'KCAA KE' | 'KCAA KR' | 'LBA' | 'LCAA LR' | 'LCAA LS' | 'MAA' | 'MCA' | 'Ministry of Transport and Communications' | 'MoIC' | 'NCAA NA' | 'NCAA NG' | 'OACM' | 'OCA' | 'ONDA' | 'PACA' | 'RCAA' | 'Rosaviation' | 'SAA' | 'SAAU' | 'SACA' | 'SACAA' | 'SCAA AZ' | 'SCAA SC' | 'SCAA SD' | 'SCAA SY' | 'SCAST' | 'SLCAA LC' | 'SLCAA SL' | 'SMCAA' | 'SSCA' | 'SSCAA' | 'TCAA' | 'TCCA' | 'TTCAA' | 'Traficom' | 'Transportstyrelsen' | 'UAEAC' | 'ULC' | 'UzCAA'> | null;
        search?: string | null;
        order_by?: string;
        order_direction?: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<AcceptedAdAssessmentsGetAdComplianceForAircraftResponses, AcceptedAdAssessmentsGetAdComplianceForAircraftErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'aircraft_id' },
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'recurrent' },
                    { in: 'query', key: 'applicability' },
                    { in: 'query', key: 'regulatory_authority' },
                    { in: 'query', key: 'search' },
                    { in: 'query', key: 'order_by' },
                    { in: 'query', key: 'order_direction' }
                ] }]);
        return (options?.client ?? client).get<AcceptedAdAssessmentsGetAdComplianceForAircraftResponses, AcceptedAdAssessmentsGetAdComplianceForAircraftErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/accepted-ad-assessments/aircraft/{aircraft_id}',
            ...options,
            ...params
        });
    }
}

export class AcceptedSbAssessmentsService {
    /**
     * Accept Assessment
     *
     * Accept a TraceSbEvalReport as the final assessment for an aircraft+SB.
     *
     * The TraceSbEvalReport must:
     * - Have all 10 fields finalized
     * - Have an aircraft_id assigned
     */
    public static acceptAssessment<ThrowOnError extends boolean = false>(parameters: {
        acceptedSbAssessmentCreate: AcceptedSbAssessmentCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<AcceptedSbAssessmentsAcceptAssessmentResponses, AcceptedSbAssessmentsAcceptAssessmentErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'acceptedSbAssessmentCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<AcceptedSbAssessmentsAcceptAssessmentResponses, AcceptedSbAssessmentsAcceptAssessmentErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/accepted-sb-assessments/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Get Sb Compliance For Aircraft
     *
     * Get all accepted SB assessments for an aircraft in table format.
     */
    public static getSbComplianceForAircraft<ThrowOnError extends boolean = false>(parameters: {
        aircraft_id: string;
        skip?: number;
        limit?: number;
        search?: string | null;
        accepted_by_id?: Array<string> | null;
        accepted_from?: string | null;
        accepted_to?: string | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<AcceptedSbAssessmentsGetSbComplianceForAircraftResponses, AcceptedSbAssessmentsGetSbComplianceForAircraftErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'aircraft_id' },
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'search' },
                    { in: 'query', key: 'accepted_by_id' },
                    { in: 'query', key: 'accepted_from' },
                    { in: 'query', key: 'accepted_to' }
                ] }]);
        return (options?.client ?? client).get<AcceptedSbAssessmentsGetSbComplianceForAircraftResponses, AcceptedSbAssessmentsGetSbComplianceForAircraftErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/accepted-sb-assessments/aircraft/{aircraft_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Export Sb Compliance Report
     */
    public static exportSbComplianceReport<ThrowOnError extends boolean = false>(parameters: {
        aircraft_id: string;
        sbComplianceExportRequest: SbComplianceExportRequest;
    }, options?: Options<never, ThrowOnError>): RequestResult<AcceptedSbAssessmentsExportSbComplianceReportResponses, AcceptedSbAssessmentsExportSbComplianceReportErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'aircraft_id' }, { key: 'sbComplianceExportRequest', map: 'body' }] }]);
        return (options?.client ?? client).post<AcceptedSbAssessmentsExportSbComplianceReportResponses, AcceptedSbAssessmentsExportSbComplianceReportErrors, ThrowOnError>({
            responseType: 'blob',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/accepted-sb-assessments/aircraft/{aircraft_id}/export',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class AdComplianceHistoryService {
    /**
     * Read AdComplianceHistories
     */
    public static readItems<ThrowOnError extends boolean = false>(parameters?: {
        skip?: number;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<AdComplianceHistoryReadItemsResponses, AdComplianceHistoryReadItemsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'query', key: 'skip' }, { in: 'query', key: 'limit' }] }]);
        return (options?.client ?? client).get<AdComplianceHistoryReadItemsResponses, AdComplianceHistoryReadItemsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/ad-compliance-history/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create AdComplianceHistory
     */
    public static createItem<ThrowOnError extends boolean = false>(parameters: {
        adComplianceHistoryCreate: AdComplianceHistoryCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<AdComplianceHistoryCreateItemResponses, AdComplianceHistoryCreateItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'adComplianceHistoryCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<AdComplianceHistoryCreateItemResponses, AdComplianceHistoryCreateItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/ad-compliance-history/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete AdComplianceHistory
     */
    public static deleteItem<ThrowOnError extends boolean = false>(parameters: {
        id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<AdComplianceHistoryDeleteItemResponses, AdComplianceHistoryDeleteItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'id' }] }]);
        return (options?.client ?? client).delete<AdComplianceHistoryDeleteItemResponses, AdComplianceHistoryDeleteItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/ad-compliance-history/{id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Read AdComplianceHistory
     */
    public static readItem<ThrowOnError extends boolean = false>(parameters: {
        id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<AdComplianceHistoryReadItemResponses, AdComplianceHistoryReadItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'id' }] }]);
        return (options?.client ?? client).get<AdComplianceHistoryReadItemResponses, AdComplianceHistoryReadItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/ad-compliance-history/{id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update AdComplianceHistory
     */
    public static updateItem<ThrowOnError extends boolean = false>(parameters: {
        id: string;
        adComplianceHistoryUpdate: AdComplianceHistoryUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<AdComplianceHistoryUpdateItemResponses, AdComplianceHistoryUpdateItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'id' }, { key: 'adComplianceHistoryUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<AdComplianceHistoryUpdateItemResponses, AdComplianceHistoryUpdateItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/ad-compliance-history/{id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class AdRecordService {
    /**
     * Trigger Backfill
     */
    public static triggerBackfill<ThrowOnError extends boolean = false>(parameters: {
        from_date: string;
        to_date: string;
        on_existing?: OnExisting;
    }, options?: Options<never, ThrowOnError>): RequestResult<AdRecordTriggerBackfillResponses, AdRecordTriggerBackfillErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'from_date' },
                    { in: 'path', key: 'to_date' },
                    { in: 'query', key: 'on_existing' }
                ] }]);
        return (options?.client ?? client).post<AdRecordTriggerBackfillResponses, AdRecordTriggerBackfillErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/ad-record/trigger-backfill/{from_date}/{to_date}',
            ...options,
            ...params
        });
    }
}

export class LoginService {
    /**
     * Admin Reset Password
     *
     * Admin-initiated password reset for users without email or emergency access.
     * Requires users:reset_password permission.
     */
    public static adminResetPassword<ThrowOnError extends boolean = false>(parameters: {
        adminPasswordReset: AdminPasswordReset;
    }, options?: Options<never, ThrowOnError>): RequestResult<LoginAdminResetPasswordResponses, LoginAdminResetPasswordErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'adminPasswordReset', map: 'body' }] }]);
        return (options?.client ?? client).post<LoginAdminResetPasswordResponses, LoginAdminResetPasswordErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/admin-reset-password',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Get Password Policy
     */
    public static getPasswordPolicy<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<LoginGetPasswordPolicyResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<LoginGetPasswordPolicyResponses, unknown, ThrowOnError>({
            responseType: 'json',
            url: '/api/v1/auth/password-policy',
            ...options
        });
    }
    
    /**
     * Get Session Freshness
     */
    public static getSessionFreshness<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<LoginGetSessionFreshnessResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<LoginGetSessionFreshnessResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/auth/session/freshness',
            ...options
        });
    }
    
    /**
     * Login Access Token
     */
    public static loginAccessToken<ThrowOnError extends boolean = false>(parameters: {
        bodyLoginLoginAccessToken: BodyLoginLoginAccessToken;
    }, options?: Options<never, ThrowOnError>): RequestResult<LoginLoginAccessTokenResponses, LoginLoginAccessTokenErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'bodyLoginLoginAccessToken', map: 'body' }] }]);
        return (options?.client ?? client).post<LoginLoginAccessTokenResponses, LoginLoginAccessTokenErrors, ThrowOnError>({
            ...urlSearchParamsBodySerializer,
            responseType: 'json',
            url: '/api/v1/login/access-token',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Logout
     */
    public static logout<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<LoginLogoutResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).post<LoginLogoutResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/logout',
            ...options
        });
    }
    
    /**
     * Recover Password Html Content
     *
     * HTML Content for Password Recovery
     */
    public static recoverPasswordHtmlContent<ThrowOnError extends boolean = false>(parameters: {
        email: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<LoginRecoverPasswordHtmlContentResponses, LoginRecoverPasswordHtmlContentErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'email' }] }]);
        return (options?.client ?? client).post<LoginRecoverPasswordHtmlContentResponses, LoginRecoverPasswordHtmlContentErrors, ThrowOnError>({
            responseType: 'text',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/password-recovery-html-content/{email}',
            ...options,
            ...params
        });
    }
    
    /**
     * Recover Password
     *
     * Password Recovery
     */
    public static recoverPassword<ThrowOnError extends boolean = false>(parameters: {
        email: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<LoginRecoverPasswordResponses, LoginRecoverPasswordErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'email' }] }]);
        return (options?.client ?? client).post<LoginRecoverPasswordResponses, LoginRecoverPasswordErrors, ThrowOnError>({
            responseType: 'json',
            url: '/api/v1/password-recovery/{email}',
            ...options,
            ...params
        });
    }
    
    /**
     * Reset Password
     *
     * Reset password
     */
    public static resetPassword<ThrowOnError extends boolean = false>(parameters: {
        newPassword: NewPassword;
    }, options?: Options<never, ThrowOnError>): RequestResult<LoginResetPasswordResponses, LoginResetPasswordErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'newPassword', map: 'body' }] }]);
        return (options?.client ?? client).post<LoginResetPasswordResponses, LoginResetPasswordErrors, ThrowOnError>({
            responseType: 'json',
            url: '/api/v1/reset-password/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class AircraftService {
    /**
     * Read Aircrafts
     */
    public static readItems<ThrowOnError extends boolean = false>(parameters?: {
        skip?: number;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<AircraftReadItemsResponses, AircraftReadItemsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'query', key: 'skip' }, { in: 'query', key: 'limit' }] }]);
        return (options?.client ?? client).get<AircraftReadItemsResponses, AircraftReadItemsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/aircraft/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create Aircraft
     */
    public static createItem<ThrowOnError extends boolean = false>(parameters: {
        aircraftCreate: AircraftCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<AircraftCreateItemResponses, AircraftCreateItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'aircraftCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<AircraftCreateItemResponses, AircraftCreateItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/aircraft/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Agent Create Aircraft
     */
    public static agentCreateAircraft<ThrowOnError extends boolean = false>(parameters: {
        aircraftAgentCreate: AircraftAgentCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<AircraftAgentCreateAircraftResponses, AircraftAgentCreateAircraftErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'aircraftAgentCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<AircraftAgentCreateAircraftResponses, AircraftAgentCreateAircraftErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/aircraft/agent-create',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Get Aircraft By Customer
     */
    public static getAircraftByCustomer<ThrowOnError extends boolean = false>(parameters: {
        customer_id: string;
        skip?: number;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<AircraftGetAircraftByCustomerResponses, AircraftGetAircraftByCustomerErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'customer_id' },
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' }
                ] }]);
        return (options?.client ?? client).get<AircraftGetAircraftByCustomerResponses, AircraftGetAircraftByCustomerErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/aircraft/by-customer/{customer_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Read Mod Status By Aircraft
     *
     * Retrieve mod statuses for a specific aircraft.
     */
    public static readModStatusByAircraft<ThrowOnError extends boolean = false>(parameters: {
        aircraft_id: string;
        skip?: number;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<AircraftReadModStatusByAircraftResponses, AircraftReadModStatusByAircraftErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'aircraft_id' },
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' }
                ] }]);
        return (options?.client ?? client).get<AircraftReadModStatusByAircraftResponses, AircraftReadModStatusByAircraftErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/aircraft/mod_status/{aircraft_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Get Fitted Components By Aircraft Id
     */
    public static getFittedComponentsByAircraftId<ThrowOnError extends boolean = false>(parameters: {
        aircraft_id: string;
        skip?: number;
        limit?: number;
        major_assemblies_only?: boolean;
    }, options?: Options<never, ThrowOnError>): RequestResult<AircraftGetFittedComponentsByAircraftIdResponses, AircraftGetFittedComponentsByAircraftIdErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'aircraft_id' },
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'major_assemblies_only' }
                ] }]);
        return (options?.client ?? client).get<AircraftGetFittedComponentsByAircraftIdResponses, AircraftGetFittedComponentsByAircraftIdErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/aircraft/{aircraft_id}/fitted-components',
            ...options,
            ...params
        });
    }
    
    /**
     * Get Mod Status By Aircraft Id
     */
    public static getModStatusByAircraftId<ThrowOnError extends boolean = false>(parameters: {
        aircraft_id: string;
        skip?: number;
        limit?: number;
        search?: string | null;
        status?: Array<ModStatusEnum> | null;
        compliance_type?: Array<SbComplianceType> | null;
        embodied_from?: string | null;
        embodied_to?: string | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<AircraftGetModStatusByAircraftIdResponses, AircraftGetModStatusByAircraftIdErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'aircraft_id' },
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'search' },
                    { in: 'query', key: 'status' },
                    { in: 'query', key: 'compliance_type' },
                    { in: 'query', key: 'embodied_from' },
                    { in: 'query', key: 'embodied_to' }
                ] }]);
        return (options?.client ?? client).get<AircraftGetModStatusByAircraftIdResponses, AircraftGetModStatusByAircraftIdErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/aircraft/{aircraft_id}/mod-status',
            ...options,
            ...params
        });
    }
    
    /**
     * Delete Aircraft
     */
    public static deleteItem<ThrowOnError extends boolean = false>(parameters: {
        id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<AircraftDeleteItemResponses, AircraftDeleteItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'id' }] }]);
        return (options?.client ?? client).delete<AircraftDeleteItemResponses, AircraftDeleteItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/aircraft/{id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Read Aircraft
     */
    public static readItem<ThrowOnError extends boolean = false>(parameters: {
        id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<AircraftReadItemResponses, AircraftReadItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'id' }] }]);
        return (options?.client ?? client).get<AircraftReadItemResponses, AircraftReadItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/aircraft/{id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update Aircraft
     */
    public static updateItem<ThrowOnError extends boolean = false>(parameters: {
        id: string;
        aircraftUpdate: AircraftUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<AircraftUpdateItemResponses, AircraftUpdateItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'id' }, { key: 'aircraftUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<AircraftUpdateItemResponses, AircraftUpdateItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/aircraft/{id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class ProgrammeAccomplishmentService {
    /**
     * List Accomplishments
     */
    public static listAccomplishments<ThrowOnError extends boolean = false>(parameters: {
        aircraft_id: string;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<ProgrammeAccomplishmentListAccomplishmentsResponses, ProgrammeAccomplishmentListAccomplishmentsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'aircraft_id' }, { in: 'query', key: 'limit' }] }]);
        return (options?.client ?? client).get<ProgrammeAccomplishmentListAccomplishmentsResponses, ProgrammeAccomplishmentListAccomplishmentsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/aircraft/{aircraft_id}/programme-accomplishments',
            ...options,
            ...params
        });
    }
    
    /**
     * Create Accomplishment
     */
    public static createAccomplishment<ThrowOnError extends boolean = false>(parameters: {
        aircraft_id: string;
        programmeAccomplishmentCreate: ProgrammeAccomplishmentCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<ProgrammeAccomplishmentCreateAccomplishmentResponses, ProgrammeAccomplishmentCreateAccomplishmentErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'aircraft_id' }, { key: 'programmeAccomplishmentCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<ProgrammeAccomplishmentCreateAccomplishmentResponses, ProgrammeAccomplishmentCreateAccomplishmentErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/aircraft/{aircraft_id}/programme-accomplishments',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete Accomplishment
     */
    public static deleteAccomplishment<ThrowOnError extends boolean = false>(parameters: {
        aircraft_id: string;
        accomplishment_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<ProgrammeAccomplishmentDeleteAccomplishmentResponses, ProgrammeAccomplishmentDeleteAccomplishmentErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'aircraft_id' }, { in: 'path', key: 'accomplishment_id' }] }]);
        return (options?.client ?? client).delete<ProgrammeAccomplishmentDeleteAccomplishmentResponses, ProgrammeAccomplishmentDeleteAccomplishmentErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/aircraft/{aircraft_id}/programme-accomplishments/{accomplishment_id}',
            ...options,
            ...params
        });
    }
}

export class UtilizationService {
    /**
     * List Aircraft Readings
     */
    public static listAircraftReadings<ThrowOnError extends boolean = false>(parameters: {
        aircraft_id: string;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<UtilizationListAircraftReadingsResponses, UtilizationListAircraftReadingsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'aircraft_id' }, { in: 'query', key: 'limit' }] }]);
        return (options?.client ?? client).get<UtilizationListAircraftReadingsResponses, UtilizationListAircraftReadingsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/aircraft/{aircraft_id}/utilization/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create Aircraft Reading
     */
    public static createAircraftReading<ThrowOnError extends boolean = false>(parameters: {
        aircraft_id: string;
        utilizationCreate: UtilizationCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<UtilizationCreateAircraftReadingResponses, UtilizationCreateAircraftReadingErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'aircraft_id' }, { key: 'utilizationCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<UtilizationCreateAircraftReadingResponses, UtilizationCreateAircraftReadingErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/aircraft/{aircraft_id}/utilization/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Record Aircraft Reading
     */
    public static recordAircraftReading<ThrowOnError extends boolean = false>(parameters: {
        aircraft_id: string;
        utilizationCreate: UtilizationCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<UtilizationRecordAircraftReadingResponses, UtilizationRecordAircraftReadingErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'aircraft_id' }, { key: 'utilizationCreate', map: 'body' }] }]);
        return (options?.client ?? client).put<UtilizationRecordAircraftReadingResponses, UtilizationRecordAircraftReadingErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/aircraft/{aircraft_id}/utilization/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete Aircraft Reading
     */
    public static deleteAircraftReading<ThrowOnError extends boolean = false>(parameters: {
        aircraft_id: string;
        utilization_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<UtilizationDeleteAircraftReadingResponses, UtilizationDeleteAircraftReadingErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'aircraft_id' }, { in: 'path', key: 'utilization_id' }] }]);
        return (options?.client ?? client).delete<UtilizationDeleteAircraftReadingResponses, UtilizationDeleteAircraftReadingErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/aircraft/{aircraft_id}/utilization/{utilization_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update Aircraft Reading
     */
    public static updateAircraftReading<ThrowOnError extends boolean = false>(parameters: {
        aircraft_id: string;
        utilization_id: string;
        utilizationUpdate: UtilizationUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<UtilizationUpdateAircraftReadingResponses, UtilizationUpdateAircraftReadingErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'aircraft_id' },
                    { in: 'path', key: 'utilization_id' },
                    { key: 'utilizationUpdate', map: 'body' }
                ] }]);
        return (options?.client ?? client).patch<UtilizationUpdateAircraftReadingResponses, UtilizationUpdateAircraftReadingErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/aircraft/{aircraft_id}/utilization/{utilization_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * List Part Instance Readings
     */
    public static listPartInstanceReadings<ThrowOnError extends boolean = false>(parameters: {
        part_instance_id: string;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<UtilizationListPartInstanceReadingsResponses, UtilizationListPartInstanceReadingsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'part_instance_id' }, { in: 'query', key: 'limit' }] }]);
        return (options?.client ?? client).get<UtilizationListPartInstanceReadingsResponses, UtilizationListPartInstanceReadingsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/part-instances/{part_instance_id}/utilization/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create Part Instance Reading
     */
    public static createPartInstanceReading<ThrowOnError extends boolean = false>(parameters: {
        part_instance_id: string;
        utilizationCreate: UtilizationCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<UtilizationCreatePartInstanceReadingResponses, UtilizationCreatePartInstanceReadingErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'part_instance_id' }, { key: 'utilizationCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<UtilizationCreatePartInstanceReadingResponses, UtilizationCreatePartInstanceReadingErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/part-instances/{part_instance_id}/utilization/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete Part Instance Reading
     */
    public static deletePartInstanceReading<ThrowOnError extends boolean = false>(parameters: {
        part_instance_id: string;
        utilization_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<UtilizationDeletePartInstanceReadingResponses, UtilizationDeletePartInstanceReadingErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'part_instance_id' }, { in: 'path', key: 'utilization_id' }] }]);
        return (options?.client ?? client).delete<UtilizationDeletePartInstanceReadingResponses, UtilizationDeletePartInstanceReadingErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/part-instances/{part_instance_id}/utilization/{utilization_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update Part Instance Reading
     */
    public static updatePartInstanceReading<ThrowOnError extends boolean = false>(parameters: {
        part_instance_id: string;
        utilization_id: string;
        utilizationUpdate: UtilizationUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<UtilizationUpdatePartInstanceReadingResponses, UtilizationUpdatePartInstanceReadingErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'part_instance_id' },
                    { in: 'path', key: 'utilization_id' },
                    { key: 'utilizationUpdate', map: 'body' }
                ] }]);
        return (options?.client ?? client).patch<UtilizationUpdatePartInstanceReadingResponses, UtilizationUpdatePartInstanceReadingErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/part-instances/{part_instance_id}/utilization/{utilization_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class ApprovalPoliciesService {
    /**
     * List Approval Policies
     */
    public static listApprovalPolicies<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<ApprovalPoliciesListApprovalPoliciesResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<ApprovalPoliciesListApprovalPoliciesResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/approval-policies/',
            ...options
        });
    }
    
    /**
     * Create Approval Policy
     */
    public static createApprovalPolicy<ThrowOnError extends boolean = false>(parameters: {
        approvalPolicyCreate: ApprovalPolicyCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<ApprovalPoliciesCreateApprovalPolicyResponses, ApprovalPoliciesCreateApprovalPolicyErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'approvalPolicyCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<ApprovalPoliciesCreateApprovalPolicyResponses, ApprovalPoliciesCreateApprovalPolicyErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/approval-policies/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Get Approval Policy Options
     */
    public static getApprovalPolicyOptions<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<ApprovalPoliciesGetApprovalPolicyOptionsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<ApprovalPoliciesGetApprovalPolicyOptionsResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/approval-policies/options',
            ...options
        });
    }
    
    /**
     * Order Approval Policies
     */
    public static orderApprovalPolicies<ThrowOnError extends boolean = false>(parameters: {
        approvalPolicyOrder: ApprovalPolicyOrder;
    }, options?: Options<never, ThrowOnError>): RequestResult<ApprovalPoliciesOrderApprovalPoliciesResponses, ApprovalPoliciesOrderApprovalPoliciesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'approvalPolicyOrder', map: 'body' }] }]);
        return (options?.client ?? client).put<ApprovalPoliciesOrderApprovalPoliciesResponses, ApprovalPoliciesOrderApprovalPoliciesErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/approval-policies/order',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Get Approval Policies
     */
    public static getApprovalPolicies<ThrowOnError extends boolean = false>(parameters: {
        tenant_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<ApprovalPoliciesGetApprovalPoliciesResponses, ApprovalPoliciesGetApprovalPoliciesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tenant_id' }] }]);
        return (options?.client ?? client).get<ApprovalPoliciesGetApprovalPoliciesResponses, ApprovalPoliciesGetApprovalPoliciesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/approval-policies/tenant/{tenant_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update Approval Policies
     */
    public static updateApprovalPolicies<ThrowOnError extends boolean = false>(parameters: {
        tenant_id: string;
        approvalPolicySetUpdate: ApprovalPolicySetUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<ApprovalPoliciesUpdateApprovalPoliciesResponses, ApprovalPoliciesUpdateApprovalPoliciesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tenant_id' }, { key: 'approvalPolicySetUpdate', map: 'body' }] }]);
        return (options?.client ?? client).put<ApprovalPoliciesUpdateApprovalPoliciesResponses, ApprovalPoliciesUpdateApprovalPoliciesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/approval-policies/tenant/{tenant_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Get Approval Policy Reference
     */
    public static getApprovalPolicyReference<ThrowOnError extends boolean = false>(parameters: {
        tenant_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<ApprovalPoliciesGetApprovalPolicyReferenceResponses, ApprovalPoliciesGetApprovalPolicyReferenceErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tenant_id' }] }]);
        return (options?.client ?? client).get<ApprovalPoliciesGetApprovalPolicyReferenceResponses, ApprovalPoliciesGetApprovalPolicyReferenceErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/approval-policies/tenant/{tenant_id}/reference',
            ...options,
            ...params
        });
    }
    
    /**
     * Delete Approval Policy
     */
    public static deleteApprovalPolicy<ThrowOnError extends boolean = false>(parameters: {
        policy_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<ApprovalPoliciesDeleteApprovalPolicyResponses, ApprovalPoliciesDeleteApprovalPolicyErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'policy_id' }] }]);
        return (options?.client ?? client).delete<ApprovalPoliciesDeleteApprovalPolicyResponses, ApprovalPoliciesDeleteApprovalPolicyErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/approval-policies/{policy_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Edit Approval Policy
     */
    public static editApprovalPolicy<ThrowOnError extends boolean = false>(parameters: {
        policy_id: string;
        approvalPolicyUpdate: ApprovalPolicyUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<ApprovalPoliciesEditApprovalPolicyResponses, ApprovalPoliciesEditApprovalPolicyErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'policy_id' }, { key: 'approvalPolicyUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<ApprovalPoliciesEditApprovalPolicyResponses, ApprovalPoliciesEditApprovalPolicyErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/approval-policies/{policy_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class ApprovedVendorsService {
    /**
     * List Approved Vendors
     */
    public static listApprovedVendors<ThrowOnError extends boolean = false>(parameters?: {
        skip?: number;
        limit?: number;
        search?: string | null;
        status?: VendorStatus | null;
        archived?: boolean;
    }, options?: Options<never, ThrowOnError>): RequestResult<ApprovedVendorsListApprovedVendorsResponses, ApprovedVendorsListApprovedVendorsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'search' },
                    { in: 'query', key: 'status' },
                    { in: 'query', key: 'archived' }
                ] }]);
        return (options?.client ?? client).get<ApprovedVendorsListApprovedVendorsResponses, ApprovedVendorsListApprovedVendorsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/approved-vendors/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create
     */
    public static create<ThrowOnError extends boolean = false>(parameters: {
        approvedVendorCreate: ApprovedVendorCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<ApprovedVendorsCreateResponses, ApprovedVendorsCreateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'approvedVendorCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<ApprovedVendorsCreateResponses, ApprovedVendorsCreateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/approved-vendors/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete Many
     */
    public static deleteMany<ThrowOnError extends boolean = false>(parameters: {
        approvedVendorBulkIds: ApprovedVendorBulkIds;
    }, options?: Options<never, ThrowOnError>): RequestResult<ApprovedVendorsDeleteManyResponses, ApprovedVendorsDeleteManyErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'approvedVendorBulkIds', map: 'body' }] }]);
        return (options?.client ?? client).post<ApprovedVendorsDeleteManyResponses, ApprovedVendorsDeleteManyErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/approved-vendors/bulk/delete',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete
     */
    public static delete<ThrowOnError extends boolean = false>(parameters: {
        vendor_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<ApprovedVendorsDeleteResponses, ApprovedVendorsDeleteErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'vendor_id' }] }]);
        return (options?.client ?? client).delete<ApprovedVendorsDeleteResponses, ApprovedVendorsDeleteErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/approved-vendors/{vendor_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Get
     */
    public static get<ThrowOnError extends boolean = false>(parameters: {
        vendor_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<ApprovedVendorsGetResponses, ApprovedVendorsGetErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'vendor_id' }] }]);
        return (options?.client ?? client).get<ApprovedVendorsGetResponses, ApprovedVendorsGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/approved-vendors/{vendor_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update
     */
    public static update<ThrowOnError extends boolean = false>(parameters: {
        vendor_id: string;
        approvedVendorUpdate: ApprovedVendorUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<ApprovedVendorsUpdateResponses, ApprovedVendorsUpdateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'vendor_id' }, { key: 'approvedVendorUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<ApprovedVendorsUpdateResponses, ApprovedVendorsUpdateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/approved-vendors/{vendor_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Archive
     */
    public static archive<ThrowOnError extends boolean = false>(parameters: {
        vendor_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<ApprovedVendorsArchiveResponses, ApprovedVendorsArchiveErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'vendor_id' }] }]);
        return (options?.client ?? client).post<ApprovedVendorsArchiveResponses, ApprovedVendorsArchiveErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/approved-vendors/{vendor_id}/archive',
            ...options,
            ...params
        });
    }
    
    /**
     * Restore
     */
    public static restore<ThrowOnError extends boolean = false>(parameters: {
        vendor_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<ApprovedVendorsRestoreResponses, ApprovedVendorsRestoreErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'vendor_id' }] }]);
        return (options?.client ?? client).post<ApprovedVendorsRestoreResponses, ApprovedVendorsRestoreErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/approved-vendors/{vendor_id}/restore',
            ...options,
            ...params
        });
    }
}

export class AtaChapterService {
    /**
     * List Chapters
     */
    public static listChapters<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<AtaChapterListChaptersResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<AtaChapterListChaptersResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/ata-chapter/',
            ...options
        });
    }
    
    /**
     * Classify All Tasks
     */
    public static classifyAllTasks<ThrowOnError extends boolean = false>(parameters: {
        tenant_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<AtaChapterClassifyAllTasksResponses, AtaChapterClassifyAllTasksErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'query', key: 'tenant_id' }] }]);
        return (options?.client ?? client).post<AtaChapterClassifyAllTasksResponses, AtaChapterClassifyAllTasksErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/ata-chapter/classify/task',
            ...options,
            ...params
        });
    }
    
    /**
     * Classify Work Task
     */
    public static classifyWorkTask<ThrowOnError extends boolean = false>(parameters: {
        work_task_number: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<AtaChapterClassifyWorkTaskResponses, AtaChapterClassifyWorkTaskErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'work_task_number' }] }]);
        return (options?.client ?? client).post<AtaChapterClassifyWorkTaskResponses, AtaChapterClassifyWorkTaskErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/ata-chapter/classify/task/{work_task_number}',
            ...options,
            ...params
        });
    }
}

export class AtlService {
    /**
     * List Atl Pages
     */
    public static listAtlPages<ThrowOnError extends boolean = false>(parameters?: {
        aircraft_id?: Array<string> | null;
        model?: Array<string> | null;
        status?: Array<AtlPageStatus> | null;
        created_by_id?: Array<string> | null;
        last_modified_by_id?: Array<string> | null;
        search?: string | null;
        sort?: AtlPageSort;
        direction?: SortDirection;
        group?: AtlPageGrouping | null;
        subgroup?: AtlPageGrouping | null;
        group_key?: string | null;
        group_limit?: number | null;
        skip?: number;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<AtlListAtlPagesResponses, AtlListAtlPagesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'aircraft_id' },
                    { in: 'query', key: 'model' },
                    { in: 'query', key: 'status' },
                    { in: 'query', key: 'created_by_id' },
                    { in: 'query', key: 'last_modified_by_id' },
                    { in: 'query', key: 'search' },
                    { in: 'query', key: 'sort' },
                    { in: 'query', key: 'direction' },
                    { in: 'query', key: 'group' },
                    { in: 'query', key: 'subgroup' },
                    { in: 'query', key: 'group_key' },
                    { in: 'query', key: 'group_limit' },
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' }
                ] }]);
        return (options?.client ?? client).get<AtlListAtlPagesResponses, AtlListAtlPagesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/atl-pages',
            ...options,
            ...params
        });
    }
    
    /**
     * Atl Page Brought Forward
     */
    public static atlPageBroughtForward<ThrowOnError extends boolean = false>(parameters: {
        aircraft_id: string;
        flight_date: string;
        atl_page_id?: string | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<AtlAtlPageBroughtForwardResponses, AtlAtlPageBroughtForwardErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'aircraft_id' },
                    { in: 'query', key: 'flight_date' },
                    { in: 'query', key: 'atl_page_id' }
                ] }]);
        return (options?.client ?? client).get<AtlAtlPageBroughtForwardResponses, AtlAtlPageBroughtForwardErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/atl-pages/brought-forward',
            ...options,
            ...params
        });
    }
    
    /**
     * Extract
     */
    public static extract<ThrowOnError extends boolean = false>(parameters: {
        extractAtl: ExtractAtl;
    }, options?: Options<never, ThrowOnError>): RequestResult<AtlExtractResponses, AtlExtractErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'extractAtl', map: 'body' }] }]);
        return (options?.client ?? client).post<AtlExtractResponses, AtlExtractErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/atl-pages/extract',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Enter Atl Page
     */
    public static enterAtlPage<ThrowOnError extends boolean = false>(parameters: {
        atlPageEntryCreate: AtlPageEntryCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<AtlEnterAtlPageResponses, AtlEnterAtlPageErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'atlPageEntryCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<AtlEnterAtlPageResponses, AtlEnterAtlPageErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/atl-pages/manual',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Void Atl Page
     */
    public static voidAtlPage<ThrowOnError extends boolean = false>(parameters: {
        atl_page_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<AtlVoidAtlPageResponses, AtlVoidAtlPageErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'atl_page_id' }] }]);
        return (options?.client ?? client).delete<AtlVoidAtlPageResponses, AtlVoidAtlPageErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/atl-pages/{atl_page_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Get Atl Page
     */
    public static getAtlPage<ThrowOnError extends boolean = false>(parameters: {
        atl_page_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<AtlGetAtlPageResponses, AtlGetAtlPageErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'atl_page_id' }] }]);
        return (options?.client ?? client).get<AtlGetAtlPageResponses, AtlGetAtlPageErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/atl-pages/{atl_page_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Apply Atl Page Update
     */
    public static applyAtlPageUpdate<ThrowOnError extends boolean = false>(parameters: {
        atl_page_id: string;
        updateAtlPage: UpdateAtlPage;
    }, options?: Options<never, ThrowOnError>): RequestResult<AtlApplyAtlPageUpdateResponses, AtlApplyAtlPageUpdateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'atl_page_id' }, { key: 'updateAtlPage', map: 'body' }] }]);
        return (options?.client ?? client).patch<AtlApplyAtlPageUpdateResponses, AtlApplyAtlPageUpdateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/atl-pages/{atl_page_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Update Atl Page
     */
    public static updateAtlPage<ThrowOnError extends boolean = false>(parameters: {
        atl_page_id: string;
        atlPageEntry: AtlPageEntry;
    }, options?: Options<never, ThrowOnError>): RequestResult<AtlUpdateAtlPageResponses, AtlUpdateAtlPageErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'atl_page_id' }, { key: 'atlPageEntry', map: 'body' }] }]);
        return (options?.client ?? client).put<AtlUpdateAtlPageResponses, AtlUpdateAtlPageErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/atl-pages/{atl_page_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Record Atl Page
     */
    public static recordAtlPage<ThrowOnError extends boolean = false>(parameters: {
        atl_page_id: string;
        body?: AtlPageEntry | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<AtlRecordAtlPageResponses, AtlRecordAtlPageErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'atl_page_id' }, { key: 'body', map: 'body' }] }]);
        return (options?.client ?? client).post<AtlRecordAtlPageResponses, AtlRecordAtlPageErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/atl-pages/{atl_page_id}/record',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class AuditLogService {
    /**
     * List Logs
     */
    public static listLogs<ThrowOnError extends boolean = false>(parameters?: {
        skip?: number;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<AuditLogListLogsResponses, AuditLogListLogsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'query', key: 'skip' }, { in: 'query', key: 'limit' }] }]);
        return (options?.client ?? client).get<AuditLogListLogsResponses, AuditLogListLogsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/audit-log/',
            ...options,
            ...params
        });
    }
}

export class CannedWorkPackagesService {
    /**
     * List Packages
     */
    public static listPackages<ThrowOnError extends boolean = false>(parameters: {
        archived: boolean;
        skip?: number;
        limit?: number;
        sort_by?: CannedWorkPackageSortField;
        direction?: SortDirection;
        search?: string | null;
        type_certificate_model_variant_id?: Array<string> | null;
        status?: Array<CannedWorkPackageStatus> | null;
        group?: CannedWorkPackageGrouping | null;
        group_key?: string | null;
        group_limit?: number | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<CannedWorkPackagesListPackagesResponses, CannedWorkPackagesListPackagesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'archived' },
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'sort_by' },
                    { in: 'query', key: 'direction' },
                    { in: 'query', key: 'search' },
                    { in: 'query', key: 'type_certificate_model_variant_id' },
                    { in: 'query', key: 'status' },
                    { in: 'query', key: 'group' },
                    { in: 'query', key: 'group_key' },
                    { in: 'query', key: 'group_limit' }
                ] }]);
        return (options?.client ?? client).get<CannedWorkPackagesListPackagesResponses, CannedWorkPackagesListPackagesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/canned-work-packages/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create
     */
    public static create<ThrowOnError extends boolean = false>(parameters: {
        cannedWorkPackageCreate: CannedWorkPackageCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<CannedWorkPackagesCreateResponses, CannedWorkPackagesCreateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'cannedWorkPackageCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<CannedWorkPackagesCreateResponses, CannedWorkPackagesCreateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/canned-work-packages/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Archive Many
     */
    public static archiveMany<ThrowOnError extends boolean = false>(parameters: {
        cannedWorkPackageBulkIds: CannedWorkPackageBulkIds;
    }, options?: Options<never, ThrowOnError>): RequestResult<CannedWorkPackagesArchiveManyResponses, CannedWorkPackagesArchiveManyErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'cannedWorkPackageBulkIds', map: 'body' }] }]);
        return (options?.client ?? client).post<CannedWorkPackagesArchiveManyResponses, CannedWorkPackagesArchiveManyErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/canned-work-packages/bulk/archive',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete Many
     */
    public static deleteMany<ThrowOnError extends boolean = false>(parameters: {
        cannedWorkPackageBulkIds: CannedWorkPackageBulkIds;
    }, options?: Options<never, ThrowOnError>): RequestResult<CannedWorkPackagesDeleteManyResponses, CannedWorkPackagesDeleteManyErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'cannedWorkPackageBulkIds', map: 'body' }] }]);
        return (options?.client ?? client).post<CannedWorkPackagesDeleteManyResponses, CannedWorkPackagesDeleteManyErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/canned-work-packages/bulk/delete',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Restore Many
     */
    public static restoreMany<ThrowOnError extends boolean = false>(parameters: {
        cannedWorkPackageBulkIds: CannedWorkPackageBulkIds;
    }, options?: Options<never, ThrowOnError>): RequestResult<CannedWorkPackagesRestoreManyResponses, CannedWorkPackagesRestoreManyErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'cannedWorkPackageBulkIds', map: 'body' }] }]);
        return (options?.client ?? client).post<CannedWorkPackagesRestoreManyResponses, CannedWorkPackagesRestoreManyErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/canned-work-packages/bulk/restore',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete Package
     */
    public static deletePackage<ThrowOnError extends boolean = false>(parameters: {
        package_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<CannedWorkPackagesDeletePackageResponses, CannedWorkPackagesDeletePackageErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'package_id' }] }]);
        return (options?.client ?? client).delete<CannedWorkPackagesDeletePackageResponses, CannedWorkPackagesDeletePackageErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/canned-work-packages/{package_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Get Package
     */
    public static getPackage<ThrowOnError extends boolean = false>(parameters: {
        package_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<CannedWorkPackagesGetPackageResponses, CannedWorkPackagesGetPackageErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'package_id' }] }]);
        return (options?.client ?? client).get<CannedWorkPackagesGetPackageResponses, CannedWorkPackagesGetPackageErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/canned-work-packages/{package_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update Package
     */
    public static updatePackage<ThrowOnError extends boolean = false>(parameters: {
        package_id: string;
        cannedWorkPackageUpdate: CannedWorkPackageUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<CannedWorkPackagesUpdatePackageResponses, CannedWorkPackagesUpdatePackageErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'package_id' }, { key: 'cannedWorkPackageUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<CannedWorkPackagesUpdatePackageResponses, CannedWorkPackagesUpdatePackageErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/canned-work-packages/{package_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Archive Package
     */
    public static archivePackage<ThrowOnError extends boolean = false>(parameters: {
        package_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<CannedWorkPackagesArchivePackageResponses, CannedWorkPackagesArchivePackageErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'package_id' }] }]);
        return (options?.client ?? client).post<CannedWorkPackagesArchivePackageResponses, CannedWorkPackagesArchivePackageErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/canned-work-packages/{package_id}/archive',
            ...options,
            ...params
        });
    }
    
    /**
     * Restore Package
     */
    public static restorePackage<ThrowOnError extends boolean = false>(parameters: {
        package_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<CannedWorkPackagesRestorePackageResponses, CannedWorkPackagesRestorePackageErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'package_id' }] }]);
        return (options?.client ?? client).post<CannedWorkPackagesRestorePackageResponses, CannedWorkPackagesRestorePackageErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/canned-work-packages/{package_id}/restore',
            ...options,
            ...params
        });
    }
}

export class CannedWorkTasksService {
    /**
     * List Tasks
     */
    public static listTasks<ThrowOnError extends boolean = false>(parameters: {
        deleted: boolean;
        skip?: number;
        limit?: number;
        review_status?: Array<ReviewStatus> | null;
        has_approved_version?: boolean;
        package_id?: string | null;
        standalone?: boolean;
        sort_by?: CannedWorkTaskSortField;
        direction?: SortDirection;
        search?: string | null;
        group?: CannedWorkTaskGrouping | null;
        group_key?: string | null;
        group_limit?: number | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<CannedWorkTasksListTasksResponses, CannedWorkTasksListTasksErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'deleted' },
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'review_status' },
                    { in: 'query', key: 'has_approved_version' },
                    { in: 'query', key: 'package_id' },
                    { in: 'query', key: 'standalone' },
                    { in: 'query', key: 'sort_by' },
                    { in: 'query', key: 'direction' },
                    { in: 'query', key: 'search' },
                    { in: 'query', key: 'group' },
                    { in: 'query', key: 'group_key' },
                    { in: 'query', key: 'group_limit' }
                ] }]);
        return (options?.client ?? client).get<CannedWorkTasksListTasksResponses, CannedWorkTasksListTasksErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/canned-work-tasks/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create
     */
    public static create<ThrowOnError extends boolean = false>(parameters: {
        cannedWorkTaskCreate: CannedWorkTaskCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<CannedWorkTasksCreateResponses, CannedWorkTasksCreateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'cannedWorkTaskCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<CannedWorkTasksCreateResponses, CannedWorkTasksCreateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/canned-work-tasks/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Archive Many
     */
    public static archiveMany<ThrowOnError extends boolean = false>(parameters: {
        cannedWorkTaskBulkIds: CannedWorkTaskBulkIds;
    }, options?: Options<never, ThrowOnError>): RequestResult<CannedWorkTasksArchiveManyResponses, CannedWorkTasksArchiveManyErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'cannedWorkTaskBulkIds', map: 'body' }] }]);
        return (options?.client ?? client).post<CannedWorkTasksArchiveManyResponses, CannedWorkTasksArchiveManyErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/canned-work-tasks/bulk/archive',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Set Department
     */
    public static setDepartment<ThrowOnError extends boolean = false>(parameters: {
        cannedWorkTaskBulkDepartment: CannedWorkTaskBulkDepartment;
    }, options?: Options<never, ThrowOnError>): RequestResult<CannedWorkTasksSetDepartmentResponses, CannedWorkTasksSetDepartmentErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'cannedWorkTaskBulkDepartment', map: 'body' }] }]);
        return (options?.client ?? client).post<CannedWorkTasksSetDepartmentResponses, CannedWorkTasksSetDepartmentErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/canned-work-tasks/bulk/department',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Restore Many
     */
    public static restoreMany<ThrowOnError extends boolean = false>(parameters: {
        cannedWorkTaskBulkIds: CannedWorkTaskBulkIds;
    }, options?: Options<never, ThrowOnError>): RequestResult<CannedWorkTasksRestoreManyResponses, CannedWorkTasksRestoreManyErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'cannedWorkTaskBulkIds', map: 'body' }] }]);
        return (options?.client ?? client).post<CannedWorkTasksRestoreManyResponses, CannedWorkTasksRestoreManyErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/canned-work-tasks/bulk/restore',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Set Task Group
     */
    public static setTaskGroup<ThrowOnError extends boolean = false>(parameters: {
        cannedWorkTaskBulkTaskGroup: CannedWorkTaskBulkTaskGroup;
    }, options?: Options<never, ThrowOnError>): RequestResult<CannedWorkTasksSetTaskGroupResponses, CannedWorkTasksSetTaskGroupErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'cannedWorkTaskBulkTaskGroup', map: 'body' }] }]);
        return (options?.client ?? client).post<CannedWorkTasksSetTaskGroupResponses, CannedWorkTasksSetTaskGroupErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/canned-work-tasks/bulk/task-group',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Review Versions
     */
    public static reviewVersions<ThrowOnError extends boolean = false>(parameters: {
        cannedWorkTaskReviews: CannedWorkTaskReviews;
    }, options?: Options<never, ThrowOnError>): RequestResult<CannedWorkTasksReviewVersionsResponses, CannedWorkTasksReviewVersionsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'cannedWorkTaskReviews', map: 'body' }] }]);
        return (options?.client ?? client).post<CannedWorkTasksReviewVersionsResponses, CannedWorkTasksReviewVersionsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/canned-work-tasks/review',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Count By Status
     */
    public static countByStatus<ThrowOnError extends boolean = false>(parameters: {
        deleted: boolean;
        search?: string | null;
        package_id?: string | null;
        standalone?: boolean;
    }, options?: Options<never, ThrowOnError>): RequestResult<CannedWorkTasksCountByStatusResponses, CannedWorkTasksCountByStatusErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'deleted' },
                    { in: 'query', key: 'search' },
                    { in: 'query', key: 'package_id' },
                    { in: 'query', key: 'standalone' }
                ] }]);
        return (options?.client ?? client).get<CannedWorkTasksCountByStatusResponses, CannedWorkTasksCountByStatusErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/canned-work-tasks/status-counts',
            ...options,
            ...params
        });
    }
    
    /**
     * Delete Task
     */
    public static deleteTask<ThrowOnError extends boolean = false>(parameters: {
        task_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<CannedWorkTasksDeleteTaskResponses, CannedWorkTasksDeleteTaskErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'task_id' }] }]);
        return (options?.client ?? client).delete<CannedWorkTasksDeleteTaskResponses, CannedWorkTasksDeleteTaskErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/canned-work-tasks/{task_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Get Task
     */
    public static getTask<ThrowOnError extends boolean = false>(parameters: {
        task_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<CannedWorkTasksGetTaskResponses, CannedWorkTasksGetTaskErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'task_id' }] }]);
        return (options?.client ?? client).get<CannedWorkTasksGetTaskResponses, CannedWorkTasksGetTaskErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/canned-work-tasks/{task_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Suggest Parts
     */
    public static suggestParts<ThrowOnError extends boolean = false>(parameters: {
        task_id: string;
        prefix?: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<CannedWorkTasksSuggestPartsResponses, CannedWorkTasksSuggestPartsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'task_id' }, { in: 'query', key: 'prefix' }] }]);
        return (options?.client ?? client).get<CannedWorkTasksSuggestPartsResponses, CannedWorkTasksSuggestPartsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/canned-work-tasks/{task_id}/parts',
            ...options,
            ...params
        });
    }
    
    /**
     * Restore Task
     */
    public static restoreTask<ThrowOnError extends boolean = false>(parameters: {
        task_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<CannedWorkTasksRestoreTaskResponses, CannedWorkTasksRestoreTaskErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'task_id' }] }]);
        return (options?.client ?? client).post<CannedWorkTasksRestoreTaskResponses, CannedWorkTasksRestoreTaskErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/canned-work-tasks/{task_id}/restore',
            ...options,
            ...params
        });
    }
    
    /**
     * Create Version
     */
    public static createVersion<ThrowOnError extends boolean = false>(parameters: {
        task_id: string;
        cannedWorkTaskVersionCreate: CannedWorkTaskVersionCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<CannedWorkTasksCreateVersionResponses, CannedWorkTasksCreateVersionErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'task_id' }, { key: 'cannedWorkTaskVersionCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<CannedWorkTasksCreateVersionResponses, CannedWorkTasksCreateVersionErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/canned-work-tasks/{task_id}/versions',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete Version
     */
    public static deleteVersion<ThrowOnError extends boolean = false>(parameters: {
        task_id: string;
        version_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<CannedWorkTasksDeleteVersionResponses, CannedWorkTasksDeleteVersionErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'task_id' }, { in: 'path', key: 'version_id' }] }]);
        return (options?.client ?? client).delete<CannedWorkTasksDeleteVersionResponses, CannedWorkTasksDeleteVersionErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/canned-work-tasks/{task_id}/versions/{version_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Review Version
     */
    public static reviewVersion<ThrowOnError extends boolean = false>(parameters: {
        task_id: string;
        version_id: string;
        cannedWorkTaskVersionReview: CannedWorkTaskVersionReview;
    }, options?: Options<never, ThrowOnError>): RequestResult<CannedWorkTasksReviewVersionResponses, CannedWorkTasksReviewVersionErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'task_id' },
                    { in: 'path', key: 'version_id' },
                    { key: 'cannedWorkTaskVersionReview', map: 'body' }
                ] }]);
        return (options?.client ?? client).patch<CannedWorkTasksReviewVersionResponses, CannedWorkTasksReviewVersionErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/canned-work-tasks/{task_id}/versions/{version_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Undo Approval
     */
    public static undoApproval<ThrowOnError extends boolean = false>(parameters: {
        task_id: string;
        version_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<CannedWorkTasksUndoApprovalResponses, CannedWorkTasksUndoApprovalErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'task_id' }, { in: 'path', key: 'version_id' }] }]);
        return (options?.client ?? client).delete<CannedWorkTasksUndoApprovalResponses, CannedWorkTasksUndoApprovalErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/canned-work-tasks/{task_id}/versions/{version_id}/approval',
            ...options,
            ...params
        });
    }
}

export class ComplianceNoteService {
    /**
     * Create a compliance note on a work task.
     */
    public static createItem<ThrowOnError extends boolean = false>(parameters: {
        complianceNoteCreate: ComplianceNoteCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<ComplianceNoteCreateItemResponses, ComplianceNoteCreateItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'complianceNoteCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<ComplianceNoteCreateItemResponses, ComplianceNoteCreateItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/compliance-note',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Get the latest compliance note for a work task.
     */
    public static getLatestComplianceNoteByWorkTaskId<ThrowOnError extends boolean = false>(parameters: {
        work_task_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<ComplianceNoteGetLatestComplianceNoteByWorkTaskIdResponses, ComplianceNoteGetLatestComplianceNoteByWorkTaskIdErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'work_task_id' }] }]);
        return (options?.client ?? client).get<ComplianceNoteGetLatestComplianceNoteByWorkTaskIdResponses, ComplianceNoteGetLatestComplianceNoteByWorkTaskIdErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/compliance-note/latest/{work_task_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update ComplianceNote
     */
    public static updateItem<ThrowOnError extends boolean = false>(parameters: {
        id: string;
        complianceNoteUpdate: ComplianceNoteUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<ComplianceNoteUpdateItemResponses, ComplianceNoteUpdateItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'id' }, { key: 'complianceNoteUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<ComplianceNoteUpdateItemResponses, ComplianceNoteUpdateItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/compliance-note/{id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class CustomerAddressService {
    /**
     * List Addresses
     */
    public static listAddresses<ThrowOnError extends boolean = false>(parameters?: {
        skip?: number;
        limit?: number;
        customer_id?: string | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<CustomerAddressListAddressesResponses, CustomerAddressListAddressesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'customer_id' }
                ] }]);
        return (options?.client ?? client).get<CustomerAddressListAddressesResponses, CustomerAddressListAddressesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/customer-address/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create
     */
    public static create<ThrowOnError extends boolean = false>(parameters: {
        customerAddressCreate: CustomerAddressCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<CustomerAddressCreateResponses, CustomerAddressCreateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'customerAddressCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<CustomerAddressCreateResponses, CustomerAddressCreateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/customer-address/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete
     */
    public static delete<ThrowOnError extends boolean = false>(parameters: {
        address_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<CustomerAddressDeleteResponses, CustomerAddressDeleteErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'address_id' }] }]);
        return (options?.client ?? client).delete<CustomerAddressDeleteResponses, CustomerAddressDeleteErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/customer-address/{address_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Get
     */
    public static get<ThrowOnError extends boolean = false>(parameters: {
        address_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<CustomerAddressGetResponses, CustomerAddressGetErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'address_id' }] }]);
        return (options?.client ?? client).get<CustomerAddressGetResponses, CustomerAddressGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/customer-address/{address_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update
     */
    public static update<ThrowOnError extends boolean = false>(parameters: {
        address_id: string;
        customerAddressUpdate: CustomerAddressUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<CustomerAddressUpdateResponses, CustomerAddressUpdateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'address_id' }, { key: 'customerAddressUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<CustomerAddressUpdateResponses, CustomerAddressUpdateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/customer-address/{address_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class CustomerContactService {
    /**
     * List Contacts
     */
    public static listContacts<ThrowOnError extends boolean = false>(parameters?: {
        skip?: number;
        limit?: number;
        customer_id?: string | null;
        archived?: boolean;
    }, options?: Options<never, ThrowOnError>): RequestResult<CustomerContactListContactsResponses, CustomerContactListContactsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'customer_id' },
                    { in: 'query', key: 'archived' }
                ] }]);
        return (options?.client ?? client).get<CustomerContactListContactsResponses, CustomerContactListContactsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/customer-contact/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create
     */
    public static create<ThrowOnError extends boolean = false>(parameters: {
        customerContactCreate: CustomerContactCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<CustomerContactCreateResponses, CustomerContactCreateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'customerContactCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<CustomerContactCreateResponses, CustomerContactCreateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/customer-contact/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete
     */
    public static delete<ThrowOnError extends boolean = false>(parameters: {
        contact_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<CustomerContactDeleteResponses, CustomerContactDeleteErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'contact_id' }] }]);
        return (options?.client ?? client).delete<CustomerContactDeleteResponses, CustomerContactDeleteErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/customer-contact/{contact_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Get
     */
    public static get<ThrowOnError extends boolean = false>(parameters: {
        contact_id: string;
        include_archived?: boolean;
    }, options?: Options<never, ThrowOnError>): RequestResult<CustomerContactGetResponses, CustomerContactGetErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'contact_id' }, { in: 'query', key: 'include_archived' }] }]);
        return (options?.client ?? client).get<CustomerContactGetResponses, CustomerContactGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/customer-contact/{contact_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update
     */
    public static update<ThrowOnError extends boolean = false>(parameters: {
        contact_id: string;
        customerContactUpdate: CustomerContactUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<CustomerContactUpdateResponses, CustomerContactUpdateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'contact_id' }, { key: 'customerContactUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<CustomerContactUpdateResponses, CustomerContactUpdateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/customer-contact/{contact_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Archive
     */
    public static archive<ThrowOnError extends boolean = false>(parameters: {
        contact_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<CustomerContactArchiveResponses, CustomerContactArchiveErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'contact_id' }] }]);
        return (options?.client ?? client).post<CustomerContactArchiveResponses, CustomerContactArchiveErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/customer-contact/{contact_id}/archive',
            ...options,
            ...params
        });
    }
    
    /**
     * Restore
     */
    public static restore<ThrowOnError extends boolean = false>(parameters: {
        contact_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<CustomerContactRestoreResponses, CustomerContactRestoreErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'contact_id' }] }]);
        return (options?.client ?? client).post<CustomerContactRestoreResponses, CustomerContactRestoreErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/customer-contact/{contact_id}/restore',
            ...options,
            ...params
        });
    }
}

export class CustomerService {
    /**
     * List Customers
     */
    public static listCustomers<ThrowOnError extends boolean = false>(parameters?: {
        skip?: number;
        limit?: number;
        search?: string | null;
        order_by?: string | null;
        order_direction?: string | null;
        archived?: boolean;
    }, options?: Options<never, ThrowOnError>): RequestResult<CustomerListCustomersResponses, CustomerListCustomersErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'search' },
                    { in: 'query', key: 'order_by' },
                    { in: 'query', key: 'order_direction' },
                    { in: 'query', key: 'archived' }
                ] }]);
        return (options?.client ?? client).get<CustomerListCustomersResponses, CustomerListCustomersErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/customer/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create Customer
     */
    public static createCustomer<ThrowOnError extends boolean = false>(parameters: {
        customerCreate: CustomerCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<CustomerCreateCustomerResponses, CustomerCreateCustomerErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'customerCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<CustomerCreateCustomerResponses, CustomerCreateCustomerErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/customer/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete Customer
     */
    public static deleteCustomer<ThrowOnError extends boolean = false>(parameters: {
        customer_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<CustomerDeleteCustomerResponses, CustomerDeleteCustomerErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'customer_id' }] }]);
        return (options?.client ?? client).delete<CustomerDeleteCustomerResponses, CustomerDeleteCustomerErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/customer/{customer_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Get Customer
     */
    public static getCustomer<ThrowOnError extends boolean = false>(parameters: {
        customer_id: string;
        include_archived?: boolean;
    }, options?: Options<never, ThrowOnError>): RequestResult<CustomerGetCustomerResponses, CustomerGetCustomerErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'customer_id' }, { in: 'query', key: 'include_archived' }] }]);
        return (options?.client ?? client).get<CustomerGetCustomerResponses, CustomerGetCustomerErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/customer/{customer_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update Customer
     */
    public static updateCustomer<ThrowOnError extends boolean = false>(parameters: {
        customer_id: string;
        customerUpdate: CustomerUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<CustomerUpdateCustomerResponses, CustomerUpdateCustomerErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'customer_id' }, { key: 'customerUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<CustomerUpdateCustomerResponses, CustomerUpdateCustomerErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/customer/{customer_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Archive Customer
     */
    public static archiveCustomer<ThrowOnError extends boolean = false>(parameters: {
        customer_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<CustomerArchiveCustomerResponses, CustomerArchiveCustomerErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'customer_id' }] }]);
        return (options?.client ?? client).post<CustomerArchiveCustomerResponses, CustomerArchiveCustomerErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/customer/{customer_id}/archive',
            ...options,
            ...params
        });
    }
    
    /**
     * Restore
     */
    public static restore<ThrowOnError extends boolean = false>(parameters: {
        customer_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<CustomerRestoreResponses, CustomerRestoreErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'customer_id' }] }]);
        return (options?.client ?? client).post<CustomerRestoreResponses, CustomerRestoreErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/customer/{customer_id}/restore',
            ...options,
            ...params
        });
    }
}

export class DepartmentsService {
    /**
     * List Departments
     */
    public static listDepartments<ThrowOnError extends boolean = false>(parameters?: {
        deleted?: boolean;
    }, options?: Options<never, ThrowOnError>): RequestResult<DepartmentsListDepartmentsResponses, DepartmentsListDepartmentsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'query', key: 'deleted' }] }]);
        return (options?.client ?? client).get<DepartmentsListDepartmentsResponses, DepartmentsListDepartmentsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/departments/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create
     */
    public static create<ThrowOnError extends boolean = false>(parameters: {
        departmentCreate: DepartmentCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<DepartmentsCreateResponses, DepartmentsCreateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'departmentCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<DepartmentsCreateResponses, DepartmentsCreateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/departments/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete
     */
    public static delete<ThrowOnError extends boolean = false>(parameters: {
        department_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<DepartmentsDeleteResponses, DepartmentsDeleteErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'department_id' }] }]);
        return (options?.client ?? client).delete<DepartmentsDeleteResponses, DepartmentsDeleteErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/departments/{department_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Get
     */
    public static get<ThrowOnError extends boolean = false>(parameters: {
        department_id: string;
        include_archived?: boolean;
    }, options?: Options<never, ThrowOnError>): RequestResult<DepartmentsGetResponses, DepartmentsGetErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'department_id' }, { in: 'query', key: 'include_archived' }] }]);
        return (options?.client ?? client).get<DepartmentsGetResponses, DepartmentsGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/departments/{department_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update
     */
    public static update<ThrowOnError extends boolean = false>(parameters: {
        department_id: string;
        departmentUpdate: DepartmentUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<DepartmentsUpdateResponses, DepartmentsUpdateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'department_id' }, { key: 'departmentUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<DepartmentsUpdateResponses, DepartmentsUpdateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/departments/{department_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Restore
     */
    public static restore<ThrowOnError extends boolean = false>(parameters: {
        department_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<DepartmentsRestoreResponses, DepartmentsRestoreErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'department_id' }] }]);
        return (options?.client ?? client).post<DepartmentsRestoreResponses, DepartmentsRestoreErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/departments/{department_id}/restore',
            ...options,
            ...params
        });
    }
}

export class DesktopService {
    /**
     * Check For Update
     */
    public static checkForUpdate<ThrowOnError extends boolean = false>(parameters: {
        current_version: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<DesktopCheckForUpdateResponses, DesktopCheckForUpdateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'query', key: 'current_version' }] }]);
        return (options?.client ?? client).get<DesktopCheckForUpdateResponses, DesktopCheckForUpdateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/desktop/updates/check',
            ...options,
            ...params
        });
    }
}

export class DocumentTemplatesService {
    /**
     * List Document Templates
     */
    public static listDocumentTemplates<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<DocumentTemplatesListDocumentTemplatesResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<DocumentTemplatesListDocumentTemplatesResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/document-templates/',
            ...options
        });
    }
    
    /**
     * Preview Document Template
     */
    public static previewDocumentTemplate<ThrowOnError extends boolean = false>(parameters: {
        documentTemplatePreview: DocumentTemplatePreview;
    }, options?: Options<never, ThrowOnError>): RequestResult<DocumentTemplatesPreviewDocumentTemplateResponses, DocumentTemplatesPreviewDocumentTemplateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'documentTemplatePreview', map: 'body' }] }]);
        return (options?.client ?? client).post<DocumentTemplatesPreviewDocumentTemplateResponses, DocumentTemplatesPreviewDocumentTemplateErrors, ThrowOnError>({
            responseType: 'blob',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/document-templates/preview',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Reset Document Template
     */
    public static resetDocumentTemplate<ThrowOnError extends boolean = false>(parameters: {
        kind: DocumentKind;
    }, options?: Options<never, ThrowOnError>): RequestResult<DocumentTemplatesResetDocumentTemplateResponses, DocumentTemplatesResetDocumentTemplateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'kind' }] }]);
        return (options?.client ?? client).delete<DocumentTemplatesResetDocumentTemplateResponses, DocumentTemplatesResetDocumentTemplateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/document-templates/{kind}',
            ...options,
            ...params
        });
    }
    
    /**
     * Get Document Template
     */
    public static getDocumentTemplate<ThrowOnError extends boolean = false>(parameters: {
        kind: DocumentKind;
    }, options?: Options<never, ThrowOnError>): RequestResult<DocumentTemplatesGetDocumentTemplateResponses, DocumentTemplatesGetDocumentTemplateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'kind' }] }]);
        return (options?.client ?? client).get<DocumentTemplatesGetDocumentTemplateResponses, DocumentTemplatesGetDocumentTemplateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/document-templates/{kind}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update Document Template
     */
    public static updateDocumentTemplate<ThrowOnError extends boolean = false>(parameters: {
        kind: DocumentKind;
        documentTemplateUpsert: DocumentTemplateUpsert;
    }, options?: Options<never, ThrowOnError>): RequestResult<DocumentTemplatesUpdateDocumentTemplateResponses, DocumentTemplatesUpdateDocumentTemplateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'kind' }, { key: 'documentTemplateUpsert', map: 'body' }] }]);
        return (options?.client ?? client).put<DocumentTemplatesUpdateDocumentTemplateResponses, DocumentTemplatesUpdateDocumentTemplateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/document-templates/{kind}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class DocumentsService {
    /**
     * List Documents
     *
     * @deprecated
     */
    public static listDocuments<ThrowOnError extends boolean = false>(parameters?: {
        visibility?: Visibility | null;
        archived?: boolean;
        superseded?: boolean;
        skip?: number;
        limit?: number;
        search?: string | null;
        order_by?: DocumentOrderBy;
    }, options?: Options<never, ThrowOnError>): RequestResult<DocumentsListDocumentsResponses, DocumentsListDocumentsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'visibility' },
                    { in: 'query', key: 'archived' },
                    { in: 'query', key: 'superseded' },
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'search' },
                    { in: 'query', key: 'order_by' }
                ] }]);
        return (options?.client ?? client).get<DocumentsListDocumentsResponses, DocumentsListDocumentsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/documents/',
            ...options,
            ...params
        });
    }
    
    /**
     * Searches airworthiness directives only, across all of them. Ranks by BM25 over each directive's number, title and full text; the filters apply before ranking, so a narrow filter with a broad query is fine. Same body and response as /documents/search, without a matched page.
     */
    public static searchAirworthinessDirectives<ThrowOnError extends boolean = false>(parameters: {
        documentSearch: DocumentSearch;
    }, options?: Options<never, ThrowOnError>): RequestResult<DocumentsSearchAirworthinessDirectivesResponses, DocumentsSearchAirworthinessDirectivesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'documentSearch', map: 'body' }] }]);
        return (options?.client ?? client).post<DocumentsSearchAirworthinessDirectivesResponses, DocumentsSearchAirworthinessDirectivesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/documents/airworthiness-directives/search',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Update Many
     */
    public static updateMany<ThrowOnError extends boolean = false>(parameters: {
        documentBulkUpdate: DocumentBulkUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<DocumentsUpdateManyResponses, DocumentsUpdateManyErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'documentBulkUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<DocumentsUpdateManyResponses, DocumentsUpdateManyErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/documents/bulk',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Archive Many
     */
    public static archiveMany<ThrowOnError extends boolean = false>(parameters: {
        documentBulkDelete: DocumentBulkDelete;
    }, options?: Options<never, ThrowOnError>): RequestResult<DocumentsArchiveManyResponses, DocumentsArchiveManyErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'documentBulkDelete', map: 'body' }] }]);
        return (options?.client ?? client).post<DocumentsArchiveManyResponses, DocumentsArchiveManyErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/documents/bulk/archive',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete Many
     */
    public static deleteMany<ThrowOnError extends boolean = false>(parameters: {
        documentBulkDelete: DocumentBulkDelete;
    }, options?: Options<never, ThrowOnError>): RequestResult<DocumentsDeleteManyResponses, DocumentsDeleteManyErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'documentBulkDelete', map: 'body' }] }]);
        return (options?.client ?? client).post<DocumentsDeleteManyResponses, DocumentsDeleteManyErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/documents/bulk/delete',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Restore Many
     */
    public static restoreMany<ThrowOnError extends boolean = false>(parameters: {
        documentBulkDelete: DocumentBulkDelete;
    }, options?: Options<never, ThrowOnError>): RequestResult<DocumentsRestoreManyResponses, DocumentsRestoreManyErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'documentBulkDelete', map: 'body' }] }]);
        return (options?.client ?? client).post<DocumentsRestoreManyResponses, DocumentsRestoreManyErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/documents/bulk/restore',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Download Many
     */
    public static downloadMany<ThrowOnError extends boolean = false>(parameters: {
        documentBatchDownload: DocumentBatchDownload;
    }, options?: Options<never, ThrowOnError>): RequestResult<DocumentsDownloadManyResponses, DocumentsDownloadManyErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'documentBatchDownload', map: 'body' }] }]);
        return (options?.client ?? client).post<DocumentsDownloadManyResponses, DocumentsDownloadManyErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/documents/download',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Filter Options
     */
    public static filterOptions<ThrowOnError extends boolean = false>(parameters: {
        limit?: number;
        documentFilters: DocumentFilters;
    }, options?: Options<never, ThrowOnError>): RequestResult<DocumentsFilterOptionsResponses, DocumentsFilterOptionsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'query', key: 'limit' }, { key: 'documentFilters', map: 'body' }] }]);
        return (options?.client ?? client).post<DocumentsFilterOptionsResponses, DocumentsFilterOptionsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/documents/filter-options',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Search Documents
     */
    public static searchDocuments<ThrowOnError extends boolean = false>(parameters: {
        documentSearch: DocumentSearch;
    }, options?: Options<never, ThrowOnError>): RequestResult<DocumentsSearchDocumentsResponses, DocumentsSearchDocumentsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'documentSearch', map: 'body' }] }]);
        return (options?.client ?? client).post<DocumentsSearchDocumentsResponses, DocumentsSearchDocumentsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/documents/search',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Upload
     */
    public static upload<ThrowOnError extends boolean = false>(parameters: {
        bodyDocumentsUpload: BodyDocumentsUpload;
    }, options?: Options<never, ThrowOnError>): RequestResult<DocumentsUploadResponses, DocumentsUploadErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'bodyDocumentsUpload', map: 'body' }] }]);
        return (options?.client ?? client).post<DocumentsUploadResponses, DocumentsUploadErrors, ThrowOnError>({
            ...formDataBodySerializer,
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/documents/upload',
            ...options,
            ...params,
            headers: {
                'Content-Type': null,
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Upload Global
     */
    public static uploadGlobal<ThrowOnError extends boolean = false>(parameters: {
        bodyDocumentsUploadGlobal: BodyDocumentsUploadGlobal;
    }, options?: Options<never, ThrowOnError>): RequestResult<DocumentsUploadGlobalResponses, DocumentsUploadGlobalErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'bodyDocumentsUploadGlobal', map: 'body' }] }]);
        return (options?.client ?? client).post<DocumentsUploadGlobalResponses, DocumentsUploadGlobalErrors, ThrowOnError>({
            ...formDataBodySerializer,
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/documents/upload/global',
            ...options,
            ...params,
            headers: {
                'Content-Type': null,
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete Document
     */
    public static deleteDocument<ThrowOnError extends boolean = false>(parameters: {
        document_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<DocumentsDeleteDocumentResponses, DocumentsDeleteDocumentErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'document_id' }] }]);
        return (options?.client ?? client).delete<DocumentsDeleteDocumentResponses, DocumentsDeleteDocumentErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/documents/{document_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Get
     */
    public static get<ThrowOnError extends boolean = false>(parameters: {
        document_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<DocumentsGetResponses, DocumentsGetErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'document_id' }] }]);
        return (options?.client ?? client).get<DocumentsGetResponses, DocumentsGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/documents/{document_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update
     */
    public static update<ThrowOnError extends boolean = false>(parameters: {
        document_id: string;
        documentUpdate: DocumentUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<DocumentsUpdateResponses, DocumentsUpdateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'document_id' }, { key: 'documentUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<DocumentsUpdateResponses, DocumentsUpdateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/documents/{document_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Archive Document
     */
    public static archiveDocument<ThrowOnError extends boolean = false>(parameters: {
        document_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<DocumentsArchiveDocumentResponses, DocumentsArchiveDocumentErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'document_id' }] }]);
        return (options?.client ?? client).post<DocumentsArchiveDocumentResponses, DocumentsArchiveDocumentErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/documents/{document_id}/archive',
            ...options,
            ...params
        });
    }
    
    /**
     * Download
     */
    public static download<ThrowOnError extends boolean = false>(parameters: {
        document_id: string;
        format?: string | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<DocumentsDownloadResponses, DocumentsDownloadErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'document_id' }, { in: 'query', key: 'format' }] }]);
        return (options?.client ?? client).get<DocumentsDownloadResponses, DocumentsDownloadErrors, ThrowOnError>({
            responseType: 'blob',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/documents/{document_id}/download',
            ...options,
            ...params
        });
    }
    
    /**
     * Re Extract
     */
    public static reExtract<ThrowOnError extends boolean = false>(parameters: {
        document_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<DocumentsReExtractResponses, DocumentsReExtractErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'document_id' }] }]);
        return (options?.client ?? client).post<DocumentsReExtractResponses, DocumentsReExtractErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/documents/{document_id}/re-extract',
            ...options,
            ...params
        });
    }
    
    /**
     * Restore Document
     */
    public static restoreDocument<ThrowOnError extends boolean = false>(parameters: {
        document_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<DocumentsRestoreDocumentResponses, DocumentsRestoreDocumentErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'document_id' }] }]);
        return (options?.client ?? client).post<DocumentsRestoreDocumentResponses, DocumentsRestoreDocumentErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/documents/{document_id}/restore',
            ...options,
            ...params
        });
    }
}

export class EmailService {
    /**
     * List Emails
     */
    public static listEmails<ThrowOnError extends boolean = false>(parameters: {
        archived: boolean;
        visibility?: EmailVisibility | null;
        search?: string | null;
        from_address?: Array<string> | null;
        received_from?: string | null;
        received_to?: string | null;
        skip?: number;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<EmailListEmailsResponses, EmailListEmailsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'archived' },
                    { in: 'query', key: 'visibility' },
                    { in: 'query', key: 'search' },
                    { in: 'query', key: 'from_address' },
                    { in: 'query', key: 'received_from' },
                    { in: 'query', key: 'received_to' },
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' }
                ] }]);
        return (options?.client ?? client).get<EmailListEmailsResponses, EmailListEmailsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/email/',
            ...options,
            ...params
        });
    }
    
    /**
     * Archive Many
     */
    public static archiveMany<ThrowOnError extends boolean = false>(parameters: {
        emailBulkIds: EmailBulkIds;
    }, options?: Options<never, ThrowOnError>): RequestResult<EmailArchiveManyResponses, EmailArchiveManyErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'emailBulkIds', map: 'body' }] }]);
        return (options?.client ?? client).post<EmailArchiveManyResponses, EmailArchiveManyErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/email/bulk/archive',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete Many
     */
    public static deleteMany<ThrowOnError extends boolean = false>(parameters: {
        emailBulkIds: EmailBulkIds;
    }, options?: Options<never, ThrowOnError>): RequestResult<EmailDeleteManyResponses, EmailDeleteManyErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'emailBulkIds', map: 'body' }] }]);
        return (options?.client ?? client).post<EmailDeleteManyResponses, EmailDeleteManyErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/email/bulk/delete',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Restore Many
     */
    public static restoreMany<ThrowOnError extends boolean = false>(parameters: {
        emailBulkIds: EmailBulkIds;
    }, options?: Options<never, ThrowOnError>): RequestResult<EmailRestoreManyResponses, EmailRestoreManyErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'emailBulkIds', map: 'body' }] }]);
        return (options?.client ?? client).post<EmailRestoreManyResponses, EmailRestoreManyErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/email/bulk/restore',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Share Many
     */
    public static shareMany<ThrowOnError extends boolean = false>(parameters: {
        emailBulkIds: EmailBulkIds;
    }, options?: Options<never, ThrowOnError>): RequestResult<EmailShareManyResponses, EmailShareManyErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'emailBulkIds', map: 'body' }] }]);
        return (options?.client ?? client).post<EmailShareManyResponses, EmailShareManyErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/email/bulk/share',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Filter Options
     */
    public static filterOptions<ThrowOnError extends boolean = false>(parameters: {
        archived: boolean;
        visibility?: EmailVisibility | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<EmailFilterOptionsResponses, EmailFilterOptionsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'query', key: 'archived' }, { in: 'query', key: 'visibility' }] }]);
        return (options?.client ?? client).get<EmailFilterOptionsResponses, EmailFilterOptionsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/email/filter-options',
            ...options,
            ...params
        });
    }
    
    /**
     * Get Forwarding Address
     */
    public static getForwardingAddress<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<EmailGetForwardingAddressResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<EmailGetForwardingAddressResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/email/forwarding-address',
            ...options
        });
    }
    
    /**
     * Receive
     */
    public static receive<ThrowOnError extends boolean = false>(parameters: {
        mailgunRequest: MailgunRequest;
    }, options?: Options<never, ThrowOnError>): RequestResult<EmailReceiveResponses, EmailReceiveErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'mailgunRequest', map: 'body' }] }]);
        return (options?.client ?? client).post<EmailReceiveResponses, EmailReceiveErrors, ThrowOnError>({
            ...urlSearchParamsBodySerializer,
            responseType: 'json',
            url: '/api/v1/email/receive',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete Email
     */
    public static deleteEmail<ThrowOnError extends boolean = false>(parameters: {
        email_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<EmailDeleteEmailResponses, EmailDeleteEmailErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'email_id' }] }]);
        return (options?.client ?? client).delete<EmailDeleteEmailResponses, EmailDeleteEmailErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/email/{email_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Get Email
     */
    public static getEmail<ThrowOnError extends boolean = false>(parameters: {
        email_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<EmailGetEmailResponses, EmailGetEmailErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'email_id' }] }]);
        return (options?.client ?? client).get<EmailGetEmailResponses, EmailGetEmailErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/email/{email_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update Email
     */
    public static updateEmail<ThrowOnError extends boolean = false>(parameters: {
        email_id: string;
        emailUpdate: EmailUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<EmailUpdateEmailResponses, EmailUpdateEmailErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'email_id' }, { key: 'emailUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<EmailUpdateEmailResponses, EmailUpdateEmailErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/email/{email_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Archive Email
     */
    public static archiveEmail<ThrowOnError extends boolean = false>(parameters: {
        email_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<EmailArchiveEmailResponses, EmailArchiveEmailErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'email_id' }] }]);
        return (options?.client ?? client).post<EmailArchiveEmailResponses, EmailArchiveEmailErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/email/{email_id}/archive',
            ...options,
            ...params
        });
    }
    
    /**
     * Restore Email
     */
    public static restoreEmail<ThrowOnError extends boolean = false>(parameters: {
        email_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<EmailRestoreEmailResponses, EmailRestoreEmailErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'email_id' }] }]);
        return (options?.client ?? client).post<EmailRestoreEmailResponses, EmailRestoreEmailErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/email/{email_id}/restore',
            ...options,
            ...params
        });
    }
    
    /**
     * Resolve Trace
     */
    public static resolveTrace<ThrowOnError extends boolean = false>(parameters: {
        email_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<EmailResolveTraceResponses, EmailResolveTraceErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'email_id' }] }]);
        return (options?.client ?? client).post<EmailResolveTraceResponses, EmailResolveTraceErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/email/{email_id}/trace',
            ...options,
            ...params
        });
    }
}

export class ErpApiKeyService {
    /**
     * Clear Erp Api Key
     */
    public static clearErpApiKey<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<ErpApiKeyClearErpApiKeyResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).delete<ErpApiKeyClearErpApiKeyResponses, unknown, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/erp/api-key',
            ...options
        });
    }
    
    /**
     * Get Erp Api Key
     */
    public static getErpApiKey<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<ErpApiKeyGetErpApiKeyResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<ErpApiKeyGetErpApiKeyResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/erp/api-key',
            ...options
        });
    }
    
    /**
     * Set Erp Api Key
     */
    public static setErpApiKey<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<ErpApiKeySetErpApiKeyResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).put<ErpApiKeySetErpApiKeyResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/erp/api-key',
            ...options
        });
    }
}

export class ErpIntegrationService {
    /**
     * Get Erp Config
     *
     * Get tenant's ERP configuration.
     *
     * Used by frontend to display correct ERP branding.
     */
    public static getErpConfig<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<ErpIntegrationGetErpConfigResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<ErpIntegrationGetErpConfigResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/erp/config',
            ...options
        });
    }
    
    /**
     * Sync From Erp
     *
     * Sync data from tenant's configured ERP.
     *
     * Pulls work packages (and dependent entities) since integration_start_date.
     */
    public static syncFromErp<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<ErpIntegrationSyncFromErpResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).post<ErpIntegrationSyncFromErpResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/erp/sync',
            ...options
        });
    }
}

export class ErpConfigsService {
    /**
     * Get all ERP configs for a tenant
     */
    public static getErpConfigs<ThrowOnError extends boolean = false>(parameters: {
        tenant_id: string;
        skip?: number;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<ErpConfigsGetErpConfigsResponses, ErpConfigsGetErpConfigsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'tenant_id' },
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' }
                ] }]);
        return (options?.client ?? client).get<ErpConfigsGetErpConfigsResponses, ErpConfigsGetErpConfigsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/erp/configs/tenant/{tenant_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Create ERP config
     */
    public static createErpConfig<ThrowOnError extends boolean = false>(parameters: {
        tenant_id: string;
        tenantErpConfigCreate: TenantErpConfigCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<ErpConfigsCreateErpConfigResponses, ErpConfigsCreateErpConfigErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tenant_id' }, { key: 'tenantErpConfigCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<ErpConfigsCreateErpConfigResponses, ErpConfigsCreateErpConfigErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/erp/configs/tenant/{tenant_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Get ERP config IDs for a tenant
     */
    public static getErpConfigIds<ThrowOnError extends boolean = false>(parameters: {
        tenant_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<ErpConfigsGetErpConfigIdsResponses, ErpConfigsGetErpConfigIdsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tenant_id' }] }]);
        return (options?.client ?? client).get<ErpConfigsGetErpConfigIdsResponses, ErpConfigsGetErpConfigIdsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/erp/configs/tenant/{tenant_id}/ids',
            ...options,
            ...params
        });
    }
    
    /**
     * Delete ERP config
     */
    public static deleteErpConfig<ThrowOnError extends boolean = false>(parameters: {
        tenant_id: string;
        id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<ErpConfigsDeleteErpConfigResponses, ErpConfigsDeleteErpConfigErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tenant_id' }, { in: 'path', key: 'id' }] }]);
        return (options?.client ?? client).delete<ErpConfigsDeleteErpConfigResponses, ErpConfigsDeleteErpConfigErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/erp/configs/tenant/{tenant_id}/{id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Get ERP config by ID
     */
    public static getErpConfigById<ThrowOnError extends boolean = false>(parameters: {
        tenant_id: string;
        id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<ErpConfigsGetErpConfigByIdResponses, ErpConfigsGetErpConfigByIdErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tenant_id' }, { in: 'path', key: 'id' }] }]);
        return (options?.client ?? client).get<ErpConfigsGetErpConfigByIdResponses, ErpConfigsGetErpConfigByIdErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/erp/configs/tenant/{tenant_id}/{id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update ERP config
     */
    public static updateErpConfig<ThrowOnError extends boolean = false>(parameters: {
        tenant_id: string;
        id: string;
        tenantErpConfigUpdate: TenantErpConfigUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<ErpConfigsUpdateErpConfigResponses, ErpConfigsUpdateErpConfigErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'tenant_id' },
                    { in: 'path', key: 'id' },
                    { key: 'tenantErpConfigUpdate', map: 'body' }
                ] }]);
        return (options?.client ?? client).patch<ErpConfigsUpdateErpConfigResponses, ErpConfigsUpdateErpConfigErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/erp/configs/tenant/{tenant_id}/{id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class ErpCorridorRelayService {
    /**
     * List Corridor Quote Pushes
     */
    public static listCorridorQuotePushes<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<ErpCorridorRelayListCorridorQuotePushesResponses, ErpCorridorRelayListCorridorQuotePushesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'query', key: 'quote_id' }] }]);
        return (options?.client ?? client).get<ErpCorridorRelayListCorridorQuotePushesResponses, ErpCorridorRelayListCorridorQuotePushesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/erp/corridor/quote-pushes',
            ...options,
            ...params
        });
    }
    
    /**
     * Create Corridor Quote Push
     */
    public static createCorridorQuotePush<ThrowOnError extends boolean = false>(parameters: {
        corridorQuotePushCreate: CorridorQuotePushCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<ErpCorridorRelayCreateCorridorQuotePushResponses, ErpCorridorRelayCreateCorridorQuotePushErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'corridorQuotePushCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<ErpCorridorRelayCreateCorridorQuotePushResponses, ErpCorridorRelayCreateCorridorQuotePushErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/erp/corridor/quote-pushes',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Retry Corridor Quote Push
     */
    public static retryCorridorQuotePush<ThrowOnError extends boolean = false>(parameters: {
        push_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<ErpCorridorRelayRetryCorridorQuotePushResponses, ErpCorridorRelayRetryCorridorQuotePushErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'push_id' }] }]);
        return (options?.client ?? client).post<ErpCorridorRelayRetryCorridorQuotePushResponses, ErpCorridorRelayRetryCorridorQuotePushErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/erp/corridor/quote-pushes/{push_id}/retry',
            ...options,
            ...params
        });
    }
    
    /**
     * Clear Corridor Relay
     */
    public static clearCorridorRelay<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<ErpCorridorRelayClearCorridorRelayResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).delete<ErpCorridorRelayClearCorridorRelayResponses, unknown, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/erp/corridor/relay',
            ...options
        });
    }
    
    /**
     * Get Corridor Relay
     */
    public static getCorridorRelay<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<ErpCorridorRelayGetCorridorRelayResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<ErpCorridorRelayGetCorridorRelayResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/erp/corridor/relay',
            ...options
        });
    }
    
    /**
     * Set Corridor Relay
     */
    public static setCorridorRelay<ThrowOnError extends boolean = false>(parameters: {
        corridorRelayUpdate: CorridorRelayUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<ErpCorridorRelaySetCorridorRelayResponses, ErpCorridorRelaySetCorridorRelayErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'corridorRelayUpdate', map: 'body' }] }]);
        return (options?.client ?? client).put<ErpCorridorRelaySetCorridorRelayResponses, ErpCorridorRelaySetCorridorRelayErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/erp/corridor/relay',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class ExtensionFeedbackService {
    /**
     * Submit Extension Feedback
     */
    public static submitExtensionFeedback<ThrowOnError extends boolean = false>(parameters: {
        extensionFeedbackCreate: ExtensionFeedbackCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<ExtensionFeedbackSubmitExtensionFeedbackResponses, ExtensionFeedbackSubmitExtensionFeedbackErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'extensionFeedbackCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<ExtensionFeedbackSubmitExtensionFeedbackResponses, ExtensionFeedbackSubmitExtensionFeedbackErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/extension-feedback/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class FacilitiesService {
    /**
     * List Facilities
     */
    public static listFacilities<ThrowOnError extends boolean = false>(parameters?: {
        deleted?: boolean;
    }, options?: Options<never, ThrowOnError>): RequestResult<FacilitiesListFacilitiesResponses, FacilitiesListFacilitiesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'query', key: 'deleted' }] }]);
        return (options?.client ?? client).get<FacilitiesListFacilitiesResponses, FacilitiesListFacilitiesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/facilities/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create
     */
    public static create<ThrowOnError extends boolean = false>(parameters: {
        facilityCreate: FacilityCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<FacilitiesCreateResponses, FacilitiesCreateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'facilityCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<FacilitiesCreateResponses, FacilitiesCreateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/facilities/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete
     */
    public static delete<ThrowOnError extends boolean = false>(parameters: {
        facility_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<FacilitiesDeleteResponses, FacilitiesDeleteErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'facility_id' }] }]);
        return (options?.client ?? client).delete<FacilitiesDeleteResponses, FacilitiesDeleteErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/facilities/{facility_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Get
     */
    public static get<ThrowOnError extends boolean = false>(parameters: {
        facility_id: string;
        include_archived?: boolean;
    }, options?: Options<never, ThrowOnError>): RequestResult<FacilitiesGetResponses, FacilitiesGetErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'facility_id' }, { in: 'query', key: 'include_archived' }] }]);
        return (options?.client ?? client).get<FacilitiesGetResponses, FacilitiesGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/facilities/{facility_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update
     */
    public static update<ThrowOnError extends boolean = false>(parameters: {
        facility_id: string;
        facilityUpdate: FacilityUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<FacilitiesUpdateResponses, FacilitiesUpdateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'facility_id' }, { key: 'facilityUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<FacilitiesUpdateResponses, FacilitiesUpdateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/facilities/{facility_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Restore
     */
    public static restore<ThrowOnError extends boolean = false>(parameters: {
        facility_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<FacilitiesRestoreResponses, FacilitiesRestoreErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'facility_id' }] }]);
        return (options?.client ?? client).post<FacilitiesRestoreResponses, FacilitiesRestoreErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/facilities/{facility_id}/restore',
            ...options,
            ...params
        });
    }
}

export class LocationsService {
    /**
     * List Locations
     */
    public static listLocations<ThrowOnError extends boolean = false>(parameters: {
        facility_id: string;
        deleted?: boolean;
    }, options?: Options<never, ThrowOnError>): RequestResult<LocationsListLocationsResponses, LocationsListLocationsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'facility_id' }, { in: 'query', key: 'deleted' }] }]);
        return (options?.client ?? client).get<LocationsListLocationsResponses, LocationsListLocationsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/facilities/{facility_id}/locations/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create
     */
    public static create<ThrowOnError extends boolean = false>(parameters: {
        facility_id: string;
        locationCreate: LocationCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<LocationsCreateResponses, LocationsCreateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'facility_id' }, { key: 'locationCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<LocationsCreateResponses, LocationsCreateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/facilities/{facility_id}/locations/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete
     */
    public static delete<ThrowOnError extends boolean = false>(parameters: {
        facility_id: string;
        location_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<LocationsDeleteResponses, LocationsDeleteErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'facility_id' }, { in: 'path', key: 'location_id' }] }]);
        return (options?.client ?? client).delete<LocationsDeleteResponses, LocationsDeleteErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/facilities/{facility_id}/locations/{location_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update
     */
    public static update<ThrowOnError extends boolean = false>(parameters: {
        facility_id: string;
        location_id: string;
        locationUpdate: LocationUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<LocationsUpdateResponses, LocationsUpdateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'facility_id' },
                    { in: 'path', key: 'location_id' },
                    { key: 'locationUpdate', map: 'body' }
                ] }]);
        return (options?.client ?? client).patch<LocationsUpdateResponses, LocationsUpdateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/facilities/{facility_id}/locations/{location_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Restore
     */
    public static restore<ThrowOnError extends boolean = false>(parameters: {
        facility_id: string;
        location_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<LocationsRestoreResponses, LocationsRestoreErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'facility_id' }, { in: 'path', key: 'location_id' }] }]);
        return (options?.client ?? client).post<LocationsRestoreResponses, LocationsRestoreErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/facilities/{facility_id}/locations/{location_id}/restore',
            ...options,
            ...params
        });
    }
}

export class FeatureFlagsService {
    /**
     * Get Feature Flags
     */
    public static getFeatureFlags<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<FeatureFlagsGetFeatureFlagsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<FeatureFlagsGetFeatureFlagsResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/feature-flags',
            ...options
        });
    }
}

export class FittedComponentService {
    /**
     * Read FittedComponents
     */
    public static readItems<ThrowOnError extends boolean = false>(parameters?: {
        skip?: number;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<FittedComponentReadItemsResponses, FittedComponentReadItemsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'query', key: 'skip' }, { in: 'query', key: 'limit' }] }]);
        return (options?.client ?? client).get<FittedComponentReadItemsResponses, FittedComponentReadItemsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/fitted-component/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create FittedComponent
     */
    public static createItem<ThrowOnError extends boolean = false>(parameters: {
        fittedComponentCreate: FittedComponentCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<FittedComponentCreateItemResponses, FittedComponentCreateItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'fittedComponentCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<FittedComponentCreateItemResponses, FittedComponentCreateItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/fitted-component/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Search FittedComponents for an aircraft
     */
    public static searchFittedComponentsByAircraftId<ThrowOnError extends boolean = false>(parameters: {
        aircraft_id: string;
        description?: string | null;
        part_number?: string | null;
        serial_number?: string | null;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<FittedComponentSearchFittedComponentsByAircraftIdResponses, FittedComponentSearchFittedComponentsByAircraftIdErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'aircraft_id' },
                    { in: 'query', key: 'description' },
                    { in: 'query', key: 'part_number' },
                    { in: 'query', key: 'serial_number' },
                    { in: 'query', key: 'limit' }
                ] }]);
        return (options?.client ?? client).get<FittedComponentSearchFittedComponentsByAircraftIdResponses, FittedComponentSearchFittedComponentsByAircraftIdErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/fitted-component/aircraft/{aircraft_id}/search',
            ...options,
            ...params
        });
    }
    
    /**
     * Delete FittedComponent
     */
    public static deleteItem<ThrowOnError extends boolean = false>(parameters: {
        id: string;
        return_facility_id?: string | null;
        return_condition?: PartCondition | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<FittedComponentDeleteItemResponses, FittedComponentDeleteItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'id' },
                    { in: 'query', key: 'return_facility_id' },
                    { in: 'query', key: 'return_condition' }
                ] }]);
        return (options?.client ?? client).delete<FittedComponentDeleteItemResponses, FittedComponentDeleteItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/fitted-component/{id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Read FittedComponent
     */
    public static readItem<ThrowOnError extends boolean = false>(parameters: {
        id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<FittedComponentReadItemResponses, FittedComponentReadItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'id' }] }]);
        return (options?.client ?? client).get<FittedComponentReadItemResponses, FittedComponentReadItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/fitted-component/{id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update FittedComponent
     */
    public static updateItem<ThrowOnError extends boolean = false>(parameters: {
        id: string;
        fittedComponentUpdate: FittedComponentUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<FittedComponentUpdateItemResponses, FittedComponentUpdateItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'id' }, { key: 'fittedComponentUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<FittedComponentUpdateItemResponses, FittedComponentUpdateItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/fitted-component/{id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class ForecastService {
    /**
     * List Forecasts
     */
    public static listForecasts<ThrowOnError extends boolean = false>(parameters?: {
        archived?: boolean | null;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<ForecastListForecastsResponses, ForecastListForecastsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'query', key: 'archived' }, { in: 'query', key: 'limit' }] }]);
        return (options?.client ?? client).get<ForecastListForecastsResponses, ForecastListForecastsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/forecasts',
            ...options,
            ...params
        });
    }
    
    /**
     * Create Forecast
     */
    public static createForecast<ThrowOnError extends boolean = false>(parameters: {
        forecastCreate: ForecastCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<ForecastCreateForecastResponses, ForecastCreateForecastErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'forecastCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<ForecastCreateForecastResponses, ForecastCreateForecastErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/forecasts',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Confirm Forecast Item
     */
    public static confirmForecastItem<ThrowOnError extends boolean = false>(parameters: {
        forecastConfirmationCreate: ForecastConfirmationCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<ForecastConfirmForecastItemResponses, ForecastConfirmForecastItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'forecastConfirmationCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<ForecastConfirmForecastItemResponses, ForecastConfirmForecastItemErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/forecasts/confirmations',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Exclude Forecast Item
     */
    public static excludeForecastItem<ThrowOnError extends boolean = false>(parameters: {
        forecastExclusionCreate: ForecastExclusionCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<ForecastExcludeForecastItemResponses, ForecastExcludeForecastItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'forecastExclusionCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<ForecastExcludeForecastItemResponses, ForecastExcludeForecastItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/forecasts/exclusions',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Include Forecast Item
     */
    public static includeForecastItem<ThrowOnError extends boolean = false>(parameters: {
        exclusion_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<ForecastIncludeForecastItemResponses, ForecastIncludeForecastItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'exclusion_id' }] }]);
        return (options?.client ?? client).delete<ForecastIncludeForecastItemResponses, ForecastIncludeForecastItemErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/forecasts/exclusions/{exclusion_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Pin Forecast
     */
    public static pinForecast<ThrowOnError extends boolean = false>(parameters: {
        aircraft_id: string;
        forecastPin: ForecastPin;
    }, options?: Options<never, ThrowOnError>): RequestResult<ForecastPinForecastResponses, ForecastPinForecastErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'aircraft_id' }, { key: 'forecastPin', map: 'body' }] }]);
        return (options?.client ?? client).put<ForecastPinForecastResponses, ForecastPinForecastErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/forecasts/pins/{aircraft_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Preview Forecast
     */
    public static previewForecast<ThrowOnError extends boolean = false>(parameters: {
        forecastParameters: ForecastParameters;
    }, options?: Options<never, ThrowOnError>): RequestResult<ForecastPreviewForecastResponses, ForecastPreviewForecastErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'forecastParameters', map: 'body' }] }]);
        return (options?.client ?? client).post<ForecastPreviewForecastResponses, ForecastPreviewForecastErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/forecasts/preview',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * List Forecast Summaries
     */
    public static listForecastSummaries<ThrowOnError extends boolean = false>(parameters: {
        forecastSummariesRequest: ForecastSummariesRequest;
    }, options?: Options<never, ThrowOnError>): RequestResult<ForecastListForecastSummariesResponses, ForecastListForecastSummariesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'forecastSummariesRequest', map: 'body' }] }]);
        return (options?.client ?? client).post<ForecastListForecastSummariesResponses, ForecastListForecastSummariesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/forecasts/summaries',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Create Forecast Work Order
     */
    public static createForecastWorkOrder<ThrowOnError extends boolean = false>(parameters: {
        forecastWorkOrderCreate: ForecastWorkOrderCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<ForecastCreateForecastWorkOrderResponses, ForecastCreateForecastWorkOrderErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'forecastWorkOrderCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<ForecastCreateForecastWorkOrderResponses, ForecastCreateForecastWorkOrderErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/forecasts/work-orders',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete Forecast
     */
    public static deleteForecast<ThrowOnError extends boolean = false>(parameters: {
        forecast_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<ForecastDeleteForecastResponses, ForecastDeleteForecastErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'forecast_id' }] }]);
        return (options?.client ?? client).delete<ForecastDeleteForecastResponses, ForecastDeleteForecastErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/forecasts/{forecast_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Get Forecast
     */
    public static getForecast<ThrowOnError extends boolean = false>(parameters: {
        forecast_id: string;
        basis?: ForecastBasis | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<ForecastGetForecastResponses, ForecastGetForecastErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'forecast_id' }, { in: 'query', key: 'basis' }] }]);
        return (options?.client ?? client).get<ForecastGetForecastResponses, ForecastGetForecastErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/forecasts/{forecast_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update Forecast
     */
    public static updateForecast<ThrowOnError extends boolean = false>(parameters: {
        forecast_id: string;
        forecastUpdate: ForecastUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<ForecastUpdateForecastResponses, ForecastUpdateForecastErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'forecast_id' }, { key: 'forecastUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<ForecastUpdateForecastResponses, ForecastUpdateForecastErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/forecasts/{forecast_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Archive Forecast
     */
    public static archiveForecast<ThrowOnError extends boolean = false>(parameters: {
        forecast_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<ForecastArchiveForecastResponses, ForecastArchiveForecastErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'forecast_id' }] }]);
        return (options?.client ?? client).post<ForecastArchiveForecastResponses, ForecastArchiveForecastErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/forecasts/{forecast_id}/archive',
            ...options,
            ...params
        });
    }
    
    /**
     * Restore Forecast
     */
    public static restoreForecast<ThrowOnError extends boolean = false>(parameters: {
        forecast_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<ForecastRestoreForecastResponses, ForecastRestoreForecastErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'forecast_id' }] }]);
        return (options?.client ?? client).post<ForecastRestoreForecastResponses, ForecastRestoreForecastErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/forecasts/{forecast_id}/restore',
            ...options,
            ...params
        });
    }
}

export class ForecastPrintingService {
    /**
     * Print Due List
     */
    public static printDueList<ThrowOnError extends boolean = false>(parameters: {
        forecast_id: string;
        printDueList: PrintDueList;
    }, options?: Options<never, ThrowOnError>): RequestResult<ForecastPrintingPrintDueListResponses, ForecastPrintingPrintDueListErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'forecast_id' }, { key: 'printDueList', map: 'body' }] }]);
        return (options?.client ?? client).post<ForecastPrintingPrintDueListResponses, ForecastPrintingPrintDueListErrors, ThrowOnError>({
            responseType: 'blob',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/forecasts/{forecast_id}/due-list',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class ImportService {
    /**
     * Import Aircraft
     *
     * Bulk import an aircraft with its fitted components and mod status records.
     * Uses the existing aircraft upsert logic (insert or update on conflict).
     * Only used for importing aircraft data from CAMOs.
     */
    public static importAircraft<ThrowOnError extends boolean = false>(parameters: {
        aircraftImportPayload: AircraftImportPayload;
    }, options?: Options<never, ThrowOnError>): RequestResult<ImportImportAircraftResponses, ImportImportAircraftErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'aircraftImportPayload', map: 'body' }] }]);
        return (options?.client ?? client).post<ImportImportAircraftResponses, ImportImportAircraftErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
            url: '/api/v1/import/aircraft',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Import Canned Work Packages
     */
    public static importCannedWorkPackages<ThrowOnError extends boolean = false>(parameters: {
        cannedWorkPackagesImport: CannedWorkPackagesImport;
    }, options?: Options<never, ThrowOnError>): RequestResult<ImportImportCannedWorkPackagesResponses, ImportImportCannedWorkPackagesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'cannedWorkPackagesImport', map: 'body' }] }]);
        return (options?.client ?? client).post<ImportImportCannedWorkPackagesResponses, ImportImportCannedWorkPackagesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
            url: '/api/v1/import/canned-work-packages',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Import Canned Work Tasks
     */
    public static importCannedWorkTasks<ThrowOnError extends boolean = false>(parameters: {
        cannedWorkTasksImport: CannedWorkTasksImport;
    }, options?: Options<never, ThrowOnError>): RequestResult<ImportImportCannedWorkTasksResponses, ImportImportCannedWorkTasksErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'cannedWorkTasksImport', map: 'body' }] }]);
        return (options?.client ?? client).post<ImportImportCannedWorkTasksResponses, ImportImportCannedWorkTasksErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
            url: '/api/v1/import/canned-work-tasks',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Get Import Checkpoint
     *
     * The sync watermark for an external source. Null means no sync has completed yet.
     */
    public static getImportCheckpoint<ThrowOnError extends boolean = false>(parameters: {
        external_source: string;
        entity: string;
        checkpoint_key: string;
        tenant_id?: string | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<ImportGetImportCheckpointResponses, ImportGetImportCheckpointErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'external_source' },
                    { in: 'query', key: 'entity' },
                    { in: 'query', key: 'checkpoint_key' },
                    { in: 'query', key: 'tenant_id' }
                ] }]);
        return (options?.client ?? client).get<ImportGetImportCheckpointResponses, ImportGetImportCheckpointErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
            url: '/api/v1/import/checkpoint',
            ...options,
            ...params
        });
    }
    
    /**
     * Put Import Checkpoint
     */
    public static putImportCheckpoint<ThrowOnError extends boolean = false>(parameters: {
        tenant_id?: string | null;
        integrationCheckpointCreate: IntegrationCheckpointCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<ImportPutImportCheckpointResponses, ImportPutImportCheckpointErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'query', key: 'tenant_id' }, { key: 'integrationCheckpointCreate', map: 'body' }] }]);
        return (options?.client ?? client).put<ImportPutImportCheckpointResponses, ImportPutImportCheckpointErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
            url: '/api/v1/import/checkpoint',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * External
     *
     * This is a single item import endpoint meant for the chrome extension
     * hence it being called "external" - data here is much less trusted
     */
    public static external<ThrowOnError extends boolean = false>(parameters: {
        appDataImportSchemasExternalImport: AppDataImportSchemasExternalImport;
    }, options?: Options<never, ThrowOnError>): RequestResult<ImportExternalResponses, ImportExternalErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'appDataImportSchemasExternalImport', map: 'body' }] }]);
        return (options?.client ?? client).post<ImportExternalResponses, ImportExternalErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/import/external',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Ingest Rates
     */
    public static ingestRates<ThrowOnError extends boolean = false>(parameters: {
        body: Array<IngestRatesItem> | IngestRatesItem;
    }, options?: Options<never, ThrowOnError>): RequestResult<ImportIngestRatesResponses, ImportIngestRatesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'body', map: 'body' }] }]);
        return (options?.client ?? client).post<ImportIngestRatesResponses, ImportIngestRatesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
            url: '/api/v1/import/ingest-rates',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Internal
     *
     * This is a bulk import endpoint meant for one-off setups of external ERPs
     * hence it being called "internal" - it is for use by us only
     */
    public static internal<ThrowOnError extends boolean = false>(parameters: {
        batch_size?: number;
        appDataImportSchemasInternalImport: AppDataImportSchemasInternalImport;
    }, options?: Options<never, ThrowOnError>): RequestResult<ImportInternalResponses, ImportInternalErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'query', key: 'batch_size' }, { key: 'appDataImportSchemasInternalImport', map: 'body' }] }]);
        return (options?.client ?? client).post<ImportInternalResponses, ImportInternalErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
            url: '/api/v1/import/internal',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Import Me
     */
    public static importMe<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<ImportImportMeResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<ImportImportMeResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ name: 'X-API-Key', type: 'apiKey' }],
            url: '/api/v1/import/me',
            ...options
        });
    }
    
    /**
     * Upsert Parts
     */
    public static upsertParts<ThrowOnError extends boolean = false>(parameters: {
        partsUpsert: PartsUpsert;
    }, options?: Options<never, ThrowOnError>): RequestResult<ImportUpsertPartsResponses, ImportUpsertPartsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'partsUpsert', map: 'body' }] }]);
        return (options?.client ?? client).post<ImportUpsertPartsResponses, ImportUpsertPartsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
            url: '/api/v1/import/parts',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Import Quotes
     */
    public static importQuotes<ThrowOnError extends boolean = false>(parameters: {
        quotesImport: QuotesImport;
    }, options?: Options<never, ThrowOnError>): RequestResult<ImportImportQuotesResponses, ImportImportQuotesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'quotesImport', map: 'body' }] }]);
        return (options?.client ?? client).post<ImportImportQuotesResponses, ImportImportQuotesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
            url: '/api/v1/import/quotes',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Open Work Packages
     *
     * External ids of the work packages Fleetcraft has no end date for, so an incremental
     * sync can re-check work orders that were closed in the ERP while it was not looking.
     */
    public static openWorkPackages<ThrowOnError extends boolean = false>(parameters: {
        tenant_erp_config_id: string;
        tenant_id?: string | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<ImportOpenWorkPackagesResponses, ImportOpenWorkPackagesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'query', key: 'tenant_erp_config_id' }, { in: 'query', key: 'tenant_id' }] }]);
        return (options?.client ?? client).get<ImportOpenWorkPackagesResponses, ImportOpenWorkPackagesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
            url: '/api/v1/import/work-packages/open',
            ...options,
            ...params
        });
    }
}

export class IntegrationsService {
    /**
     * Get integration credentials by tenant ID
     */
    public static getIntegrationCredentialsByTenant<ThrowOnError extends boolean = false>(parameters: {
        tenant_id: string;
        skip?: number;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<IntegrationsGetIntegrationCredentialsByTenantResponses, IntegrationsGetIntegrationCredentialsByTenantErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'tenant_id' },
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' }
                ] }]);
        return (options?.client ?? client).get<IntegrationsGetIntegrationCredentialsByTenantResponses, IntegrationsGetIntegrationCredentialsByTenantErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/integrations/credentials/tenant/{tenant_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Create integration credentials with plaintext password
     */
    public static createIntegrationCredentialsWithPlaintextPassword<ThrowOnError extends boolean = false>(parameters: {
        tenant_id: string;
        integrationCredentialsCreateWithPlaintextPassword: IntegrationCredentialsCreateWithPlaintextPassword;
    }, options?: Options<never, ThrowOnError>): RequestResult<IntegrationsCreateIntegrationCredentialsWithPlaintextPasswordResponses, IntegrationsCreateIntegrationCredentialsWithPlaintextPasswordErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tenant_id' }, { key: 'integrationCredentialsCreateWithPlaintextPassword', map: 'body' }] }]);
        return (options?.client ?? client).post<IntegrationsCreateIntegrationCredentialsWithPlaintextPasswordResponses, IntegrationsCreateIntegrationCredentialsWithPlaintextPasswordErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/integrations/credentials/tenant/{tenant_id}/create-with-plaintext-password',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Update integration credentials with plaintext password
     */
    public static updateIntegrationCredentialsWithPlaintextPassword<ThrowOnError extends boolean = false>(parameters: {
        tenant_id: string;
        id: string;
        integrationCredentialsUpdateWithPlaintextPassword: IntegrationCredentialsUpdateWithPlaintextPassword;
    }, options?: Options<never, ThrowOnError>): RequestResult<IntegrationsUpdateIntegrationCredentialsWithPlaintextPasswordResponses, IntegrationsUpdateIntegrationCredentialsWithPlaintextPasswordErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'tenant_id' },
                    { in: 'path', key: 'id' },
                    { key: 'integrationCredentialsUpdateWithPlaintextPassword', map: 'body' }
                ] }]);
        return (options?.client ?? client).put<IntegrationsUpdateIntegrationCredentialsWithPlaintextPasswordResponses, IntegrationsUpdateIntegrationCredentialsWithPlaintextPasswordErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/integrations/credentials/tenant/{tenant_id}/update-with-plaintext-password/{id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete integration credential by tenant ID
     */
    public static deleteIntegrationCredentialByTenant<ThrowOnError extends boolean = false>(parameters: {
        tenant_id: string;
        id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<IntegrationsDeleteIntegrationCredentialByTenantResponses, IntegrationsDeleteIntegrationCredentialByTenantErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tenant_id' }, { in: 'path', key: 'id' }] }]);
        return (options?.client ?? client).delete<IntegrationsDeleteIntegrationCredentialByTenantResponses, IntegrationsDeleteIntegrationCredentialByTenantErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/integrations/credentials/tenant/{tenant_id}/{id}',
            ...options,
            ...params
        });
    }
}

export class MaintenanceProgrammeService {
    /**
     * List Programmes
     */
    public static listProgrammes<ThrowOnError extends boolean = false>(parameters?: {
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<MaintenanceProgrammeListProgrammesResponses, MaintenanceProgrammeListProgrammesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'query', key: 'limit' }] }]);
        return (options?.client ?? client).get<MaintenanceProgrammeListProgrammesResponses, MaintenanceProgrammeListProgrammesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/maintenance-programmes/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create Programme
     */
    public static createProgramme<ThrowOnError extends boolean = false>(parameters: {
        programmeCreate: ProgrammeCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<MaintenanceProgrammeCreateProgrammeResponses, MaintenanceProgrammeCreateProgrammeErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'programmeCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<MaintenanceProgrammeCreateProgrammeResponses, MaintenanceProgrammeCreateProgrammeErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/maintenance-programmes/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Archive Programmes
     */
    public static archiveProgrammes<ThrowOnError extends boolean = false>(parameters: {
        programmesBulkChange: ProgrammesBulkChange;
    }, options?: Options<never, ThrowOnError>): RequestResult<MaintenanceProgrammeArchiveProgrammesResponses, MaintenanceProgrammeArchiveProgrammesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'programmesBulkChange', map: 'body' }] }]);
        return (options?.client ?? client).post<MaintenanceProgrammeArchiveProgrammesResponses, MaintenanceProgrammeArchiveProgrammesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/maintenance-programmes/archive',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete Programmes
     */
    public static deleteProgrammes<ThrowOnError extends boolean = false>(parameters: {
        programmesBulkChange: ProgrammesBulkChange;
    }, options?: Options<never, ThrowOnError>): RequestResult<MaintenanceProgrammeDeleteProgrammesResponses, MaintenanceProgrammeDeleteProgrammesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'programmesBulkChange', map: 'body' }] }]);
        return (options?.client ?? client).post<MaintenanceProgrammeDeleteProgrammesResponses, MaintenanceProgrammeDeleteProgrammesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/maintenance-programmes/delete',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * List Aircraft Enrolments
     */
    public static listAircraftEnrolments<ThrowOnError extends boolean = false>(parameters: {
        aircraft_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<MaintenanceProgrammeListAircraftEnrolmentsResponses, MaintenanceProgrammeListAircraftEnrolmentsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'query', key: 'aircraft_id' }] }]);
        return (options?.client ?? client).get<MaintenanceProgrammeListAircraftEnrolmentsResponses, MaintenanceProgrammeListAircraftEnrolmentsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/maintenance-programmes/enrolments',
            ...options,
            ...params
        });
    }
    
    /**
     * Extract
     */
    public static extract<ThrowOnError extends boolean = false>(parameters: {
        extractProgramme: ExtractProgramme;
    }, options?: Options<never, ThrowOnError>): RequestResult<MaintenanceProgrammeExtractResponses, MaintenanceProgrammeExtractErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'extractProgramme', map: 'body' }] }]);
        return (options?.client ?? client).post<MaintenanceProgrammeExtractResponses, MaintenanceProgrammeExtractErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/maintenance-programmes/extractions',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Next Programme Number
     */
    public static nextProgrammeNumber<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<MaintenanceProgrammeNextProgrammeNumberResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<MaintenanceProgrammeNextProgrammeNumberResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/maintenance-programmes/next-number',
            ...options
        });
    }
    
    /**
     * Get Programme Overview
     */
    public static getProgrammeOverview<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<MaintenanceProgrammeGetProgrammeOverviewResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<MaintenanceProgrammeGetProgrammeOverviewResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/maintenance-programmes/overview',
            ...options
        });
    }
    
    /**
     * Restore Programmes
     */
    public static restoreProgrammes<ThrowOnError extends boolean = false>(parameters: {
        programmesBulkChange: ProgrammesBulkChange;
    }, options?: Options<never, ThrowOnError>): RequestResult<MaintenanceProgrammeRestoreProgrammesResponses, MaintenanceProgrammeRestoreProgrammesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'programmesBulkChange', map: 'body' }] }]);
        return (options?.client ?? client).post<MaintenanceProgrammeRestoreProgrammesResponses, MaintenanceProgrammeRestoreProgrammesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/maintenance-programmes/restore',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * List Tracked Components
     */
    public static listTrackedComponents<ThrowOnError extends boolean = false>(parameters: {
        aircraft_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<MaintenanceProgrammeListTrackedComponentsResponses, MaintenanceProgrammeListTrackedComponentsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'query', key: 'aircraft_id' }] }]);
        return (options?.client ?? client).get<MaintenanceProgrammeListTrackedComponentsResponses, MaintenanceProgrammeListTrackedComponentsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/maintenance-programmes/tracked-components',
            ...options,
            ...params
        });
    }
    
    /**
     * Get Programme
     */
    public static getProgramme<ThrowOnError extends boolean = false>(parameters: {
        programme_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<MaintenanceProgrammeGetProgrammeResponses, MaintenanceProgrammeGetProgrammeErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'programme_id' }] }]);
        return (options?.client ?? client).get<MaintenanceProgrammeGetProgrammeResponses, MaintenanceProgrammeGetProgrammeErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/maintenance-programmes/{programme_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update Programme
     */
    public static updateProgramme<ThrowOnError extends boolean = false>(parameters: {
        programme_id: string;
        updateProgramme: UpdateProgramme;
    }, options?: Options<never, ThrowOnError>): RequestResult<MaintenanceProgrammeUpdateProgrammeResponses, MaintenanceProgrammeUpdateProgrammeErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'programme_id' }, { key: 'updateProgramme', map: 'body' }] }]);
        return (options?.client ?? client).patch<MaintenanceProgrammeUpdateProgrammeResponses, MaintenanceProgrammeUpdateProgrammeErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/maintenance-programmes/{programme_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * List Programme Activity
     */
    public static listProgrammeActivity<ThrowOnError extends boolean = false>(parameters: {
        programme_id: string;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<MaintenanceProgrammeListProgrammeActivityResponses, MaintenanceProgrammeListProgrammeActivityErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'programme_id' }, { in: 'query', key: 'limit' }] }]);
        return (options?.client ?? client).get<MaintenanceProgrammeListProgrammeActivityResponses, MaintenanceProgrammeListProgrammeActivityErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/maintenance-programmes/{programme_id}/activity',
            ...options,
            ...params
        });
    }
    
    /**
     * List Programme Aircraft
     */
    public static listProgrammeAircraft<ThrowOnError extends boolean = false>(parameters: {
        programme_id: string;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<MaintenanceProgrammeListProgrammeAircraftResponses, MaintenanceProgrammeListProgrammeAircraftErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'programme_id' }, { in: 'query', key: 'limit' }] }]);
        return (options?.client ?? client).get<MaintenanceProgrammeListProgrammeAircraftResponses, MaintenanceProgrammeListProgrammeAircraftErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/maintenance-programmes/{programme_id}/aircraft',
            ...options,
            ...params
        });
    }
    
    /**
     * Enrol Programme Aircraft
     */
    public static enrolProgrammeAircraft<ThrowOnError extends boolean = false>(parameters: {
        programme_id: string;
        programmeEnrolmentCreate: ProgrammeEnrolmentCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<MaintenanceProgrammeEnrolProgrammeAircraftResponses, MaintenanceProgrammeEnrolProgrammeAircraftErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'programme_id' }, { key: 'programmeEnrolmentCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<MaintenanceProgrammeEnrolProgrammeAircraftResponses, MaintenanceProgrammeEnrolProgrammeAircraftErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/maintenance-programmes/{programme_id}/aircraft',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Unenrol Programme Aircraft
     */
    public static unenrolProgrammeAircraft<ThrowOnError extends boolean = false>(parameters: {
        programme_id: string;
        enrolment_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<MaintenanceProgrammeUnenrolProgrammeAircraftResponses, MaintenanceProgrammeUnenrolProgrammeAircraftErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'programme_id' }, { in: 'path', key: 'enrolment_id' }] }]);
        return (options?.client ?? client).delete<MaintenanceProgrammeUnenrolProgrammeAircraftResponses, MaintenanceProgrammeUnenrolProgrammeAircraftErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/maintenance-programmes/{programme_id}/aircraft/{enrolment_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * List Programme Revisions
     */
    public static listProgrammeRevisions<ThrowOnError extends boolean = false>(parameters: {
        programme_id: string;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<MaintenanceProgrammeListProgrammeRevisionsResponses, MaintenanceProgrammeListProgrammeRevisionsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'programme_id' }, { in: 'query', key: 'limit' }] }]);
        return (options?.client ?? client).get<MaintenanceProgrammeListProgrammeRevisionsResponses, MaintenanceProgrammeListProgrammeRevisionsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/maintenance-programmes/{programme_id}/revisions',
            ...options,
            ...params
        });
    }
    
    /**
     * Create Programme Revision
     */
    public static createProgrammeRevision<ThrowOnError extends boolean = false>(parameters: {
        programme_id: string;
        programmeDraftRevisionCreate: ProgrammeDraftRevisionCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<MaintenanceProgrammeCreateProgrammeRevisionResponses, MaintenanceProgrammeCreateProgrammeRevisionErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'programme_id' }, { key: 'programmeDraftRevisionCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<MaintenanceProgrammeCreateProgrammeRevisionResponses, MaintenanceProgrammeCreateProgrammeRevisionErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/maintenance-programmes/{programme_id}/revisions',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Apply Programme Revision Update
     */
    public static applyProgrammeRevisionUpdate<ThrowOnError extends boolean = false>(parameters: {
        programme_id: string;
        revision_id: string;
        updateProgrammeRevision: UpdateProgrammeRevision;
    }, options?: Options<never, ThrowOnError>): RequestResult<MaintenanceProgrammeApplyProgrammeRevisionUpdateResponses, MaintenanceProgrammeApplyProgrammeRevisionUpdateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'programme_id' },
                    { in: 'path', key: 'revision_id' },
                    { key: 'updateProgrammeRevision', map: 'body' }
                ] }]);
        return (options?.client ?? client).patch<MaintenanceProgrammeApplyProgrammeRevisionUpdateResponses, MaintenanceProgrammeApplyProgrammeRevisionUpdateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/maintenance-programmes/{programme_id}/revisions/{revision_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * List Programme Checks
     */
    public static listProgrammeChecks<ThrowOnError extends boolean = false>(parameters: {
        programme_id: string;
        revision_id: string;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<MaintenanceProgrammeListProgrammeChecksResponses, MaintenanceProgrammeListProgrammeChecksErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'programme_id' },
                    { in: 'path', key: 'revision_id' },
                    { in: 'query', key: 'limit' }
                ] }]);
        return (options?.client ?? client).get<MaintenanceProgrammeListProgrammeChecksResponses, MaintenanceProgrammeListProgrammeChecksErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/maintenance-programmes/{programme_id}/revisions/{revision_id}/checks',
            ...options,
            ...params
        });
    }
    
    /**
     * Add Programme Check
     */
    public static addProgrammeCheck<ThrowOnError extends boolean = false>(parameters: {
        programme_id: string;
        revision_id: string;
        programmeCheckBase: ProgrammeCheckBase;
    }, options?: Options<never, ThrowOnError>): RequestResult<MaintenanceProgrammeAddProgrammeCheckResponses, MaintenanceProgrammeAddProgrammeCheckErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'programme_id' },
                    { in: 'path', key: 'revision_id' },
                    { key: 'programmeCheckBase', map: 'body' }
                ] }]);
        return (options?.client ?? client).post<MaintenanceProgrammeAddProgrammeCheckResponses, MaintenanceProgrammeAddProgrammeCheckErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/maintenance-programmes/{programme_id}/revisions/{revision_id}/checks',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Remove Programme Check
     */
    public static removeProgrammeCheck<ThrowOnError extends boolean = false>(parameters: {
        programme_id: string;
        revision_id: string;
        check_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<MaintenanceProgrammeRemoveProgrammeCheckResponses, MaintenanceProgrammeRemoveProgrammeCheckErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'programme_id' },
                    { in: 'path', key: 'revision_id' },
                    { in: 'path', key: 'check_id' }
                ] }]);
        return (options?.client ?? client).delete<MaintenanceProgrammeRemoveProgrammeCheckResponses, MaintenanceProgrammeRemoveProgrammeCheckErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/maintenance-programmes/{programme_id}/revisions/{revision_id}/checks/{check_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Replace Programme Check
     */
    public static replaceProgrammeCheck<ThrowOnError extends boolean = false>(parameters: {
        programme_id: string;
        revision_id: string;
        check_id: string;
        programmeCheckBase: ProgrammeCheckBase;
    }, options?: Options<never, ThrowOnError>): RequestResult<MaintenanceProgrammeReplaceProgrammeCheckResponses, MaintenanceProgrammeReplaceProgrammeCheckErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'programme_id' },
                    { in: 'path', key: 'revision_id' },
                    { in: 'path', key: 'check_id' },
                    { key: 'programmeCheckBase', map: 'body' }
                ] }]);
        return (options?.client ?? client).put<MaintenanceProgrammeReplaceProgrammeCheckResponses, MaintenanceProgrammeReplaceProgrammeCheckErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/maintenance-programmes/{programme_id}/revisions/{revision_id}/checks/{check_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Release Programme Revision
     */
    public static releaseProgrammeRevision<ThrowOnError extends boolean = false>(parameters: {
        programme_id: string;
        revision_id: string;
        programmeRevisionRelease: ProgrammeRevisionRelease;
    }, options?: Options<never, ThrowOnError>): RequestResult<MaintenanceProgrammeReleaseProgrammeRevisionResponses, MaintenanceProgrammeReleaseProgrammeRevisionErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'programme_id' },
                    { in: 'path', key: 'revision_id' },
                    { key: 'programmeRevisionRelease', map: 'body' }
                ] }]);
        return (options?.client ?? client).post<MaintenanceProgrammeReleaseProgrammeRevisionResponses, MaintenanceProgrammeReleaseProgrammeRevisionErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/maintenance-programmes/{programme_id}/revisions/{revision_id}/release',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * List Programme Tasks
     */
    public static listProgrammeTasks<ThrowOnError extends boolean = false>(parameters: {
        programme_id: string;
        revision_id: string;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<MaintenanceProgrammeListProgrammeTasksResponses, MaintenanceProgrammeListProgrammeTasksErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'programme_id' },
                    { in: 'path', key: 'revision_id' },
                    { in: 'query', key: 'limit' }
                ] }]);
        return (options?.client ?? client).get<MaintenanceProgrammeListProgrammeTasksResponses, MaintenanceProgrammeListProgrammeTasksErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/maintenance-programmes/{programme_id}/revisions/{revision_id}/tasks',
            ...options,
            ...params
        });
    }
    
    /**
     * Add Programme Task
     */
    public static addProgrammeTask<ThrowOnError extends boolean = false>(parameters: {
        programme_id: string;
        revision_id: string;
        programmeTaskBase: ProgrammeTaskBase;
    }, options?: Options<never, ThrowOnError>): RequestResult<MaintenanceProgrammeAddProgrammeTaskResponses, MaintenanceProgrammeAddProgrammeTaskErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'programme_id' },
                    { in: 'path', key: 'revision_id' },
                    { key: 'programmeTaskBase', map: 'body' }
                ] }]);
        return (options?.client ?? client).post<MaintenanceProgrammeAddProgrammeTaskResponses, MaintenanceProgrammeAddProgrammeTaskErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/maintenance-programmes/{programme_id}/revisions/{revision_id}/tasks',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Remove Programme Task
     */
    public static removeProgrammeTask<ThrowOnError extends boolean = false>(parameters: {
        programme_id: string;
        revision_id: string;
        task_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<MaintenanceProgrammeRemoveProgrammeTaskResponses, MaintenanceProgrammeRemoveProgrammeTaskErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'programme_id' },
                    { in: 'path', key: 'revision_id' },
                    { in: 'path', key: 'task_id' }
                ] }]);
        return (options?.client ?? client).delete<MaintenanceProgrammeRemoveProgrammeTaskResponses, MaintenanceProgrammeRemoveProgrammeTaskErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/maintenance-programmes/{programme_id}/revisions/{revision_id}/tasks/{task_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Replace Programme Task
     */
    public static replaceProgrammeTask<ThrowOnError extends boolean = false>(parameters: {
        programme_id: string;
        revision_id: string;
        task_id: string;
        programmeTaskBase: ProgrammeTaskBase;
    }, options?: Options<never, ThrowOnError>): RequestResult<MaintenanceProgrammeReplaceProgrammeTaskResponses, MaintenanceProgrammeReplaceProgrammeTaskErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'programme_id' },
                    { in: 'path', key: 'revision_id' },
                    { in: 'path', key: 'task_id' },
                    { key: 'programmeTaskBase', map: 'body' }
                ] }]);
        return (options?.client ?? client).put<MaintenanceProgrammeReplaceProgrammeTaskResponses, MaintenanceProgrammeReplaceProgrammeTaskErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/maintenance-programmes/{programme_id}/revisions/{revision_id}/tasks/{task_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * List Task Tracked Components
     */
    public static listTaskTrackedComponents<ThrowOnError extends boolean = false>(parameters: {
        programme_id: string;
        revision_id: string;
        task_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<MaintenanceProgrammeListTaskTrackedComponentsResponses, MaintenanceProgrammeListTaskTrackedComponentsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'programme_id' },
                    { in: 'path', key: 'revision_id' },
                    { in: 'path', key: 'task_id' }
                ] }]);
        return (options?.client ?? client).get<MaintenanceProgrammeListTaskTrackedComponentsResponses, MaintenanceProgrammeListTaskTrackedComponentsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/maintenance-programmes/{programme_id}/revisions/{revision_id}/tasks/{task_id}/tracked-components',
            ...options,
            ...params
        });
    }
    
    /**
     * Send Programme To Salesforce
     */
    public static sendProgrammeToSalesforce<ThrowOnError extends boolean = false>(parameters: {
        programme_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<MaintenanceProgrammeSendProgrammeToSalesforceResponses, MaintenanceProgrammeSendProgrammeToSalesforceErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'programme_id' }] }]);
        return (options?.client ?? client).post<MaintenanceProgrammeSendProgrammeToSalesforceResponses, MaintenanceProgrammeSendProgrammeToSalesforceErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/maintenance-programmes/{programme_id}/salesforce-opportunity',
            ...options,
            ...params
        });
    }
}

export class ModStatusService {
    /**
     * Read ModStatuses
     */
    public static readItems<ThrowOnError extends boolean = false>(parameters?: {
        skip?: number;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<ModStatusReadItemsResponses, ModStatusReadItemsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'query', key: 'skip' }, { in: 'query', key: 'limit' }] }]);
        return (options?.client ?? client).get<ModStatusReadItemsResponses, ModStatusReadItemsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/mod-status/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create ModStatus
     */
    public static createItem<ThrowOnError extends boolean = false>(parameters: {
        modStatusCreate: ModStatusCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<ModStatusCreateItemResponses, ModStatusCreateItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'modStatusCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<ModStatusCreateItemResponses, ModStatusCreateItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/mod-status/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Search ModStatuses for an aircraft
     */
    public static searchModStatusByAircraftId<ThrowOnError extends boolean = false>(parameters: {
        aircraft_id: string;
        mod_number?: string | null;
        sb_number?: string | null;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<ModStatusSearchModStatusByAircraftIdResponses, ModStatusSearchModStatusByAircraftIdErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'aircraft_id' },
                    { in: 'query', key: 'mod_number' },
                    { in: 'query', key: 'sb_number' },
                    { in: 'query', key: 'limit' }
                ] }]);
        return (options?.client ?? client).get<ModStatusSearchModStatusByAircraftIdResponses, ModStatusSearchModStatusByAircraftIdErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/mod-status/aircraft/{aircraft_id}/search',
            ...options,
            ...params
        });
    }
    
    /**
     * Delete ModStatus
     */
    public static deleteItem<ThrowOnError extends boolean = false>(parameters: {
        id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<ModStatusDeleteItemResponses, ModStatusDeleteItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'id' }] }]);
        return (options?.client ?? client).delete<ModStatusDeleteItemResponses, ModStatusDeleteItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/mod-status/{id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Read ModStatus
     */
    public static readItem<ThrowOnError extends boolean = false>(parameters: {
        id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<ModStatusReadItemResponses, ModStatusReadItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'id' }] }]);
        return (options?.client ?? client).get<ModStatusReadItemResponses, ModStatusReadItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/mod-status/{id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update ModStatus
     */
    public static updateItem<ThrowOnError extends boolean = false>(parameters: {
        id: string;
        modStatusUpdate: ModStatusUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<ModStatusUpdateItemResponses, ModStatusUpdateItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'id' }, { key: 'modStatusUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<ModStatusUpdateItemResponses, ModStatusUpdateItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/mod-status/{id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class NotificationRulesService {
    /**
     * List Notification Rules
     */
    public static listNotificationRules<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<NotificationRulesListNotificationRulesResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<NotificationRulesListNotificationRulesResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/notification-rules/',
            ...options
        });
    }
    
    /**
     * Create Notification Rule
     */
    public static createNotificationRule<ThrowOnError extends boolean = false>(parameters: {
        notificationRuleCreate: NotificationRuleCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<NotificationRulesCreateNotificationRuleResponses, NotificationRulesCreateNotificationRuleErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'notificationRuleCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<NotificationRulesCreateNotificationRuleResponses, NotificationRulesCreateNotificationRuleErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/notification-rules/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Get Notification Rule Options
     */
    public static getNotificationRuleOptions<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<NotificationRulesGetNotificationRuleOptionsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<NotificationRulesGetNotificationRuleOptionsResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/notification-rules/options',
            ...options
        });
    }
    
    /**
     * Get Notification Rules
     */
    public static getNotificationRules<ThrowOnError extends boolean = false>(parameters: {
        tenant_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<NotificationRulesGetNotificationRulesResponses, NotificationRulesGetNotificationRulesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tenant_id' }] }]);
        return (options?.client ?? client).get<NotificationRulesGetNotificationRulesResponses, NotificationRulesGetNotificationRulesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/notification-rules/tenant/{tenant_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update Notification Rules
     */
    public static updateNotificationRules<ThrowOnError extends boolean = false>(parameters: {
        tenant_id: string;
        notificationRuleSetUpdate: NotificationRuleSetUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<NotificationRulesUpdateNotificationRulesResponses, NotificationRulesUpdateNotificationRulesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tenant_id' }, { key: 'notificationRuleSetUpdate', map: 'body' }] }]);
        return (options?.client ?? client).put<NotificationRulesUpdateNotificationRulesResponses, NotificationRulesUpdateNotificationRulesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/notification-rules/tenant/{tenant_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Get Notification Rule Reference
     */
    public static getNotificationRuleReference<ThrowOnError extends boolean = false>(parameters: {
        tenant_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<NotificationRulesGetNotificationRuleReferenceResponses, NotificationRulesGetNotificationRuleReferenceErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tenant_id' }] }]);
        return (options?.client ?? client).get<NotificationRulesGetNotificationRuleReferenceResponses, NotificationRulesGetNotificationRuleReferenceErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/notification-rules/tenant/{tenant_id}/reference',
            ...options,
            ...params
        });
    }
    
    /**
     * Delete Notification Rule
     */
    public static deleteNotificationRule<ThrowOnError extends boolean = false>(parameters: {
        rule_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<NotificationRulesDeleteNotificationRuleResponses, NotificationRulesDeleteNotificationRuleErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'rule_id' }] }]);
        return (options?.client ?? client).delete<NotificationRulesDeleteNotificationRuleResponses, NotificationRulesDeleteNotificationRuleErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/notification-rules/{rule_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Edit Notification Rule
     */
    public static editNotificationRule<ThrowOnError extends boolean = false>(parameters: {
        rule_id: string;
        notificationRuleUpdate: NotificationRuleUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<NotificationRulesEditNotificationRuleResponses, NotificationRulesEditNotificationRuleErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'rule_id' }, { key: 'notificationRuleUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<NotificationRulesEditNotificationRuleResponses, NotificationRulesEditNotificationRuleErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/notification-rules/{rule_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class NotificationsService {
    /**
     * List Notifications
     */
    public static listNotifications<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<NotificationsListNotificationsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<NotificationsListNotificationsResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/notifications/',
            ...options
        });
    }
    
    /**
     * List Notification Preferences
     */
    public static listNotificationPreferences<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<NotificationsListNotificationPreferencesResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<NotificationsListNotificationPreferencesResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/notifications/preferences/',
            ...options
        });
    }
    
    /**
     * Update Notification Preferences
     */
    public static updateNotificationPreferences<ThrowOnError extends boolean = false>(parameters: {
        body: Array<NotificationPreferenceUpsert>;
    }, options?: Options<never, ThrowOnError>): RequestResult<NotificationsUpdateNotificationPreferencesResponses, NotificationsUpdateNotificationPreferencesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'body', map: 'body' }] }]);
        return (options?.client ?? client).put<NotificationsUpdateNotificationPreferencesResponses, NotificationsUpdateNotificationPreferencesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/notifications/preferences/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Mark All Seen
     */
    public static markAllSeen<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<NotificationsMarkAllSeenResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).post<NotificationsMarkAllSeenResponses, unknown, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/notifications/seen',
            ...options
        });
    }
    
    /**
     * Dismiss
     */
    public static dismiss<ThrowOnError extends boolean = false>(parameters: {
        notification_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<NotificationsDismissResponses, NotificationsDismissErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'notification_id' }] }]);
        return (options?.client ?? client).delete<NotificationsDismissResponses, NotificationsDismissErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/notifications/{notification_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Mark Seen
     */
    public static markSeen<ThrowOnError extends boolean = false>(parameters: {
        notification_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<NotificationsMarkSeenResponses, NotificationsMarkSeenErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'notification_id' }] }]);
        return (options?.client ?? client).post<NotificationsMarkSeenResponses, NotificationsMarkSeenErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/notifications/{notification_id}/seen',
            ...options,
            ...params
        });
    }
    
    /**
     * Resolve Trace
     */
    public static resolveTrace<ThrowOnError extends boolean = false>(parameters: {
        notification_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<NotificationsResolveTraceResponses, NotificationsResolveTraceErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'notification_id' }] }]);
        return (options?.client ?? client).post<NotificationsResolveTraceResponses, NotificationsResolveTraceErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/notifications/{notification_id}/trace',
            ...options,
            ...params
        });
    }
}

export class PartAlternateService {
    /**
     * List Alternates
     */
    public static listAlternates<ThrowOnError extends boolean = false>(parameters?: {
        skip?: number;
        limit?: number;
        part_id?: string | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<PartAlternateListAlternatesResponses, PartAlternateListAlternatesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'part_id' }
                ] }]);
        return (options?.client ?? client).get<PartAlternateListAlternatesResponses, PartAlternateListAlternatesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/part-alternate/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create
     */
    public static create<ThrowOnError extends boolean = false>(parameters: {
        partAlternateCreate: PartAlternateCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<PartAlternateCreateResponses, PartAlternateCreateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'partAlternateCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<PartAlternateCreateResponses, PartAlternateCreateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/part-alternate/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete
     */
    public static delete<ThrowOnError extends boolean = false>(parameters: {
        alternate_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<PartAlternateDeleteResponses, PartAlternateDeleteErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'alternate_id' }] }]);
        return (options?.client ?? client).delete<PartAlternateDeleteResponses, PartAlternateDeleteErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/part-alternate/{alternate_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Get
     */
    public static get<ThrowOnError extends boolean = false>(parameters: {
        alternate_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<PartAlternateGetResponses, PartAlternateGetErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'alternate_id' }] }]);
        return (options?.client ?? client).get<PartAlternateGetResponses, PartAlternateGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/part-alternate/{alternate_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update
     */
    public static update<ThrowOnError extends boolean = false>(parameters: {
        alternate_id: string;
        partAlternateUpdate: PartAlternateUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<PartAlternateUpdateResponses, PartAlternateUpdateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'alternate_id' }, { key: 'partAlternateUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<PartAlternateUpdateResponses, PartAlternateUpdateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/part-alternate/{alternate_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class PartBalanceService {
    /**
     * List Balances
     */
    public static listBalances<ThrowOnError extends boolean = false>(parameters?: {
        skip?: number;
        limit?: number;
        part_id?: string | null;
        facility_id?: string | null;
        condition?: PartCondition | null;
        search?: string | null;
        fittable_only?: boolean;
    }, options?: Options<never, ThrowOnError>): RequestResult<PartBalanceListBalancesResponses, PartBalanceListBalancesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'part_id' },
                    { in: 'query', key: 'facility_id' },
                    { in: 'query', key: 'condition' },
                    { in: 'query', key: 'search' },
                    { in: 'query', key: 'fittable_only' }
                ] }]);
        return (options?.client ?? client).get<PartBalanceListBalancesResponses, PartBalanceListBalancesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/part-balance/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create
     */
    public static create<ThrowOnError extends boolean = false>(parameters: {
        partBalanceCreate: PartBalanceCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<PartBalanceCreateResponses, PartBalanceCreateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'partBalanceCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<PartBalanceCreateResponses, PartBalanceCreateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/part-balance/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete
     */
    public static delete<ThrowOnError extends boolean = false>(parameters: {
        balance_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<PartBalanceDeleteResponses, PartBalanceDeleteErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'balance_id' }] }]);
        return (options?.client ?? client).delete<PartBalanceDeleteResponses, PartBalanceDeleteErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/part-balance/{balance_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Get
     */
    public static get<ThrowOnError extends boolean = false>(parameters: {
        balance_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<PartBalanceGetResponses, PartBalanceGetErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'balance_id' }] }]);
        return (options?.client ?? client).get<PartBalanceGetResponses, PartBalanceGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/part-balance/{balance_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update
     */
    public static update<ThrowOnError extends boolean = false>(parameters: {
        balance_id: string;
        partBalanceUpdate: PartBalanceUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<PartBalanceUpdateResponses, PartBalanceUpdateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'balance_id' }, { key: 'partBalanceUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<PartBalanceUpdateResponses, PartBalanceUpdateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/part-balance/{balance_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class PartWorkHistoryService {
    /**
     * List Entries
     */
    public static listEntries<ThrowOnError extends boolean = false>(parameters: {
        part_instance_id: string;
        skip?: number;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<PartWorkHistoryListEntriesResponses, PartWorkHistoryListEntriesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'part_instance_id' },
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' }
                ] }]);
        return (options?.client ?? client).get<PartWorkHistoryListEntriesResponses, PartWorkHistoryListEntriesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/part-instances/{part_instance_id}/work-history/',
            ...options,
            ...params
        });
    }
    
    /**
     * Link
     */
    public static link<ThrowOnError extends boolean = false>(parameters: {
        part_instance_id: string;
        partInstanceWorkHistoryEntryCreate: PartInstanceWorkHistoryEntryCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<PartWorkHistoryLinkResponses, PartWorkHistoryLinkErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'part_instance_id' }, { key: 'partInstanceWorkHistoryEntryCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<PartWorkHistoryLinkResponses, PartWorkHistoryLinkErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/part-instances/{part_instance_id}/work-history/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Unlink
     */
    public static unlink<ThrowOnError extends boolean = false>(parameters: {
        part_instance_id: string;
        entry_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<PartWorkHistoryUnlinkResponses, PartWorkHistoryUnlinkErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'part_instance_id' }, { in: 'path', key: 'entry_id' }] }]);
        return (options?.client ?? client).delete<PartWorkHistoryUnlinkResponses, PartWorkHistoryUnlinkErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/part-instances/{part_instance_id}/work-history/{entry_id}',
            ...options,
            ...params
        });
    }
}

export class PartPriceService {
    /**
     * List Prices
     */
    public static listPrices<ThrowOnError extends boolean = false>(parameters?: {
        skip?: number;
        limit?: number;
        part_id?: string | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<PartPriceListPricesResponses, PartPriceListPricesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'part_id' }
                ] }]);
        return (options?.client ?? client).get<PartPriceListPricesResponses, PartPriceListPricesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/part-price/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create
     */
    public static create<ThrowOnError extends boolean = false>(parameters: {
        partPriceCreate: PartPriceCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<PartPriceCreateResponses, PartPriceCreateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'partPriceCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<PartPriceCreateResponses, PartPriceCreateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/part-price/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete
     */
    public static delete<ThrowOnError extends boolean = false>(parameters: {
        price_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<PartPriceDeleteResponses, PartPriceDeleteErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'price_id' }] }]);
        return (options?.client ?? client).delete<PartPriceDeleteResponses, PartPriceDeleteErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/part-price/{price_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Get
     */
    public static get<ThrowOnError extends boolean = false>(parameters: {
        price_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<PartPriceGetResponses, PartPriceGetErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'price_id' }] }]);
        return (options?.client ?? client).get<PartPriceGetResponses, PartPriceGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/part-price/{price_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update
     */
    public static update<ThrowOnError extends boolean = false>(parameters: {
        price_id: string;
        partPriceUpdate: PartPriceUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<PartPriceUpdateResponses, PartPriceUpdateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'price_id' }, { key: 'partPriceUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<PartPriceUpdateResponses, PartPriceUpdateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/part-price/{price_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class PartReservationService {
    /**
     * List Reservations
     */
    public static listReservations<ThrowOnError extends boolean = false>(parameters?: {
        skip?: number;
        limit?: number;
        part_id?: string | null;
        condition?: PartCondition | null;
        quote_task_id?: string | null;
        work_package_id?: string | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<PartReservationListReservationsResponses, PartReservationListReservationsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'part_id' },
                    { in: 'query', key: 'condition' },
                    { in: 'query', key: 'quote_task_id' },
                    { in: 'query', key: 'work_package_id' }
                ] }]);
        return (options?.client ?? client).get<PartReservationListReservationsResponses, PartReservationListReservationsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/part-reservation/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create
     */
    public static create<ThrowOnError extends boolean = false>(parameters: {
        partReservationCreate: PartReservationCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<PartReservationCreateResponses, PartReservationCreateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'partReservationCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<PartReservationCreateResponses, PartReservationCreateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/part-reservation/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * List Holding Work Orders
     */
    public static listHoldingWorkOrders<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<PartReservationListHoldingWorkOrdersResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<PartReservationListHoldingWorkOrdersResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/part-reservation/work-orders',
            ...options
        });
    }
    
    /**
     * Delete
     */
    public static delete<ThrowOnError extends boolean = false>(parameters: {
        reservation_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<PartReservationDeleteResponses, PartReservationDeleteErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'reservation_id' }] }]);
        return (options?.client ?? client).delete<PartReservationDeleteResponses, PartReservationDeleteErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/part-reservation/{reservation_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Get
     */
    public static get<ThrowOnError extends boolean = false>(parameters: {
        reservation_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<PartReservationGetResponses, PartReservationGetErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'reservation_id' }] }]);
        return (options?.client ?? client).get<PartReservationGetResponses, PartReservationGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/part-reservation/{reservation_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update
     */
    public static update<ThrowOnError extends boolean = false>(parameters: {
        reservation_id: string;
        partReservationUpdate: PartReservationUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<PartReservationUpdateResponses, PartReservationUpdateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'reservation_id' }, { key: 'partReservationUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<PartReservationUpdateResponses, PartReservationUpdateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/part-reservation/{reservation_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class PartStockService {
    /**
     * List Stock
     */
    public static listStock<ThrowOnError extends boolean = false>(parameters?: {
        search?: string | null;
        number?: Array<string> | null;
        view?: PartStockView | null;
        status?: Array<PartStockStatus> | null;
        manufacturer?: Array<string> | null;
        condition?: Array<PartCondition> | null;
        facility_id?: Array<string> | null;
        work_package_id?: Array<string> | null;
        archive?: PartArchiveScope;
        group?: PartStockGrouping | null;
        subgroup?: PartStockGrouping | null;
        group_key?: string | null;
        group_limit?: number | null;
        sort?: PartStockSort | null;
        direction?: SortDirection;
        skip?: number;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<PartStockListStockResponses, PartStockListStockErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'search' },
                    { in: 'query', key: 'number' },
                    { in: 'query', key: 'view' },
                    { in: 'query', key: 'status' },
                    { in: 'query', key: 'manufacturer' },
                    { in: 'query', key: 'condition' },
                    { in: 'query', key: 'facility_id' },
                    { in: 'query', key: 'work_package_id' },
                    { in: 'query', key: 'archive' },
                    { in: 'query', key: 'group' },
                    { in: 'query', key: 'subgroup' },
                    { in: 'query', key: 'group_key' },
                    { in: 'query', key: 'group_limit' },
                    { in: 'query', key: 'sort' },
                    { in: 'query', key: 'direction' },
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' }
                ] }]);
        return (options?.client ?? client).get<PartStockListStockResponses, PartStockListStockErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/part-stock/',
            ...options,
            ...params
        });
    }
    
    /**
     * Get
     */
    public static get<ThrowOnError extends boolean = false>(parameters: {
        part_id: string;
        archive?: PartArchiveScope;
    }, options?: Options<never, ThrowOnError>): RequestResult<PartStockGetResponses, PartStockGetErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'part_id' }, { in: 'query', key: 'archive' }] }]);
        return (options?.client ?? client).get<PartStockGetResponses, PartStockGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/part-stock/{part_id}',
            ...options,
            ...params
        });
    }
}

export class PartsService {
    /**
     * Search Parts
     */
    public static searchParts<ThrowOnError extends boolean = false>(parameters?: {
        search?: string | null;
        part_id?: Array<string> | null;
        skip?: number;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<PartsSearchPartsResponses, PartsSearchPartsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'search' },
                    { in: 'query', key: 'part_id' },
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' }
                ] }]);
        return (options?.client ?? client).get<PartsSearchPartsResponses, PartsSearchPartsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/parts/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create Part
     */
    public static createPart<ThrowOnError extends boolean = false>(parameters: {
        partDetails: PartDetails;
    }, options?: Options<never, ThrowOnError>): RequestResult<PartsCreatePartResponses, PartsCreatePartErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'partDetails', map: 'body' }] }]);
        return (options?.client ?? client).post<PartsCreatePartResponses, PartsCreatePartErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/parts/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete Parts
     */
    public static deleteParts<ThrowOnError extends boolean = false>(parameters: {
        partBulkIds: PartBulkIds;
    }, options?: Options<never, ThrowOnError>): RequestResult<PartsDeletePartsResponses, PartsDeletePartsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'partBulkIds', map: 'body' }] }]);
        return (options?.client ?? client).post<PartsDeletePartsResponses, PartsDeletePartsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/parts/bulk/delete',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * List Manufacturers
     */
    public static listManufacturers<ThrowOnError extends boolean = false>(parameters?: {
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<PartsListManufacturersResponses, PartsListManufacturersErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'query', key: 'limit' }] }]);
        return (options?.client ?? client).get<PartsListManufacturersResponses, PartsListManufacturersErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/parts/manufacturers',
            ...options,
            ...params
        });
    }
    
    /**
     * Delete Part
     */
    public static deletePart<ThrowOnError extends boolean = false>(parameters: {
        part_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<PartsDeletePartResponses, PartsDeletePartErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'part_id' }] }]);
        return (options?.client ?? client).delete<PartsDeletePartResponses, PartsDeletePartErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/parts/{part_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Get Part
     */
    public static getPart<ThrowOnError extends boolean = false>(parameters: {
        part_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<PartsGetPartResponses, PartsGetPartErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'part_id' }] }]);
        return (options?.client ?? client).get<PartsGetPartResponses, PartsGetPartErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/parts/{part_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update Part
     */
    public static updatePart<ThrowOnError extends boolean = false>(parameters: {
        part_id: string;
        partUpdate: PartUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<PartsUpdatePartResponses, PartsUpdatePartErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'part_id' }, { key: 'partUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<PartsUpdatePartResponses, PartsUpdatePartErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/parts/{part_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Archive Part
     */
    public static archivePart<ThrowOnError extends boolean = false>(parameters: {
        part_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<PartsArchivePartResponses, PartsArchivePartErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'part_id' }] }]);
        return (options?.client ?? client).post<PartsArchivePartResponses, PartsArchivePartErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/parts/{part_id}/archive',
            ...options,
            ...params
        });
    }
    
    /**
     * Restore Part
     */
    public static restorePart<ThrowOnError extends boolean = false>(parameters: {
        part_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<PartsRestorePartResponses, PartsRestorePartErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'part_id' }] }]);
        return (options?.client ?? client).post<PartsRestorePartResponses, PartsRestorePartErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/parts/{part_id}/restore',
            ...options,
            ...params
        });
    }
}

export class PositionsService {
    /**
     * List Positions
     */
    public static listPositions<ThrowOnError extends boolean = false>(parameters?: {
        team_id?: string | null;
        department_id?: string | null;
        facility_id?: string | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<PositionsListPositionsResponses, PositionsListPositionsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'team_id' },
                    { in: 'query', key: 'department_id' },
                    { in: 'query', key: 'facility_id' }
                ] }]);
        return (options?.client ?? client).get<PositionsListPositionsResponses, PositionsListPositionsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/positions/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create
     */
    public static create<ThrowOnError extends boolean = false>(parameters: {
        positionCreate: PositionCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<PositionsCreateResponses, PositionsCreateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'positionCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<PositionsCreateResponses, PositionsCreateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/positions/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete
     */
    public static delete<ThrowOnError extends boolean = false>(parameters: {
        position_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<PositionsDeleteResponses, PositionsDeleteErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'position_id' }] }]);
        return (options?.client ?? client).delete<PositionsDeleteResponses, PositionsDeleteErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/positions/{position_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update
     */
    public static update<ThrowOnError extends boolean = false>(parameters: {
        position_id: string;
        positionUpdate: PositionUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<PositionsUpdateResponses, PositionsUpdateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'position_id' }, { key: 'positionUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<PositionsUpdateResponses, PositionsUpdateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/positions/{position_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class PurchaseOrderService {
    /**
     * List Purchase Orders
     */
    public static listPurchaseOrders<ThrowOnError extends boolean = false>(parameters?: {
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<PurchaseOrderListPurchaseOrdersResponses, PurchaseOrderListPurchaseOrdersErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'query', key: 'limit' }] }]);
        return (options?.client ?? client).get<PurchaseOrderListPurchaseOrdersResponses, PurchaseOrderListPurchaseOrdersErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/purchase-orders',
            ...options,
            ...params
        });
    }
    
    /**
     * Create Purchase Order
     */
    public static createPurchaseOrder<ThrowOnError extends boolean = false>(parameters: {
        purchaseOrderCreate: PurchaseOrderCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<PurchaseOrderCreatePurchaseOrderResponses, PurchaseOrderCreatePurchaseOrderErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'purchaseOrderCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<PurchaseOrderCreatePurchaseOrderResponses, PurchaseOrderCreatePurchaseOrderErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/purchase-orders',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Get Purchase Order
     */
    public static getPurchaseOrder<ThrowOnError extends boolean = false>(parameters: {
        purchase_order_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<PurchaseOrderGetPurchaseOrderResponses, PurchaseOrderGetPurchaseOrderErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'purchase_order_id' }] }]);
        return (options?.client ?? client).get<PurchaseOrderGetPurchaseOrderResponses, PurchaseOrderGetPurchaseOrderErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/purchase-orders/{purchase_order_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Export Purchase Order Pdf
     */
    public static exportPurchaseOrderPdf<ThrowOnError extends boolean = false>(parameters: {
        purchase_order_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<PurchaseOrderExportPurchaseOrderPdfResponses, PurchaseOrderExportPurchaseOrderPdfErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'purchase_order_id' }] }]);
        return (options?.client ?? client).get<PurchaseOrderExportPurchaseOrderPdfResponses, PurchaseOrderExportPurchaseOrderPdfErrors, ThrowOnError>({
            responseType: 'blob',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/purchase-orders/{purchase_order_id}/pdf',
            ...options,
            ...params
        });
    }
}

export class QuoteDispositionsService {
    /**
     * List Quote Dispositions
     */
    public static listQuoteDispositions<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<QuoteDispositionsListQuoteDispositionsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<QuoteDispositionsListQuoteDispositionsResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quote-dispositions/',
            ...options
        });
    }
    
    /**
     * Update
     */
    public static update<ThrowOnError extends boolean = false>(parameters: {
        disposition_id: string;
        quoteDispositionUpdate: QuoteDispositionUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteDispositionsUpdateResponses, QuoteDispositionsUpdateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'disposition_id' }, { key: 'quoteDispositionUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<QuoteDispositionsUpdateResponses, QuoteDispositionsUpdateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quote-dispositions/{disposition_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class QuoteFeeTemplatesService {
    /**
     * List Quote Fee Templates
     */
    public static listQuoteFeeTemplates<ThrowOnError extends boolean = false>(parameters?: {
        skip?: number;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteFeeTemplatesListQuoteFeeTemplatesResponses, QuoteFeeTemplatesListQuoteFeeTemplatesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'query', key: 'skip' }, { in: 'query', key: 'limit' }] }]);
        return (options?.client ?? client).get<QuoteFeeTemplatesListQuoteFeeTemplatesResponses, QuoteFeeTemplatesListQuoteFeeTemplatesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quote-fee-templates/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create
     */
    public static create<ThrowOnError extends boolean = false>(parameters: {
        quoteFeeTemplateCreate: QuoteFeeTemplateCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteFeeTemplatesCreateResponses, QuoteFeeTemplatesCreateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'quoteFeeTemplateCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<QuoteFeeTemplatesCreateResponses, QuoteFeeTemplatesCreateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quote-fee-templates/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete
     */
    public static delete<ThrowOnError extends boolean = false>(parameters: {
        fee_template_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteFeeTemplatesDeleteResponses, QuoteFeeTemplatesDeleteErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'fee_template_id' }] }]);
        return (options?.client ?? client).delete<QuoteFeeTemplatesDeleteResponses, QuoteFeeTemplatesDeleteErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quote-fee-templates/{fee_template_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Get
     */
    public static get<ThrowOnError extends boolean = false>(parameters: {
        fee_template_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteFeeTemplatesGetResponses, QuoteFeeTemplatesGetErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'fee_template_id' }] }]);
        return (options?.client ?? client).get<QuoteFeeTemplatesGetResponses, QuoteFeeTemplatesGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quote-fee-templates/{fee_template_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update
     */
    public static update<ThrowOnError extends boolean = false>(parameters: {
        fee_template_id: string;
        quoteFeeTemplateUpdate: QuoteFeeTemplateUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteFeeTemplatesUpdateResponses, QuoteFeeTemplatesUpdateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'fee_template_id' }, { key: 'quoteFeeTemplateUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<QuoteFeeTemplatesUpdateResponses, QuoteFeeTemplatesUpdateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quote-fee-templates/{fee_template_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class QuoteNumberSequenceService {
    /**
     * Get Quote Number Sequence
     */
    public static getQuoteNumberSequence<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<QuoteNumberSequenceGetQuoteNumberSequenceResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<QuoteNumberSequenceGetQuoteNumberSequenceResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quote-number-sequence/',
            ...options
        });
    }
    
    /**
     * Upsert Quote Number Sequence
     */
    public static upsertQuoteNumberSequence<ThrowOnError extends boolean = false>(parameters: {
        quoteNumberSequenceUpsert: QuoteNumberSequenceUpsert;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteNumberSequenceUpsertQuoteNumberSequenceResponses, QuoteNumberSequenceUpsertQuoteNumberSequenceErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'quoteNumberSequenceUpsert', map: 'body' }] }]);
        return (options?.client ?? client).put<QuoteNumberSequenceUpsertQuoteNumberSequenceResponses, QuoteNumberSequenceUpsertQuoteNumberSequenceErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quote-number-sequence/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class QuoteReviewsService {
    /**
     * Link
     */
    public static link<ThrowOnError extends boolean = false>(parameters: {
        token: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteReviewsLinkResponses, QuoteReviewsLinkErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'token' }] }]);
        return (options?.client ?? client).get<QuoteReviewsLinkResponses, QuoteReviewsLinkErrors, ThrowOnError>({
            responseType: 'json',
            url: '/api/v1/quote-reviews/{token}',
            ...options,
            ...params
        });
    }
    
    /**
     * Send Code
     */
    public static sendCode<ThrowOnError extends boolean = false>(parameters: {
        token: string;
        quoteReviewCodeRequest: QuoteReviewCodeRequest;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteReviewsSendCodeResponses, QuoteReviewsSendCodeErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'token' }, { key: 'quoteReviewCodeRequest', map: 'body' }] }]);
        return (options?.client ?? client).post<QuoteReviewsSendCodeResponses, QuoteReviewsSendCodeErrors, ThrowOnError>({
            responseType: 'json',
            url: '/api/v1/quote-reviews/{token}/codes',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Decide
     */
    public static decide<ThrowOnError extends boolean = false>(parameters: {
        'x-review-session': string;
        token: string;
        quoteReviewDecision: QuoteReviewDecision;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteReviewsDecideResponses, QuoteReviewsDecideErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'headers', key: 'x-review-session' },
                    { in: 'path', key: 'token' },
                    { key: 'quoteReviewDecision', map: 'body' }
                ] }]);
        return (options?.client ?? client).put<QuoteReviewsDecideResponses, QuoteReviewsDecideErrors, ThrowOnError>({
            responseType: 'json',
            url: '/api/v1/quote-reviews/{token}/decisions',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Proposal
     */
    public static proposal<ThrowOnError extends boolean = false>(parameters: {
        'x-review-session': string;
        token: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteReviewsProposalResponses, QuoteReviewsProposalErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'headers', key: 'x-review-session' }, { in: 'path', key: 'token' }] }]);
        return (options?.client ?? client).get<QuoteReviewsProposalResponses, QuoteReviewsProposalErrors, ThrowOnError>({
            responseType: 'json',
            url: '/api/v1/quote-reviews/{token}/proposal',
            ...options,
            ...params
        });
    }
    
    /**
     * Open Session
     */
    public static openSession<ThrowOnError extends boolean = false>(parameters: {
        token: string;
        quoteReviewSessionCreate: QuoteReviewSessionCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteReviewsOpenSessionResponses, QuoteReviewsOpenSessionErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'token' }, { key: 'quoteReviewSessionCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<QuoteReviewsOpenSessionResponses, QuoteReviewsOpenSessionErrors, ThrowOnError>({
            responseType: 'json',
            url: '/api/v1/quote-reviews/{token}/sessions',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Sign
     */
    public static sign<ThrowOnError extends boolean = false>(parameters: {
        'x-review-session': string;
        token: string;
        quoteReviewSignatureCreate: QuoteReviewSignatureCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteReviewsSignResponses, QuoteReviewsSignErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'headers', key: 'x-review-session' },
                    { in: 'path', key: 'token' },
                    { key: 'quoteReviewSignatureCreate', map: 'body' }
                ] }]);
        return (options?.client ?? client).post<QuoteReviewsSignResponses, QuoteReviewsSignErrors, ThrowOnError>({
            responseType: 'json',
            url: '/api/v1/quote-reviews/{token}/signatures',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Signed Authorisation
     */
    public static signedAuthorisation<ThrowOnError extends boolean = false>(parameters: {
        'x-review-session': string;
        token: string;
        signature_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteReviewsSignedAuthorisationResponses, QuoteReviewsSignedAuthorisationErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'headers', key: 'x-review-session' },
                    { in: 'path', key: 'token' },
                    { in: 'path', key: 'signature_id' }
                ] }]);
        return (options?.client ?? client).get<QuoteReviewsSignedAuthorisationResponses, QuoteReviewsSignedAuthorisationErrors, ThrowOnError>({
            responseType: 'blob',
            url: '/api/v1/quote-reviews/{token}/signatures/{signature_id}/document',
            ...options,
            ...params
        });
    }
    
    /**
     * Comment
     */
    public static comment<ThrowOnError extends boolean = false>(parameters: {
        'x-review-session': string;
        token: string;
        task_id: string;
        quoteReviewCommentCreate: QuoteReviewCommentCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteReviewsCommentResponses, QuoteReviewsCommentErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'headers', key: 'x-review-session' },
                    { in: 'path', key: 'token' },
                    { in: 'path', key: 'task_id' },
                    { key: 'quoteReviewCommentCreate', map: 'body' }
                ] }]);
        return (options?.client ?? client).post<QuoteReviewsCommentResponses, QuoteReviewsCommentErrors, ThrowOnError>({
            responseType: 'json',
            url: '/api/v1/quote-reviews/{token}/tasks/{task_id}/comments',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class QuoteRevisionsService {
    /**
     * Get
     */
    public static get<ThrowOnError extends boolean = false>(parameters: {
        revision_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteRevisionsGetResponses, QuoteRevisionsGetErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'revision_id' }] }]);
        return (options?.client ?? client).get<QuoteRevisionsGetResponses, QuoteRevisionsGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quote-revisions/{revision_id}',
            ...options,
            ...params
        });
    }
}

export class QuoteRulesetEvaluationsService {
    /**
     * List Evaluations
     */
    public static listEvaluations<ThrowOnError extends boolean = false>(parameters?: {
        quote_id?: string | null;
        ruleset_id?: string | null;
        skip?: number;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteRulesetEvaluationsListEvaluationsResponses, QuoteRulesetEvaluationsListEvaluationsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'quote_id' },
                    { in: 'query', key: 'ruleset_id' },
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' }
                ] }]);
        return (options?.client ?? client).get<QuoteRulesetEvaluationsListEvaluationsResponses, QuoteRulesetEvaluationsListEvaluationsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quote-ruleset-evaluations/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create
     */
    public static create<ThrowOnError extends boolean = false>(parameters: {
        quoteRulesetEvaluationCreate: QuoteRulesetEvaluationCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteRulesetEvaluationsCreateResponses, QuoteRulesetEvaluationsCreateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'quoteRulesetEvaluationCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<QuoteRulesetEvaluationsCreateResponses, QuoteRulesetEvaluationsCreateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quote-ruleset-evaluations/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Create Applicable
     */
    public static createApplicable<ThrowOnError extends boolean = false>(parameters: {
        quoteRulesetEvaluationsCreate: QuoteRulesetEvaluationsCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteRulesetEvaluationsCreateApplicableResponses, QuoteRulesetEvaluationsCreateApplicableErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'quoteRulesetEvaluationsCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<QuoteRulesetEvaluationsCreateApplicableResponses, QuoteRulesetEvaluationsCreateApplicableErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quote-ruleset-evaluations/applicable',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete
     */
    public static delete<ThrowOnError extends boolean = false>(parameters: {
        evaluation_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteRulesetEvaluationsDeleteResponses, QuoteRulesetEvaluationsDeleteErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'evaluation_id' }] }]);
        return (options?.client ?? client).delete<QuoteRulesetEvaluationsDeleteResponses, QuoteRulesetEvaluationsDeleteErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quote-ruleset-evaluations/{evaluation_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Get
     */
    public static get<ThrowOnError extends boolean = false>(parameters: {
        evaluation_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteRulesetEvaluationsGetResponses, QuoteRulesetEvaluationsGetErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'evaluation_id' }] }]);
        return (options?.client ?? client).get<QuoteRulesetEvaluationsGetResponses, QuoteRulesetEvaluationsGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quote-ruleset-evaluations/{evaluation_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Pending Rules
     */
    public static pendingRules<ThrowOnError extends boolean = false>(parameters: {
        evaluation_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteRulesetEvaluationsPendingRulesResponses, QuoteRulesetEvaluationsPendingRulesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'evaluation_id' }] }]);
        return (options?.client ?? client).get<QuoteRulesetEvaluationsPendingRulesResponses, QuoteRulesetEvaluationsPendingRulesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quote-ruleset-evaluations/{evaluation_id}/pending-rules',
            ...options,
            ...params
        });
    }
    
    /**
     * Create Result
     */
    public static createResult<ThrowOnError extends boolean = false>(parameters: {
        evaluation_id: string;
        quoteRulesetEvaluationResultCreate: QuoteRulesetEvaluationResultCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteRulesetEvaluationsCreateResultResponses, QuoteRulesetEvaluationsCreateResultErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'evaluation_id' }, { key: 'quoteRulesetEvaluationResultCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<QuoteRulesetEvaluationsCreateResultResponses, QuoteRulesetEvaluationsCreateResultErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quote-ruleset-evaluations/{evaluation_id}/results',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class QuoteRulesetsService {
    /**
     * List Rulesets
     */
    public static listRulesets<ThrowOnError extends boolean = false>(parameters?: {
        skip?: number;
        limit?: number;
        search?: string | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteRulesetsListRulesetsResponses, QuoteRulesetsListRulesetsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'search' }
                ] }]);
        return (options?.client ?? client).get<QuoteRulesetsListRulesetsResponses, QuoteRulesetsListRulesetsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quote-rulesets/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create
     */
    public static create<ThrowOnError extends boolean = false>(parameters: {
        quoteRulesetCreate: QuoteRulesetCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteRulesetsCreateResponses, QuoteRulesetsCreateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'quoteRulesetCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<QuoteRulesetsCreateResponses, QuoteRulesetsCreateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quote-rulesets/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Archive
     */
    public static archive<ThrowOnError extends boolean = false>(parameters: {
        ruleset_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteRulesetsArchiveResponses, QuoteRulesetsArchiveErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'ruleset_id' }] }]);
        return (options?.client ?? client).delete<QuoteRulesetsArchiveResponses, QuoteRulesetsArchiveErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quote-rulesets/{ruleset_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Get
     */
    public static get<ThrowOnError extends boolean = false>(parameters: {
        ruleset_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteRulesetsGetResponses, QuoteRulesetsGetErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'ruleset_id' }] }]);
        return (options?.client ?? client).get<QuoteRulesetsGetResponses, QuoteRulesetsGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quote-rulesets/{ruleset_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update
     */
    public static update<ThrowOnError extends boolean = false>(parameters: {
        ruleset_id: string;
        quoteRulesetUpdate: QuoteRulesetUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteRulesetsUpdateResponses, QuoteRulesetsUpdateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'ruleset_id' }, { key: 'quoteRulesetUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<QuoteRulesetsUpdateResponses, QuoteRulesetsUpdateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quote-rulesets/{ruleset_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * List Versions
     */
    public static listVersions<ThrowOnError extends boolean = false>(parameters: {
        ruleset_id: string;
        skip?: number;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteRulesetsListVersionsResponses, QuoteRulesetsListVersionsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'ruleset_id' },
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' }
                ] }]);
        return (options?.client ?? client).get<QuoteRulesetsListVersionsResponses, QuoteRulesetsListVersionsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quote-rulesets/{ruleset_id}/versions',
            ...options,
            ...params
        });
    }
    
    /**
     * Create Version
     */
    public static createVersion<ThrowOnError extends boolean = false>(parameters: {
        ruleset_id: string;
        quoteRulesetVersionCreate: QuoteRulesetVersionCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteRulesetsCreateVersionResponses, QuoteRulesetsCreateVersionErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'ruleset_id' }, { key: 'quoteRulesetVersionCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<QuoteRulesetsCreateVersionResponses, QuoteRulesetsCreateVersionErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quote-rulesets/{ruleset_id}/versions',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class QuoteTaskAttachmentService {
    /**
     * List For Quote Task
     */
    public static listForQuoteTask<ThrowOnError extends boolean = false>(parameters: {
        quote_task_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteTaskAttachmentListForQuoteTaskResponses, QuoteTaskAttachmentListForQuoteTaskErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'quote_task_id' }] }]);
        return (options?.client ?? client).get<QuoteTaskAttachmentListForQuoteTaskResponses, QuoteTaskAttachmentListForQuoteTaskErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quote-task-attachment/quote-task/{quote_task_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Upload For Quote Task
     */
    public static uploadForQuoteTask<ThrowOnError extends boolean = false>(parameters: {
        quote_task_id: string;
        bodyQuoteTaskAttachmentUploadForQuoteTask: BodyQuoteTaskAttachmentUploadForQuoteTask;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteTaskAttachmentUploadForQuoteTaskResponses, QuoteTaskAttachmentUploadForQuoteTaskErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'quote_task_id' }, { key: 'bodyQuoteTaskAttachmentUploadForQuoteTask', map: 'body' }] }]);
        return (options?.client ?? client).post<QuoteTaskAttachmentUploadForQuoteTaskResponses, QuoteTaskAttachmentUploadForQuoteTaskErrors, ThrowOnError>({
            ...formDataBodySerializer,
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quote-task-attachment/quote-task/{quote_task_id}/upload',
            ...options,
            ...params,
            headers: {
                'Content-Type': null,
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete Attachment
     */
    public static deleteAttachment<ThrowOnError extends boolean = false>(parameters: {
        document_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteTaskAttachmentDeleteAttachmentResponses, QuoteTaskAttachmentDeleteAttachmentErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'document_id' }] }]);
        return (options?.client ?? client).delete<QuoteTaskAttachmentDeleteAttachmentResponses, QuoteTaskAttachmentDeleteAttachmentErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quote-task-attachment/{document_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Get Download Url
     */
    public static getDownloadUrl<ThrowOnError extends boolean = false>(parameters: {
        document_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteTaskAttachmentGetDownloadUrlResponses, QuoteTaskAttachmentGetDownloadUrlErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'document_id' }] }]);
        return (options?.client ?? client).get<QuoteTaskAttachmentGetDownloadUrlResponses, QuoteTaskAttachmentGetDownloadUrlErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quote-task-attachment/{document_id}/download-url',
            ...options,
            ...params
        });
    }
}

export class QuoteTaskGroupsService {
    /**
     * List Quote Task Groups
     */
    public static listQuoteTaskGroups<ThrowOnError extends boolean = false>(parameters?: {
        deleted?: boolean;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteTaskGroupsListQuoteTaskGroupsResponses, QuoteTaskGroupsListQuoteTaskGroupsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'query', key: 'deleted' }] }]);
        return (options?.client ?? client).get<QuoteTaskGroupsListQuoteTaskGroupsResponses, QuoteTaskGroupsListQuoteTaskGroupsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quote-task-groups/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create
     */
    public static create<ThrowOnError extends boolean = false>(parameters: {
        quoteTaskGroupCreate: QuoteTaskGroupCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteTaskGroupsCreateResponses, QuoteTaskGroupsCreateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'quoteTaskGroupCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<QuoteTaskGroupsCreateResponses, QuoteTaskGroupsCreateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quote-task-groups/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Create Many
     */
    public static createMany<ThrowOnError extends boolean = false>(parameters: {
        quoteTaskGroupsCreate: QuoteTaskGroupsCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteTaskGroupsCreateManyResponses, QuoteTaskGroupsCreateManyErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'quoteTaskGroupsCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<QuoteTaskGroupsCreateManyResponses, QuoteTaskGroupsCreateManyErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quote-task-groups/bulk',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Reorder
     */
    public static reorder<ThrowOnError extends boolean = false>(parameters: {
        quoteTaskGroupOrder: QuoteTaskGroupOrder;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteTaskGroupsReorderResponses, QuoteTaskGroupsReorderErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'quoteTaskGroupOrder', map: 'body' }] }]);
        return (options?.client ?? client).put<QuoteTaskGroupsReorderResponses, QuoteTaskGroupsReorderErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quote-task-groups/order',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete
     */
    public static delete<ThrowOnError extends boolean = false>(parameters: {
        group_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteTaskGroupsDeleteResponses, QuoteTaskGroupsDeleteErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'group_id' }] }]);
        return (options?.client ?? client).delete<QuoteTaskGroupsDeleteResponses, QuoteTaskGroupsDeleteErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quote-task-groups/{group_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Get
     */
    public static get<ThrowOnError extends boolean = false>(parameters: {
        group_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteTaskGroupsGetResponses, QuoteTaskGroupsGetErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'group_id' }] }]);
        return (options?.client ?? client).get<QuoteTaskGroupsGetResponses, QuoteTaskGroupsGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quote-task-groups/{group_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update
     */
    public static update<ThrowOnError extends boolean = false>(parameters: {
        group_id: string;
        quoteTaskGroupUpdate: QuoteTaskGroupUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteTaskGroupsUpdateResponses, QuoteTaskGroupsUpdateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'group_id' }, { key: 'quoteTaskGroupUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<QuoteTaskGroupsUpdateResponses, QuoteTaskGroupsUpdateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quote-task-groups/{group_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Restore
     */
    public static restore<ThrowOnError extends boolean = false>(parameters: {
        group_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteTaskGroupsRestoreResponses, QuoteTaskGroupsRestoreErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'group_id' }] }]);
        return (options?.client ?? client).post<QuoteTaskGroupsRestoreResponses, QuoteTaskGroupsRestoreErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quote-task-groups/{group_id}/restore',
            ...options,
            ...params
        });
    }
}

export class QuotesService {
    /**
     * List Quotes
     */
    public static listQuotes<ThrowOnError extends boolean = false>(parameters?: {
        skip?: number;
        limit?: number;
        search?: string | null;
        disposition?: Array<QuoteDispositionKind> | null;
        kind?: Array<QuoteKind> | null;
        customer_id?: Array<string> | null;
        aircraft_id?: Array<string> | null;
        aircraft_model?: Array<string> | null;
        part_id?: Array<string> | null;
        department_id?: Array<string> | null;
        sales_rep_id?: Array<string> | null;
        reviewer_id?: Array<string> | null;
        created_by_id?: Array<string> | null;
        revision?: Array<number> | null;
        work_package_id?: Array<string> | null;
        created_from?: string | null;
        created_to?: string | null;
        archived?: boolean;
        order?: QuoteOrder;
        sort?: QuoteSort | null;
        direction?: SortDirection;
        group?: QuoteGrouping | null;
        subgroup?: QuoteGrouping | null;
        group_key?: string | null;
        group_limit?: number | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotesListQuotesResponses, QuotesListQuotesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'search' },
                    { in: 'query', key: 'disposition' },
                    { in: 'query', key: 'kind' },
                    { in: 'query', key: 'customer_id' },
                    { in: 'query', key: 'aircraft_id' },
                    { in: 'query', key: 'aircraft_model' },
                    { in: 'query', key: 'part_id' },
                    { in: 'query', key: 'department_id' },
                    { in: 'query', key: 'sales_rep_id' },
                    { in: 'query', key: 'reviewer_id' },
                    { in: 'query', key: 'created_by_id' },
                    { in: 'query', key: 'revision' },
                    { in: 'query', key: 'work_package_id' },
                    { in: 'query', key: 'created_from' },
                    { in: 'query', key: 'created_to' },
                    { in: 'query', key: 'archived' },
                    { in: 'query', key: 'order' },
                    { in: 'query', key: 'sort' },
                    { in: 'query', key: 'direction' },
                    { in: 'query', key: 'group' },
                    { in: 'query', key: 'subgroup' },
                    { in: 'query', key: 'group_key' },
                    { in: 'query', key: 'group_limit' }
                ] }]);
        return (options?.client ?? client).get<QuotesListQuotesResponses, QuotesListQuotesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create
     */
    public static create<ThrowOnError extends boolean = false>(parameters: {
        quoteCreate: QuoteCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotesCreateResponses, QuotesCreateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'quoteCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<QuotesCreateResponses, QuotesCreateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Filter Options
     */
    public static filterOptions<ThrowOnError extends boolean = false>(parameters?: {
        archived?: boolean;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotesFilterOptionsResponses, QuotesFilterOptionsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'query', key: 'archived' }, { in: 'query', key: 'limit' }] }]);
        return (options?.client ?? client).get<QuotesFilterOptionsResponses, QuotesFilterOptionsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/filter-options',
            ...options,
            ...params
        });
    }
    
    /**
     * List Hubspot Deals
     */
    public static listHubspotDeals<ThrowOnError extends boolean = false>(parameters?: {
        limit?: number;
        after?: string | null;
        query?: string | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotesListHubspotDealsResponses, QuotesListHubspotDealsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'after' },
                    { in: 'query', key: 'query' }
                ] }]);
        return (options?.client ?? client).get<QuotesListHubspotDealsResponses, QuotesListHubspotDealsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/hubspot/deals',
            ...options,
            ...params
        });
    }
    
    /**
     * Get Hubspot Deal
     */
    public static getHubspotDeal<ThrowOnError extends boolean = false>(parameters: {
        deal_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotesGetHubspotDealResponses, QuotesGetHubspotDealErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'deal_id' }] }]);
        return (options?.client ?? client).get<QuotesGetHubspotDealResponses, QuotesGetHubspotDealErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/hubspot/deals/{deal_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Import Hubspot Attachment
     */
    public static importHubspotAttachment<ThrowOnError extends boolean = false>(parameters: {
        deal_id: string;
        file_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotesImportHubspotAttachmentResponses, QuotesImportHubspotAttachmentErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'deal_id' }, { in: 'path', key: 'file_id' }] }]);
        return (options?.client ?? client).post<QuotesImportHubspotAttachmentResponses, QuotesImportHubspotAttachmentErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/hubspot/deals/{deal_id}/attachments/{file_id}/import',
            ...options,
            ...params
        });
    }
    
    /**
     * Create Quote From Hubspot Deal
     */
    public static createQuoteFromHubspotDeal<ThrowOnError extends boolean = false>(parameters: {
        deal_id: string;
        hubSpotQuoteCreate: HubSpotQuoteCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotesCreateQuoteFromHubspotDealResponses, QuotesCreateQuoteFromHubspotDealErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'deal_id' }, { key: 'hubSpotQuoteCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<QuotesCreateQuoteFromHubspotDealResponses, QuotesCreateQuoteFromHubspotDealErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/hubspot/deals/{deal_id}/quote',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Get Overview
     */
    public static getOverview<ThrowOnError extends boolean = false>(parameters?: {
        customer_id?: Array<string> | null;
        aircraft_id?: Array<string> | null;
        aircraft_model?: Array<string> | null;
        part_id?: Array<string> | null;
        department_id?: Array<string> | null;
        sales_rep_id?: Array<string> | null;
        created_by_id?: Array<string> | null;
        months?: number;
        end?: string | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotesGetOverviewResponses, QuotesGetOverviewErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'customer_id' },
                    { in: 'query', key: 'aircraft_id' },
                    { in: 'query', key: 'aircraft_model' },
                    { in: 'query', key: 'part_id' },
                    { in: 'query', key: 'department_id' },
                    { in: 'query', key: 'sales_rep_id' },
                    { in: 'query', key: 'created_by_id' },
                    { in: 'query', key: 'months' },
                    { in: 'query', key: 'end' }
                ] }]);
        return (options?.client ?? client).get<QuotesGetOverviewResponses, QuotesGetOverviewErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/overview',
            ...options,
            ...params
        });
    }
    
    /**
     * Delete
     */
    public static delete<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotesDeleteResponses, QuotesDeleteErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'quote_id' }] }]);
        return (options?.client ?? client).delete<QuotesDeleteResponses, QuotesDeleteErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Get
     */
    public static get<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotesGetResponses, QuotesGetErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'quote_id' }] }]);
        return (options?.client ?? client).get<QuotesGetResponses, QuotesGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Apply Update
     */
    public static applyUpdate<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
        updateQuote: UpdateQuote;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotesApplyUpdateResponses, QuotesApplyUpdateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'quote_id' }, { key: 'updateQuote', map: 'body' }] }]);
        return (options?.client ?? client).patch<QuotesApplyUpdateResponses, QuotesApplyUpdateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Update
     */
    public static update<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
        quoteUpdate: QuoteUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotesUpdateResponses, QuotesUpdateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'quote_id' }, { key: 'quoteUpdate', map: 'body' }] }]);
        return (options?.client ?? client).put<QuotesUpdateResponses, QuotesUpdateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Archive
     */
    public static archive<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotesArchiveResponses, QuotesArchiveErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'quote_id' }] }]);
        return (options?.client ?? client).post<QuotesArchiveResponses, QuotesArchiveErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}/archive',
            ...options,
            ...params
        });
    }
    
    /**
     * Preview For Customer
     */
    public static previewForCustomer<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotesPreviewForCustomerResponses, QuotesPreviewForCustomerErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'quote_id' }] }]);
        return (options?.client ?? client).get<QuotesPreviewForCustomerResponses, QuotesPreviewForCustomerErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}/customer-preview',
            ...options,
            ...params
        });
    }
    
    /**
     * Change Disposition
     */
    public static changeDisposition<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
        quoteDispositionChange: QuoteDispositionChange;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotesChangeDispositionResponses, QuotesChangeDispositionErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'quote_id' }, { key: 'quoteDispositionChange', map: 'body' }] }]);
        return (options?.client ?? client).post<QuotesChangeDispositionResponses, QuotesChangeDispositionErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}/disposition',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Duplicate
     */
    public static duplicate<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotesDuplicateResponses, QuotesDuplicateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'quote_id' }] }]);
        return (options?.client ?? client).post<QuotesDuplicateResponses, QuotesDuplicateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}/duplicate',
            ...options,
            ...params
        });
    }
    
    /**
     * Resend Email
     */
    public static resendEmail<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotesResendEmailResponses, QuotesResendEmailErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'quote_id' }] }]);
        return (options?.client ?? client).post<QuotesResendEmailResponses, QuotesResendEmailErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}/email',
            ...options,
            ...params
        });
    }
    
    /**
     * Export Pdf
     */
    public static exportPdf<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
        format?: QuoteExportFormat;
        task_ids?: Array<string> | null;
        prices?: boolean;
        rejected?: boolean;
        notes?: boolean;
        payer_split?: boolean;
        customer_copy?: boolean;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotesExportPdfResponses, QuotesExportPdfErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'quote_id' },
                    { in: 'query', key: 'format' },
                    { in: 'query', key: 'task_ids' },
                    { in: 'query', key: 'prices' },
                    { in: 'query', key: 'rejected' },
                    { in: 'query', key: 'notes' },
                    { in: 'query', key: 'payer_split' },
                    { in: 'query', key: 'customer_copy' }
                ] }]);
        return (options?.client ?? client).post<QuotesExportPdfResponses, QuotesExportPdfErrors, ThrowOnError>({
            responseType: 'blob',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}/export',
            ...options,
            ...params
        });
    }
    
    /**
     * List Part History
     */
    public static listPartHistory<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotesListPartHistoryResponses, QuotesListPartHistoryErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'quote_id' }] }]);
        return (options?.client ?? client).get<QuotesListPartHistoryResponses, QuotesListPartHistoryErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}/part-history',
            ...options,
            ...params
        });
    }
    
    /**
     * Extract Parts Rfp
     */
    public static extractPartsRfp<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
        partsRfpExtractionCreate: PartsRfpExtractionCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotesExtractPartsRfpResponses, QuotesExtractPartsRfpErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'quote_id' }, { key: 'partsRfpExtractionCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<QuotesExtractPartsRfpResponses, QuotesExtractPartsRfpErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}/parts-rfp-extractions',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * List Rate Cards
     */
    public static listRateCards<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotesListRateCardsResponses, QuotesListRateCardsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'quote_id' }] }]);
        return (options?.client ?? client).get<QuotesListRateCardsResponses, QuotesListRateCardsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}/rate-cards',
            ...options,
            ...params
        });
    }
    
    /**
     * Restore
     */
    public static restore<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotesRestoreResponses, QuotesRestoreErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'quote_id' }] }]);
        return (options?.client ?? client).post<QuotesRestoreResponses, QuotesRestoreErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}/restore',
            ...options,
            ...params
        });
    }
    
    /**
     * Review Tasks
     */
    public static reviewTasks<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
        quoteTaskReview: QuoteTaskReview;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotesReviewTasksResponses, QuotesReviewTasksErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'quote_id' }, { key: 'quoteTaskReview', map: 'body' }] }]);
        return (options?.client ?? client).post<QuotesReviewTasksResponses, QuotesReviewTasksErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}/review-decisions',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Undo Task Reviews
     */
    public static undoTaskReviews<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
        quoteTaskReviewUndo: QuoteTaskReviewUndo;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotesUndoTaskReviewsResponses, QuotesUndoTaskReviewsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'quote_id' }, { key: 'quoteTaskReviewUndo', map: 'body' }] }]);
        return (options?.client ?? client).post<QuotesUndoTaskReviewsResponses, QuotesUndoTaskReviewsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}/review-decisions/undo',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Review History
     */
    public static reviewHistory<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotesReviewHistoryResponses, QuotesReviewHistoryErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'quote_id' }] }]);
        return (options?.client ?? client).get<QuotesReviewHistoryResponses, QuotesReviewHistoryErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}/review-history',
            ...options,
            ...params
        });
    }
    
    /**
     * Set Reviewers
     */
    public static setReviewers<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
        quoteReviewersChange: QuoteReviewersChange;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotesSetReviewersResponses, QuotesSetReviewersErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'quote_id' }, { key: 'quoteReviewersChange', map: 'body' }] }]);
        return (options?.client ?? client).put<QuotesSetReviewersResponses, QuotesSetReviewersErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}/reviewers',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Send Quote To Salesforce
     */
    public static sendQuoteToSalesforce<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotesSendQuoteToSalesforceResponses, QuotesSendQuoteToSalesforceErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'quote_id' }] }]);
        return (options?.client ?? client).post<QuotesSendQuoteToSalesforceResponses, QuotesSendQuoteToSalesforceErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}/salesforce-opportunity',
            ...options,
            ...params
        });
    }
    
    /**
     * Find Similar Packages
     */
    public static findSimilarPackages<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotesFindSimilarPackagesResponses, QuotesFindSimilarPackagesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'quote_id' }] }]);
        return (options?.client ?? client).get<QuotesFindSimilarPackagesResponses, QuotesFindSimilarPackagesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}/similar-packages',
            ...options,
            ...params
        });
    }
    
    /**
     * Extract Tasks
     */
    public static extractTasks<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
        quoteTaskExtractionCreate: QuoteTaskExtractionCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotesExtractTasksResponses, QuotesExtractTasksErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'quote_id' }, { key: 'quoteTaskExtractionCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<QuotesExtractTasksResponses, QuotesExtractTasksErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}/task-extractions',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Update Task
     */
    public static updateTask<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
        task_id: string;
        quoteTaskBase: QuoteTaskBase;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotesUpdateTaskResponses, QuotesUpdateTaskErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'quote_id' },
                    { in: 'path', key: 'task_id' },
                    { key: 'quoteTaskBase', map: 'body' }
                ] }]);
        return (options?.client ?? client).put<QuotesUpdateTaskResponses, QuotesUpdateTaskErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}/tasks/{task_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Get Tax
     */
    public static getTax<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotesGetTaxResponses, QuotesGetTaxErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'quote_id' }] }]);
        return (options?.client ?? client).get<QuotesGetTaxResponses, QuotesGetTaxErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}/tax',
            ...options,
            ...params
        });
    }
    
    /**
     * Create Work Package
     */
    public static createWorkPackage<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotesCreateWorkPackageResponses, QuotesCreateWorkPackageErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'quote_id' }] }]);
        return (options?.client ?? client).post<QuotesCreateWorkPackageResponses, QuotesCreateWorkPackageErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}/work-package',
            ...options,
            ...params
        });
    }
}

export class QuoteChargesService {
    /**
     * Set Avref Price
     */
    public static setAvrefPrice<ThrowOnError extends boolean = false>(parameters: {
        charge_id: string;
        setAvrefPrice: SetAvrefPrice;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteChargesSetAvrefPriceResponses, QuoteChargesSetAvrefPriceErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'charge_id' }, { key: 'setAvrefPrice', map: 'body' }] }]);
        return (options?.client ?? client).post<QuoteChargesSetAvrefPriceResponses, QuoteChargesSetAvrefPriceErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/charges/{charge_id}/avref-price',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Search Avref Prices
     */
    public static searchAvrefPrices<ThrowOnError extends boolean = false>(parameters: {
        charge_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteChargesSearchAvrefPricesResponses, QuoteChargesSearchAvrefPricesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'charge_id' }] }]);
        return (options?.client ?? client).get<QuoteChargesSearchAvrefPricesResponses, QuoteChargesSearchAvrefPricesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/charges/{charge_id}/avref-prices',
            ...options,
            ...params
        });
    }
    
    /**
     * Set Inventory Price
     */
    public static setInventoryPrice<ThrowOnError extends boolean = false>(parameters: {
        charge_id: string;
        setInventoryPrice: SetInventoryPrice;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteChargesSetInventoryPriceResponses, QuoteChargesSetInventoryPriceErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'charge_id' }, { key: 'setInventoryPrice', map: 'body' }] }]);
        return (options?.client ?? client).post<QuoteChargesSetInventoryPriceResponses, QuoteChargesSetInventoryPriceErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/charges/{charge_id}/inventory-price',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Suggest Outside Service Prices
     */
    public static suggestOutsideServicePrices<ThrowOnError extends boolean = false>(parameters: {
        charge_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteChargesSuggestOutsideServicePricesResponses, QuoteChargesSuggestOutsideServicePricesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'charge_id' }] }]);
        return (options?.client ?? client).get<QuoteChargesSuggestOutsideServicePricesResponses, QuoteChargesSuggestOutsideServicePricesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/charges/{charge_id}/outside-service-prices',
            ...options,
            ...params
        });
    }
}

export class QuoteTasksService {
    /**
     * Classify Task Groups
     */
    public static classifyTaskGroups<ThrowOnError extends boolean = false>(parameters: {
        classifyTasks: ClassifyTasks;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteTasksClassifyTaskGroupsResponses, QuoteTasksClassifyTaskGroupsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'classifyTasks', map: 'body' }] }]);
        return (options?.client ?? client).post<QuoteTasksClassifyTaskGroupsResponses, QuoteTasksClassifyTaskGroupsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/tasks/classify',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Merge Tasks
     */
    public static mergeTasks<ThrowOnError extends boolean = false>(parameters: {
        mergeQuoteTasks: MergeQuoteTasks;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteTasksMergeTasksResponses, QuoteTasksMergeTasksErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'mergeQuoteTasks', map: 'body' }] }]);
        return (options?.client ?? client).post<QuoteTasksMergeTasksResponses, QuoteTasksMergeTasksErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/tasks/merge',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Search Canned Tasks
     */
    public static searchCannedTasks<ThrowOnError extends boolean = false>(parameters: {
        quote_task_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteTasksSearchCannedTasksResponses, QuoteTasksSearchCannedTasksErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'quote_task_id' }] }]);
        return (options?.client ?? client).get<QuoteTasksSearchCannedTasksResponses, QuoteTasksSearchCannedTasksErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/tasks/{quote_task_id}/canned-tasks',
            ...options,
            ...params
        });
    }
    
    /**
     * Estimate Labour
     */
    public static estimateLabour<ThrowOnError extends boolean = false>(parameters: {
        quote_task_id: string;
        aircraft_type_ids?: Array<string> | null;
        same_aircraft_type?: boolean;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteTasksEstimateLabourResponses, QuoteTasksEstimateLabourErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'quote_task_id' },
                    { in: 'query', key: 'aircraft_type_ids' },
                    { in: 'query', key: 'same_aircraft_type' }
                ] }]);
        return (options?.client ?? client).get<QuoteTasksEstimateLabourResponses, QuoteTasksEstimateLabourErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/tasks/{quote_task_id}/labour',
            ...options,
            ...params
        });
    }
    
    /**
     * Suggest Parts
     */
    public static suggestParts<ThrowOnError extends boolean = false>(parameters: {
        quote_task_id: string;
        prefix?: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteTasksSuggestPartsResponses, QuoteTasksSuggestPartsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'quote_task_id' }, { in: 'query', key: 'prefix' }] }]);
        return (options?.client ?? client).get<QuoteTasksSuggestPartsResponses, QuoteTasksSuggestPartsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/tasks/{quote_task_id}/parts',
            ...options,
            ...params
        });
    }
    
    /**
     * List Past Parts
     */
    public static listPastParts<ThrowOnError extends boolean = false>(parameters: {
        quote_task_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteTasksListPastPartsResponses, QuoteTasksListPastPartsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'quote_task_id' }] }]);
        return (options?.client ?? client).get<QuoteTasksListPastPartsResponses, QuoteTasksListPastPartsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/tasks/{quote_task_id}/past-parts',
            ...options,
            ...params
        });
    }
    
    /**
     * Get Price History
     */
    public static getPriceHistory<ThrowOnError extends boolean = false>(parameters: {
        quote_task_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteTasksGetPriceHistoryResponses, QuoteTasksGetPriceHistoryErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'quote_task_id' }] }]);
        return (options?.client ?? client).get<QuoteTasksGetPriceHistoryResponses, QuoteTasksGetPriceHistoryErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/tasks/{quote_task_id}/price-history',
            ...options,
            ...params
        });
    }
    
    /**
     * Find Similar Packages
     */
    public static findSimilarPackages<ThrowOnError extends boolean = false>(parameters: {
        quote_task_id: string;
        kind: Workscope;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteTasksFindSimilarPackagesResponses, QuoteTasksFindSimilarPackagesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'quote_task_id' }, { in: 'query', key: 'kind' }] }]);
        return (options?.client ?? client).get<QuoteTasksFindSimilarPackagesResponses, QuoteTasksFindSimilarPackagesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/tasks/{quote_task_id}/similar-packages',
            ...options,
            ...params
        });
    }
}

export class QuoteActivityService {
    /**
     * List Activity
     */
    public static listActivity<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
        skip?: number;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteActivityListActivityResponses, QuoteActivityListActivityErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'quote_id' },
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' }
                ] }]);
        return (options?.client ?? client).get<QuoteActivityListActivityResponses, QuoteActivityListActivityErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}/activity',
            ...options,
            ...params
        });
    }
}

export class QuoteCommentsService {
    /**
     * List Comments
     */
    public static listComments<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
        skip?: number;
        limit?: number;
        quote_task_id?: string | null;
        visibility?: CommentVisibility | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteCommentsListCommentsResponses, QuoteCommentsListCommentsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'quote_id' },
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'quote_task_id' },
                    { in: 'query', key: 'visibility' }
                ] }]);
        return (options?.client ?? client).get<QuoteCommentsListCommentsResponses, QuoteCommentsListCommentsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}/comments',
            ...options,
            ...params
        });
    }
    
    /**
     * Create
     */
    public static create<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
        quoteCommentCreate: QuoteCommentCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteCommentsCreateResponses, QuoteCommentsCreateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'quote_id' }, { key: 'quoteCommentCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<QuoteCommentsCreateResponses, QuoteCommentsCreateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}/comments',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Count By Task
     */
    public static countByTask<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteCommentsCountByTaskResponses, QuoteCommentsCountByTaskErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'quote_id' }] }]);
        return (options?.client ?? client).get<QuoteCommentsCountByTaskResponses, QuoteCommentsCountByTaskErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}/comments/task-counts',
            ...options,
            ...params
        });
    }
    
    /**
     * Delete
     */
    public static delete<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
        comment_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteCommentsDeleteResponses, QuoteCommentsDeleteErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'quote_id' }, { in: 'path', key: 'comment_id' }] }]);
        return (options?.client ?? client).delete<QuoteCommentsDeleteResponses, QuoteCommentsDeleteErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}/comments/{comment_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update
     */
    public static update<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
        comment_id: string;
        quoteCommentUpdate: QuoteCommentUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteCommentsUpdateResponses, QuoteCommentsUpdateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'quote_id' },
                    { in: 'path', key: 'comment_id' },
                    { key: 'quoteCommentUpdate', map: 'body' }
                ] }]);
        return (options?.client ?? client).patch<QuoteCommentsUpdateResponses, QuoteCommentsUpdateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}/comments/{comment_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class QuotePayerAllocationsService {
    /**
     * List Payer Allocations
     */
    public static listPayerAllocations<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
        skip?: number;
        limit?: number;
        quote_task_id?: string | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotePayerAllocationsListPayerAllocationsResponses, QuotePayerAllocationsListPayerAllocationsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'quote_id' },
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'quote_task_id' }
                ] }]);
        return (options?.client ?? client).get<QuotePayerAllocationsListPayerAllocationsResponses, QuotePayerAllocationsListPayerAllocationsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}/payer-allocations',
            ...options,
            ...params
        });
    }
    
    /**
     * Create
     */
    public static create<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
        quotePayerAllocationCreate: QuotePayerAllocationCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotePayerAllocationsCreateResponses, QuotePayerAllocationsCreateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'quote_id' }, { key: 'quotePayerAllocationCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<QuotePayerAllocationsCreateResponses, QuotePayerAllocationsCreateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}/payer-allocations',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete
     */
    public static delete<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
        allocation_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotePayerAllocationsDeleteResponses, QuotePayerAllocationsDeleteErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'quote_id' }, { in: 'path', key: 'allocation_id' }] }]);
        return (options?.client ?? client).delete<QuotePayerAllocationsDeleteResponses, QuotePayerAllocationsDeleteErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}/payer-allocations/{allocation_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Get
     */
    public static get<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
        allocation_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotePayerAllocationsGetResponses, QuotePayerAllocationsGetErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'quote_id' }, { in: 'path', key: 'allocation_id' }] }]);
        return (options?.client ?? client).get<QuotePayerAllocationsGetResponses, QuotePayerAllocationsGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}/payer-allocations/{allocation_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update
     */
    public static update<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
        allocation_id: string;
        quotePayerAllocationUpdate: QuotePayerAllocationUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotePayerAllocationsUpdateResponses, QuotePayerAllocationsUpdateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'quote_id' },
                    { in: 'path', key: 'allocation_id' },
                    { key: 'quotePayerAllocationUpdate', map: 'body' }
                ] }]);
        return (options?.client ?? client).patch<QuotePayerAllocationsUpdateResponses, QuotePayerAllocationsUpdateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}/payer-allocations/{allocation_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class QuotePhasesService {
    /**
     * Create Phase
     */
    public static createPhase<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
        quotePhaseCreate: QuotePhaseCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotePhasesCreatePhaseResponses, QuotePhasesCreatePhaseErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'quote_id' }, { key: 'quotePhaseCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<QuotePhasesCreatePhaseResponses, QuotePhasesCreatePhaseErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}/phases',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Reorder Phases
     */
    public static reorderPhases<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
        quotePhaseOrder: QuotePhaseOrder;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotePhasesReorderPhasesResponses, QuotePhasesReorderPhasesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'quote_id' }, { key: 'quotePhaseOrder', map: 'body' }] }]);
        return (options?.client ?? client).put<QuotePhasesReorderPhasesResponses, QuotePhasesReorderPhasesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}/phases/order',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete Phase
     */
    public static deletePhase<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
        phase_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotePhasesDeletePhaseResponses, QuotePhasesDeletePhaseErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'quote_id' }, { in: 'path', key: 'phase_id' }] }]);
        return (options?.client ?? client).delete<QuotePhasesDeletePhaseResponses, QuotePhasesDeletePhaseErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}/phases/{phase_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update Phase
     */
    public static updatePhase<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
        phase_id: string;
        quotePhaseUpdate: QuotePhaseUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuotePhasesUpdatePhaseResponses, QuotePhasesUpdatePhaseErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'quote_id' },
                    { in: 'path', key: 'phase_id' },
                    { key: 'quotePhaseUpdate', map: 'body' }
                ] }]);
        return (options?.client ?? client).patch<QuotePhasesUpdatePhaseResponses, QuotePhasesUpdatePhaseErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}/phases/{phase_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class QuoteTaskStepsService {
    /**
     * Create Task Step
     */
    public static createTaskStep<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
        task_id: string;
        quoteTaskStepCreate: QuoteTaskStepCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteTaskStepsCreateTaskStepResponses, QuoteTaskStepsCreateTaskStepErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'quote_id' },
                    { in: 'path', key: 'task_id' },
                    { key: 'quoteTaskStepCreate', map: 'body' }
                ] }]);
        return (options?.client ?? client).post<QuoteTaskStepsCreateTaskStepResponses, QuoteTaskStepsCreateTaskStepErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}/tasks/{task_id}/steps',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete Task Step
     */
    public static deleteTaskStep<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
        task_id: string;
        step_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteTaskStepsDeleteTaskStepResponses, QuoteTaskStepsDeleteTaskStepErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'quote_id' },
                    { in: 'path', key: 'task_id' },
                    { in: 'path', key: 'step_id' }
                ] }]);
        return (options?.client ?? client).delete<QuoteTaskStepsDeleteTaskStepResponses, QuoteTaskStepsDeleteTaskStepErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}/tasks/{task_id}/steps/{step_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update Task Step
     */
    public static updateTaskStep<ThrowOnError extends boolean = false>(parameters: {
        quote_id: string;
        task_id: string;
        step_id: string;
        quoteTaskStepUpdate: QuoteTaskStepUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<QuoteTaskStepsUpdateTaskStepResponses, QuoteTaskStepsUpdateTaskStepErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'quote_id' },
                    { in: 'path', key: 'task_id' },
                    { in: 'path', key: 'step_id' },
                    { key: 'quoteTaskStepUpdate', map: 'body' }
                ] }]);
        return (options?.client ?? client).patch<QuoteTaskStepsUpdateTaskStepResponses, QuoteTaskStepsUpdateTaskStepErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/quotes/{quote_id}/tasks/{task_id}/steps/{step_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class RateCardsService {
    /**
     * List Rate Cards
     */
    public static listRateCards<ThrowOnError extends boolean = false>(parameters?: {
        skip?: number;
        limit?: number;
        search?: string | null;
        deleted?: boolean;
    }, options?: Options<never, ThrowOnError>): RequestResult<RateCardsListRateCardsResponses, RateCardsListRateCardsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'search' },
                    { in: 'query', key: 'deleted' }
                ] }]);
        return (options?.client ?? client).get<RateCardsListRateCardsResponses, RateCardsListRateCardsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/rate-cards/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create
     */
    public static create<ThrowOnError extends boolean = false>(parameters: {
        rateCardCreate: RateCardCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<RateCardsCreateResponses, RateCardsCreateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'rateCardCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<RateCardsCreateResponses, RateCardsCreateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/rate-cards/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete
     */
    public static delete<ThrowOnError extends boolean = false>(parameters: {
        rate_card_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<RateCardsDeleteResponses, RateCardsDeleteErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'rate_card_id' }] }]);
        return (options?.client ?? client).delete<RateCardsDeleteResponses, RateCardsDeleteErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/rate-cards/{rate_card_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Get
     */
    public static get<ThrowOnError extends boolean = false>(parameters: {
        rate_card_id: string;
        include_archived?: boolean;
    }, options?: Options<never, ThrowOnError>): RequestResult<RateCardsGetResponses, RateCardsGetErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'rate_card_id' }, { in: 'query', key: 'include_archived' }] }]);
        return (options?.client ?? client).get<RateCardsGetResponses, RateCardsGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/rate-cards/{rate_card_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update
     */
    public static update<ThrowOnError extends boolean = false>(parameters: {
        rate_card_id: string;
        rateCardUpdate: RateCardUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<RateCardsUpdateResponses, RateCardsUpdateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'rate_card_id' }, { key: 'rateCardUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<RateCardsUpdateResponses, RateCardsUpdateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/rate-cards/{rate_card_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Restore
     */
    public static restore<ThrowOnError extends boolean = false>(parameters: {
        rate_card_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<RateCardsRestoreResponses, RateCardsRestoreErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'rate_card_id' }] }]);
        return (options?.client ?? client).post<RateCardsRestoreResponses, RateCardsRestoreErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/rate-cards/{rate_card_id}/restore',
            ...options,
            ...params
        });
    }
}

export class RolesService {
    /**
     * List Roles
     *
     * List all roles in the tenant.
     */
    public static listRoles<ThrowOnError extends boolean = false>(parameters?: {
        skip?: number;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<RolesListRolesResponses, RolesListRolesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'query', key: 'skip' }, { in: 'query', key: 'limit' }] }]);
        return (options?.client ?? client).get<RolesListRolesResponses, RolesListRolesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/roles/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create Role
     */
    public static createRole<ThrowOnError extends boolean = false>(parameters: {
        customRoleCreate: CustomRoleCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<RolesCreateRoleResponses, RolesCreateRoleErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'customRoleCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<RolesCreateRoleResponses, RolesCreateRoleErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/roles/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Assign Role To User
     *
     * Assign a role to a user.
     */
    public static assignRoleToUser<ThrowOnError extends boolean = false>(parameters: {
        userRoleCreate: UserRoleCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<RolesAssignRoleToUserResponses, RolesAssignRoleToUserErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'userRoleCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<RolesAssignRoleToUserResponses, RolesAssignRoleToUserErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/roles/users/roles',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Remove Role From User
     *
     * Remove a role from a user.
     */
    public static removeRoleFromUser<ThrowOnError extends boolean = false>(parameters: {
        user_id: string;
        role_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<RolesRemoveRoleFromUserResponses, RolesRemoveRoleFromUserErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'user_id' }, { in: 'path', key: 'role_id' }] }]);
        return (options?.client ?? client).delete<RolesRemoveRoleFromUserResponses, RolesRemoveRoleFromUserErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/roles/users/{user_id}/roles/{role_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Delete Role
     */
    public static deleteRole<ThrowOnError extends boolean = false>(parameters: {
        role_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<RolesDeleteRoleResponses, RolesDeleteRoleErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'role_id' }] }]);
        return (options?.client ?? client).delete<RolesDeleteRoleResponses, RolesDeleteRoleErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/roles/{role_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update Role
     */
    public static updateRole<ThrowOnError extends boolean = false>(parameters: {
        role_id: string;
        customRoleUpdate: CustomRoleUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<RolesUpdateRoleResponses, RolesUpdateRoleErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'role_id' }, { key: 'customRoleUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<RolesUpdateRoleResponses, RolesUpdateRoleErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/roles/{role_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Reset Role
     */
    public static resetRole<ThrowOnError extends boolean = false>(parameters: {
        role_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<RolesResetRoleResponses, RolesResetRoleErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'role_id' }] }]);
        return (options?.client ?? client).post<RolesResetRoleResponses, RolesResetRoleErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/roles/{role_id}/reset',
            ...options,
            ...params
        });
    }
}

export class SquawksService {
    /**
     * List Squawks
     */
    public static listSquawks<ThrowOnError extends boolean = false>(parameters?: {
        skip?: number;
        limit?: number;
        work_package_id?: string | null;
        work_task_id?: string | null;
        status?: Array<FilterableSquawkStatus> | null;
        search?: string | null;
        archived?: boolean;
        scope?: WorkPackageScope;
        work_package_number?: Array<string> | null;
        customer_id?: Array<string> | null;
        reported_by_id?: Array<string> | null;
        severity?: Array<SeverityFilter> | null;
        ata_chapter?: Array<number> | null;
        sort?: SquawkSort | null;
        direction?: SortDirection;
        group?: SquawkGrouping | null;
        subgroup?: SquawkGrouping | null;
        group_key?: string | null;
        group_limit?: number | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<SquawksListSquawksResponses, SquawksListSquawksErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'work_package_id' },
                    { in: 'query', key: 'work_task_id' },
                    { in: 'query', key: 'status' },
                    { in: 'query', key: 'search' },
                    { in: 'query', key: 'archived' },
                    { in: 'query', key: 'scope' },
                    { in: 'query', key: 'work_package_number' },
                    { in: 'query', key: 'customer_id' },
                    { in: 'query', key: 'reported_by_id' },
                    { in: 'query', key: 'severity' },
                    { in: 'query', key: 'ata_chapter' },
                    { in: 'query', key: 'sort' },
                    { in: 'query', key: 'direction' },
                    { in: 'query', key: 'group' },
                    { in: 'query', key: 'subgroup' },
                    { in: 'query', key: 'group_key' },
                    { in: 'query', key: 'group_limit' }
                ] }]);
        return (options?.client ?? client).get<SquawksListSquawksResponses, SquawksListSquawksErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/squawks/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create
     */
    public static create<ThrowOnError extends boolean = false>(parameters: {
        squawkUpsert: SquawkUpsert;
    }, options?: Options<never, ThrowOnError>): RequestResult<SquawksCreateResponses, SquawksCreateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'squawkUpsert', map: 'body' }] }]);
        return (options?.client ?? client).post<SquawksCreateResponses, SquawksCreateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/squawks/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Archive Many
     */
    public static archiveMany<ThrowOnError extends boolean = false>(parameters: {
        squawkBulkIds: SquawkBulkIds;
    }, options?: Options<never, ThrowOnError>): RequestResult<SquawksArchiveManyResponses, SquawksArchiveManyErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'squawkBulkIds', map: 'body' }] }]);
        return (options?.client ?? client).post<SquawksArchiveManyResponses, SquawksArchiveManyErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/squawks/bulk/archive',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Restore Many
     */
    public static restoreMany<ThrowOnError extends boolean = false>(parameters: {
        squawkBulkIds: SquawkBulkIds;
    }, options?: Options<never, ThrowOnError>): RequestResult<SquawksRestoreManyResponses, SquawksRestoreManyErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'squawkBulkIds', map: 'body' }] }]);
        return (options?.client ?? client).post<SquawksRestoreManyResponses, SquawksRestoreManyErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/squawks/bulk/restore',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Set Avref Price
     */
    public static setAvrefPrice<ThrowOnError extends boolean = false>(parameters: {
        charge_id: string;
        setAvrefPrice: SetAvrefPrice;
    }, options?: Options<never, ThrowOnError>): RequestResult<SquawksSetAvrefPriceResponses, SquawksSetAvrefPriceErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'charge_id' }, { key: 'setAvrefPrice', map: 'body' }] }]);
        return (options?.client ?? client).post<SquawksSetAvrefPriceResponses, SquawksSetAvrefPriceErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/squawks/charges/{charge_id}/avref-price',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Search Avref Prices
     */
    public static searchAvrefPrices<ThrowOnError extends boolean = false>(parameters: {
        charge_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<SquawksSearchAvrefPricesResponses, SquawksSearchAvrefPricesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'charge_id' }] }]);
        return (options?.client ?? client).get<SquawksSearchAvrefPricesResponses, SquawksSearchAvrefPricesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/squawks/charges/{charge_id}/avref-prices',
            ...options,
            ...params
        });
    }
    
    /**
     * Filter Options
     */
    public static filterOptions<ThrowOnError extends boolean = false>(parameters?: {
        work_package_id?: string | null;
        search?: string | null;
        archived?: boolean;
        scope?: WorkPackageScope;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<SquawksFilterOptionsResponses, SquawksFilterOptionsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'work_package_id' },
                    { in: 'query', key: 'search' },
                    { in: 'query', key: 'archived' },
                    { in: 'query', key: 'scope' },
                    { in: 'query', key: 'limit' }
                ] }]);
        return (options?.client ?? client).get<SquawksFilterOptionsResponses, SquawksFilterOptionsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/squawks/filter-options',
            ...options,
            ...params
        });
    }
    
    /**
     * List Squawks Grouped
     */
    public static listSquawksGrouped<ThrowOnError extends boolean = false>(parameters?: {
        skip?: number;
        limit?: number;
        work_package_id?: string | null;
        status?: Array<FilterableSquawkStatus> | null;
        search?: string | null;
        archived?: boolean;
        scope?: WorkPackageScope;
    }, options?: Options<never, ThrowOnError>): RequestResult<SquawksListSquawksGroupedResponses, SquawksListSquawksGroupedErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'work_package_id' },
                    { in: 'query', key: 'status' },
                    { in: 'query', key: 'search' },
                    { in: 'query', key: 'archived' },
                    { in: 'query', key: 'scope' }
                ] }]);
        return (options?.client ?? client).get<SquawksListSquawksGroupedResponses, SquawksListSquawksGroupedErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/squawks/grouped',
            ...options,
            ...params
        });
    }
    
    /**
     * Quote Squawks
     */
    public static quoteSquawks<ThrowOnError extends boolean = false>(parameters: {
        squawkQuoteCreate: SquawkQuoteCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<SquawksQuoteSquawksResponses, SquawksQuoteSquawksErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'squawkQuoteCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<SquawksQuoteSquawksResponses, SquawksQuoteSquawksErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/squawks/quote',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Update Statuses
     */
    public static updateStatuses<ThrowOnError extends boolean = false>(parameters: {
        squawkStatusUpdates: SquawkStatusUpdates;
    }, options?: Options<never, ThrowOnError>): RequestResult<SquawksUpdateStatusesResponses, SquawksUpdateStatusesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'squawkStatusUpdates', map: 'body' }] }]);
        return (options?.client ?? client).post<SquawksUpdateStatusesResponses, SquawksUpdateStatusesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/squawks/status',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete
     */
    public static delete<ThrowOnError extends boolean = false>(parameters: {
        squawk_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<SquawksDeleteResponses, SquawksDeleteErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'squawk_id' }] }]);
        return (options?.client ?? client).delete<SquawksDeleteResponses, SquawksDeleteErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/squawks/{squawk_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Get
     */
    public static get<ThrowOnError extends boolean = false>(parameters: {
        squawk_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<SquawksGetResponses, SquawksGetErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'squawk_id' }] }]);
        return (options?.client ?? client).get<SquawksGetResponses, SquawksGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/squawks/{squawk_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update
     */
    public static update<ThrowOnError extends boolean = false>(parameters: {
        squawk_id: string;
        squawkUpdate: SquawkUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<SquawksUpdateResponses, SquawksUpdateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'squawk_id' }, { key: 'squawkUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<SquawksUpdateResponses, SquawksUpdateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/squawks/{squawk_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Approval History
     */
    public static approvalHistory<ThrowOnError extends boolean = false>(parameters: {
        squawk_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<SquawksApprovalHistoryResponses, SquawksApprovalHistoryErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'squawk_id' }] }]);
        return (options?.client ?? client).get<SquawksApprovalHistoryResponses, SquawksApprovalHistoryErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/squawks/{squawk_id}/approval-history',
            ...options,
            ...params
        });
    }
    
    /**
     * Archive
     */
    public static archive<ThrowOnError extends boolean = false>(parameters: {
        squawk_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<SquawksArchiveResponses, SquawksArchiveErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'squawk_id' }] }]);
        return (options?.client ?? client).post<SquawksArchiveResponses, SquawksArchiveErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/squawks/{squawk_id}/archive',
            ...options,
            ...params
        });
    }
    
    /**
     * List Comments
     */
    public static listComments<ThrowOnError extends boolean = false>(parameters: {
        squawk_id: string;
        skip?: number;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<SquawksListCommentsResponses, SquawksListCommentsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'squawk_id' },
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' }
                ] }]);
        return (options?.client ?? client).get<SquawksListCommentsResponses, SquawksListCommentsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/squawks/{squawk_id}/comments',
            ...options,
            ...params
        });
    }
    
    /**
     * Add Comment
     */
    public static addComment<ThrowOnError extends boolean = false>(parameters: {
        squawk_id: string;
        squawkCommentCreate: SquawkCommentCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<SquawksAddCommentResponses, SquawksAddCommentErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'squawk_id' }, { key: 'squawkCommentCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<SquawksAddCommentResponses, SquawksAddCommentErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/squawks/{squawk_id}/comments',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Find Duplicates
     */
    public static findDuplicates<ThrowOnError extends boolean = false>(parameters: {
        squawk_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<SquawksFindDuplicatesResponses, SquawksFindDuplicatesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'squawk_id' }] }]);
        return (options?.client ?? client).get<SquawksFindDuplicatesResponses, SquawksFindDuplicatesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/squawks/{squawk_id}/duplicates',
            ...options,
            ...params
        });
    }
    
    /**
     * Estimate Labour
     */
    public static estimateLabour<ThrowOnError extends boolean = false>(parameters: {
        squawk_id: string;
        aircraft_type_ids?: Array<string> | null;
        same_aircraft_type?: boolean;
    }, options?: Options<never, ThrowOnError>): RequestResult<SquawksEstimateLabourResponses, SquawksEstimateLabourErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'squawk_id' },
                    { in: 'query', key: 'aircraft_type_ids' },
                    { in: 'query', key: 'same_aircraft_type' }
                ] }]);
        return (options?.client ?? client).get<SquawksEstimateLabourResponses, SquawksEstimateLabourErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/squawks/{squawk_id}/labour',
            ...options,
            ...params
        });
    }
    
    /**
     * List Past Parts
     */
    public static listPastParts<ThrowOnError extends boolean = false>(parameters: {
        squawk_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<SquawksListPastPartsResponses, SquawksListPastPartsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'squawk_id' }] }]);
        return (options?.client ?? client).get<SquawksListPastPartsResponses, SquawksListPastPartsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/squawks/{squawk_id}/past-parts',
            ...options,
            ...params
        });
    }
    
    /**
     * Get Price History
     */
    public static getPriceHistory<ThrowOnError extends boolean = false>(parameters: {
        squawk_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<SquawksGetPriceHistoryResponses, SquawksGetPriceHistoryErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'squawk_id' }] }]);
        return (options?.client ?? client).get<SquawksGetPriceHistoryResponses, SquawksGetPriceHistoryErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/squawks/{squawk_id}/price-history',
            ...options,
            ...params
        });
    }
    
    /**
     * Restore
     */
    public static restore<ThrowOnError extends boolean = false>(parameters: {
        squawk_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<SquawksRestoreResponses, SquawksRestoreErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'squawk_id' }] }]);
        return (options?.client ?? client).post<SquawksRestoreResponses, SquawksRestoreErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/squawks/{squawk_id}/restore',
            ...options,
            ...params
        });
    }
    
    /**
     * Suggest Details
     */
    public static suggestDetails<ThrowOnError extends boolean = false>(parameters: {
        squawk_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<SquawksSuggestDetailsResponses, SquawksSuggestDetailsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'squawk_id' }] }]);
        return (options?.client ?? client).get<SquawksSuggestDetailsResponses, SquawksSuggestDetailsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/squawks/{squawk_id}/suggestions',
            ...options,
            ...params
        });
    }
    
    /**
     * Apply Suggestion
     */
    public static applySuggestion<ThrowOnError extends boolean = false>(parameters: {
        squawk_id: string;
        applySquawkSuggestion: ApplySquawkSuggestion;
    }, options?: Options<never, ThrowOnError>): RequestResult<SquawksApplySuggestionResponses, SquawksApplySuggestionErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'squawk_id' }, { key: 'applySquawkSuggestion', map: 'body' }] }]);
        return (options?.client ?? client).post<SquawksApplySuggestionResponses, SquawksApplySuggestionErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/squawks/{squawk_id}/suggestions/apply',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class SquawkPrintingService {
    /**
     * Print Squawk Cards
     */
    public static printSquawkCards<ThrowOnError extends boolean = false>(parameters: {
        printSquawkCards: PrintSquawkCards;
    }, options?: Options<never, ThrowOnError>): RequestResult<SquawkPrintingPrintSquawkCardsResponses, SquawkPrintingPrintSquawkCardsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'printSquawkCards', map: 'body' }] }]);
        return (options?.client ?? client).post<SquawkPrintingPrintSquawkCardsResponses, SquawkPrintingPrintSquawkCardsErrors, ThrowOnError>({
            responseType: 'blob',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/squawks/cards',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Print Squawk List
     */
    public static printSquawkList<ThrowOnError extends boolean = false>(parameters: {
        printSquawkList: PrintSquawkList;
    }, options?: Options<never, ThrowOnError>): RequestResult<SquawkPrintingPrintSquawkListResponses, SquawkPrintingPrintSquawkListErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'printSquawkList', map: 'body' }] }]);
        return (options?.client ?? client).post<SquawkPrintingPrintSquawkListResponses, SquawkPrintingPrintSquawkListErrors, ThrowOnError>({
            responseType: 'blob',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/squawks/list',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class SuggestedComplianceNoteService {
    /**
     * Accept a suggested compliance note by ID and create a compliance note.
     */
    public static acceptSuggestedComplianceNoteRoute<ThrowOnError extends boolean = false>(parameters: {
        id: string;
        edited_content?: string | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<SuggestedComplianceNoteAcceptSuggestedComplianceNoteRouteResponses, SuggestedComplianceNoteAcceptSuggestedComplianceNoteRouteErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'id' }, { in: 'query', key: 'edited_content' }] }]);
        return (options?.client ?? client).post<SuggestedComplianceNoteAcceptSuggestedComplianceNoteRouteResponses, SuggestedComplianceNoteAcceptSuggestedComplianceNoteRouteErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/suggested-compliance-note/accept/{id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Create a compliance note when a suggested compliance note is accepted.
     *
     * @deprecated
     */
    public static createComplianceNoteWhenSuggestedComplianceNoteIsAcceptedRoute<ThrowOnError extends boolean = false>(parameters: {
        work_task_id: string;
        edited_content?: string | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<SuggestedComplianceNoteCreateComplianceNoteWhenSuggestedComplianceNoteIsAcceptedRouteResponses, SuggestedComplianceNoteCreateComplianceNoteWhenSuggestedComplianceNoteIsAcceptedRouteErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'work_task_id' }, { in: 'query', key: 'edited_content' }] }]);
        return (options?.client ?? client).post<SuggestedComplianceNoteCreateComplianceNoteWhenSuggestedComplianceNoteIsAcceptedRouteResponses, SuggestedComplianceNoteCreateComplianceNoteWhenSuggestedComplianceNoteIsAcceptedRouteErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/suggested-compliance-note/create-compliance-note-when-suggested-compliance-note-is-accepted/{work_task_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Get a generated compliance note suggestion for a description using RAG.
     *
     * Returns a list of suggested compliance notes:
     * - Note, generated based on description
     * - Static list of default notes
     */
    public static generateNoteContentByDescription<ThrowOnError extends boolean = false>(parameters: {
        description: string;
        work_task_id?: string | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<SuggestedComplianceNoteGenerateNoteContentByDescriptionResponses, SuggestedComplianceNoteGenerateNoteContentByDescriptionErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'query', key: 'description' }, { in: 'query', key: 'work_task_id' }] }]);
        return (options?.client ?? client).get<SuggestedComplianceNoteGenerateNoteContentByDescriptionResponses, SuggestedComplianceNoteGenerateNoteContentByDescriptionErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/suggested-compliance-note/generate-note-content-by-description',
            ...options,
            ...params
        });
    }
    
    /**
     * Get a generated compliance note suggestion to eval for a description.
     */
    public static evalGenerateNoteContentByDescription<ThrowOnError extends boolean = false>(parameters: {
        work_task_number: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<SuggestedComplianceNoteEvalGenerateNoteContentByDescriptionResponses, SuggestedComplianceNoteEvalGenerateNoteContentByDescriptionErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'query', key: 'work_task_number' }] }]);
        return (options?.client ?? client).get<SuggestedComplianceNoteEvalGenerateNoteContentByDescriptionResponses, SuggestedComplianceNoteEvalGenerateNoteContentByDescriptionErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/suggested-compliance-note/generate-note-content-by-description/eval',
            ...options,
            ...params
        });
    }
    
    /**
     * Get the latest suggested compliance note by work task id and type.
     *
     * @deprecated
     */
    public static getLatestSuggestedComplianceNoteByWorkTaskIdAndTypeRoute<ThrowOnError extends boolean = false>(parameters: {
        work_task_id: string;
        type: SuggestedComplianceNoteType;
    }, options?: Options<never, ThrowOnError>): RequestResult<SuggestedComplianceNoteGetLatestSuggestedComplianceNoteByWorkTaskIdAndTypeRouteResponses, SuggestedComplianceNoteGetLatestSuggestedComplianceNoteByWorkTaskIdAndTypeRouteErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'work_task_id' }, { in: 'path', key: 'type' }] }]);
        return (options?.client ?? client).get<SuggestedComplianceNoteGetLatestSuggestedComplianceNoteByWorkTaskIdAndTypeRouteResponses, SuggestedComplianceNoteGetLatestSuggestedComplianceNoteByWorkTaskIdAndTypeRouteErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/suggested-compliance-note/latest/{work_task_id}/{type}',
            ...options,
            ...params
        });
    }
    
    /**
     * Read Item
     */
    public static readItem<ThrowOnError extends boolean = false>(parameters: {
        id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<SuggestedComplianceNoteReadItemResponses, SuggestedComplianceNoteReadItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'id' }] }]);
        return (options?.client ?? client).get<SuggestedComplianceNoteReadItemResponses, SuggestedComplianceNoteReadItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/suggested-compliance-note/{id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update Item
     */
    public static updateItem<ThrowOnError extends boolean = false>(parameters: {
        id: string;
        suggestedComplianceNoteUpdate: SuggestedComplianceNoteUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<SuggestedComplianceNoteUpdateItemResponses, SuggestedComplianceNoteUpdateItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'id' }, { key: 'suggestedComplianceNoteUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<SuggestedComplianceNoteUpdateItemResponses, SuggestedComplianceNoteUpdateItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/suggested-compliance-note/{id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class TaskTranscriptService {
    /**
     * Get work tasks and work packages with recent tie-in transcripts.
     */
    public static getLatestTieInsReferences<ThrowOnError extends boolean = false>(parameters?: {
        skip?: number;
        limit?: number;
        search?: string | null;
        types?: Array<TieInReferenceType> | null;
        load_tie_ins?: boolean;
    }, options?: Options<never, ThrowOnError>): RequestResult<TaskTranscriptGetLatestTieInsReferencesResponses, TaskTranscriptGetLatestTieInsReferencesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'search' },
                    { in: 'query', key: 'types' },
                    { in: 'query', key: 'load_tie_ins' }
                ] }]);
        return (options?.client ?? client).get<TaskTranscriptGetLatestTieInsReferencesResponses, TaskTranscriptGetLatestTieInsReferencesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/task-transcript/latest-tie-ins-references',
            ...options,
            ...params
        });
    }
    
    /**
     * Create a tie-in. Pass content and an optional work_task_id or work_package_id (not both); omit both to leave it unassigned.
     */
    public static createTieIn<ThrowOnError extends boolean = false>(parameters: {
        tieInAgentCreate: TieInAgentCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<TaskTranscriptCreateTieInResponses, TaskTranscriptCreateTieInErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'tieInAgentCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<TaskTranscriptCreateTieInResponses, TaskTranscriptCreateTieInErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/task-transcript/tie-in',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Get a single tie-in by id.
     */
    public static getTieIn<ThrowOnError extends boolean = false>(parameters: {
        id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<TaskTranscriptGetTieInResponses, TaskTranscriptGetTieInErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'id' }] }]);
        return (options?.client ?? client).get<TaskTranscriptGetTieInResponses, TaskTranscriptGetTieInErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/task-transcript/tie-in/{id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Get tie-in transcripts with assignment, newest first.
     */
    public static getTieIns<ThrowOnError extends boolean = false>(parameters?: {
        skip?: number;
        limit?: number;
        search?: string | null;
        unassigned?: boolean;
    }, options?: Options<never, ThrowOnError>): RequestResult<TaskTranscriptGetTieInsResponses, TaskTranscriptGetTieInsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'search' },
                    { in: 'query', key: 'unassigned' }
                ] }]);
        return (options?.client ?? client).get<TaskTranscriptGetTieInsResponses, TaskTranscriptGetTieInsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/task-transcript/tie-ins',
            ...options,
            ...params
        });
    }
    
    /**
     * Get task transcripts by work package id.
     */
    public static getTaskTranscriptsByWorkPackageId<ThrowOnError extends boolean = false>(parameters: {
        work_package_id: string;
        skip?: number;
        limit?: number;
        category?: TaskTranscriptCategory | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<TaskTranscriptGetTaskTranscriptsByWorkPackageIdResponses, TaskTranscriptGetTaskTranscriptsByWorkPackageIdErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'work_package_id' },
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'category' }
                ] }]);
        return (options?.client ?? client).get<TaskTranscriptGetTaskTranscriptsByWorkPackageIdResponses, TaskTranscriptGetTaskTranscriptsByWorkPackageIdErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/task-transcript/work-package/{work_package_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Get task transcripts by work task id.
     */
    public static getTaskTranscriptsByWorkTaskId<ThrowOnError extends boolean = false>(parameters: {
        work_task_id: string;
        skip?: number;
        limit?: number;
        category?: TaskTranscriptCategory | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<TaskTranscriptGetTaskTranscriptsByWorkTaskIdResponses, TaskTranscriptGetTaskTranscriptsByWorkTaskIdErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'work_task_id' },
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'category' }
                ] }]);
        return (options?.client ?? client).get<TaskTranscriptGetTaskTranscriptsByWorkTaskIdResponses, TaskTranscriptGetTaskTranscriptsByWorkTaskIdErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/task-transcript/work-task/{work_task_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update a task transcript.
     */
    public static updateItem<ThrowOnError extends boolean = false>(parameters: {
        id: string;
        taskTranscriptUpdate: TaskTranscriptUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<TaskTranscriptUpdateItemResponses, TaskTranscriptUpdateItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'id' }, { key: 'taskTranscriptUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<TaskTranscriptUpdateItemResponses, TaskTranscriptUpdateItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/task-transcript/{id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class TieInsService {
    /**
     * Create a tie-in. Pass content and an optional work_task_id or work_package_id (not both); omit both to leave it unassigned.
     */
    public static createTieIn<ThrowOnError extends boolean = false>(parameters: {
        tieInAgentCreate: TieInAgentCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<TaskTranscriptCreateTieInResponses, TaskTranscriptCreateTieInErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'tieInAgentCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<TaskTranscriptCreateTieInResponses, TaskTranscriptCreateTieInErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/task-transcript/tie-in',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class TaxRatesService {
    /**
     * List Tax Rates
     */
    public static listTaxRates<ThrowOnError extends boolean = false>(parameters?: {
        skip?: number;
        limit?: number;
        search?: string | null;
        deleted?: boolean;
    }, options?: Options<never, ThrowOnError>): RequestResult<TaxRatesListTaxRatesResponses, TaxRatesListTaxRatesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'search' },
                    { in: 'query', key: 'deleted' }
                ] }]);
        return (options?.client ?? client).get<TaxRatesListTaxRatesResponses, TaxRatesListTaxRatesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tax-rates/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create
     */
    public static create<ThrowOnError extends boolean = false>(parameters: {
        taxRateCreate: TaxRateCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<TaxRatesCreateResponses, TaxRatesCreateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'taxRateCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<TaxRatesCreateResponses, TaxRatesCreateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tax-rates/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete
     */
    public static delete<ThrowOnError extends boolean = false>(parameters: {
        tax_rate_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<TaxRatesDeleteResponses, TaxRatesDeleteErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tax_rate_id' }] }]);
        return (options?.client ?? client).delete<TaxRatesDeleteResponses, TaxRatesDeleteErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tax-rates/{tax_rate_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Get
     */
    public static get<ThrowOnError extends boolean = false>(parameters: {
        tax_rate_id: string;
        include_archived?: boolean;
    }, options?: Options<never, ThrowOnError>): RequestResult<TaxRatesGetResponses, TaxRatesGetErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tax_rate_id' }, { in: 'query', key: 'include_archived' }] }]);
        return (options?.client ?? client).get<TaxRatesGetResponses, TaxRatesGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tax-rates/{tax_rate_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update
     */
    public static update<ThrowOnError extends boolean = false>(parameters: {
        tax_rate_id: string;
        taxRateUpdate: TaxRateUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<TaxRatesUpdateResponses, TaxRatesUpdateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tax_rate_id' }, { key: 'taxRateUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<TaxRatesUpdateResponses, TaxRatesUpdateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tax-rates/{tax_rate_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Restore
     */
    public static restore<ThrowOnError extends boolean = false>(parameters: {
        tax_rate_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<TaxRatesRestoreResponses, TaxRatesRestoreErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tax_rate_id' }] }]);
        return (options?.client ?? client).post<TaxRatesRestoreResponses, TaxRatesRestoreErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tax-rates/{tax_rate_id}/restore',
            ...options,
            ...params
        });
    }
}

export class TeamsService {
    /**
     * List Teams
     */
    public static listTeams<ThrowOnError extends boolean = false>(parameters?: {
        deleted?: boolean;
    }, options?: Options<never, ThrowOnError>): RequestResult<TeamsListTeamsResponses, TeamsListTeamsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'query', key: 'deleted' }] }]);
        return (options?.client ?? client).get<TeamsListTeamsResponses, TeamsListTeamsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/teams/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create
     */
    public static create<ThrowOnError extends boolean = false>(parameters: {
        teamCreate: TeamCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<TeamsCreateResponses, TeamsCreateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'teamCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<TeamsCreateResponses, TeamsCreateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/teams/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete
     */
    public static delete<ThrowOnError extends boolean = false>(parameters: {
        team_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<TeamsDeleteResponses, TeamsDeleteErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'team_id' }] }]);
        return (options?.client ?? client).delete<TeamsDeleteResponses, TeamsDeleteErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/teams/{team_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Get
     */
    public static get<ThrowOnError extends boolean = false>(parameters: {
        team_id: string;
        include_archived?: boolean;
    }, options?: Options<never, ThrowOnError>): RequestResult<TeamsGetResponses, TeamsGetErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'team_id' }, { in: 'query', key: 'include_archived' }] }]);
        return (options?.client ?? client).get<TeamsGetResponses, TeamsGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/teams/{team_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update
     */
    public static update<ThrowOnError extends boolean = false>(parameters: {
        team_id: string;
        teamUpdate: TeamUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<TeamsUpdateResponses, TeamsUpdateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'team_id' }, { key: 'teamUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<TeamsUpdateResponses, TeamsUpdateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/teams/{team_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Restore
     */
    public static restore<ThrowOnError extends boolean = false>(parameters: {
        team_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<TeamsRestoreResponses, TeamsRestoreErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'team_id' }] }]);
        return (options?.client ?? client).post<TeamsRestoreResponses, TeamsRestoreErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/teams/{team_id}/restore',
            ...options,
            ...params
        });
    }
}

export class TenantIndexingService {
    /**
     * Index Tenant
     */
    public static indexTenant<ThrowOnError extends boolean = false>(parameters: {
        tenant_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<TenantIndexingIndexTenantResponses, TenantIndexingIndexTenantErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tenant_id' }] }]);
        return (options?.client ?? client).post<TenantIndexingIndexTenantResponses, TenantIndexingIndexTenantErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant-indexing/{tenant_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Reindex Tenant
     */
    public static reindexTenant<ThrowOnError extends boolean = false>(parameters: {
        tenant_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<TenantIndexingReindexTenantResponses, TenantIndexingReindexTenantErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tenant_id' }] }]);
        return (options?.client ?? client).post<TenantIndexingReindexTenantResponses, TenantIndexingReindexTenantErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant-indexing/{tenant_id}/reindex',
            ...options,
            ...params
        });
    }
}

export class TenantIntegrationConfigsService {
    /**
     * List Configs
     */
    public static listConfigs<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<TenantIntegrationConfigsListConfigsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<TenantIntegrationConfigsListConfigsResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant-integration-configs/',
            ...options
        });
    }
    
    /**
     * Create
     */
    public static create<ThrowOnError extends boolean = false>(parameters: {
        tenantIntegrationConfigCreate: TenantIntegrationConfigCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<TenantIntegrationConfigsCreateResponses, TenantIntegrationConfigsCreateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'tenantIntegrationConfigCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<TenantIntegrationConfigsCreateResponses, TenantIntegrationConfigsCreateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant-integration-configs/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete
     */
    public static delete<ThrowOnError extends boolean = false>(parameters: {
        config_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<TenantIntegrationConfigsDeleteResponses, TenantIntegrationConfigsDeleteErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'config_id' }] }]);
        return (options?.client ?? client).delete<TenantIntegrationConfigsDeleteResponses, TenantIntegrationConfigsDeleteErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant-integration-configs/{config_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Get
     */
    public static get<ThrowOnError extends boolean = false>(parameters: {
        config_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<TenantIntegrationConfigsGetResponses, TenantIntegrationConfigsGetErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'config_id' }] }]);
        return (options?.client ?? client).get<TenantIntegrationConfigsGetResponses, TenantIntegrationConfigsGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant-integration-configs/{config_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update
     */
    public static update<ThrowOnError extends boolean = false>(parameters: {
        config_id: string;
        tenantIntegrationConfigUpdate: TenantIntegrationConfigUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<TenantIntegrationConfigsUpdateResponses, TenantIntegrationConfigsUpdateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'config_id' }, { key: 'tenantIntegrationConfigUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<TenantIntegrationConfigsUpdateResponses, TenantIntegrationConfigsUpdateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant-integration-configs/{config_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Get Hubspot Config
     */
    public static getHubspotConfig<ThrowOnError extends boolean = false>(parameters: {
        config_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<TenantIntegrationConfigsGetHubspotConfigResponses, TenantIntegrationConfigsGetHubspotConfigErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'config_id' }] }]);
        return (options?.client ?? client).get<TenantIntegrationConfigsGetHubspotConfigResponses, TenantIntegrationConfigsGetHubspotConfigErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant-integration-configs/{config_id}/hubspot',
            ...options,
            ...params
        });
    }
    
    /**
     * Set Hubspot Webhook Secret
     */
    public static setHubspotWebhookSecret<ThrowOnError extends boolean = false>(parameters: {
        config_id: string;
        hubSpotIntegrationConfigUpsert: HubSpotIntegrationConfigUpsert;
    }, options?: Options<never, ThrowOnError>): RequestResult<TenantIntegrationConfigsSetHubspotWebhookSecretResponses, TenantIntegrationConfigsSetHubspotWebhookSecretErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'config_id' }, { key: 'hubSpotIntegrationConfigUpsert', map: 'body' }] }]);
        return (options?.client ?? client).put<TenantIntegrationConfigsSetHubspotWebhookSecretResponses, TenantIntegrationConfigsSetHubspotWebhookSecretErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant-integration-configs/{config_id}/hubspot',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Get Hubspot Eligibility
     */
    public static getHubspotEligibility<ThrowOnError extends boolean = false>(parameters: {
        config_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<TenantIntegrationConfigsGetHubspotEligibilityResponses, TenantIntegrationConfigsGetHubspotEligibilityErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'config_id' }] }]);
        return (options?.client ?? client).get<TenantIntegrationConfigsGetHubspotEligibilityResponses, TenantIntegrationConfigsGetHubspotEligibilityErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant-integration-configs/{config_id}/hubspot/eligibility',
            ...options,
            ...params
        });
    }
    
    /**
     * Set Hubspot Eligibility
     */
    public static setHubspotEligibility<ThrowOnError extends boolean = false>(parameters: {
        config_id: string;
        hubSpotEligibilityUpsert: HubSpotEligibilityUpsert;
    }, options?: Options<never, ThrowOnError>): RequestResult<TenantIntegrationConfigsSetHubspotEligibilityResponses, TenantIntegrationConfigsSetHubspotEligibilityErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'config_id' }, { key: 'hubSpotEligibilityUpsert', map: 'body' }] }]);
        return (options?.client ?? client).put<TenantIntegrationConfigsSetHubspotEligibilityResponses, TenantIntegrationConfigsSetHubspotEligibilityErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant-integration-configs/{config_id}/hubspot/eligibility',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Get Hubspot Property Mapping
     */
    public static getHubspotPropertyMapping<ThrowOnError extends boolean = false>(parameters: {
        config_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<TenantIntegrationConfigsGetHubspotPropertyMappingResponses, TenantIntegrationConfigsGetHubspotPropertyMappingErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'config_id' }] }]);
        return (options?.client ?? client).get<TenantIntegrationConfigsGetHubspotPropertyMappingResponses, TenantIntegrationConfigsGetHubspotPropertyMappingErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant-integration-configs/{config_id}/hubspot/property-mapping',
            ...options,
            ...params
        });
    }
    
    /**
     * Set Hubspot Property Mapping
     */
    public static setHubspotPropertyMapping<ThrowOnError extends boolean = false>(parameters: {
        config_id: string;
        hubSpotPropertyMappingUpsert: HubSpotPropertyMappingUpsert;
    }, options?: Options<never, ThrowOnError>): RequestResult<TenantIntegrationConfigsSetHubspotPropertyMappingResponses, TenantIntegrationConfigsSetHubspotPropertyMappingErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'config_id' }, { key: 'hubSpotPropertyMappingUpsert', map: 'body' }] }]);
        return (options?.client ?? client).put<TenantIntegrationConfigsSetHubspotPropertyMappingResponses, TenantIntegrationConfigsSetHubspotPropertyMappingErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant-integration-configs/{config_id}/hubspot/property-mapping',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Get Hubspot Quoting Config
     */
    public static getHubspotQuotingConfig<ThrowOnError extends boolean = false>(parameters: {
        config_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<TenantIntegrationConfigsGetHubspotQuotingConfigResponses, TenantIntegrationConfigsGetHubspotQuotingConfigErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'config_id' }] }]);
        return (options?.client ?? client).get<TenantIntegrationConfigsGetHubspotQuotingConfigResponses, TenantIntegrationConfigsGetHubspotQuotingConfigErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant-integration-configs/{config_id}/hubspot/quoting',
            ...options,
            ...params
        });
    }
    
    /**
     * Set Hubspot Quoting Config
     */
    public static setHubspotQuotingConfig<ThrowOnError extends boolean = false>(parameters: {
        config_id: string;
        hubSpotQuotingConfigUpsert: HubSpotQuotingConfigUpsert;
    }, options?: Options<never, ThrowOnError>): RequestResult<TenantIntegrationConfigsSetHubspotQuotingConfigResponses, TenantIntegrationConfigsSetHubspotQuotingConfigErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'config_id' }, { key: 'hubSpotQuotingConfigUpsert', map: 'body' }] }]);
        return (options?.client ?? client).put<TenantIntegrationConfigsSetHubspotQuotingConfigResponses, TenantIntegrationConfigsSetHubspotQuotingConfigErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant-integration-configs/{config_id}/hubspot/quoting',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class TenantQuotingSettingsService {
    /**
     * Get Tenant Quoting Settings
     */
    public static getTenantQuotingSettings<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<TenantQuotingSettingsGetTenantQuotingSettingsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<TenantQuotingSettingsGetTenantQuotingSettingsResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant-quoting-settings/',
            ...options
        });
    }
    
    /**
     * Upsert Tenant Quoting Settings
     */
    public static upsertTenantQuotingSettings<ThrowOnError extends boolean = false>(parameters: {
        tenantQuotingSettingsUpsert: TenantQuotingSettingsUpsert;
    }, options?: Options<never, ThrowOnError>): RequestResult<TenantQuotingSettingsUpsertTenantQuotingSettingsResponses, TenantQuotingSettingsUpsertTenantQuotingSettingsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'tenantQuotingSettingsUpsert', map: 'body' }] }]);
        return (options?.client ?? client).put<TenantQuotingSettingsUpsertTenantQuotingSettingsResponses, TenantQuotingSettingsUpsertTenantQuotingSettingsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant-quoting-settings/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class TenantService {
    /**
     * Get Tenants
     */
    public static getTenants<ThrowOnError extends boolean = false>(parameters?: {
        skip?: number;
        limit?: number;
        search?: string | null;
        type?: string | null;
        is_active?: boolean | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<TenantGetTenantsResponses, TenantGetTenantsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'search' },
                    { in: 'query', key: 'type' },
                    { in: 'query', key: 'is_active' }
                ] }]);
        return (options?.client ?? client).get<TenantGetTenantsResponses, TenantGetTenantsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create Tenant
     */
    public static createTenant<ThrowOnError extends boolean = false>(parameters: {
        tenantCreate: TenantCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<TenantCreateTenantResponses, TenantCreateTenantErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'tenantCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<TenantCreateTenantResponses, TenantCreateTenantErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Get Current Tenant
     */
    public static getCurrentTenant<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<TenantGetCurrentTenantResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<TenantGetCurrentTenantResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant/current',
            ...options
        });
    }
    
    /**
     * Update Current Tenant
     */
    public static updateCurrentTenant<ThrowOnError extends boolean = false>(parameters: {
        tenantProfile: TenantProfile;
    }, options?: Options<never, ThrowOnError>): RequestResult<TenantUpdateCurrentTenantResponses, TenantUpdateCurrentTenantErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'tenantProfile', map: 'body' }] }]);
        return (options?.client ?? client).put<TenantUpdateCurrentTenantResponses, TenantUpdateCurrentTenantErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant/current',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete Current Company Logo
     */
    public static deleteCurrentCompanyLogo<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<TenantDeleteCurrentCompanyLogoResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).delete<TenantDeleteCurrentCompanyLogoResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant/current/company-logo',
            ...options
        });
    }
    
    /**
     * Upload Current Company Logo
     */
    public static uploadCurrentCompanyLogo<ThrowOnError extends boolean = false>(parameters: {
        bodyTenantUploadCurrentCompanyLogo: BodyTenantUploadCurrentCompanyLogo;
    }, options?: Options<never, ThrowOnError>): RequestResult<TenantUploadCurrentCompanyLogoResponses, TenantUploadCurrentCompanyLogoErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'bodyTenantUploadCurrentCompanyLogo', map: 'body' }] }]);
        return (options?.client ?? client).post<TenantUploadCurrentCompanyLogoResponses, TenantUploadCurrentCompanyLogoErrors, ThrowOnError>({
            ...formDataBodySerializer,
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant/current/company-logo',
            ...options,
            ...params,
            headers: {
                'Content-Type': null,
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Get Tenant
     */
    public static getTenant<ThrowOnError extends boolean = false>(parameters: {
        tenant_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<TenantGetTenantResponses, TenantGetTenantErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tenant_id' }] }]);
        return (options?.client ?? client).get<TenantGetTenantResponses, TenantGetTenantErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant/{tenant_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update Tenant
     */
    public static updateTenant<ThrowOnError extends boolean = false>(parameters: {
        tenant_id: string;
        tenantUpdate: TenantUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<TenantUpdateTenantResponses, TenantUpdateTenantErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tenant_id' }, { key: 'tenantUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<TenantUpdateTenantResponses, TenantUpdateTenantErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant/{tenant_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete Company Logo
     *
     * Delete the company logo for the tenant (system admin only).
     */
    public static deleteCompanyLogo<ThrowOnError extends boolean = false>(parameters: {
        tenant_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<TenantDeleteCompanyLogoResponses, TenantDeleteCompanyLogoErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tenant_id' }] }]);
        return (options?.client ?? client).delete<TenantDeleteCompanyLogoResponses, TenantDeleteCompanyLogoErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant/{tenant_id}/company-logo',
            ...options,
            ...params
        });
    }
    
    /**
     * Upload Company Logo
     *
     * Upload a company logo for the tenant (system admin only).
     * Supported formats: PNG, JPG, JPEG
     * Max size: 5MB
     */
    public static uploadCompanyLogo<ThrowOnError extends boolean = false>(parameters: {
        tenant_id: string;
        bodyTenantUploadCompanyLogo: BodyTenantUploadCompanyLogo;
    }, options?: Options<never, ThrowOnError>): RequestResult<TenantUploadCompanyLogoResponses, TenantUploadCompanyLogoErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tenant_id' }, { key: 'bodyTenantUploadCompanyLogo', map: 'body' }] }]);
        return (options?.client ?? client).post<TenantUploadCompanyLogoResponses, TenantUploadCompanyLogoErrors, ThrowOnError>({
            ...formDataBodySerializer,
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant/{tenant_id}/company-logo',
            ...options,
            ...params,
            headers: {
                'Content-Type': null,
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Get Tenant Modules Enabled
     */
    public static getTenantModulesEnabled<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<TenantGetTenantModulesEnabledResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<TenantGetTenantModulesEnabledResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant/{tenant_id}/modules-enabled',
            ...options
        });
    }
    
    /**
     * Create Multiple Users
     */
    public static createMultipleUsers<ThrowOnError extends boolean = false>(parameters: {
        tenant_id: string;
        usersBulkCreate: UsersBulkCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<TenantCreateMultipleUsersResponses, TenantCreateMultipleUsersErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tenant_id' }, { key: 'usersBulkCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<TenantCreateMultipleUsersResponses, TenantCreateMultipleUsersErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant/{tenant_id}/multiple_users',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Get Tenant Owner
     */
    public static getTenantOwner<ThrowOnError extends boolean = false>(parameters: {
        tenant_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<TenantGetTenantOwnerResponses, TenantGetTenantOwnerErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tenant_id' }] }]);
        return (options?.client ?? client).get<TenantGetTenantOwnerResponses, TenantGetTenantOwnerErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant/{tenant_id}/owner',
            ...options,
            ...params
        });
    }
    
    /**
     * Assign Tenant Owner
     */
    public static assignTenantOwner<ThrowOnError extends boolean = false>(parameters: {
        tenant_id: string;
        tenantOwnerAssign: TenantOwnerAssign;
    }, options?: Options<never, ThrowOnError>): RequestResult<TenantAssignTenantOwnerResponses, TenantAssignTenantOwnerErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tenant_id' }, { key: 'tenantOwnerAssign', map: 'body' }] }]);
        return (options?.client ?? client).post<TenantAssignTenantOwnerResponses, TenantAssignTenantOwnerErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant/{tenant_id}/owner',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * List Roles
     *
     * List all roles in the tenant.
     */
    public static listRoles<ThrowOnError extends boolean = false>(parameters: {
        tenant_id: string;
        skip?: number;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<TenantListRolesResponses, TenantListRolesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'tenant_id' },
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' }
                ] }]);
        return (options?.client ?? client).get<TenantListRolesResponses, TenantListRolesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant/{tenant_id}/roles',
            ...options,
            ...params
        });
    }
    
    /**
     * Remove Role From User
     *
     * Remove a role from a user.
     */
    public static removeRoleFromUser<ThrowOnError extends boolean = false>(parameters: {
        tenant_id: string;
        user_id: string;
        role_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<TenantRemoveRoleFromUserResponses, TenantRemoveRoleFromUserErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'tenant_id' },
                    { in: 'query', key: 'user_id' },
                    { in: 'query', key: 'role_id' }
                ] }]);
        return (options?.client ?? client).delete<TenantRemoveRoleFromUserResponses, TenantRemoveRoleFromUserErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant/{tenant_id}/roles/users/roles',
            ...options,
            ...params
        });
    }
    
    /**
     * Assign Role To User
     *
     * Assign a role to a user.
     */
    public static assignRoleToUser<ThrowOnError extends boolean = false>(parameters: {
        tenant_id: string;
        userRoleCreate: UserRoleCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<TenantAssignRoleToUserResponses, TenantAssignRoleToUserErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tenant_id' }, { key: 'userRoleCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<TenantAssignRoleToUserResponses, TenantAssignRoleToUserErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant/{tenant_id}/roles/users/roles',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Read Users By Tenant Id
     */
    public static readUsersByTenantId<ThrowOnError extends boolean = false>(parameters: {
        tenant_id: string;
        skip?: number;
        limit?: number;
        search?: string | null;
        designation?: string | null;
        is_system_user?: boolean | null;
        is_active?: boolean | null;
        role_ids?: Array<string> | null;
        sort_by?: UserSortField;
        sort_direction?: 'asc' | 'desc';
    }, options?: Options<never, ThrowOnError>): RequestResult<TenantReadUsersByTenantIdResponses, TenantReadUsersByTenantIdErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'tenant_id' },
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'search' },
                    { in: 'query', key: 'designation' },
                    { in: 'query', key: 'is_system_user' },
                    { in: 'query', key: 'is_active' },
                    { in: 'query', key: 'role_ids' },
                    { in: 'query', key: 'sort_by' },
                    { in: 'query', key: 'sort_direction' }
                ] }]);
        return (options?.client ?? client).get<TenantReadUsersByTenantIdResponses, TenantReadUsersByTenantIdErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant/{tenant_id}/users',
            ...options,
            ...params
        });
    }
    
    /**
     * Create User By Tenant Id
     */
    public static createUserByTenantId<ThrowOnError extends boolean = false>(parameters: {
        tenant_id: string;
        userCreate: UserCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<TenantCreateUserByTenantIdResponses, TenantCreateUserByTenantIdErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tenant_id' }, { key: 'userCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<TenantCreateUserByTenantIdResponses, TenantCreateUserByTenantIdErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant/{tenant_id}/users',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Export Users By Tenant Id
     */
    public static exportUsersByTenantId<ThrowOnError extends boolean = false>(parameters: {
        tenant_id: string;
        search?: string | null;
        designation?: string | null;
        is_system_user?: boolean | null;
        is_active?: boolean | null;
        role_ids?: Array<string> | null;
        sort_by?: UserSortField;
        sort_direction?: 'asc' | 'desc';
    }, options?: Options<never, ThrowOnError>): RequestResult<TenantExportUsersByTenantIdResponses, TenantExportUsersByTenantIdErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'tenant_id' },
                    { in: 'query', key: 'search' },
                    { in: 'query', key: 'designation' },
                    { in: 'query', key: 'is_system_user' },
                    { in: 'query', key: 'is_active' },
                    { in: 'query', key: 'role_ids' },
                    { in: 'query', key: 'sort_by' },
                    { in: 'query', key: 'sort_direction' }
                ] }]);
        return (options?.client ?? client).get<TenantExportUsersByTenantIdResponses, TenantExportUsersByTenantIdErrors, ThrowOnError>({
            responseType: 'text',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant/{tenant_id}/users/export',
            ...options,
            ...params
        });
    }
    
    /**
     * Delete User By Tenant Id
     */
    public static deleteUserByTenantId<ThrowOnError extends boolean = false>(parameters: {
        tenant_id: string;
        user_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<TenantDeleteUserByTenantIdResponses, TenantDeleteUserByTenantIdErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tenant_id' }, { in: 'path', key: 'user_id' }] }]);
        return (options?.client ?? client).delete<TenantDeleteUserByTenantIdResponses, TenantDeleteUserByTenantIdErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant/{tenant_id}/users/{user_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update User By Tenant Id
     */
    public static updateUserByTenantId<ThrowOnError extends boolean = false>(parameters: {
        tenant_id: string;
        user_id: string;
        userUpdate: UserUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<TenantUpdateUserByTenantIdResponses, TenantUpdateUserByTenantIdErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'tenant_id' },
                    { in: 'path', key: 'user_id' },
                    { key: 'userUpdate', map: 'body' }
                ] }]);
        return (options?.client ?? client).patch<TenantUpdateUserByTenantIdResponses, TenantUpdateUserByTenantIdErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant/{tenant_id}/users/{user_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Resend Login Email By Tenant Id
     */
    public static resendLoginEmailByTenantId<ThrowOnError extends boolean = false>(parameters: {
        tenant_id: string;
        user_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<TenantResendLoginEmailByTenantIdResponses, TenantResendLoginEmailByTenantIdErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tenant_id' }, { in: 'path', key: 'user_id' }] }]);
        return (options?.client ?? client).post<TenantResendLoginEmailByTenantIdResponses, TenantResendLoginEmailByTenantIdErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tenant/{tenant_id}/users/{user_id}/resend-login-email',
            ...options,
            ...params
        });
    }
}

export class TimeEntryService {
    /**
     * List Time Entries
     */
    public static listTimeEntries<ThrowOnError extends boolean = false>(parameters?: {
        since?: string | null;
        time_zone?: string;
        work_package_id?: Array<string> | null;
        aircraft?: Array<string> | null;
        status?: Array<TimeEntryStatus> | null;
        group?: TimeEntryGrouping | null;
        subgroup?: TimeEntryGrouping | null;
        skip?: number;
        limit?: number;
        group_key?: string | null;
        group_limit?: number | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<TimeEntryListTimeEntriesResponses, TimeEntryListTimeEntriesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'since' },
                    { in: 'query', key: 'time_zone' },
                    { in: 'query', key: 'work_package_id' },
                    { in: 'query', key: 'aircraft' },
                    { in: 'query', key: 'status' },
                    { in: 'query', key: 'group' },
                    { in: 'query', key: 'subgroup' },
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'group_key' },
                    { in: 'query', key: 'group_limit' }
                ] }]);
        return (options?.client ?? client).get<TimeEntryListTimeEntriesResponses, TimeEntryListTimeEntriesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/time-entry/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create Time Entry
     */
    public static createTimeEntry<ThrowOnError extends boolean = false>(parameters: {
        timeEntryCreate: TimeEntryCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<TimeEntryCreateTimeEntryResponses, TimeEntryCreateTimeEntryErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'timeEntryCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<TimeEntryCreateTimeEntryResponses, TimeEntryCreateTimeEntryErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/time-entry/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * List Time Entry Filter Options
     */
    public static listTimeEntryFilterOptions<ThrowOnError extends boolean = false>(parameters?: {
        since?: string | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<TimeEntryListTimeEntryFilterOptionsResponses, TimeEntryListTimeEntryFilterOptionsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'query', key: 'since' }] }]);
        return (options?.client ?? client).get<TimeEntryListTimeEntryFilterOptionsResponses, TimeEntryListTimeEntryFilterOptionsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/time-entry/filter-options',
            ...options,
            ...params
        });
    }
    
    /**
     * Search Time Entry Tasks
     */
    public static searchTimeEntryTasks<ThrowOnError extends boolean = false>(parameters?: {
        search?: string | null;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<TimeEntrySearchTimeEntryTasksResponses, TimeEntrySearchTimeEntryTasksErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'query', key: 'search' }, { in: 'query', key: 'limit' }] }]);
        return (options?.client ?? client).get<TimeEntrySearchTimeEntryTasksResponses, TimeEntrySearchTimeEntryTasksErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/time-entry/tasks',
            ...options,
            ...params
        });
    }
    
    /**
     * List Recent Time Entry Tasks
     */
    public static listRecentTimeEntryTasks<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<TimeEntryListRecentTimeEntryTasksResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<TimeEntryListRecentTimeEntryTasksResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/time-entry/tasks/recent',
            ...options
        });
    }
    
    /**
     * Get Task Time
     */
    public static getTaskTime<ThrowOnError extends boolean = false>(parameters: {
        work_task_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<TimeEntryGetTaskTimeResponses, TimeEntryGetTaskTimeErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'work_task_id' }] }]);
        return (options?.client ?? client).get<TimeEntryGetTaskTimeResponses, TimeEntryGetTaskTimeErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/time-entry/tasks/{work_task_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Delete Time Entry
     */
    public static deleteTimeEntry<ThrowOnError extends boolean = false>(parameters: {
        time_entry_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<TimeEntryDeleteTimeEntryResponses, TimeEntryDeleteTimeEntryErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'time_entry_id' }] }]);
        return (options?.client ?? client).delete<TimeEntryDeleteTimeEntryResponses, TimeEntryDeleteTimeEntryErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/time-entry/{time_entry_id}',
            ...options,
            ...params
        });
    }
}

export class TimerService {
    /**
     * Stop Timer
     */
    public static stopTimer<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<TimerStopTimerResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).delete<TimerStopTimerResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/timer/',
            ...options
        });
    }
    
    /**
     * Get Timer
     */
    public static getTimer<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<TimerGetTimerResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<TimerGetTimerResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/timer/',
            ...options
        });
    }
    
    /**
     * Start Timer
     */
    public static startTimer<ThrowOnError extends boolean = false>(parameters: {
        startTimer: StartTimer;
    }, options?: Options<never, ThrowOnError>): RequestResult<TimerStartTimerResponses, TimerStartTimerErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'startTimer', map: 'body' }] }]);
        return (options?.client ?? client).post<TimerStartTimerResponses, TimerStartTimerErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/timer/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Pause Timer
     */
    public static pauseTimer<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<TimerPauseTimerResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).post<TimerPauseTimerResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/timer/pause',
            ...options
        });
    }
    
    /**
     * Resume Timer
     */
    public static resumeTimer<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<TimerResumeTimerResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).post<TimerResumeTimerResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/timer/resume',
            ...options
        });
    }
    
    /**
     * Stop Timer Task
     */
    public static stopTimerTask<ThrowOnError extends boolean = false>(parameters: {
        work_task_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<TimerStopTimerTaskResponses, TimerStopTimerTaskErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'work_task_id' }] }]);
        return (options?.client ?? client).delete<TimerStopTimerTaskResponses, TimerStopTimerTaskErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/timer/tasks/{work_task_id}',
            ...options,
            ...params
        });
    }
}

export class ToolCategoriesService {
    /**
     * List Tool Categories
     */
    public static listToolCategories<ThrowOnError extends boolean = false>(parameters?: {
        deleted?: boolean;
    }, options?: Options<never, ThrowOnError>): RequestResult<ToolCategoriesListToolCategoriesResponses, ToolCategoriesListToolCategoriesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'query', key: 'deleted' }] }]);
        return (options?.client ?? client).get<ToolCategoriesListToolCategoriesResponses, ToolCategoriesListToolCategoriesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tool-categories',
            ...options,
            ...params
        });
    }
    
    /**
     * Create Tool Category
     */
    public static createToolCategory<ThrowOnError extends boolean = false>(parameters: {
        toolCategoryCreate: ToolCategoryCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<ToolCategoriesCreateToolCategoryResponses, ToolCategoriesCreateToolCategoryErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'toolCategoryCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<ToolCategoriesCreateToolCategoryResponses, ToolCategoriesCreateToolCategoryErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tool-categories',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete Tool Category
     */
    public static deleteToolCategory<ThrowOnError extends boolean = false>(parameters: {
        category_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<ToolCategoriesDeleteToolCategoryResponses, ToolCategoriesDeleteToolCategoryErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'category_id' }] }]);
        return (options?.client ?? client).delete<ToolCategoriesDeleteToolCategoryResponses, ToolCategoriesDeleteToolCategoryErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tool-categories/{category_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update Tool Category
     */
    public static updateToolCategory<ThrowOnError extends boolean = false>(parameters: {
        category_id: string;
        toolCategoryUpdate: ToolCategoryUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<ToolCategoriesUpdateToolCategoryResponses, ToolCategoriesUpdateToolCategoryErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'category_id' }, { key: 'toolCategoryUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<ToolCategoriesUpdateToolCategoryResponses, ToolCategoriesUpdateToolCategoryErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tool-categories/{category_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Restore Tool Category
     */
    public static restoreToolCategory<ThrowOnError extends boolean = false>(parameters: {
        category_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<ToolCategoriesRestoreToolCategoryResponses, ToolCategoriesRestoreToolCategoryErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'category_id' }] }]);
        return (options?.client ?? client).post<ToolCategoriesRestoreToolCategoryResponses, ToolCategoriesRestoreToolCategoryErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tool-categories/{category_id}/restore',
            ...options,
            ...params
        });
    }
}

export class ToolsService {
    /**
     * List Tools
     */
    public static listTools<ThrowOnError extends boolean = false>(parameters?: {
        include_retired?: boolean;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<ToolsListToolsResponses, ToolsListToolsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'query', key: 'include_retired' }, { in: 'query', key: 'limit' }] }]);
        return (options?.client ?? client).get<ToolsListToolsResponses, ToolsListToolsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tools',
            ...options,
            ...params
        });
    }
    
    /**
     * Create Tool
     */
    public static createTool<ThrowOnError extends boolean = false>(parameters: {
        toolCreate: ToolCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<ToolsCreateToolResponses, ToolsCreateToolErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'toolCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<ToolsCreateToolResponses, ToolsCreateToolErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tools',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Get Tool
     */
    public static getTool<ThrowOnError extends boolean = false>(parameters: {
        tool_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<ToolsGetToolResponses, ToolsGetToolErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tool_id' }] }]);
        return (options?.client ?? client).get<ToolsGetToolResponses, ToolsGetToolErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tools/{tool_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update Tool
     */
    public static updateTool<ThrowOnError extends boolean = false>(parameters: {
        tool_id: string;
        toolUpdate: ToolUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<ToolsUpdateToolResponses, ToolsUpdateToolErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tool_id' }, { key: 'toolUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<ToolsUpdateToolResponses, ToolsUpdateToolErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tools/{tool_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Add Tool Calibration
     */
    public static addToolCalibration<ThrowOnError extends boolean = false>(parameters: {
        tool_id: string;
        toolCalibrationCreate: ToolCalibrationCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<ToolsAddToolCalibrationResponses, ToolsAddToolCalibrationErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tool_id' }, { key: 'toolCalibrationCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<ToolsAddToolCalibrationResponses, ToolsAddToolCalibrationErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tools/{tool_id}/calibrations',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Complete Tool Calibration
     */
    public static completeToolCalibration<ThrowOnError extends boolean = false>(parameters: {
        tool_id: string;
        calibration_id: string;
        toolCalibrationComplete: ToolCalibrationComplete;
    }, options?: Options<never, ThrowOnError>): RequestResult<ToolsCompleteToolCalibrationResponses, ToolsCompleteToolCalibrationErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'tool_id' },
                    { in: 'path', key: 'calibration_id' },
                    { key: 'toolCalibrationComplete', map: 'body' }
                ] }]);
        return (options?.client ?? client).post<ToolsCompleteToolCalibrationResponses, ToolsCompleteToolCalibrationErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tools/{tool_id}/calibrations/{calibration_id}/complete',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Add Tool Document
     */
    public static addToolDocument<ThrowOnError extends boolean = false>(parameters: {
        tool_id: string;
        toolDocumentCreate: ToolDocumentCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<ToolsAddToolDocumentResponses, ToolsAddToolDocumentErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tool_id' }, { key: 'toolDocumentCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<ToolsAddToolDocumentResponses, ToolsAddToolDocumentErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tools/{tool_id}/documents',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Remove Tool Document
     */
    public static removeToolDocument<ThrowOnError extends boolean = false>(parameters: {
        tool_id: string;
        tool_document_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<ToolsRemoveToolDocumentResponses, ToolsRemoveToolDocumentErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tool_id' }, { in: 'path', key: 'tool_document_id' }] }]);
        return (options?.client ?? client).delete<ToolsRemoveToolDocumentResponses, ToolsRemoveToolDocumentErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tools/{tool_id}/documents/{tool_document_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Issue Tool
     */
    public static issueTool<ThrowOnError extends boolean = false>(parameters: {
        tool_id: string;
        toolIssue: ToolIssue;
    }, options?: Options<never, ThrowOnError>): RequestResult<ToolsIssueToolResponses, ToolsIssueToolErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tool_id' }, { key: 'toolIssue', map: 'body' }] }]);
        return (options?.client ?? client).post<ToolsIssueToolResponses, ToolsIssueToolErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tools/{tool_id}/loans',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Undo Tool Issue
     */
    public static undoToolIssue<ThrowOnError extends boolean = false>(parameters: {
        tool_id: string;
        loan_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<ToolsUndoToolIssueResponses, ToolsUndoToolIssueErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tool_id' }, { in: 'path', key: 'loan_id' }] }]);
        return (options?.client ?? client).delete<ToolsUndoToolIssueResponses, ToolsUndoToolIssueErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tools/{tool_id}/loans/{loan_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update Tool Loan
     */
    public static updateToolLoan<ThrowOnError extends boolean = false>(parameters: {
        tool_id: string;
        loan_id: string;
        toolLoanUpdate: ToolLoanUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<ToolsUpdateToolLoanResponses, ToolsUpdateToolLoanErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'tool_id' },
                    { in: 'path', key: 'loan_id' },
                    { key: 'toolLoanUpdate', map: 'body' }
                ] }]);
        return (options?.client ?? client).patch<ToolsUpdateToolLoanResponses, ToolsUpdateToolLoanErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tools/{tool_id}/loans/{loan_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Receive Tool
     */
    public static receiveTool<ThrowOnError extends boolean = false>(parameters: {
        tool_id: string;
        loan_id: string;
        toolReceive: ToolReceive;
    }, options?: Options<never, ThrowOnError>): RequestResult<ToolsReceiveToolResponses, ToolsReceiveToolErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'tool_id' },
                    { in: 'path', key: 'loan_id' },
                    { key: 'toolReceive', map: 'body' }
                ] }]);
        return (options?.client ?? client).post<ToolsReceiveToolResponses, ToolsReceiveToolErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tools/{tool_id}/loans/{loan_id}/receive',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Restore Tool
     */
    public static restoreTool<ThrowOnError extends boolean = false>(parameters: {
        tool_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<ToolsRestoreToolResponses, ToolsRestoreToolErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tool_id' }] }]);
        return (options?.client ?? client).post<ToolsRestoreToolResponses, ToolsRestoreToolErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tools/{tool_id}/restore',
            ...options,
            ...params
        });
    }
    
    /**
     * Retire Tool
     */
    public static retireTool<ThrowOnError extends boolean = false>(parameters: {
        tool_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<ToolsRetireToolResponses, ToolsRetireToolErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tool_id' }] }]);
        return (options?.client ?? client).post<ToolsRetireToolResponses, ToolsRetireToolErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tools/{tool_id}/retire',
            ...options,
            ...params
        });
    }
}

export class TraceAdEvalReportsService {
    /**
     * Create TraceAdEvalReport
     */
    public static createItem<ThrowOnError extends boolean = false>(parameters: {
        traceAdEvalReportCreate: TraceAdEvalReportCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<TraceAdEvalReportsCreateItemResponses, TraceAdEvalReportsCreateItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'traceAdEvalReportCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<TraceAdEvalReportsCreateItemResponses, TraceAdEvalReportsCreateItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trace-ad-eval-reports/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Get Reports By Trace
     */
    public static getReportsByTrace<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<TraceAdEvalReportsGetReportsByTraceResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<TraceAdEvalReportsGetReportsByTraceResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trace-ad-eval-reports/by-trace',
            ...options
        });
    }
    
    /**
     * Get Reports By Trace Id
     */
    public static getReportsByTraceId<ThrowOnError extends boolean = false>(parameters: {
        trace_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<TraceAdEvalReportsGetReportsByTraceIdResponses, TraceAdEvalReportsGetReportsByTraceIdErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'trace_id' }] }]);
        return (options?.client ?? client).get<TraceAdEvalReportsGetReportsByTraceIdResponses, TraceAdEvalReportsGetReportsByTraceIdErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trace-ad-eval-reports/by-trace/{trace_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Read TraceAdEvalReport
     */
    public static readItem<ThrowOnError extends boolean = false>(parameters: {
        id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<TraceAdEvalReportsReadItemResponses, TraceAdEvalReportsReadItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'id' }] }]);
        return (options?.client ?? client).get<TraceAdEvalReportsReadItemResponses, TraceAdEvalReportsReadItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trace-ad-eval-reports/{id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update evaluation field
     *
     * Update any evaluation field's edited value (initial_assessment, applicable_msn, ad_reason, compliance_requirements, recurrent_ad, due_date)
     */
    public static updateField<ThrowOnError extends boolean = false>(parameters: {
        report_id: string;
        field_name: 'initial_assessment' | 'applicable_msn' | 'ad_reason' | 'compliance_requirements' | 'recurrent_ad' | 'due_date';
        fieldUpdateRequest: FieldUpdateRequest;
    }, options?: Options<never, ThrowOnError>): RequestResult<TraceAdEvalReportsUpdateFieldResponses, TraceAdEvalReportsUpdateFieldErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'report_id' },
                    { in: 'path', key: 'field_name' },
                    { key: 'fieldUpdateRequest', map: 'body' }
                ] }]);
        return (options?.client ?? client).patch<TraceAdEvalReportsUpdateFieldResponses, TraceAdEvalReportsUpdateFieldErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trace-ad-eval-reports/{report_id}/fields/{field_name}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Unfinalize Field
     */
    public static unfinalizeField<ThrowOnError extends boolean = false>(parameters: {
        report_id: string;
        field_name: 'initial_assessment' | 'applicable_msn' | 'ad_reason' | 'compliance_requirements' | 'recurrent_ad' | 'due_date';
    }, options?: Options<never, ThrowOnError>): RequestResult<TraceAdEvalReportsUnfinalizeFieldResponses, TraceAdEvalReportsUnfinalizeFieldErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'report_id' }, { in: 'path', key: 'field_name' }] }]);
        return (options?.client ?? client).delete<TraceAdEvalReportsUnfinalizeFieldResponses, TraceAdEvalReportsUnfinalizeFieldErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trace-ad-eval-reports/{report_id}/fields/{field_name}/finalize',
            ...options,
            ...params
        });
    }
    
    /**
     * Finalize Field
     */
    public static finalizeField<ThrowOnError extends boolean = false>(parameters: {
        report_id: string;
        field_name: 'initial_assessment' | 'applicable_msn' | 'ad_reason' | 'compliance_requirements' | 'recurrent_ad' | 'due_date';
    }, options?: Options<never, ThrowOnError>): RequestResult<TraceAdEvalReportsFinalizeFieldResponses, TraceAdEvalReportsFinalizeFieldErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'report_id' }, { in: 'path', key: 'field_name' }] }]);
        return (options?.client ?? client).post<TraceAdEvalReportsFinalizeFieldResponses, TraceAdEvalReportsFinalizeFieldErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trace-ad-eval-reports/{report_id}/fields/{field_name}/finalize',
            ...options,
            ...params
        });
    }
}

export class TraceSbEvalReportsService {
    /**
     * Create TraceSbEvalReport
     */
    public static createItem<ThrowOnError extends boolean = false>(parameters: {
        traceSbEvalReportCreate: TraceSbEvalReportCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<TraceSbEvalReportsCreateItemResponses, TraceSbEvalReportsCreateItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'traceSbEvalReportCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<TraceSbEvalReportsCreateItemResponses, TraceSbEvalReportsCreateItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trace-sb-eval-reports/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Get Reports By Trace
     */
    public static getReportsByTrace<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<TraceSbEvalReportsGetReportsByTraceResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<TraceSbEvalReportsGetReportsByTraceResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trace-sb-eval-reports/by-trace',
            ...options
        });
    }
    
    /**
     * Read TraceSbEvalReport
     */
    public static readItem<ThrowOnError extends boolean = false>(parameters: {
        id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<TraceSbEvalReportsReadItemResponses, TraceSbEvalReportsReadItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'id' }] }]);
        return (options?.client ?? client).get<TraceSbEvalReportsReadItemResponses, TraceSbEvalReportsReadItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trace-sb-eval-reports/{id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update evaluation field
     *
     * Update any SB evaluation field's edited value
     */
    public static updateField<ThrowOnError extends boolean = false>(parameters: {
        report_id: string;
        field_name: 'applicability' | 'manpower_requirements' | 'electrical_load_analysis' | 'weight_and_balance_impact' | 'parts_required' | 'tooling_required' | 'compliance' | 'concurrent_requirements' | 'consumables' | 'manuals_publications_affected';
        sbFieldUpdateRequest: SbFieldUpdateRequest;
    }, options?: Options<never, ThrowOnError>): RequestResult<TraceSbEvalReportsUpdateFieldResponses, TraceSbEvalReportsUpdateFieldErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'report_id' },
                    { in: 'path', key: 'field_name' },
                    { key: 'sbFieldUpdateRequest', map: 'body' }
                ] }]);
        return (options?.client ?? client).patch<TraceSbEvalReportsUpdateFieldResponses, TraceSbEvalReportsUpdateFieldErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trace-sb-eval-reports/{report_id}/fields/{field_name}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Unfinalize Field
     */
    public static unfinalizeField<ThrowOnError extends boolean = false>(parameters: {
        report_id: string;
        field_name: 'applicability' | 'manpower_requirements' | 'electrical_load_analysis' | 'weight_and_balance_impact' | 'parts_required' | 'tooling_required' | 'compliance' | 'concurrent_requirements' | 'consumables' | 'manuals_publications_affected';
    }, options?: Options<never, ThrowOnError>): RequestResult<TraceSbEvalReportsUnfinalizeFieldResponses, TraceSbEvalReportsUnfinalizeFieldErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'report_id' }, { in: 'path', key: 'field_name' }] }]);
        return (options?.client ?? client).delete<TraceSbEvalReportsUnfinalizeFieldResponses, TraceSbEvalReportsUnfinalizeFieldErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trace-sb-eval-reports/{report_id}/fields/{field_name}/finalize',
            ...options,
            ...params
        });
    }
    
    /**
     * Finalize Field
     */
    public static finalizeField<ThrowOnError extends boolean = false>(parameters: {
        report_id: string;
        field_name: 'applicability' | 'manpower_requirements' | 'electrical_load_analysis' | 'weight_and_balance_impact' | 'parts_required' | 'tooling_required' | 'compliance' | 'concurrent_requirements' | 'consumables' | 'manuals_publications_affected';
    }, options?: Options<never, ThrowOnError>): RequestResult<TraceSbEvalReportsFinalizeFieldResponses, TraceSbEvalReportsFinalizeFieldErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'report_id' }, { in: 'path', key: 'field_name' }] }]);
        return (options?.client ?? client).post<TraceSbEvalReportsFinalizeFieldResponses, TraceSbEvalReportsFinalizeFieldErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trace-sb-eval-reports/{report_id}/fields/{field_name}/finalize',
            ...options,
            ...params
        });
    }
}

export class TraceService {
    /**
     * Audio
     */
    public static audio<ThrowOnError extends boolean = false>(parameters: {
        traceparent?: string | null;
        trace_id: string;
        features?: Array<string>;
        intent_id?: AudioIntent | string | null;
        mode_id?: Mode | string | null;
        attachment_ids?: Array<string>;
        bodyTraceAudio: BodyTraceAudio;
    }, options?: Options<never, ThrowOnError>): RequestResult<TraceAudioResponses, TraceAudioErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'headers', key: 'traceparent' },
                    { in: 'query', key: 'trace_id' },
                    { in: 'query', key: 'features' },
                    { in: 'query', key: 'intent_id' },
                    { in: 'query', key: 'mode_id' },
                    { in: 'query', key: 'attachment_ids' },
                    { key: 'bodyTraceAudio', map: 'body' }
                ] }]);
        return (options?.client ?? client).post<TraceAudioResponses, TraceAudioErrors, ThrowOnError>({
            ...formDataBodySerializer,
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trace-ws/audio',
            ...options,
            ...params,
            headers: {
                'Content-Type': null,
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Available Intents
     *
     * @deprecated
     */
    public static availableIntents<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<TraceAvailableIntentsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<TraceAvailableIntentsResponses, unknown, ThrowOnError>({
            responseType: 'json',
            url: '/api/v1/trace-ws/intents',
            ...options
        });
    }
    
    /**
     * Available Intents V2
     */
    public static availableIntentsV2<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<TraceAvailableIntentsV2Responses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<TraceAvailableIntentsV2Responses, unknown, ThrowOnError>({
            responseType: 'json',
            url: '/api/v1/trace-ws/intents-v2',
            ...options
        });
    }
    
    /**
     * Available Modes
     */
    public static availableModes<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<TraceAvailableModesResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<TraceAvailableModesResponses, unknown, ThrowOnError>({
            responseType: 'json',
            url: '/api/v1/trace-ws/modes',
            ...options
        });
    }
    
    /**
     * Transcribe
     */
    public static transcribe<ThrowOnError extends boolean = false>(parameters: {
        bodyTraceTranscribe: BodyTraceTranscribe;
    }, options?: Options<never, ThrowOnError>): RequestResult<TraceTranscribeResponses, TraceTranscribeErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'bodyTraceTranscribe', map: 'body' }] }]);
        return (options?.client ?? client).post<TraceTranscribeResponses, TraceTranscribeErrors, ThrowOnError>({
            ...formDataBodySerializer,
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trace-ws/transcriptions',
            ...options,
            ...params,
            headers: {
                'Content-Type': null,
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Trace Activity
     */
    public static traceActivity<ThrowOnError extends boolean = false>(parameters: {
        trace_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<TraceTraceActivityResponses, TraceTraceActivityErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'trace_id' }] }]);
        return (options?.client ?? client).get<TraceTraceActivityResponses, TraceTraceActivityErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trace-ws/{trace_id}/activity',
            ...options,
            ...params
        });
    }
}

export class UserActionsService {
    /**
     * Audio
     */
    public static audio<ThrowOnError extends boolean = false>(parameters: {
        traceparent?: string | null;
        trace_id: string;
        features?: Array<string>;
        intent_id?: AudioIntent | string | null;
        mode_id?: Mode | string | null;
        attachment_ids?: Array<string>;
        bodyTraceAudio: BodyTraceAudio;
    }, options?: Options<never, ThrowOnError>): RequestResult<TraceAudioResponses, TraceAudioErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'headers', key: 'traceparent' },
                    { in: 'query', key: 'trace_id' },
                    { in: 'query', key: 'features' },
                    { in: 'query', key: 'intent_id' },
                    { in: 'query', key: 'mode_id' },
                    { in: 'query', key: 'attachment_ids' },
                    { key: 'bodyTraceAudio', map: 'body' }
                ] }]);
        return (options?.client ?? client).post<TraceAudioResponses, TraceAudioErrors, ThrowOnError>({
            ...formDataBodySerializer,
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trace-ws/audio',
            ...options,
            ...params,
            headers: {
                'Content-Type': null,
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Available Intents
     *
     * @deprecated
     */
    public static availableIntents<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<TraceAvailableIntentsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<TraceAvailableIntentsResponses, unknown, ThrowOnError>({
            responseType: 'json',
            url: '/api/v1/trace-ws/intents',
            ...options
        });
    }
    
    /**
     * Available Intents V2
     */
    public static availableIntentsV2<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<TraceAvailableIntentsV2Responses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<TraceAvailableIntentsV2Responses, unknown, ThrowOnError>({
            responseType: 'json',
            url: '/api/v1/trace-ws/intents-v2',
            ...options
        });
    }
    
    /**
     * Available Modes
     */
    public static availableModes<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<TraceAvailableModesResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<TraceAvailableModesResponses, unknown, ThrowOnError>({
            responseType: 'json',
            url: '/api/v1/trace-ws/modes',
            ...options
        });
    }
    
    /**
     * Transcribe
     */
    public static transcribe<ThrowOnError extends boolean = false>(parameters: {
        bodyTraceTranscribe: BodyTraceTranscribe;
    }, options?: Options<never, ThrowOnError>): RequestResult<TraceTranscribeResponses, TraceTranscribeErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'bodyTraceTranscribe', map: 'body' }] }]);
        return (options?.client ?? client).post<TraceTranscribeResponses, TraceTranscribeErrors, ThrowOnError>({
            ...formDataBodySerializer,
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trace-ws/transcriptions',
            ...options,
            ...params,
            headers: {
                'Content-Type': null,
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Trace Activity
     */
    public static traceActivity<ThrowOnError extends boolean = false>(parameters: {
        trace_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<TraceTraceActivityResponses, TraceTraceActivityErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'trace_id' }] }]);
        return (options?.client ?? client).get<TraceTraceActivityResponses, TraceTraceActivityErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trace-ws/{trace_id}/activity',
            ...options,
            ...params
        });
    }
}

export class TraceAttachmentService {
    /**
     * Upload Sandbox Attachment
     */
    public static uploadSandboxAttachment<ThrowOnError extends boolean = false>(parameters: {
        bodyTraceAttachmentUploadSandboxAttachment: BodyTraceAttachmentUploadSandboxAttachment;
    }, options?: Options<never, ThrowOnError>): RequestResult<TraceAttachmentUploadSandboxAttachmentResponses, TraceAttachmentUploadSandboxAttachmentErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'bodyTraceAttachmentUploadSandboxAttachment', map: 'body' }] }]);
        return (options?.client ?? client).post<TraceAttachmentUploadSandboxAttachmentResponses, TraceAttachmentUploadSandboxAttachmentErrors, ThrowOnError>({
            ...formDataBodySerializer,
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trace/attachments',
            ...options,
            ...params,
            headers: {
                'Content-Type': null,
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Read Sandbox Attachment
     */
    public static readSandboxAttachment<ThrowOnError extends boolean = false>(parameters: {
        conversation_session_id: string;
        file_path: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<TraceAttachmentReadSandboxAttachmentResponses, TraceAttachmentReadSandboxAttachmentErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'conversation_session_id' }, { in: 'path', key: 'file_path' }] }]);
        return (options?.client ?? client).get<TraceAttachmentReadSandboxAttachmentResponses, TraceAttachmentReadSandboxAttachmentErrors, ThrowOnError>({
            responseType: 'blob',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trace/sandbox/{conversation_session_id}/{file_path}',
            ...options,
            ...params
        });
    }
    
    /**
     * Upload Attachment
     */
    public static uploadAttachment<ThrowOnError extends boolean = false>(parameters: {
        trace_id: string;
        bodyTraceAttachmentUploadAttachment: BodyTraceAttachmentUploadAttachment;
    }, options?: Options<never, ThrowOnError>): RequestResult<TraceAttachmentUploadAttachmentResponses, TraceAttachmentUploadAttachmentErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'trace_id' }, { key: 'bodyTraceAttachmentUploadAttachment', map: 'body' }] }]);
        return (options?.client ?? client).post<TraceAttachmentUploadAttachmentResponses, TraceAttachmentUploadAttachmentErrors, ThrowOnError>({
            ...formDataBodySerializer,
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trace/{trace_id}/attachments',
            ...options,
            ...params,
            headers: {
                'Content-Type': null,
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Attach Existing Documents
     */
    public static attachExistingDocuments<ThrowOnError extends boolean = false>(parameters: {
        trace_id: string;
        attachExistingDocuments: AttachExistingDocuments;
    }, options?: Options<never, ThrowOnError>): RequestResult<TraceAttachmentAttachExistingDocumentsResponses, TraceAttachmentAttachExistingDocumentsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'trace_id' }, { key: 'attachExistingDocuments', map: 'body' }] }]);
        return (options?.client ?? client).post<TraceAttachmentAttachExistingDocumentsResponses, TraceAttachmentAttachExistingDocumentsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trace/{trace_id}/attachments/existing',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class TracesService {
    /**
     * Read Traces
     *
     * Get traces created by the current user.
     */
    public static readUserTraces<ThrowOnError extends boolean = false>(parameters?: {
        skip?: number;
        limit?: number;
        search?: string | null;
        order_by?: 'created_at' | 'updated_at';
        order_direction?: 'asc' | 'desc';
        scope?: TraceScope;
    }, options?: Options<never, ThrowOnError>): RequestResult<TracesReadUserTracesResponses, TracesReadUserTracesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'search' },
                    { in: 'query', key: 'order_by' },
                    { in: 'query', key: 'order_direction' },
                    { in: 'query', key: 'scope' }
                ] }]);
        return (options?.client ?? client).get<TracesReadUserTracesResponses, TracesReadUserTracesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/traces/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create draft trace
     *
     * Create a new draft trace for uploading documents before starting conversation.
     */
    public static createDraftTrace<ThrowOnError extends boolean = false>(parameters?: {
        body?: DraftTraceCreate | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<TracesCreateDraftTraceResponses, TracesCreateDraftTraceErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'body', map: 'body' }] }]);
        return (options?.client ?? client).post<TracesCreateDraftTraceResponses, TracesCreateDraftTraceErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/traces/draft',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Search Traces
     *
     * The current user's traces with their latest messages, newest first, or with their messages containing every word of the text, leaving out the trace of the conversation the request comes from.
     */
    public static searchTraces<ThrowOnError extends boolean = false>(parameters?: {
        text?: string | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<TracesSearchTracesResponses, TracesSearchTracesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'query', key: 'text' }] }]);
        return (options?.client ?? client).get<TracesSearchTracesResponses, TracesSearchTracesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/traces/search',
            ...options,
            ...params
        });
    }
    
    /**
     * Delete Trace
     *
     * Delete a trace and clean up associated external resources.
     */
    public static deleteItem<ThrowOnError extends boolean = false>(parameters: {
        id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<TracesDeleteItemResponses, TracesDeleteItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'id' }] }]);
        return (options?.client ?? client).delete<TracesDeleteItemResponses, TracesDeleteItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/traces/{id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Read Trace
     */
    public static readItem<ThrowOnError extends boolean = false>(parameters: {
        id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<TracesReadItemResponses, TracesReadItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'id' }] }]);
        return (options?.client ?? client).get<TracesReadItemResponses, TracesReadItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/traces/{id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update Trace
     */
    public static updateItem<ThrowOnError extends boolean = false>(parameters: {
        id: string;
        traceUpdate: TraceUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<TracesUpdateItemResponses, TracesUpdateItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'id' }, { key: 'traceUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<TracesUpdateItemResponses, TracesUpdateItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/traces/{id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Archive Trace
     */
    public static archiveItem<ThrowOnError extends boolean = false>(parameters: {
        id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<TracesArchiveItemResponses, TracesArchiveItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'id' }] }]);
        return (options?.client ?? client).post<TracesArchiveItemResponses, TracesArchiveItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/traces/{id}/archive',
            ...options,
            ...params
        });
    }
    
    /**
     * Read Trace Messages
     *
     * The user's messages and the agent's replies in a trace, oldest first.
     */
    public static readTraceMessages<ThrowOnError extends boolean = false>(parameters: {
        id: string;
        skip?: number;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<TracesReadTraceMessagesResponses, TracesReadTraceMessagesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'id' },
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' }
                ] }]);
        return (options?.client ?? client).get<TracesReadTraceMessagesResponses, TracesReadTraceMessagesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/traces/{id}/messages',
            ...options,
            ...params
        });
    }
    
    /**
     * Restore Trace
     */
    public static restoreItem<ThrowOnError extends boolean = false>(parameters: {
        id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<TracesRestoreItemResponses, TracesRestoreItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'id' }] }]);
        return (options?.client ?? client).post<TracesRestoreItemResponses, TracesRestoreItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/traces/{id}/restore',
            ...options,
            ...params
        });
    }
    
    /**
     * Set trace work task associations
     *
     * Set the work tasks associated with a trace. Replaces all existing associations.
     */
    public static setTraceWorkTasksEndpoint<ThrowOnError extends boolean = false>(parameters: {
        trace_id: string;
        traceWorkTasksUpdate: TraceWorkTasksUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<TracesSetTraceWorkTasksEndpointResponses, TracesSetTraceWorkTasksEndpointErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'trace_id' }, { key: 'traceWorkTasksUpdate', map: 'body' }] }]);
        return (options?.client ?? client).put<TracesSetTraceWorkTasksEndpointResponses, TracesSetTraceWorkTasksEndpointErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/traces/{trace_id}/work-tasks',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class TypeCertificateService {
    /**
     * Trigger Assign All Aircraft
     */
    public static triggerAssignAllAircraft<ThrowOnError extends boolean = false>(parameters: {
        tenant_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<TypeCertificateTriggerAssignAllAircraftResponses, TypeCertificateTriggerAssignAllAircraftErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tenant_id' }] }]);
        return (options?.client ?? client).post<TypeCertificateTriggerAssignAllAircraftResponses, TypeCertificateTriggerAssignAllAircraftErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/type-certificate-assignment/aircraft/{tenant_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Trigger Assign All Work Packages
     */
    public static triggerAssignAllWorkPackages<ThrowOnError extends boolean = false>(parameters: {
        tenant_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<TypeCertificateTriggerAssignAllWorkPackagesResponses, TypeCertificateTriggerAssignAllWorkPackagesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'tenant_id' }] }]);
        return (options?.client ?? client).post<TypeCertificateTriggerAssignAllWorkPackagesResponses, TypeCertificateTriggerAssignAllWorkPackagesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/type-certificate-assignment/work-packages/{tenant_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * List Grouped
     */
    public static listGrouped<ThrowOnError extends boolean = false>(parameters?: {
        with_work_history?: boolean;
    }, options?: Options<never, ThrowOnError>): RequestResult<TypeCertificateListGroupedResponses, TypeCertificateListGroupedErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'query', key: 'with_work_history' }] }]);
        return (options?.client ?? client).get<TypeCertificateListGroupedResponses, TypeCertificateListGroupedErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/type-certificate-model-variants/grouped',
            ...options,
            ...params
        });
    }
    
    /**
     * Resolve
     */
    public static resolve<ThrowOnError extends boolean = false>(parameters: {
        model: string;
        manufacturer?: string | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<TypeCertificateResolveResponses, TypeCertificateResolveErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'query', key: 'model' }, { in: 'query', key: 'manufacturer' }] }]);
        return (options?.client ?? client).get<TypeCertificateResolveResponses, TypeCertificateResolveErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/type-certificate-model-variants/resolve',
            ...options,
            ...params
        });
    }
    
    /**
     * Get Variant
     */
    public static getVariant<ThrowOnError extends boolean = false>(parameters: {
        variant_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<TypeCertificateGetVariantResponses, TypeCertificateGetVariantErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'variant_id' }] }]);
        return (options?.client ?? client).get<TypeCertificateGetVariantResponses, TypeCertificateGetVariantErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/type-certificate-model-variants/{variant_id}',
            ...options,
            ...params
        });
    }
}

export class UsersService {
    /**
     * Read Users
     *
     * Retrieve users.
     */
    public static readUsers<ThrowOnError extends boolean = false>(parameters?: {
        skip?: number;
        limit?: number;
        search?: string | null;
        sort_by?: UserSortField;
        sort_direction?: 'asc' | 'desc';
        role_ids?: Array<string> | null;
        is_active?: boolean | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<UsersReadUsersResponses, UsersReadUsersErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'search' },
                    { in: 'query', key: 'sort_by' },
                    { in: 'query', key: 'sort_direction' },
                    { in: 'query', key: 'role_ids' },
                    { in: 'query', key: 'is_active' }
                ] }]);
        return (options?.client ?? client).get<UsersReadUsersResponses, UsersReadUsersErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/users/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create User
     *
     * Create new user.
     */
    public static createUser<ThrowOnError extends boolean = false>(parameters: {
        userCreate: UserCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<UsersCreateUserResponses, UsersCreateUserErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'userCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<UsersCreateUserResponses, UsersCreateUserErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/users/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Create Multiple Users
     */
    public static createMultipleUsers<ThrowOnError extends boolean = false>(parameters: {
        usersBulkCreate: UsersBulkCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<UsersCreateMultipleUsersResponses, UsersCreateMultipleUsersErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'usersBulkCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<UsersCreateMultipleUsersResponses, UsersCreateMultipleUsersErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/users/bulk',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Export Users
     */
    public static exportUsers<ThrowOnError extends boolean = false>(parameters?: {
        search?: string | null;
        sort_by?: UserSortField;
        sort_direction?: 'asc' | 'desc';
        role_ids?: Array<string> | null;
        is_active?: boolean | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<UsersExportUsersResponses, UsersExportUsersErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'search' },
                    { in: 'query', key: 'sort_by' },
                    { in: 'query', key: 'sort_direction' },
                    { in: 'query', key: 'role_ids' },
                    { in: 'query', key: 'is_active' }
                ] }]);
        return (options?.client ?? client).get<UsersExportUsersResponses, UsersExportUsersErrors, ThrowOnError>({
            responseType: 'text',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/users/export',
            ...options,
            ...params
        });
    }
    
    /**
     * List Inspectors
     */
    public static listInspectors<ThrowOnError extends boolean = false>(parameters?: {
        skip?: number;
        limit?: number;
        search?: string | null;
        sort_by?: UserSortField;
        sort_direction?: 'asc' | 'desc';
    }, options?: Options<never, ThrowOnError>): RequestResult<UsersListInspectorsResponses, UsersListInspectorsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'search' },
                    { in: 'query', key: 'sort_by' },
                    { in: 'query', key: 'sort_direction' }
                ] }]);
        return (options?.client ?? client).get<UsersListInspectorsResponses, UsersListInspectorsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/users/inspectors',
            ...options,
            ...params
        });
    }
    
    /**
     * Delete User Me
     *
     * Delete own user.
     */
    public static deleteUserMe<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<UsersDeleteUserMeResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).delete<UsersDeleteUserMeResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/users/me',
            ...options
        });
    }
    
    /**
     * Read User Me
     *
     * Get current user.
     */
    public static readUserMe<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<UsersReadUserMeResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<UsersReadUserMeResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/users/me',
            ...options
        });
    }
    
    /**
     * Update User Me
     *
     * Update own user - username changes NOT allowed here.
     */
    public static updateUserMe<ThrowOnError extends boolean = false>(parameters: {
        userUpdateMe: UserUpdateMe;
    }, options?: Options<never, ThrowOnError>): RequestResult<UsersUpdateUserMeResponses, UsersUpdateUserMeErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'userUpdateMe', map: 'body' }] }]);
        return (options?.client ?? client).patch<UsersUpdateUserMeResponses, UsersUpdateUserMeErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/users/me',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Update Password Me
     *
     * Update own password.
     */
    public static updatePasswordMe<ThrowOnError extends boolean = false>(parameters: {
        updatePassword: UpdatePassword;
    }, options?: Options<never, ThrowOnError>): RequestResult<UsersUpdatePasswordMeResponses, UsersUpdatePasswordMeErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'updatePassword', map: 'body' }] }]);
        return (options?.client ?? client).patch<UsersUpdatePasswordMeResponses, UsersUpdatePasswordMeErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/users/me/password',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Set Signing Pin Me
     */
    public static setSigningPinMe<ThrowOnError extends boolean = false>(parameters: {
        setSigningPin: SetSigningPin;
    }, options?: Options<never, ThrowOnError>): RequestResult<UsersSetSigningPinMeResponses, UsersSetSigningPinMeErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'setSigningPin', map: 'body' }] }]);
        return (options?.client ?? client).put<UsersSetSigningPinMeResponses, UsersSetSigningPinMeErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/users/me/signing-pin',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Remove Signing Pin Me
     */
    public static removeSigningPinMe<ThrowOnError extends boolean = false>(parameters: {
        removeSigningPin: RemoveSigningPin;
    }, options?: Options<never, ThrowOnError>): RequestResult<UsersRemoveSigningPinMeResponses, UsersRemoveSigningPinMeErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'removeSigningPin', map: 'body' }] }]);
        return (options?.client ?? client).post<UsersRemoveSigningPinMeResponses, UsersRemoveSigningPinMeErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/users/me/signing-pin/remove',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * List Quote Reviewers
     */
    public static listQuoteReviewers<ThrowOnError extends boolean = false>(parameters?: {
        skip?: number;
        limit?: number;
        search?: string | null;
        sort_by?: UserSortField;
        sort_direction?: 'asc' | 'desc';
    }, options?: Options<never, ThrowOnError>): RequestResult<UsersListQuoteReviewersResponses, UsersListQuoteReviewersErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'search' },
                    { in: 'query', key: 'sort_by' },
                    { in: 'query', key: 'sort_direction' }
                ] }]);
        return (options?.client ?? client).get<UsersListQuoteReviewersResponses, UsersListQuoteReviewersErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/users/quote-reviewers',
            ...options,
            ...params
        });
    }
    
    /**
     * List Reporters
     *
     * List users who may be recorded as the reporter of a squawk logged through a
     * shop-floor account (those flagged `users:be_acted_as`).
     */
    public static listReporters<ThrowOnError extends boolean = false>(parameters?: {
        skip?: number;
        limit?: number;
        search?: string | null;
        sort_by?: UserSortField;
        sort_direction?: 'asc' | 'desc';
    }, options?: Options<never, ThrowOnError>): RequestResult<UsersListReportersResponses, UsersListReportersErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'search' },
                    { in: 'query', key: 'sort_by' },
                    { in: 'query', key: 'sort_direction' }
                ] }]);
        return (options?.client ?? client).get<UsersListReportersResponses, UsersListReportersErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/users/reporters',
            ...options,
            ...params
        });
    }
    
    /**
     * List Sales Reps
     */
    public static listSalesReps<ThrowOnError extends boolean = false>(parameters?: {
        skip?: number;
        limit?: number;
        search?: string | null;
        sort_by?: UserSortField;
        sort_direction?: 'asc' | 'desc';
    }, options?: Options<never, ThrowOnError>): RequestResult<UsersListSalesRepsResponses, UsersListSalesRepsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'search' },
                    { in: 'query', key: 'sort_by' },
                    { in: 'query', key: 'sort_direction' }
                ] }]);
        return (options?.client ?? client).get<UsersListSalesRepsResponses, UsersListSalesRepsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/users/sales-reps',
            ...options,
            ...params
        });
    }
    
    /**
     * Delete User
     *
     * Delete a user.
     */
    public static deleteUser<ThrowOnError extends boolean = false>(parameters: {
        user_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<UsersDeleteUserResponses, UsersDeleteUserErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'user_id' }] }]);
        return (options?.client ?? client).delete<UsersDeleteUserResponses, UsersDeleteUserErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/users/{user_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Read User By Id
     *
     * Get a specific user by id.
     */
    public static readUserById<ThrowOnError extends boolean = false>(parameters: {
        user_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<UsersReadUserByIdResponses, UsersReadUserByIdErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'user_id' }] }]);
        return (options?.client ?? client).get<UsersReadUserByIdResponses, UsersReadUserByIdErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/users/{user_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update User
     *
     * Update a user by admin.
     */
    public static updateUser<ThrowOnError extends boolean = false>(parameters: {
        user_id: string;
        userUpdate: UserUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<UsersUpdateUserResponses, UsersUpdateUserErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'user_id' }, { key: 'userUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<UsersUpdateUserResponses, UsersUpdateUserErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/users/{user_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Resend Login Email
     */
    public static resendLoginEmail<ThrowOnError extends boolean = false>(parameters: {
        user_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<UsersResendLoginEmailResponses, UsersResendLoginEmailErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'user_id' }] }]);
        return (options?.client ?? client).post<UsersResendLoginEmailResponses, UsersResendLoginEmailErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/users/{user_id}/resend-login-email',
            ...options,
            ...params
        });
    }
}

export class UtilsService {
    /**
     * Health Check
     */
    public static healthCheck<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<UtilsHealthCheckResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<UtilsHealthCheckResponses, unknown, ThrowOnError>({
            responseType: 'json',
            url: '/api/v1/utils/health-check/',
            ...options
        });
    }
}

export class WebhooksService {
    /**
     * Health Reducto Webhook
     */
    public static healthReductoWebhook<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<WebhooksHealthReductoWebhookResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<WebhooksHealthReductoWebhookResponses, unknown, ThrowOnError>({
            responseType: 'json',
            url: '/api/v1/webhooks/reducto',
            ...options
        });
    }
    
    /**
     * Handle Reducto Webhook
     */
    public static handleReductoWebhook<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<WebhooksHandleReductoWebhookResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).post<WebhooksHandleReductoWebhookResponses, unknown, ThrowOnError>({
            responseType: 'json',
            url: '/api/v1/webhooks/reducto',
            ...options
        });
    }
}

export class WorkOrderIntakeService {
    /**
     * Create Work Order
     */
    public static createWorkOrder<ThrowOnError extends boolean = false>(parameters: {
        workOrderIntake: WorkOrderIntake;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkOrderIntakeCreateWorkOrderResponses, WorkOrderIntakeCreateWorkOrderErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'workOrderIntake', map: 'body' }] }]);
        return (options?.client ?? client).post<WorkOrderIntakeCreateWorkOrderResponses, WorkOrderIntakeCreateWorkOrderErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-order-intake',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Extract Work Order
     */
    public static extractWorkOrder<ThrowOnError extends boolean = false>(parameters: {
        extractionRequest: ExtractionRequest;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkOrderIntakeExtractWorkOrderResponses, WorkOrderIntakeExtractWorkOrderErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'extractionRequest', map: 'body' }] }]);
        return (options?.client ?? client).post<WorkOrderIntakeExtractWorkOrderResponses, WorkOrderIntakeExtractWorkOrderErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-order-intake/extract',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class WorkPackageClassificationService {
    /**
     * Classify
     */
    public static classify<ThrowOnError extends boolean = false>(parameters: {
        tenant_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkPackageClassificationClassifyResponses, WorkPackageClassificationClassifyErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'query', key: 'tenant_id' }] }]);
        return (options?.client ?? client).post<WorkPackageClassificationClassifyResponses, WorkPackageClassificationClassifyErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-package-classification/classify',
            ...options,
            ...params
        });
    }
    
    /**
     * Set Classification
     */
    public static setClassification<ThrowOnError extends boolean = false>(parameters: {
        work_package_id: string;
        workPackageClassificationSet: WorkPackageClassificationSet;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkPackageClassificationSetClassificationResponses, WorkPackageClassificationSetClassificationErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'work_package_id' }, { key: 'workPackageClassificationSet', map: 'body' }] }]);
        return (options?.client ?? client).put<WorkPackageClassificationSetClassificationResponses, WorkPackageClassificationSetClassificationErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-package-classification/{work_package_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class WorkPackageNumberSequenceService {
    /**
     * Get Work Package Number Sequence
     */
    public static getWorkPackageNumberSequence<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<WorkPackageNumberSequenceGetWorkPackageNumberSequenceResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<WorkPackageNumberSequenceGetWorkPackageNumberSequenceResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-package-number-sequence/',
            ...options
        });
    }
    
    /**
     * Upsert Work Package Number Sequence
     */
    public static upsertWorkPackageNumberSequence<ThrowOnError extends boolean = false>(parameters: {
        workPackageNumberSequenceUpsert: WorkPackageNumberSequenceUpsert;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkPackageNumberSequenceUpsertWorkPackageNumberSequenceResponses, WorkPackageNumberSequenceUpsertWorkPackageNumberSequenceErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'workPackageNumberSequenceUpsert', map: 'body' }] }]);
        return (options?.client ?? client).put<WorkPackageNumberSequenceUpsertWorkPackageNumberSequenceResponses, WorkPackageNumberSequenceUpsertWorkPackageNumberSequenceErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-package-number-sequence/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class WorkPackageSettingsService {
    /**
     * Get Work Package Settings
     */
    public static getWorkPackageSettings<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<WorkPackageSettingsGetWorkPackageSettingsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<WorkPackageSettingsGetWorkPackageSettingsResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-package-settings/',
            ...options
        });
    }
    
    /**
     * Upsert Work Package Settings
     */
    public static upsertWorkPackageSettings<ThrowOnError extends boolean = false>(parameters: {
        workPackageSettingsUpsert: WorkPackageSettingsUpsert;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkPackageSettingsUpsertWorkPackageSettingsResponses, WorkPackageSettingsUpsertWorkPackageSettingsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'workPackageSettingsUpsert', map: 'body' }] }]);
        return (options?.client ?? client).put<WorkPackageSettingsUpsertWorkPackageSettingsResponses, WorkPackageSettingsUpsertWorkPackageSettingsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-package-settings/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class WorkPackageService {
    /**
     * Read Items
     */
    public static readItems<ThrowOnError extends boolean = false>(parameters?: {
        skip?: number;
        limit?: number;
        search?: string | null;
        customer_id?: Array<string> | null;
        aircraft_id?: string | null;
        view?: WorkPackageView | null;
        subscribed?: boolean | null;
        status?: Array<WorkPackageStatus> | null;
        priority?: Array<WorkPackagePriority> | null;
        kind?: Array<WorkPackageKind> | null;
        order_by?: string | null;
        order_direction?: string | null;
        filters?: Array<WorkPackageFilter> | null;
        group?: WorkPackageGrouping | null;
        subgroup?: WorkPackageGrouping | null;
        group_key?: string | null;
        group_limit?: number | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkPackageReadItemsResponses, WorkPackageReadItemsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'search' },
                    { in: 'query', key: 'customer_id' },
                    { in: 'query', key: 'aircraft_id' },
                    { in: 'query', key: 'view' },
                    { in: 'query', key: 'subscribed' },
                    { in: 'query', key: 'status' },
                    { in: 'query', key: 'priority' },
                    { in: 'query', key: 'kind' },
                    { in: 'query', key: 'order_by' },
                    { in: 'query', key: 'order_direction' },
                    { in: 'query', key: 'filters' },
                    { in: 'query', key: 'group' },
                    { in: 'query', key: 'subgroup' },
                    { in: 'query', key: 'group_key' },
                    { in: 'query', key: 'group_limit' }
                ] }]);
        return (options?.client ?? client).get<WorkPackageReadItemsResponses, WorkPackageReadItemsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-package/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create Item
     */
    public static createItem<ThrowOnError extends boolean = false>(parameters: {
        workPackageCreate: WorkPackageCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkPackageCreateItemResponses, WorkPackageCreateItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'workPackageCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<WorkPackageCreateItemResponses, WorkPackageCreateItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-package/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Read Grouped
     */
    public static readGrouped<ThrowOnError extends boolean = false>(parameters?: {
        skip?: number;
        limit?: number;
        order_by?: string | null;
        search?: string | null;
        order_direction?: string | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkPackageReadGroupedResponses, WorkPackageReadGroupedErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'order_by' },
                    { in: 'query', key: 'search' },
                    { in: 'query', key: 'order_direction' }
                ] }]);
        return (options?.client ?? client).get<WorkPackageReadGroupedResponses, WorkPackageReadGroupedErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-package/grouped',
            ...options,
            ...params
        });
    }
    
    /**
     * Subjects
     */
    public static subjects<ThrowOnError extends boolean = false>(options?: Options<never, ThrowOnError>): RequestResult<WorkPackageSubjectsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<WorkPackageSubjectsResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-package/subjects',
            ...options
        });
    }
    
    /**
     * Delete Item
     */
    public static deleteItem<ThrowOnError extends boolean = false>(parameters: {
        id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkPackageDeleteItemResponses, WorkPackageDeleteItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'id' }] }]);
        return (options?.client ?? client).delete<WorkPackageDeleteItemResponses, WorkPackageDeleteItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-package/{id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Read Item
     */
    public static readItem<ThrowOnError extends boolean = false>(parameters: {
        id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkPackageReadItemResponses, WorkPackageReadItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'id' }] }]);
        return (options?.client ?? client).get<WorkPackageReadItemResponses, WorkPackageReadItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-package/{id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update Item
     */
    public static updateItem<ThrowOnError extends boolean = false>(parameters: {
        id: string;
        workPackageUpdate: WorkPackageUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkPackageUpdateItemResponses, WorkPackageUpdateItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'id' }, { key: 'workPackageUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<WorkPackageUpdateItemResponses, WorkPackageUpdateItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-package/{id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Archive Item
     */
    public static archiveItem<ThrowOnError extends boolean = false>(parameters: {
        id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkPackageArchiveItemResponses, WorkPackageArchiveItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'id' }] }]);
        return (options?.client ?? client).post<WorkPackageArchiveItemResponses, WorkPackageArchiveItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-package/{id}/archive',
            ...options,
            ...params
        });
    }
    
    /**
     * List Rate Cards
     */
    public static listRateCards<ThrowOnError extends boolean = false>(parameters: {
        id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkPackageListRateCardsResponses, WorkPackageListRateCardsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'id' }] }]);
        return (options?.client ?? client).get<WorkPackageListRateCardsResponses, WorkPackageListRateCardsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-package/{id}/rate-cards',
            ...options,
            ...params
        });
    }
    
    /**
     * Restore Item
     */
    public static restoreItem<ThrowOnError extends boolean = false>(parameters: {
        id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkPackageRestoreItemResponses, WorkPackageRestoreItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'id' }] }]);
        return (options?.client ?? client).post<WorkPackageRestoreItemResponses, WorkPackageRestoreItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-package/{id}/restore',
            ...options,
            ...params
        });
    }
    
    /**
     * Read With Tasks
     */
    public static readWithTasks<ThrowOnError extends boolean = false>(parameters: {
        id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkPackageReadWithTasksResponses, WorkPackageReadWithTasksErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'id' }] }]);
        return (options?.client ?? client).get<WorkPackageReadWithTasksResponses, WorkPackageReadWithTasksErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-package/{id}/tasks',
            ...options,
            ...params
        });
    }
    
    /**
     * Subscribe To Work Package
     */
    public static subscribeToWorkPackage<ThrowOnError extends boolean = false>(parameters: {
        work_package_number: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkPackageSubscribeToWorkPackageResponses, WorkPackageSubscribeToWorkPackageErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'work_package_number' }] }]);
        return (options?.client ?? client).post<WorkPackageSubscribeToWorkPackageResponses, WorkPackageSubscribeToWorkPackageErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-package/{work_package_number}/subscribe',
            ...options,
            ...params
        });
    }
    
    /**
     * Unsubscribe From Work Package
     */
    public static unsubscribeFromWorkPackage<ThrowOnError extends boolean = false>(parameters: {
        work_package_number: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkPackageUnsubscribeFromWorkPackageResponses, WorkPackageUnsubscribeFromWorkPackageErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'work_package_number' }] }]);
        return (options?.client ?? client).post<WorkPackageUnsubscribeFromWorkPackageResponses, WorkPackageUnsubscribeFromWorkPackageErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-package/{work_package_number}/unsubscribe',
            ...options,
            ...params
        });
    }
}

export class WorkPackageLifecycleService {
    /**
     * Close Work Packages
     */
    public static closeWorkPackages<ThrowOnError extends boolean = false>(parameters: {
        closeWorkPackages: CloseWorkPackages;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkPackageLifecycleCloseWorkPackagesResponses, WorkPackageLifecycleCloseWorkPackagesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'closeWorkPackages', map: 'body' }] }]);
        return (options?.client ?? client).post<WorkPackageLifecycleCloseWorkPackagesResponses, WorkPackageLifecycleCloseWorkPackagesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-package/close',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Clear Work Package Aog
     */
    public static clearWorkPackageAog<ThrowOnError extends boolean = false>(parameters: {
        work_package_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkPackageLifecycleClearWorkPackageAogResponses, WorkPackageLifecycleClearWorkPackageAogErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'work_package_id' }] }]);
        return (options?.client ?? client).delete<WorkPackageLifecycleClearWorkPackageAogResponses, WorkPackageLifecycleClearWorkPackageAogErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-package/{work_package_id}/aog',
            ...options,
            ...params
        });
    }
    
    /**
     * Mark Work Package Aog
     */
    public static markWorkPackageAog<ThrowOnError extends boolean = false>(parameters: {
        work_package_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkPackageLifecycleMarkWorkPackageAogResponses, WorkPackageLifecycleMarkWorkPackageAogErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'work_package_id' }] }]);
        return (options?.client ?? client).post<WorkPackageLifecycleMarkWorkPackageAogResponses, WorkPackageLifecycleMarkWorkPackageAogErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-package/{work_package_id}/aog',
            ...options,
            ...params
        });
    }
    
    /**
     * Close Work Package
     */
    public static closeWorkPackage<ThrowOnError extends boolean = false>(parameters: {
        work_package_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkPackageLifecycleCloseWorkPackageResponses, WorkPackageLifecycleCloseWorkPackageErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'work_package_id' }] }]);
        return (options?.client ?? client).post<WorkPackageLifecycleCloseWorkPackageResponses, WorkPackageLifecycleCloseWorkPackageErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-package/{work_package_id}/close',
            ...options,
            ...params
        });
    }
    
    /**
     * Change Work Package Status
     */
    public static changeWorkPackageStatus<ThrowOnError extends boolean = false>(parameters: {
        work_package_id: string;
        workPackageTransition: WorkPackageTransition;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkPackageLifecycleChangeWorkPackageStatusResponses, WorkPackageLifecycleChangeWorkPackageStatusErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'work_package_id' }, { key: 'workPackageTransition', map: 'body' }] }]);
        return (options?.client ?? client).post<WorkPackageLifecycleChangeWorkPackageStatusResponses, WorkPackageLifecycleChangeWorkPackageStatusErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-package/{work_package_id}/status',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Close Work Package Tasks
     */
    public static closeWorkPackageTasks<ThrowOnError extends boolean = false>(parameters: {
        work_package_id: string;
        closeWorkTasks: CloseWorkTasks;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkPackageLifecycleCloseWorkPackageTasksResponses, WorkPackageLifecycleCloseWorkPackageTasksErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'work_package_id' }, { key: 'closeWorkTasks', map: 'body' }] }]);
        return (options?.client ?? client).post<WorkPackageLifecycleCloseWorkPackageTasksResponses, WorkPackageLifecycleCloseWorkPackageTasksErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-package/{work_package_id}/tasks/close',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class WorkPackageActivityService {
    /**
     * List Activity
     */
    public static listActivity<ThrowOnError extends boolean = false>(parameters: {
        work_package_id: string;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkPackageActivityListActivityResponses, WorkPackageActivityListActivityErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'work_package_id' }, { in: 'query', key: 'limit' }] }]);
        return (options?.client ?? client).get<WorkPackageActivityListActivityResponses, WorkPackageActivityListActivityErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-package/{work_package_id}/activity',
            ...options,
            ...params
        });
    }
}

export class WorkPackagePhasesService {
    /**
     * Create Phase
     */
    public static createPhase<ThrowOnError extends boolean = false>(parameters: {
        work_package_id: string;
        workPackagePhaseCreate: WorkPackagePhaseCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkPackagePhasesCreatePhaseResponses, WorkPackagePhasesCreatePhaseErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'work_package_id' }, { key: 'workPackagePhaseCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<WorkPackagePhasesCreatePhaseResponses, WorkPackagePhasesCreatePhaseErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-package/{work_package_id}/phases',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Reorder Phases
     */
    public static reorderPhases<ThrowOnError extends boolean = false>(parameters: {
        work_package_id: string;
        workPackagePhaseOrder: WorkPackagePhaseOrder;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkPackagePhasesReorderPhasesResponses, WorkPackagePhasesReorderPhasesErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'work_package_id' }, { key: 'workPackagePhaseOrder', map: 'body' }] }]);
        return (options?.client ?? client).put<WorkPackagePhasesReorderPhasesResponses, WorkPackagePhasesReorderPhasesErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-package/{work_package_id}/phases/order',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete Phase
     */
    public static deletePhase<ThrowOnError extends boolean = false>(parameters: {
        work_package_id: string;
        phase_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkPackagePhasesDeletePhaseResponses, WorkPackagePhasesDeletePhaseErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'work_package_id' }, { in: 'path', key: 'phase_id' }] }]);
        return (options?.client ?? client).delete<WorkPackagePhasesDeletePhaseResponses, WorkPackagePhasesDeletePhaseErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-package/{work_package_id}/phases/{phase_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update Phase
     */
    public static updatePhase<ThrowOnError extends boolean = false>(parameters: {
        work_package_id: string;
        phase_id: string;
        workPackagePhaseUpdate: WorkPackagePhaseUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkPackagePhasesUpdatePhaseResponses, WorkPackagePhasesUpdatePhaseErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'work_package_id' },
                    { in: 'path', key: 'phase_id' },
                    { key: 'workPackagePhaseUpdate', map: 'body' }
                ] }]);
        return (options?.client ?? client).patch<WorkPackagePhasesUpdatePhaseResponses, WorkPackagePhasesUpdatePhaseErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-package/{work_package_id}/phases/{phase_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class WorkPackagePrintingService {
    /**
     * Print Task Cards
     */
    public static printTaskCards<ThrowOnError extends boolean = false>(parameters: {
        work_package_id: string;
        printTaskCards: PrintTaskCards;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkPackagePrintingPrintTaskCardsResponses, WorkPackagePrintingPrintTaskCardsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'work_package_id' }, { key: 'printTaskCards', map: 'body' }] }]);
        return (options?.client ?? client).post<WorkPackagePrintingPrintTaskCardsResponses, WorkPackagePrintingPrintTaskCardsErrors, ThrowOnError>({
            responseType: 'blob',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-package/{work_package_id}/task-cards',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Print Work Pack
     */
    public static printWorkPack<ThrowOnError extends boolean = false>(parameters: {
        work_package_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkPackagePrintingPrintWorkPackResponses, WorkPackagePrintingPrintWorkPackErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'work_package_id' }] }]);
        return (options?.client ?? client).get<WorkPackagePrintingPrintWorkPackResponses, WorkPackagePrintingPrintWorkPackErrors, ThrowOnError>({
            responseType: 'blob',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-package/{work_package_id}/work-pack',
            ...options,
            ...params
        });
    }
}

export class WorkTaskPartsService {
    /**
     * List Parts
     */
    public static listParts<ThrowOnError extends boolean = false>(parameters: {
        part_id: string;
        skip?: number;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkTaskPartsListPartsResponses, WorkTaskPartsListPartsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'part_id' },
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' }
                ] }]);
        return (options?.client ?? client).get<WorkTaskPartsListPartsResponses, WorkTaskPartsListPartsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-task-part/',
            ...options,
            ...params
        });
    }
    
    /**
     * Request Part
     */
    public static requestPart<ThrowOnError extends boolean = false>(parameters: {
        work_task_id: string;
        requestWorkTaskPart: RequestWorkTaskPart;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkTaskPartsRequestPartResponses, WorkTaskPartsRequestPartErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'work_task_id' }, { key: 'requestWorkTaskPart', map: 'body' }] }]);
        return (options?.client ?? client).post<WorkTaskPartsRequestPartResponses, WorkTaskPartsRequestPartErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-task/{work_task_id}/parts',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Withdraw Part
     */
    public static withdrawPart<ThrowOnError extends boolean = false>(parameters: {
        work_task_id: string;
        work_task_part_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkTaskPartsWithdrawPartResponses, WorkTaskPartsWithdrawPartErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'work_task_id' }, { in: 'path', key: 'work_task_part_id' }] }]);
        return (options?.client ?? client).delete<WorkTaskPartsWithdrawPartResponses, WorkTaskPartsWithdrawPartErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-task/{work_task_id}/parts/{work_task_part_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update Part
     */
    public static updatePart<ThrowOnError extends boolean = false>(parameters: {
        work_task_id: string;
        work_task_part_id: string;
        workTaskPartUpdate: WorkTaskPartUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkTaskPartsUpdatePartResponses, WorkTaskPartsUpdatePartErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'work_task_id' },
                    { in: 'path', key: 'work_task_part_id' },
                    { key: 'workTaskPartUpdate', map: 'body' }
                ] }]);
        return (options?.client ?? client).patch<WorkTaskPartsUpdatePartResponses, WorkTaskPartsUpdatePartErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-task/{work_task_id}/parts/{work_task_part_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Issue Part
     */
    public static issuePart<ThrowOnError extends boolean = false>(parameters: {
        work_task_id: string;
        work_task_part_id: string;
        issueWorkTaskPart: IssueWorkTaskPart;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkTaskPartsIssuePartResponses, WorkTaskPartsIssuePartErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'work_task_id' },
                    { in: 'path', key: 'work_task_part_id' },
                    { key: 'issueWorkTaskPart', map: 'body' }
                ] }]);
        return (options?.client ?? client).post<WorkTaskPartsIssuePartResponses, WorkTaskPartsIssuePartErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-task/{work_task_id}/parts/{work_task_part_id}/issues',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class WorkTaskService {
    /**
     * Read WorkTasks
     */
    public static readItems<ThrowOnError extends boolean = false>(parameters?: {
        skip?: number;
        limit?: number;
        search?: string | null;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkTaskReadItemsResponses, WorkTaskReadItemsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'search' }
                ] }]);
        return (options?.client ?? client).get<WorkTaskReadItemsResponses, WorkTaskReadItemsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-task/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create WorkTask
     */
    public static createItem<ThrowOnError extends boolean = false>(parameters: {
        workTaskCreate: WorkTaskCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkTaskCreateItemResponses, WorkTaskCreateItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'workTaskCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<WorkTaskCreateItemResponses, WorkTaskCreateItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-task/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Assign work tasks
     */
    public static assign<ThrowOnError extends boolean = false>(parameters: {
        assignWorkTasks: AssignWorkTasks;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkTaskAssignResponses, WorkTaskAssignErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'assignWorkTasks', map: 'body' }] }]);
        return (options?.client ?? client).post<WorkTaskAssignResponses, WorkTaskAssignErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-task/assignee',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete Items
     */
    public static deleteItems<ThrowOnError extends boolean = false>(parameters: {
        deleteWorkTasks: DeleteWorkTasks;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkTaskDeleteItemsResponses, WorkTaskDeleteItemsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'deleteWorkTasks', map: 'body' }] }]);
        return (options?.client ?? client).post<WorkTaskDeleteItemsResponses, WorkTaskDeleteItemsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-task/delete',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Get work task by ERP vendor and external ID
     */
    public static getWorkTaskByErpExternalId<ThrowOnError extends boolean = false>(parameters: {
        erp_vendor: ErpVendor;
        id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkTaskGetWorkTaskByErpExternalIdResponses, WorkTaskGetWorkTaskByErpExternalIdErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'erp_vendor' }, { in: 'path', key: 'id' }] }]);
        return (options?.client ?? client).get<WorkTaskGetWorkTaskByErpExternalIdResponses, WorkTaskGetWorkTaskByErpExternalIdErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-task/external/{erp_vendor}/{id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Search Work Tasks
     */
    public static searchWorkTasks<ThrowOnError extends boolean = false>(parameters: {
        searchRequest: SearchRequest;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkTaskSearchWorkTasksResponses, WorkTaskSearchWorkTasksErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'searchRequest', map: 'body' }] }]);
        return (options?.client ?? client).post<WorkTaskSearchWorkTasksResponses, WorkTaskSearchWorkTasksErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-task/search',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Change the status of work tasks
     */
    public static changeStatus<ThrowOnError extends boolean = false>(parameters: {
        workTaskStatusChange: WorkTaskStatusChange;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkTaskChangeStatusResponses, WorkTaskChangeStatusErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'workTaskStatusChange', map: 'body' }] }]);
        return (options?.client ?? client).post<WorkTaskChangeStatusResponses, WorkTaskChangeStatusErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-task/status',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Get work tasks by work package id
     */
    public static getWorkTaskByWorkPackageId<ThrowOnError extends boolean = false>(parameters: {
        work_package_id: string;
        skip?: number;
        limit?: number;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkTaskGetWorkTaskByWorkPackageIdResponses, WorkTaskGetWorkTaskByWorkPackageIdErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'work_package_id' },
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' }
                ] }]);
        return (options?.client ?? client).get<WorkTaskGetWorkTaskByWorkPackageIdResponses, WorkTaskGetWorkTaskByWorkPackageIdErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-task/work-package/{work_package_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Read WorkTask
     */
    public static readItem<ThrowOnError extends boolean = false>(parameters: {
        id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkTaskReadItemResponses, WorkTaskReadItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'id' }] }]);
        return (options?.client ?? client).get<WorkTaskReadItemResponses, WorkTaskReadItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-task/{id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update WorkTask
     */
    public static updateItem<ThrowOnError extends boolean = false>(parameters: {
        id: string;
        workTaskUpdate: WorkTaskUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkTaskUpdateItemResponses, WorkTaskUpdateItemErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'id' }, { key: 'workTaskUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<WorkTaskUpdateItemResponses, WorkTaskUpdateItemErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-task/{id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class WorkTaskSignOffService {
    /**
     * Sign Off Tasks
     */
    public static signOffTasks<ThrowOnError extends boolean = false>(parameters: {
        signOffWorkTasks: SignOffWorkTasks;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkTaskSignOffSignOffTasksResponses, WorkTaskSignOffSignOffTasksErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'signOffWorkTasks', map: 'body' }] }]);
        return (options?.client ?? client).post<WorkTaskSignOffSignOffTasksResponses, WorkTaskSignOffSignOffTasksErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-task/sign-off',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * List Signers
     */
    public static listSigners<ThrowOnError extends boolean = false>(parameters: {
        kind: SignerKind;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkTaskSignOffListSignersResponses, WorkTaskSignOffListSignersErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'query', key: 'kind' }] }]);
        return (options?.client ?? client).get<WorkTaskSignOffListSignersResponses, WorkTaskSignOffListSignersErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-task/sign-off/signers',
            ...options,
            ...params
        });
    }
    
    /**
     * Undo Task Inspection
     */
    public static undoTaskInspection<ThrowOnError extends boolean = false>(parameters: {
        work_task_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkTaskSignOffUndoTaskInspectionResponses, WorkTaskSignOffUndoTaskInspectionErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'work_task_id' }] }]);
        return (options?.client ?? client).delete<WorkTaskSignOffUndoTaskInspectionResponses, WorkTaskSignOffUndoTaskInspectionErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-task/{work_task_id}/inspection',
            ...options,
            ...params
        });
    }
    
    /**
     * Inspect Task
     */
    public static inspectTask<ThrowOnError extends boolean = false>(parameters: {
        work_task_id: string;
        workTaskSignature: WorkTaskSignature;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkTaskSignOffInspectTaskResponses, WorkTaskSignOffInspectTaskErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'work_task_id' }, { key: 'workTaskSignature', map: 'body' }] }]);
        return (options?.client ?? client).post<WorkTaskSignOffInspectTaskResponses, WorkTaskSignOffInspectTaskErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-task/{work_task_id}/inspection',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Undo Task Sign Off
     */
    public static undoTaskSignOff<ThrowOnError extends boolean = false>(parameters: {
        work_task_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkTaskSignOffUndoTaskSignOffResponses, WorkTaskSignOffUndoTaskSignOffErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'work_task_id' }] }]);
        return (options?.client ?? client).delete<WorkTaskSignOffUndoTaskSignOffResponses, WorkTaskSignOffUndoTaskSignOffErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-task/{work_task_id}/sign-off',
            ...options,
            ...params
        });
    }
    
    /**
     * Sign Off Task
     */
    public static signOffTask<ThrowOnError extends boolean = false>(parameters: {
        work_task_id: string;
        workTaskSignature: WorkTaskSignature;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkTaskSignOffSignOffTaskResponses, WorkTaskSignOffSignOffTaskErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'work_task_id' }, { key: 'workTaskSignature', map: 'body' }] }]);
        return (options?.client ?? client).post<WorkTaskSignOffSignOffTaskResponses, WorkTaskSignOffSignOffTaskErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-task/{work_task_id}/sign-off',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Task Sign Off History
     */
    public static taskSignOffHistory<ThrowOnError extends boolean = false>(parameters: {
        work_task_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkTaskSignOffTaskSignOffHistoryResponses, WorkTaskSignOffTaskSignOffHistoryErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'work_task_id' }] }]);
        return (options?.client ?? client).get<WorkTaskSignOffTaskSignOffHistoryResponses, WorkTaskSignOffTaskSignOffHistoryErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-task/{work_task_id}/sign-off-history',
            ...options,
            ...params
        });
    }
}

export class WorkTaskNotesService {
    /**
     * Create Note
     */
    public static createNote<ThrowOnError extends boolean = false>(parameters: {
        work_task_id: string;
        workTaskNoteCreate: WorkTaskNoteCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkTaskNotesCreateNoteResponses, WorkTaskNotesCreateNoteErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'work_task_id' }, { key: 'workTaskNoteCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<WorkTaskNotesCreateNoteResponses, WorkTaskNotesCreateNoteErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-task/{work_task_id}/notes',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class WorkTaskOutsideServicesService {
    /**
     * Request Outside Service
     */
    public static requestOutsideService<ThrowOnError extends boolean = false>(parameters: {
        work_task_id: string;
        requestOutsideService: RequestOutsideService;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkTaskOutsideServicesRequestOutsideServiceResponses, WorkTaskOutsideServicesRequestOutsideServiceErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'work_task_id' }, { key: 'requestOutsideService', map: 'body' }] }]);
        return (options?.client ?? client).post<WorkTaskOutsideServicesRequestOutsideServiceResponses, WorkTaskOutsideServicesRequestOutsideServiceErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-task/{work_task_id}/outside-services',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Withdraw Outside Service
     */
    public static withdrawOutsideService<ThrowOnError extends boolean = false>(parameters: {
        work_task_id: string;
        service_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkTaskOutsideServicesWithdrawOutsideServiceResponses, WorkTaskOutsideServicesWithdrawOutsideServiceErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'work_task_id' }, { in: 'path', key: 'service_id' }] }]);
        return (options?.client ?? client).delete<WorkTaskOutsideServicesWithdrawOutsideServiceResponses, WorkTaskOutsideServicesWithdrawOutsideServiceErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-task/{work_task_id}/outside-services/{service_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update Outside Service
     */
    public static updateOutsideService<ThrowOnError extends boolean = false>(parameters: {
        work_task_id: string;
        service_id: string;
        workTaskOutsideServiceUpdate: WorkTaskOutsideServiceUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkTaskOutsideServicesUpdateOutsideServiceResponses, WorkTaskOutsideServicesUpdateOutsideServiceErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'work_task_id' },
                    { in: 'path', key: 'service_id' },
                    { key: 'workTaskOutsideServiceUpdate', map: 'body' }
                ] }]);
        return (options?.client ?? client).patch<WorkTaskOutsideServicesUpdateOutsideServiceResponses, WorkTaskOutsideServicesUpdateOutsideServiceErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-task/{work_task_id}/outside-services/{service_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Move Outside Service
     */
    public static moveOutsideService<ThrowOnError extends boolean = false>(parameters: {
        work_task_id: string;
        service_id: string;
        moveOutsideService: MoveOutsideService;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkTaskOutsideServicesMoveOutsideServiceResponses, WorkTaskOutsideServicesMoveOutsideServiceErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'work_task_id' },
                    { in: 'path', key: 'service_id' },
                    { key: 'moveOutsideService', map: 'body' }
                ] }]);
        return (options?.client ?? client).post<WorkTaskOutsideServicesMoveOutsideServiceResponses, WorkTaskOutsideServicesMoveOutsideServiceErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-task/{work_task_id}/outside-services/{service_id}/moves',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class WorkTaskStepsService {
    /**
     * Create Step
     */
    public static createStep<ThrowOnError extends boolean = false>(parameters: {
        work_task_id: string;
        workTaskStepCreate: WorkTaskStepCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkTaskStepsCreateStepResponses, WorkTaskStepsCreateStepErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'work_task_id' }, { key: 'workTaskStepCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<WorkTaskStepsCreateStepResponses, WorkTaskStepsCreateStepErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-task/{work_task_id}/steps',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete Step
     */
    public static deleteStep<ThrowOnError extends boolean = false>(parameters: {
        work_task_id: string;
        step_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkTaskStepsDeleteStepResponses, WorkTaskStepsDeleteStepErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'work_task_id' }, { in: 'path', key: 'step_id' }] }]);
        return (options?.client ?? client).delete<WorkTaskStepsDeleteStepResponses, WorkTaskStepsDeleteStepErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-task/{work_task_id}/steps/{step_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update Step
     */
    public static updateStep<ThrowOnError extends boolean = false>(parameters: {
        work_task_id: string;
        step_id: string;
        workTaskStepUpdate: WorkTaskStepUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkTaskStepsUpdateStepResponses, WorkTaskStepsUpdateStepErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'work_task_id' },
                    { in: 'path', key: 'step_id' },
                    { key: 'workTaskStepUpdate', map: 'body' }
                ] }]);
        return (options?.client ?? client).patch<WorkTaskStepsUpdateStepResponses, WorkTaskStepsUpdateStepErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-task/{work_task_id}/steps/{step_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Undo Step Inspection
     */
    public static undoStepInspection<ThrowOnError extends boolean = false>(parameters: {
        work_task_id: string;
        step_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkTaskStepsUndoStepInspectionResponses, WorkTaskStepsUndoStepInspectionErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'work_task_id' }, { in: 'path', key: 'step_id' }] }]);
        return (options?.client ?? client).delete<WorkTaskStepsUndoStepInspectionResponses, WorkTaskStepsUndoStepInspectionErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-task/{work_task_id}/steps/{step_id}/inspection',
            ...options,
            ...params
        });
    }
    
    /**
     * Inspect Step
     */
    public static inspectStep<ThrowOnError extends boolean = false>(parameters: {
        work_task_id: string;
        step_id: string;
        workTaskStepInspection: WorkTaskStepInspection;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkTaskStepsInspectStepResponses, WorkTaskStepsInspectStepErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'work_task_id' },
                    { in: 'path', key: 'step_id' },
                    { key: 'workTaskStepInspection', map: 'body' }
                ] }]);
        return (options?.client ?? client).post<WorkTaskStepsInspectStepResponses, WorkTaskStepsInspectStepErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-task/{work_task_id}/steps/{step_id}/inspection',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Undo Step Sign Off
     */
    public static undoStepSignOff<ThrowOnError extends boolean = false>(parameters: {
        work_task_id: string;
        step_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkTaskStepsUndoStepSignOffResponses, WorkTaskStepsUndoStepSignOffErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'work_task_id' }, { in: 'path', key: 'step_id' }] }]);
        return (options?.client ?? client).delete<WorkTaskStepsUndoStepSignOffResponses, WorkTaskStepsUndoStepSignOffErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-task/{work_task_id}/steps/{step_id}/sign-off',
            ...options,
            ...params
        });
    }
    
    /**
     * Sign Off Step
     */
    public static signOffStep<ThrowOnError extends boolean = false>(parameters: {
        work_task_id: string;
        step_id: string;
        workTaskStepSignOff: WorkTaskStepSignOff;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkTaskStepsSignOffStepResponses, WorkTaskStepsSignOffStepErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'work_task_id' },
                    { in: 'path', key: 'step_id' },
                    { key: 'workTaskStepSignOff', map: 'body' }
                ] }]);
        return (options?.client ?? client).post<WorkTaskStepsSignOffStepResponses, WorkTaskStepsSignOffStepErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/work-task/{work_task_id}/steps/{step_id}/sign-off',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class WorkflowsService {
    /**
     * List Workflows
     */
    public static listWorkflows<ThrowOnError extends boolean = false>(parameters?: {
        skip?: number;
        limit?: number;
        deleted?: boolean;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkflowsListWorkflowsResponses, WorkflowsListWorkflowsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'query', key: 'skip' },
                    { in: 'query', key: 'limit' },
                    { in: 'query', key: 'deleted' }
                ] }]);
        return (options?.client ?? client).get<WorkflowsListWorkflowsResponses, WorkflowsListWorkflowsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/workflows/',
            ...options,
            ...params
        });
    }
    
    /**
     * Create
     */
    public static create<ThrowOnError extends boolean = false>(parameters: {
        workflowCreate: WorkflowCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkflowsCreateResponses, WorkflowsCreateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ key: 'workflowCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<WorkflowsCreateResponses, WorkflowsCreateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/workflows/',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete
     */
    public static delete<ThrowOnError extends boolean = false>(parameters: {
        workflow_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkflowsDeleteResponses, WorkflowsDeleteErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'workflow_id' }] }]);
        return (options?.client ?? client).delete<WorkflowsDeleteResponses, WorkflowsDeleteErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/workflows/{workflow_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Get
     */
    public static get<ThrowOnError extends boolean = false>(parameters: {
        workflow_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkflowsGetResponses, WorkflowsGetErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'workflow_id' }] }]);
        return (options?.client ?? client).get<WorkflowsGetResponses, WorkflowsGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/workflows/{workflow_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update
     */
    public static update<ThrowOnError extends boolean = false>(parameters: {
        workflow_id: string;
        workflowUpdate: WorkflowUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkflowsUpdateResponses, WorkflowsUpdateErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'workflow_id' }, { key: 'workflowUpdate', map: 'body' }] }]);
        return (options?.client ?? client).patch<WorkflowsUpdateResponses, WorkflowsUpdateErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/workflows/{workflow_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}

export class WorkflowStepsService {
    /**
     * List Steps
     */
    public static listSteps<ThrowOnError extends boolean = false>(parameters: {
        workflow_id: string;
        deleted?: boolean;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkflowStepsListStepsResponses, WorkflowStepsListStepsErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'workflow_id' }, { in: 'query', key: 'deleted' }] }]);
        return (options?.client ?? client).get<WorkflowStepsListStepsResponses, WorkflowStepsListStepsErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/workflows/{workflow_id}/steps',
            ...options,
            ...params
        });
    }
    
    /**
     * Create Step
     */
    public static createStep<ThrowOnError extends boolean = false>(parameters: {
        workflow_id: string;
        workflowStepCreate: WorkflowStepCreate;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkflowStepsCreateStepResponses, WorkflowStepsCreateStepErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'workflow_id' }, { key: 'workflowStepCreate', map: 'body' }] }]);
        return (options?.client ?? client).post<WorkflowStepsCreateStepResponses, WorkflowStepsCreateStepErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/workflows/{workflow_id}/steps',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
    
    /**
     * Delete Step
     */
    public static deleteStep<ThrowOnError extends boolean = false>(parameters: {
        workflow_id: string;
        workflow_step_id: string;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkflowStepsDeleteStepResponses, WorkflowStepsDeleteStepErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [{ in: 'path', key: 'workflow_id' }, { in: 'path', key: 'workflow_step_id' }] }]);
        return (options?.client ?? client).delete<WorkflowStepsDeleteStepResponses, WorkflowStepsDeleteStepErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/workflows/{workflow_id}/steps/{workflow_step_id}',
            ...options,
            ...params
        });
    }
    
    /**
     * Update Step
     */
    public static updateStep<ThrowOnError extends boolean = false>(parameters: {
        workflow_id: string;
        workflow_step_id: string;
        workflowStepUpdate: WorkflowStepUpdate;
    }, options?: Options<never, ThrowOnError>): RequestResult<WorkflowStepsUpdateStepResponses, WorkflowStepsUpdateStepErrors, ThrowOnError> {
        const params = buildClientParams([parameters], [{ args: [
                    { in: 'path', key: 'workflow_id' },
                    { in: 'path', key: 'workflow_step_id' },
                    { key: 'workflowStepUpdate', map: 'body' }
                ] }]);
        return (options?.client ?? client).patch<WorkflowStepsUpdateStepResponses, WorkflowStepsUpdateStepErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/workflows/{workflow_id}/steps/{workflow_step_id}',
            ...options,
            ...params,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
                ...params.headers
            }
        });
    }
}
